//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AddressGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<Address> {
        let url_ = this.baseUrl + "/api/v1/address/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Address>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Address>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Address> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Address.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(address: Address, id: string): Observable<Address> {
        let url_ = this.baseUrl + "/api/v1/address/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Address>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Address>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Address> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Address.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/address/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<Address[]> {
        let url_ = this.baseUrl + "/api/v1/address";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Address[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Address[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Address[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Address.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(address: Address): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(address);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    geocode(location: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/address/geocode?";
        if (location === undefined || location === null)
            throw new globalThis.Error("The parameter 'location' must be defined and cannot be null.");
        else
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeocode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeocode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGeocode(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    routeOptimize(json: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/address/route?";
        if (json === undefined || json === null)
            throw new globalThis.Error("The parameter 'json' must be defined and cannot be null.");
        else
            url_ += "json=" + encodeURIComponent("" + json) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRouteOptimize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRouteOptimize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRouteOptimize(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthenticationGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    userAuthenticate(request: LoginRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/authentication/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUserAuthenticate(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPublicPem(): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/authentication/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicPem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicPem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGetPublicPem(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    resetPassword(username: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/authentication/resetPassword?";
        if (username === undefined || username === null)
            throw new globalThis.Error("The parameter 'username' must be defined and cannot be null.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changePassword(newPassword: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/authentication/changePassword?";
        if (newPassword === undefined || newPassword === null)
            throw new globalThis.Error("The parameter 'newPassword' must be defined and cannot be null.");
        else
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BigDayBucketGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<BigDayBucket> {
        let url_ = this.baseUrl + "/api/v1/bigDayBuckets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucket>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucket>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BigDayBucket> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayBucket.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/bigDayBuckets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<BigDayBucket[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayBuckets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucket[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucket[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BigDayBucket[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayBucket.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(request: BigDayBucketUpdateRequest): Observable<BigDayBucket> {
        let url_ = this.baseUrl + "/api/v1/bigDayBuckets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucket>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucket>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BigDayBucket> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayBucket.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(bigDayBucket: BigDayBucket): Observable<BigDayBucket> {
        let url_ = this.baseUrl + "/api/v1/bigDayBuckets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bigDayBucket);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucket>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucket>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<BigDayBucket> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayBucket.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWithWellnessWorkOrders(): Observable<BigDayBucket[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayBuckets/getWithWellnessWorkOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithWellnessWorkOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithWellnessWorkOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucket[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucket[]>;
        }));
    }

    protected processGetWithWellnessWorkOrders(response: HttpResponseBase): Observable<BigDayBucket[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayBucket.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWithWorkWorkOrders(): Observable<BigDayBucket[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayBuckets/getWithWorkWorkOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithWorkWorkOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithWorkWorkOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucket[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucket[]>;
        }));
    }

    protected processGetWithWorkWorkOrders(response: HttpResponseBase): Observable<BigDayBucket[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayBucket.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BigDayBucketSubrangeGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<BigDayBucketSubrange> {
        let url_ = this.baseUrl + "/api/v1/bigDayBucketSubranges/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucketSubrange>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucketSubrange>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BigDayBucketSubrange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayBucketSubrange.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(bigDayBucketSubrange: BigDayBucketSubrange, id: string): Observable<BigDayBucketSubrange> {
        let url_ = this.baseUrl + "/api/v1/bigDayBucketSubranges/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bigDayBucketSubrange);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucketSubrange>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucketSubrange>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BigDayBucketSubrange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayBucketSubrange.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/bigDayBucketSubranges/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<BigDayBucketSubrange[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayBucketSubranges";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucketSubrange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucketSubrange[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BigDayBucketSubrange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayBucketSubrange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(bigDayBucketSubrange: BigDayBucketSubrange): Observable<BigDayBucketSubrange> {
        let url_ = this.baseUrl + "/api/v1/bigDayBucketSubranges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bigDayBucketSubrange);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucketSubrange>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucketSubrange>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<BigDayBucketSubrange> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayBucketSubrange.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWithBigDayBucketId(id: number): Observable<BigDayBucketSubrange[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayBucketSubranges/withBigDayBucketId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithBigDayBucketId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithBigDayBucketId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucketSubrange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucketSubrange[]>;
        }));
    }

    protected processGetAllWithBigDayBucketId(response: HttpResponseBase): Observable<BigDayBucketSubrange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayBucketSubrange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllBigDayBucketSubrangeInDateRange(fromDate: Date, toDate: Date): Observable<BigDayBucketSubrange[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayBucketSubranges/withinDateRange?";
        if (fromDate === undefined || fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new globalThis.Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBigDayBucketSubrangeInDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBigDayBucketSubrangeInDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucketSubrange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucketSubrange[]>;
        }));
    }

    protected processGetAllBigDayBucketSubrangeInDateRange(response: HttpResponseBase): Observable<BigDayBucketSubrange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayBucketSubrange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllBigDayBucketSubrangeInDateRangeForAUser(empId: number, startDate: Date, endDate: Date): Observable<BigDayBucketSubrange[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayBucketSubranges/withinDateRangeForAUser?";
        if (empId === undefined || empId === null)
            throw new globalThis.Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBigDayBucketSubrangeInDateRangeForAUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBigDayBucketSubrangeInDateRangeForAUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayBucketSubrange[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayBucketSubrange[]>;
        }));
    }

    protected processGetAllBigDayBucketSubrangeInDateRangeForAUser(response: HttpResponseBase): Observable<BigDayBucketSubrange[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayBucketSubrange.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BigDayEmployeeGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<BigDayEmployee> {
        let url_ = this.baseUrl + "/api/v1/bigDayEmployees/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEmployee>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEmployee>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BigDayEmployee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayEmployee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(bigDayEmployee: BigDayEmployee, id: string): Observable<BigDayEmployee> {
        let url_ = this.baseUrl + "/api/v1/bigDayEmployees/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bigDayEmployee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEmployee>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEmployee>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BigDayEmployee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayEmployee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/bigDayEmployees/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<BigDayEmployee[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayEmployees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEmployee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEmployee[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BigDayEmployee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayEmployee.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(bigDayEmployee: BigDayEmployee): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/bigDayEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bigDayEmployee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWithBigDayBucketId(id: number): Observable<BigDayEmployee[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayEmployees/withBigDayBucketId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithBigDayBucketId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithBigDayBucketId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEmployee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEmployee[]>;
        }));
    }

    protected processGetAllWithBigDayBucketId(response: HttpResponseBase): Observable<BigDayEmployee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayEmployee.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWithBigDayBucketSubrangeId(id: number): Observable<BigDayEmployee[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayEmployees/withBigDayBucketSubrangeId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithBigDayBucketSubrangeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithBigDayBucketSubrangeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEmployee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEmployee[]>;
        }));
    }

    protected processGetAllWithBigDayBucketSubrangeId(response: HttpResponseBase): Observable<BigDayEmployee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayEmployee.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BigDayEquipmentGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<BigDayEquipment> {
        let url_ = this.baseUrl + "/api/v1/bigDayEquipment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEquipment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEquipment>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BigDayEquipment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayEquipment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(bigDayEquipment: BigDayEquipment, id: string): Observable<BigDayEquipment> {
        let url_ = this.baseUrl + "/api/v1/bigDayEquipment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bigDayEquipment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEquipment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEquipment>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BigDayEquipment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BigDayEquipment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/bigDayEquipment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<BigDayEquipment[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayEquipment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEquipment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEquipment[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BigDayEquipment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayEquipment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(bigDayEquipment: BigDayEquipment): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/bigDayEquipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bigDayEquipment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWithBigDayBucketId(id: number): Observable<BigDayEquipment[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayEquipment/withBigDayBucketId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithBigDayBucketId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithBigDayBucketId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEquipment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEquipment[]>;
        }));
    }

    protected processGetAllWithBigDayBucketId(response: HttpResponseBase): Observable<BigDayEquipment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayEquipment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWithBigDayBucketSubrangeId(id: number): Observable<BigDayEquipment[]> {
        let url_ = this.baseUrl + "/api/v1/bigDayEquipment/withBigDayBucketSubrangeId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithBigDayBucketSubrangeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithBigDayBucketSubrangeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BigDayEquipment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BigDayEquipment[]>;
        }));
    }

    protected processGetAllWithBigDayBucketSubrangeId(response: HttpResponseBase): Observable<BigDayEquipment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BigDayEquipment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BlobGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    getBlobs(containerName: string, id: number): Observable<BlobWithSAS[]> {
        let url_ = this.baseUrl + "/api/v1/blob/GetBlobs{containerName}/{id}";
        if (containerName === undefined || containerName === null)
            throw new globalThis.Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlobWithSAS[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlobWithSAS[]>;
        }));
    }

    protected processGetBlobs(response: HttpResponseBase): Observable<BlobWithSAS[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlobWithSAS.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAnonymousBlobs(container: string, id: number): Observable<BlobWithSAS[]> {
        let url_ = this.baseUrl + "/api/v1/blob/GetAnonymousBlobs/{container}/{id}";
        if (container === undefined || container === null)
            throw new globalThis.Error("The parameter 'container' must be defined.");
        url_ = url_.replace("{container}", encodeURIComponent("" + container));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnonymousBlobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnonymousBlobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlobWithSAS[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlobWithSAS[]>;
        }));
    }

    protected processGetAnonymousBlobs(response: HttpResponseBase): Observable<BlobWithSAS[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlobWithSAS.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSAS(): Observable<SasResponse> {
        let url_ = this.baseUrl + "/api/v1/blob/GetSAS";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSAS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSAS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SasResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SasResponse>;
        }));
    }

    protected processGetSAS(response: HttpResponseBase): Observable<SasResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SasResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    uploadBlob(containerName: string, id: number): Observable<BlobWithSAS[]> {
        let url_ = this.baseUrl + "/api/v1/blob/UploadBlob/{containerName}/{id}";
        if (containerName === undefined || containerName === null)
            throw new globalThis.Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlobWithSAS[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlobWithSAS[]>;
        }));
    }

    protected processUploadBlob(response: HttpResponseBase): Observable<BlobWithSAS[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlobWithSAS.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteBlob(containerName: string, displayName: string, id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/blob/DeleteBlob/{containerName}/{id}?";
        if (containerName === undefined || containerName === null)
            throw new globalThis.Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (displayName === undefined || displayName === null)
            throw new globalThis.Error("The parameter 'displayName' must be defined and cannot be null.");
        else
            url_ += "displayName=" + encodeURIComponent("" + displayName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteBlob(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteBlobAnonymous(containerName: string, displayName: string, id: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/blob/DeleteBlobAnonymous/{containerName}/{id}?";
        if (containerName === undefined || containerName === null)
            throw new globalThis.Error("The parameter 'containerName' must be defined.");
        url_ = url_.replace("{containerName}", encodeURIComponent("" + containerName));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (displayName === undefined || displayName === null)
            throw new globalThis.Error("The parameter 'displayName' must be defined and cannot be null.");
        else
            url_ += "displayName=" + encodeURIComponent("" + displayName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBlobAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBlobAnonymous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteBlobAnonymous(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BroughtByGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<BroughtBy> {
        let url_ = this.baseUrl + "/api/v1/broughtBy/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BroughtBy>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BroughtBy>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BroughtBy> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BroughtBy.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<BroughtBy[]> {
        let url_ = this.baseUrl + "/api/v1/broughtBy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BroughtBy[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BroughtBy[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BroughtBy[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BroughtBy.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChemicalGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<Chemical> {
        let url_ = this.baseUrl + "/api/v1/chemical/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Chemical>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Chemical>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Chemical> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Chemical.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(chemical: Chemical, id: string): Observable<Chemical> {
        let url_ = this.baseUrl + "/api/v1/chemical/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemical);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Chemical>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Chemical>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Chemical> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Chemical.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/chemical/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<Chemical[]> {
        let url_ = this.baseUrl + "/api/v1/chemical";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Chemical[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Chemical[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Chemical[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Chemical.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(chemical: Chemical): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/chemical";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemical);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChemicalApplicationLocationGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<ChemicalApplicationLocation> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationLocation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalApplicationLocation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalApplicationLocation>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ChemicalApplicationLocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChemicalApplicationLocation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(chemicalApplicationLocation: ChemicalApplicationLocation, id: string): Observable<ChemicalApplicationLocation> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationLocation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemicalApplicationLocation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalApplicationLocation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalApplicationLocation>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ChemicalApplicationLocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChemicalApplicationLocation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationLocation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ChemicalApplicationLocation[]> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalApplicationLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalApplicationLocation[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ChemicalApplicationLocation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChemicalApplicationLocation.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(chemicalApplicationLocation: ChemicalApplicationLocation): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemicalApplicationLocation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChemicalApplicationMethodGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<ChemicalApplicationMethod> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationMethod/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalApplicationMethod>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalApplicationMethod>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ChemicalApplicationMethod> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChemicalApplicationMethod.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(chemicalApplicationMethod: ChemicalApplicationMethod, id: string): Observable<ChemicalApplicationMethod> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationMethod/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemicalApplicationMethod);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalApplicationMethod>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalApplicationMethod>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ChemicalApplicationMethod> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChemicalApplicationMethod.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationMethod/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ChemicalApplicationMethod[]> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationMethod";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalApplicationMethod[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalApplicationMethod[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ChemicalApplicationMethod[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChemicalApplicationMethod.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(chemicalApplicationMethod: ChemicalApplicationMethod): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/chemicalApplicationMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemicalApplicationMethod);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChemicalComboGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<ChemicalCombo> {
        let url_ = this.baseUrl + "/api/v1/chemicalCombo/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalCombo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalCombo>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ChemicalCombo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChemicalCombo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(chemicalCombo: ChemicalCombo, id: string): Observable<ChemicalCombo> {
        let url_ = this.baseUrl + "/api/v1/chemicalCombo/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemicalCombo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalCombo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalCombo>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ChemicalCombo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChemicalCombo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/chemicalCombo/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ChemicalCombo[]> {
        let url_ = this.baseUrl + "/api/v1/chemicalCombo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalCombo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalCombo[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ChemicalCombo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChemicalCombo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(chemicalCombo: ChemicalCombo): Observable<ChemicalCombo> {
        let url_ = this.baseUrl + "/api/v1/chemicalCombo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chemicalCombo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChemicalCombo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChemicalCombo>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ChemicalCombo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChemicalCombo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CrewGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<Crew> {
        let url_ = this.baseUrl + "/api/v1/crews/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Crew>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Crew>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Crew> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Crew.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(crew: Crew, id: string): Observable<Crew> {
        let url_ = this.baseUrl + "/api/v1/crews/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Crew>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Crew>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Crew> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Crew.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/crews/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<Crew[]> {
        let url_ = this.baseUrl + "/api/v1/crews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Crew[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Crew[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Crew[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Crew.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(crew: Crew): Observable<Crew> {
        let url_ = this.baseUrl + "/api/v1/crews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(crew);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Crew>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Crew>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<Crew> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Crew.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCrewsInDateRange(startDate: Date, endDate: Date): Observable<Crew[]> {
        let url_ = this.baseUrl + "/api/v1/crews/getCrewsInDateRange?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCrewsInDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCrewsInDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Crew[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Crew[]>;
        }));
    }

    protected processGetCrewsInDateRange(response: HttpResponseBase): Observable<Crew[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Crew.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getValidCrewsInDateRange(startDate: Date, endDate: Date): Observable<Crew[]> {
        let url_ = this.baseUrl + "/api/v1/crews/getValidCrewsInDateRange?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidCrewsInDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidCrewsInDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Crew[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Crew[]>;
        }));
    }

    protected processGetValidCrewsInDateRange(response: HttpResponseBase): Observable<Crew[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Crew.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<Customer> {
        let url_ = this.baseUrl + "/api/v1/customers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(customer: Customer, id: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/customers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<Customer[]> {
        let url_ = this.baseUrl + "/api/v1/customers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Customer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Customer.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(customer: Customer): Observable<CustomerAndToken> {
        let url_ = this.baseUrl + "/api/v1/customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerAndToken>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerAndToken>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerAndToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAndToken.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(customer: Customer, sendWelcomeEmail: boolean): Observable<Customer> {
        let url_ = this.baseUrl + "/api/v1/customers?";
        if (sendWelcomeEmail === undefined || sendWelcomeEmail === null)
            throw new globalThis.Error("The parameter 'sendWelcomeEmail' must be defined and cannot be null.");
        else
            url_ += "sendWelcomeEmail=" + encodeURIComponent("" + sendWelcomeEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customer);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAnonymous(id: number): Observable<Customer> {
        let url_ = this.baseUrl + "/api/v1/customers/getAnonymous?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnonymous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer>;
        }));
    }

    protected processGetAnonymous(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActive(): Observable<Customer[]> {
        let url_ = this.baseUrl + "/api/v1/customers/getactive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer[]>;
        }));
    }

    protected processGetActive(response: HttpResponseBase): Observable<Customer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Customer.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPaginated(skip: number, take: number, includeInactive: boolean, sortOption: SortOption, globalFilter: string, includeSecondaryContacts: boolean): Observable<PagedResultOfCustomerListView> {
        let url_ = this.baseUrl + "/api/v1/customers/getPaginated?";
        if (skip === undefined || skip === null)
            throw new globalThis.Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new globalThis.Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (includeInactive === undefined || includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' must be defined and cannot be null.");
        else
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (sortOption === undefined || sortOption === null)
            throw new globalThis.Error("The parameter 'sortOption' must be defined and cannot be null.");
        else
            url_ += "sortOption=" + encodeURIComponent("" + sortOption) + "&";
        if (globalFilter === undefined || globalFilter === null)
            throw new globalThis.Error("The parameter 'globalFilter' must be defined and cannot be null.");
        else
            url_ += "globalFilter=" + encodeURIComponent("" + globalFilter) + "&";
        if (includeSecondaryContacts === undefined || includeSecondaryContacts === null)
            throw new globalThis.Error("The parameter 'includeSecondaryContacts' must be defined and cannot be null.");
        else
            url_ += "includeSecondaryContacts=" + encodeURIComponent("" + includeSecondaryContacts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfCustomerListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfCustomerListView>;
        }));
    }

    protected processGetPaginated(response: HttpResponseBase): Observable<PagedResultOfCustomerListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfCustomerListView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getListViewCustomer(id: number): Observable<CustomerListView> {
        let url_ = this.baseUrl + "/api/v1/customers/getListViewCustomer?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListViewCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListViewCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerListView>;
        }));
    }

    protected processGetListViewCustomer(response: HttpResponseBase): Observable<CustomerListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerListView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCustomerDetails(id: number): Observable<CustomerDetails> {
        let url_ = this.baseUrl + "/api/v1/customers/getCustomerDetails?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDetails>;
        }));
    }

    protected processGetCustomerDetails(response: HttpResponseBase): Observable<CustomerDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getByFilter(globalFilter: string): Observable<CustomerListView[]> {
        let url_ = this.baseUrl + "/api/v1/customers/getByFilter?";
        if (globalFilter === undefined || globalFilter === null)
            throw new globalThis.Error("The parameter 'globalFilter' must be defined and cannot be null.");
        else
            url_ += "globalFilter=" + encodeURIComponent("" + globalFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerListView[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerListView[]>;
        }));
    }

    protected processGetByFilter(response: HttpResponseBase): Observable<CustomerListView[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerListView.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getUnfinalizedQuoteRequests(request: WorkOrderInfoPaginatedRequest): Observable<AllQuoteRequests> {
        let url_ = this.baseUrl + "/api/v1/customers/getUnfinalizedQuoteRequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnfinalizedQuoteRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnfinalizedQuoteRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllQuoteRequests>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllQuoteRequests>;
        }));
    }

    protected processGetUnfinalizedQuoteRequests(response: HttpResponseBase): Observable<AllQuoteRequests> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllQuoteRequests.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentQuotes(request: WorkOrderInfoPaginatedRequest): Observable<AllWorkOrders> {
        let url_ = this.baseUrl + "/api/v1/customers/getCurrentQuotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentQuotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentQuotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllWorkOrders>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllWorkOrders>;
        }));
    }

    protected processGetCurrentQuotes(response: HttpResponseBase): Observable<AllWorkOrders> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllWorkOrders.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentWorkOrders(request: WorkOrderInfoPaginatedRequest): Observable<AllWorkOrders> {
        let url_ = this.baseUrl + "/api/v1/customers/getCurrentWorkOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentWorkOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentWorkOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllWorkOrders>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllWorkOrders>;
        }));
    }

    protected processGetCurrentWorkOrders(response: HttpResponseBase): Observable<AllWorkOrders> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllWorkOrders.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getQuoteHistoryInfo(request: WorkOrderInfoPaginatedRequest): Observable<AllWorkOrdersWithBilling> {
        let url_ = this.baseUrl + "/api/v1/customers/getQuoteHistoryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteHistoryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteHistoryInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllWorkOrdersWithBilling>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllWorkOrdersWithBilling>;
        }));
    }

    protected processGetQuoteHistoryInfo(response: HttpResponseBase): Observable<AllWorkOrdersWithBilling> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllWorkOrdersWithBilling.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWorkOrderHistoryInfo(request: WorkOrderInfoPaginatedRequest): Observable<AllWorkOrdersWithBilling> {
        let url_ = this.baseUrl + "/api/v1/customers/getWorkOrderHistoryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkOrderHistoryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkOrderHistoryInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllWorkOrdersWithBilling>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllWorkOrdersWithBilling>;
        }));
    }

    protected processGetWorkOrderHistoryInfo(response: HttpResponseBase): Observable<AllWorkOrdersWithBilling> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllWorkOrdersWithBilling.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    combineCustomers(targetCustomer: number, sourceCustomer: number, uiDate: Date, selectedContacts: number[]): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/customers/combineCustomers?";
        if (targetCustomer === undefined || targetCustomer === null)
            throw new globalThis.Error("The parameter 'targetCustomer' must be defined and cannot be null.");
        else
            url_ += "targetCustomer=" + encodeURIComponent("" + targetCustomer) + "&";
        if (sourceCustomer === undefined || sourceCustomer === null)
            throw new globalThis.Error("The parameter 'sourceCustomer' must be defined and cannot be null.");
        else
            url_ += "sourceCustomer=" + encodeURIComponent("" + sourceCustomer) + "&";
        if (uiDate === undefined || uiDate === null)
            throw new globalThis.Error("The parameter 'uiDate' must be defined and cannot be null.");
        else
            url_ += "uiDate=" + encodeURIComponent(uiDate ? "" + uiDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedContacts);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCombineCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCombineCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCombineCustomers(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerCommentStageGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(): Observable<CustomerCommentStage[]> {
        let url_ = this.baseUrl + "/api/v1/customerCommentStage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerCommentStage[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerCommentStage[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerCommentStage[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerCommentStage.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerNoteGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    update(customerComment: CustomerComment): Observable<CustomerComment> {
        let url_ = this.baseUrl + "/api/v1/customerNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerComment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComment>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(customerComment: CustomerComment): Observable<CustomerComment> {
        let url_ = this.baseUrl + "/api/v1/customerNotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerComment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComment>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<CustomerComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addQuoteChangeRequest(changesRequest: RequestChangesEmailRequest): Observable<CustomerComment> {
        let url_ = this.baseUrl + "/api/v1/customerNotes/addQuoteChangeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changesRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQuoteChangeRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQuoteChangeRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerComment>;
        }));
    }

    protected processAddQuoteChangeRequest(response: HttpResponseBase): Observable<CustomerComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/customerNotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CustomerTypeGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(): Observable<CustomerType[]> {
        let url_ = this.baseUrl + "/api/v1/customerType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerType[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getThing(): Observable<CustomerType[]> {
        let url_ = this.baseUrl + "/api/v1/customerType/sfd";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetThing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetThing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerType[]>;
        }));
    }

    protected processGetThing(response: HttpResponseBase): Observable<CustomerType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmployeeGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<Employee> {
        let url_ = this.baseUrl + "/api/v1/employees/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Employee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(employee: Employee, id: string): Observable<Employee> {
        let url_ = this.baseUrl + "/api/v1/employees/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Employee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/employees/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/v1/employees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(employee: Employee): Observable<Employee> {
        let url_ = this.baseUrl + "/api/v1/employees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<Employee> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Employee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentlyEmployed(): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/v1/employees/GetCurrentlyEmployed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentlyEmployed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentlyEmployed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetCurrentlyEmployed(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRegionalManagers(): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/v1/employees/GetRegionalManagers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalManagers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalManagers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetRegionalManagers(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSchedulable(): Observable<Employee[]> {
        let url_ = this.baseUrl + "/api/v1/employees/GetSchedulable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedulable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedulable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Employee[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Employee[]>;
        }));
    }

    protected processGetSchedulable(response: HttpResponseBase): Observable<Employee[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Employee.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateZipCodeAssignments(employees: Employee[]): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/employees/updateZipCodeAssignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employees);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZipCodeAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZipCodeAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdateZipCodeAssignments(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEmployeePreference(id: number): Observable<EmployeeMFAPreferenceViewModel> {
        let url_ = this.baseUrl + "/api/v1/employees/GetEmployeePreference/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeePreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeMFAPreferenceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeMFAPreferenceViewModel>;
        }));
    }

    protected processGetEmployeePreference(response: HttpResponseBase): Observable<EmployeeMFAPreferenceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeMFAPreferenceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendVerificationCode(viewModel: EmployeeMFAPreferenceViewModel): Observable<EmployeeMFAPreferenceViewModel> {
        let url_ = this.baseUrl + "/api/v1/employees/SendVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeMFAPreferenceViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeMFAPreferenceViewModel>;
        }));
    }

    protected processSendVerificationCode(response: HttpResponseBase): Observable<EmployeeMFAPreferenceViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeMFAPreferenceViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    checkVerificationCode(code: string): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/employees/CheckVerificationCode?";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckVerificationCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckVerificationCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckVerificationCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    saveEmployeePreference(viewModel: EmployeeMFAPreferenceViewModel): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/employees/SaveEmployeePreference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEmployeePreference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEmployeePreference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveEmployeePreference(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EquipmentGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<Equipment> {
        let url_ = this.baseUrl + "/api/v1/equipment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Equipment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Equipment>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Equipment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Equipment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(equipment: Equipment, id: string): Observable<Equipment> {
        let url_ = this.baseUrl + "/api/v1/equipment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Equipment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Equipment>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Equipment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Equipment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/equipment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<Equipment[]> {
        let url_ = this.baseUrl + "/api/v1/equipment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Equipment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Equipment[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Equipment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Equipment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(equipment: Equipment): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/equipment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEquipmentInService(): Observable<Equipment[]> {
        let url_ = this.baseUrl + "/api/v1/equipment/GetEquipmentInService";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEquipmentInService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquipmentInService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Equipment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Equipment[]>;
        }));
    }

    protected processGetEquipmentInService(response: HttpResponseBase): Observable<Equipment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Equipment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EquipmentTypeGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<EquipmentType> {
        let url_ = this.baseUrl + "/api/v1/equipmentType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentType>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EquipmentType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(equipmentType: EquipmentType, id: string): Observable<EquipmentType> {
        let url_ = this.baseUrl + "/api/v1/equipmentType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentType>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EquipmentType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EquipmentType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/equipmentType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<EquipmentType[]> {
        let url_ = this.baseUrl + "/api/v1/equipmentType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentType[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EquipmentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EquipmentType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(equipmentType: EquipmentType): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/equipmentType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(equipmentType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActive(): Observable<EquipmentType[]> {
        let url_ = this.baseUrl + "/api/v1/equipmentType/getactive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EquipmentType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EquipmentType[]>;
        }));
    }

    protected processGetActive(response: HttpResponseBase): Observable<EquipmentType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EquipmentType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ExportGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(): Observable<ExportModel[]> {
        let url_ = this.baseUrl + "/api/v1/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ExportModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    export(request: ReportWithDatesRequest): Observable<ExportResponseModel> {
        let url_ = this.baseUrl + "/api/v1/export/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportResponseModel>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<ExportResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LogGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    add(logData: LogViewModel): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    logSchedule(logData: LogViewModel): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/log/LogSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processLogSchedule(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MessageToCustomerTemplateGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(): Observable<MessageToCustomerTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/messageToCustomer";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageToCustomerTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageToCustomerTemplate[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MessageToCustomerTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageToCustomerTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(template: MessageToCustomerTemplate): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/messageToCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActive(): Observable<MessageToCustomerTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/messageToCustomer/getActive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageToCustomerTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageToCustomerTemplate[]>;
        }));
    }

    protected processGetActive(response: HttpResponseBase): Observable<MessageToCustomerTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageToCustomerTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(template: MessageToCustomerTemplate, id: string): Observable<MessageToCustomerTemplate> {
        let url_ = this.baseUrl + "/api/v1/messageToCustomer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageToCustomerTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageToCustomerTemplate>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MessageToCustomerTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageToCustomerTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/messageToCustomer/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NeighborPermissionGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    update(neighborPermission: NeighborPermission): Observable<NeighborPermission> {
        let url_ = this.baseUrl + "/api/v1/neighborPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(neighborPermission);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NeighborPermission>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NeighborPermission>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NeighborPermission> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NeighborPermission.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationsGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    resendWorkOrderCompleteEmail(id: number, type: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/ResendWorkOrderCompleteEmail?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendWorkOrderCompleteEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendWorkOrderCompleteEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processResendWorkOrderCompleteEmail(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendAnytimeConfirmEmail(quoteRequest: QuoteRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendAnytimeConfirmEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAnytimeConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAnytimeConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendAnytimeConfirmEmail(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendVirtualConfirmEmail(quoteRequest: QuoteRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendVirtualConfirmEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVirtualConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVirtualConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendVirtualConfirmEmail(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendQuoteCreation(quoteWorkOrder: QuoteWorkOrder, encodedCustId: string, encodedQuoteId: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendQuoteCreation?";
        if (encodedCustId === undefined || encodedCustId === null)
            throw new globalThis.Error("The parameter 'encodedCustId' must be defined and cannot be null.");
        else
            url_ += "encodedCustId=" + encodeURIComponent("" + encodedCustId) + "&";
        if (encodedQuoteId === undefined || encodedQuoteId === null)
            throw new globalThis.Error("The parameter 'encodedQuoteId' must be defined and cannot be null.");
        else
            url_ += "encodedQuoteId=" + encodeURIComponent("" + encodedQuoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteWorkOrder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendQuoteCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendQuoteCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendQuoteCreation(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendNeighborPermissionRequest(neighborPermission: NeighborPermissionDTO): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendNeighborPermissionRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(neighborPermission);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNeighborPermissionRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNeighborPermissionRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendNeighborPermissionRequest(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendCustomerNeighborSignedEmail(quoteWorkOrder: QuoteWorkOrder, neighhborPermissionId: number, encodedCustId: string, encodedQuoteId: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendCustomerNeighborSignedEmail?";
        if (neighhborPermissionId === undefined || neighhborPermissionId === null)
            throw new globalThis.Error("The parameter 'neighhborPermissionId' must be defined and cannot be null.");
        else
            url_ += "neighhborPermissionId=" + encodeURIComponent("" + neighhborPermissionId) + "&";
        if (encodedCustId === undefined || encodedCustId === null)
            throw new globalThis.Error("The parameter 'encodedCustId' must be defined and cannot be null.");
        else
            url_ += "encodedCustId=" + encodeURIComponent("" + encodedCustId) + "&";
        if (encodedQuoteId === undefined || encodedQuoteId === null)
            throw new globalThis.Error("The parameter 'encodedQuoteId' must be defined and cannot be null.");
        else
            url_ += "encodedQuoteId=" + encodeURIComponent("" + encodedQuoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteWorkOrder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendCustomerNeighborSignedEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCustomerNeighborSignedEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendCustomerNeighborSignedEmail(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendQuoteAcceptance(quoteWorkOrder: QuoteWorkOrder, encodedCustId: string, encodedQuoteId: string, addCustomerMessage: boolean): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendQuoteAcceptance?";
        if (encodedCustId === undefined || encodedCustId === null)
            throw new globalThis.Error("The parameter 'encodedCustId' must be defined and cannot be null.");
        else
            url_ += "encodedCustId=" + encodeURIComponent("" + encodedCustId) + "&";
        if (encodedQuoteId === undefined || encodedQuoteId === null)
            throw new globalThis.Error("The parameter 'encodedQuoteId' must be defined and cannot be null.");
        else
            url_ += "encodedQuoteId=" + encodeURIComponent("" + encodedQuoteId) + "&";
        if (addCustomerMessage === undefined || addCustomerMessage === null)
            throw new globalThis.Error("The parameter 'addCustomerMessage' must be defined and cannot be null.");
        else
            url_ += "addCustomerMessage=" + encodeURIComponent("" + addCustomerMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteWorkOrder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendQuoteAcceptance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendQuoteAcceptance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendQuoteAcceptance(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendWorkOrdersScheduledByScheduledBucket(scheduledBucketIds: number[]): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendWorkOrdersScheduledByScheduledBucket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduledBucketIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWorkOrdersScheduledByScheduledBucket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWorkOrdersScheduledByScheduledBucket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendWorkOrdersScheduledByScheduledBucket(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendWorkOrdersScheduledBySubrange(subrangeIds: number[]): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendWorkOrderScheduledBySubrange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subrangeIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWorkOrdersScheduledBySubrange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWorkOrdersScheduledBySubrange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendWorkOrdersScheduledBySubrange(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendWellnessWorkOrderUnableToComplete(wellnessWorkOrder: WellnessWorkOrder, message: string, foreman: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendWellnessWorkOrderUnableToComplete?";
        if (message === undefined || message === null)
            throw new globalThis.Error("The parameter 'message' must be defined and cannot be null.");
        else
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (foreman === undefined || foreman === null)
            throw new globalThis.Error("The parameter 'foreman' must be defined and cannot be null.");
        else
            url_ += "foreman=" + encodeURIComponent("" + foreman) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wellnessWorkOrder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWellnessWorkOrderUnableToComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWellnessWorkOrderUnableToComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendWellnessWorkOrderUnableToComplete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendWorkWorkOrderUnableToComplete(workWorkOrder: WorkWorkOrder, message: string, foreman: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendWorkWorkOrderUnableToComplete?";
        if (message === undefined || message === null)
            throw new globalThis.Error("The parameter 'message' must be defined and cannot be null.");
        else
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (foreman === undefined || foreman === null)
            throw new globalThis.Error("The parameter 'foreman' must be defined and cannot be null.");
        else
            url_ += "foreman=" + encodeURIComponent("" + foreman) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workWorkOrder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWorkWorkOrderUnableToComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWorkWorkOrderUnableToComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendWorkWorkOrderUnableToComplete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendAnytimeOnWayNotification(quoteRequestId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendAnytimeOnWayNotification?";
        if (quoteRequestId === undefined || quoteRequestId === null)
            throw new globalThis.Error("The parameter 'quoteRequestId' must be defined and cannot be null.");
        else
            url_ += "quoteRequestId=" + encodeURIComponent("" + quoteRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAnytimeOnWayNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAnytimeOnWayNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendAnytimeOnWayNotification(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendFirmtimeOnWayNotification(quoteRequestId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendFirmtimeOnWayNotification?";
        if (quoteRequestId === undefined || quoteRequestId === null)
            throw new globalThis.Error("The parameter 'quoteRequestId' must be defined and cannot be null.");
        else
            url_ += "quoteRequestId=" + encodeURIComponent("" + quoteRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendFirmtimeOnWayNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendFirmtimeOnWayNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendFirmtimeOnWayNotification(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendWellnessWorkOrderOnWayNotification(wellnessWorkOrderId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendWellnessWorkOrderOnWayNotification?";
        if (wellnessWorkOrderId === undefined || wellnessWorkOrderId === null)
            throw new globalThis.Error("The parameter 'wellnessWorkOrderId' must be defined and cannot be null.");
        else
            url_ += "wellnessWorkOrderId=" + encodeURIComponent("" + wellnessWorkOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWellnessWorkOrderOnWayNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWellnessWorkOrderOnWayNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendWellnessWorkOrderOnWayNotification(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendWorkWorkOrderOnWayNotification(workWorkOrderId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendWorkWorkOrderOnWayNotification?";
        if (workWorkOrderId === undefined || workWorkOrderId === null)
            throw new globalThis.Error("The parameter 'workWorkOrderId' must be defined and cannot be null.");
        else
            url_ += "workWorkOrderId=" + encodeURIComponent("" + workWorkOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWorkWorkOrderOnWayNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWorkWorkOrderOnWayNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendWorkWorkOrderOnWayNotification(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendWellnessWorkOrderWrappingUpNotification(wellnessWorkOrderId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendWellnessWorkOrderWrappingUpNotification?";
        if (wellnessWorkOrderId === undefined || wellnessWorkOrderId === null)
            throw new globalThis.Error("The parameter 'wellnessWorkOrderId' must be defined and cannot be null.");
        else
            url_ += "wellnessWorkOrderId=" + encodeURIComponent("" + wellnessWorkOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWellnessWorkOrderWrappingUpNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWellnessWorkOrderWrappingUpNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendWellnessWorkOrderWrappingUpNotification(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sendWorkWorkOrderWrappingUpNotification(workWorkOrderId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/notifications/SendWorkWorkOrderWrappingUpNotification?";
        if (workWorkOrderId === undefined || workWorkOrderId === null)
            throw new globalThis.Error("The parameter 'workWorkOrderId' must be defined and cannot be null.");
        else
            url_ += "workWorkOrderId=" + encodeURIComponent("" + workWorkOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWorkWorkOrderWrappingUpNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWorkWorkOrderWrappingUpNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSendWorkWorkOrderWrappingUpNotification(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationTemplateGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(): Observable<NotificationTemplateDTO[]> {
        let url_ = this.baseUrl + "/api/v1/notificationTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationTemplateDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationTemplateDTO[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NotificationTemplateDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationTemplateDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getById(id: number): Observable<NotificationTemplateDTO> {
        let url_ = this.baseUrl + "/api/v1/notificationTemplates/GetById?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationTemplateDTO>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<NotificationTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(template: NotificationTemplateDTO): Observable<NotificationTemplateDTO> {
        let url_ = this.baseUrl + "/api/v1/notificationTemplates/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(template);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationTemplateDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationTemplateDTO>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NotificationTemplateDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationTemplateDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentDueOptionGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<PaymentDueOption> {
        let url_ = this.baseUrl + "/api/v1/paymentOptions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentDueOption>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentDueOption>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PaymentDueOption> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentDueOption.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<PaymentDueOption[]> {
        let url_ = this.baseUrl + "/api/v1/paymentOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentDueOption[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentDueOption[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaymentDueOption[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentDueOption.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PesticideApplicationRecordGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<PesticideApplicationRecord> {
        let url_ = this.baseUrl + "/api/v1/pesticideAppRecords/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesticideApplicationRecord>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesticideApplicationRecord>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PesticideApplicationRecord> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PesticideApplicationRecord.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(record: PesticideApplicationRecord, id: string): Observable<PesticideApplicationRecord> {
        let url_ = this.baseUrl + "/api/v1/pesticideAppRecords/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesticideApplicationRecord>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesticideApplicationRecord>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PesticideApplicationRecord> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PesticideApplicationRecord.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/pesticideAppRecords/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<PesticideApplicationRecord[]> {
        let url_ = this.baseUrl + "/api/v1/pesticideAppRecords";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PesticideApplicationRecord[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PesticideApplicationRecord[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PesticideApplicationRecord[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PesticideApplicationRecord.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(record: PesticideApplicationRecord): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/pesticideAppRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PriorityLevelGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<PriorityLevel> {
        let url_ = this.baseUrl + "/api/v1/priorityLevels/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorityLevel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorityLevel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PriorityLevel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriorityLevel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(priority: PriorityLevel, id: string): Observable<PriorityLevel> {
        let url_ = this.baseUrl + "/api/v1/priorityLevels/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(priority);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorityLevel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorityLevel>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PriorityLevel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriorityLevel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/priorityLevels/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<PriorityLevel[]> {
        let url_ = this.baseUrl + "/api/v1/priorityLevels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorityLevel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorityLevel[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PriorityLevel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriorityLevel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(priority: PriorityLevel): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/priorityLevels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(priority);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PriorityTypeShortcutGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    getAll(): Observable<PriorityTypeShortcut[]> {
        let url_ = this.baseUrl + "/api/v1/priorityTypeShortcuts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorityTypeShortcut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorityTypeShortcut[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PriorityTypeShortcut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriorityTypeShortcut.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentBacklog(): Observable<PriorityTypeShortcut> {
        let url_ = this.baseUrl + "/api/v1/priorityTypeShortcuts/getBacklog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentBacklog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentBacklog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorityTypeShortcut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorityTypeShortcut>;
        }));
    }

    protected processGetCurrentBacklog(response: HttpResponseBase): Observable<PriorityTypeShortcut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PriorityTypeShortcut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentBacklogs(): Observable<PriorityTypeShortcut[]> {
        let url_ = this.baseUrl + "/api/v1/priorityTypeShortcuts/getBacklogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentBacklogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentBacklogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PriorityTypeShortcut[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PriorityTypeShortcut[]>;
        }));
    }

    protected processGetCurrentBacklogs(response: HttpResponseBase): Observable<PriorityTypeShortcut[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PriorityTypeShortcut.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateBackLog(id: number, weeksOutStart: number, weeksOutEnd: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/priorityTypeShortcuts/updateBacklog?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (weeksOutStart === undefined || weeksOutStart === null)
            throw new globalThis.Error("The parameter 'weeksOutStart' must be defined and cannot be null.");
        else
            url_ += "weeksOutStart=" + encodeURIComponent("" + weeksOutStart) + "&";
        if (weeksOutEnd === undefined || weeksOutEnd === null)
            throw new globalThis.Error("The parameter 'weeksOutEnd' must be defined and cannot be null.");
        else
            url_ += "weeksOutEnd=" + encodeURIComponent("" + weeksOutEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBackLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBackLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateBackLog(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QuoteGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(quote: QuoteWorkOrder, id: string): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/quotes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<QuoteWorkOrder[]> {
        let url_ = this.baseUrl + "/api/v1/quotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<QuoteWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(quote: QuoteWorkOrder): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAnon(id: number): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes/getAnon?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processGetAnon(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAnonForOneClick(id: number): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes/getAnonForOneClick?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAnonForOneClick(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAnonForOneClick(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processGetAnonForOneClick(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPaginated(advancedFilters: AdvancedWorkOrderFilter): Observable<PagedResultsForInvoicingOfWorkOrderListView> {
        let url_ = this.baseUrl + "/api/v1/quotes/getPaginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedFilters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsForInvoicingOfWorkOrderListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsForInvoicingOfWorkOrderListView>;
        }));
    }

    protected processGetPaginated(response: HttpResponseBase): Observable<PagedResultsForInvoicingOfWorkOrderListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsForInvoicingOfWorkOrderListView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    duplicateWellnessToQuote(baseWellnessWOId: number, autoRenewal: boolean): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/quotes/DuplicateWellnessToQuote?";
        if (baseWellnessWOId === undefined || baseWellnessWOId === null)
            throw new globalThis.Error("The parameter 'baseWellnessWOId' must be defined and cannot be null.");
        else
            url_ += "baseWellnessWOId=" + encodeURIComponent("" + baseWellnessWOId) + "&";
        if (autoRenewal === undefined || autoRenewal === null)
            throw new globalThis.Error("The parameter 'autoRenewal' must be defined and cannot be null.");
        else
            url_ += "autoRenewal=" + encodeURIComponent("" + autoRenewal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateWellnessToQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateWellnessToQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDuplicateWellnessToQuote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    duplicateWorkToQuote(baseWorkWOId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/quotes/DuplicateWorkToQuote?";
        if (baseWorkWOId === undefined || baseWorkWOId === null)
            throw new globalThis.Error("The parameter 'baseWorkWOId' must be defined and cannot be null.");
        else
            url_ += "baseWorkWOId=" + encodeURIComponent("" + baseWorkWOId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDuplicateWorkToQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDuplicateWorkToQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDuplicateWorkToQuote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    markAsSigned(dto: Dto): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/quotes/MarkAsSigned";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsSigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsSigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processMarkAsSigned(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateQuoteAndTasks(quote: QuoteWorkOrder): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes/UpdateQuoteAndTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuoteAndTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuoteAndTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processUpdateQuoteAndTasks(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    resetQuote(quoteId: number): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes/resetQuote?";
        if (quoteId === undefined || quoteId === null)
            throw new globalThis.Error("The parameter 'quoteId' must be defined and cannot be null.");
        else
            url_ += "quoteId=" + encodeURIComponent("" + quoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processResetQuote(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    convertToWorkOrders(quote: QuoteWorkOrder, wellnessIdsCSV: string, workIdsCSV: string): Observable<WorkOrdersCreatedDTO> {
        let url_ = this.baseUrl + "/api/v1/quotes/convertToWorkOrders?";
        if (wellnessIdsCSV === undefined || wellnessIdsCSV === null)
            throw new globalThis.Error("The parameter 'wellnessIdsCSV' must be defined and cannot be null.");
        else
            url_ += "wellnessIdsCSV=" + encodeURIComponent("" + wellnessIdsCSV) + "&";
        if (workIdsCSV === undefined || workIdsCSV === null)
            throw new globalThis.Error("The parameter 'workIdsCSV' must be defined and cannot be null.");
        else
            url_ += "workIdsCSV=" + encodeURIComponent("" + workIdsCSV) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quote);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToWorkOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToWorkOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrdersCreatedDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrdersCreatedDTO>;
        }));
    }

    protected processConvertToWorkOrders(response: HttpResponseBase): Observable<WorkOrdersCreatedDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrdersCreatedDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setQuoteToReviewed(id: number): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes/setQuoteToReviewed?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetQuoteToReviewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetQuoteToReviewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processSetQuoteToReviewed(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    reactivateQuote(id: number): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quotes/ReactivateQuote?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReactivateQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReactivateQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processReactivateQuote(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QuoteAndAuthenticationGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    addQuoteAndCustomer(quoteRequest: QuoteRequest): Observable<QuoteRequest> {
        let url_ = this.baseUrl + "/api/v1/quoteAndAuthentication/AddQuoteAndCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQuoteAndCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQuoteAndCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest>;
        }));
    }

    protected processAddQuoteAndCustomer(response: HttpResponseBase): Observable<QuoteRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addQuote(quoteRequest: QuoteRequest): Observable<QuoteRequest> {
        let url_ = this.baseUrl + "/api/v1/quoteAndAuthentication/AddQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest>;
        }));
    }

    protected processAddQuote(response: HttpResponseBase): Observable<QuoteRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateQuote(quoteRequest: QuoteRequest): Observable<QuoteRequest> {
        let url_ = this.baseUrl + "/api/v1/quoteAndAuthentication/UpdateQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest>;
        }));
    }

    protected processUpdateQuote(response: HttpResponseBase): Observable<QuoteRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class QuoteRequestGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<QuoteRequest> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<QuoteRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(quoteRequest: QuoteRequest, id: string): Observable<QuoteRequest> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<QuoteRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<QuoteRequest[]> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<QuoteRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPaginated(skip: number, take: number, includeInactive: boolean, sortOption: SortOption2, globalFilter: string): Observable<PagedResultOfQuoteRequestListView> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/getPaginated?";
        if (skip === undefined || skip === null)
            throw new globalThis.Error("The parameter 'skip' must be defined and cannot be null.");
        else
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === undefined || take === null)
            throw new globalThis.Error("The parameter 'take' must be defined and cannot be null.");
        else
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (includeInactive === undefined || includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' must be defined and cannot be null.");
        else
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (sortOption === undefined || sortOption === null)
            throw new globalThis.Error("The parameter 'sortOption' must be defined and cannot be null.");
        else
            url_ += "sortOption=" + encodeURIComponent("" + sortOption) + "&";
        if (globalFilter === undefined || globalFilter === null)
            throw new globalThis.Error("The parameter 'globalFilter' must be defined and cannot be null.");
        else
            url_ += "globalFilter=" + encodeURIComponent("" + globalFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfQuoteRequestListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfQuoteRequestListView>;
        }));
    }

    protected processGetPaginated(response: HttpResponseBase): Observable<PagedResultOfQuoteRequestListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfQuoteRequestListView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getActive(): Observable<QuoteRequest[]> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/getactive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest[]>;
        }));
    }

    protected processGetActive(response: HttpResponseBase): Observable<QuoteRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllRequestsInDateRangeForRM(empId: number, startDate: Date, endDate: Date): Observable<QuoteRequest[]> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/getAllRequestsInDateRangeForRM?";
        if (empId === undefined || empId === null)
            throw new globalThis.Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequestsInDateRangeForRM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequestsInDateRangeForRM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest[]>;
        }));
    }

    protected processGetAllRequestsInDateRangeForRM(response: HttpResponseBase): Observable<QuoteRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllRequestsInDateRangeForRMs(request: RegionalManagerDateRangeRequest): Observable<QuoteRequest[]> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/getAllRequestsInDateRangeForRMs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRequestsInDateRangeForRMs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequestsInDateRangeForRMs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest[]>;
        }));
    }

    protected processGetAllRequestsInDateRangeForRMs(response: HttpResponseBase): Observable<QuoteRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getSchedulableAnytimeRequestsForRM(id: number): Observable<QuoteRequest[]> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/getSchedulableAnytimeRequestsForRM?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchedulableAnytimeRequestsForRM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchedulableAnytimeRequestsForRM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest[]>;
        }));
    }

    protected processGetSchedulableAnytimeRequestsForRM(response: HttpResponseBase): Observable<QuoteRequest[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuoteRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateStartOrEnd(quoteRequestScheduleUpdate: QuoteRequestScheduleUpdate, id: string): Observable<QuoteRequest> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/updateStartOrEnd/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequestScheduleUpdate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStartOrEnd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStartOrEnd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest>;
        }));
    }

    protected processUpdateStartOrEnd(response: HttpResponseBase): Observable<QuoteRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unscheduleById(id: number): Observable<QuoteRequest> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/unscheduleById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnscheduleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnscheduleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteRequest>;
        }));
    }

    protected processUnscheduleById(response: HttpResponseBase): Observable<QuoteRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    convertToQuote(quoteRequest: QuoteRequest): Observable<QuoteWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/quoteRequests/convertToQuote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quoteRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertToQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteWorkOrder>;
        }));
    }

    protected processConvertToQuote(response: HttpResponseBase): Observable<QuoteWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RegionalManagerScheduleEventGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    add(scheduleEvent: RegionalManagerScheduleEvent): Observable<RegionalManagerScheduleEvent> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerScheduleEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleEvent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionalManagerScheduleEvent>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionalManagerScheduleEvent>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<RegionalManagerScheduleEvent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionalManagerScheduleEvent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEventsInDateRangeForRM(empId: number, startDate: Date, endDate: Date): Observable<RegionalManagerScheduleEvent[]> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerScheduleEvent/getAllEventsInDateRangeForRM?";
        if (empId === undefined || empId === null)
            throw new globalThis.Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEventsInDateRangeForRM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEventsInDateRangeForRM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionalManagerScheduleEvent[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionalManagerScheduleEvent[]>;
        }));
    }

    protected processGetAllEventsInDateRangeForRM(response: HttpResponseBase): Observable<RegionalManagerScheduleEvent[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionalManagerScheduleEvent.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllEventsInDateRangeForRMs(request: RegionalManagerDateRangeRequest): Observable<RegionalManagerScheduleEvent[]> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerScheduleEvent/getAllEventsInDateRangeForRMs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEventsInDateRangeForRMs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEventsInDateRangeForRMs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionalManagerScheduleEvent[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionalManagerScheduleEvent[]>;
        }));
    }

    protected processGetAllEventsInDateRangeForRMs(response: HttpResponseBase): Observable<RegionalManagerScheduleEvent[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionalManagerScheduleEvent.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllCustomerIssueWorkOrdersForRM(empId: number): Observable<IWorkOrder[]> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerScheduleEvent/getAllCustomerIssueWorkOrdersForRM?";
        if (empId === undefined || empId === null)
            throw new globalThis.Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustomerIssueWorkOrdersForRM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomerIssueWorkOrdersForRM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IWorkOrder[]>;
        }));
    }

    protected processGetAllCustomerIssueWorkOrdersForRM(response: HttpResponseBase): Observable<IWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(scheduleEvent: RegionalManagerScheduleEvent, id: string): Observable<RegionalManagerScheduleEvent> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerScheduleEvent/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleEvent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionalManagerScheduleEvent>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionalManagerScheduleEvent>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RegionalManagerScheduleEvent> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionalManagerScheduleEvent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(scheduleEvent: RegionalManagerScheduleEvent, id: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerScheduleEvent/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleEvent);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteById(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerScheduleEvent/deleteById/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RegionalManagerTimeSlotGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    add(timeSlot: RegionalManagerTimeSlot): Observable<RegionalManagerTimeSlot> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerTimeSlot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeSlot);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionalManagerTimeSlot>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionalManagerTimeSlot>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<RegionalManagerTimeSlot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionalManagerTimeSlot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(timeSlot: RegionalManagerTimeSlot, id: string): Observable<RegionalManagerTimeSlot> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerTimeSlot/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeSlot);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionalManagerTimeSlot>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionalManagerTimeSlot>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RegionalManagerTimeSlot> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegionalManagerTimeSlot.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(timeSlot: RegionalManagerTimeSlot, id: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/regionalManagerTimeSlot/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeSlot);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    startARReport(advancedFilters: AdvancedAccountsReceivableFilter): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/reports/StartARReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedFilters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartARReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartARReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processStartARReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getReportTiles(): Observable<ReportTileViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/GetReportTiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportTiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportTiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTileViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTileViewModel[]>;
        }));
    }

    protected processGetReportTiles(response: HttpResponseBase): Observable<ReportTileViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportTileViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getEmployeeAssignedReports(employeeId: number): Observable<ReportTileViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/GetEmployeeAssignedReports?";
        if (employeeId === undefined || employeeId === null)
            throw new globalThis.Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeAssignedReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTileViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTileViewModel[]>;
        }));
    }

    protected processGetEmployeeAssignedReports(response: HttpResponseBase): Observable<ReportTileViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportTileViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRoleAssignedReports(roleId: number): Observable<ReportTileRoleDefaultViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/GetRoleAssignedReports?";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined and cannot be null.");
        else
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleAssignedReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTileRoleDefaultViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTileRoleDefaultViewModel[]>;
        }));
    }

    protected processGetRoleAssignedReports(response: HttpResponseBase): Observable<ReportTileRoleDefaultViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportTileRoleDefaultViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getRolesAssignedReports(roleIds: number[]): Observable<ReportTileRoleDefaultViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/GetRolesAssignedReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesAssignedReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesAssignedReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTileRoleDefaultViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTileRoleDefaultViewModel[]>;
        }));
    }

    protected processGetRolesAssignedReports(response: HttpResponseBase): Observable<ReportTileRoleDefaultViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportTileRoleDefaultViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addRoleAssignedReport(roleId: number, reportTileId: number): Observable<ReportTileRoleDefaultViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/AddRoleAssignedReport?";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined and cannot be null.");
        else
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (reportTileId === undefined || reportTileId === null)
            throw new globalThis.Error("The parameter 'reportTileId' must be defined and cannot be null.");
        else
            url_ += "reportTileId=" + encodeURIComponent("" + reportTileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRoleAssignedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRoleAssignedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTileRoleDefaultViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTileRoleDefaultViewModel[]>;
        }));
    }

    protected processAddRoleAssignedReport(response: HttpResponseBase): Observable<ReportTileRoleDefaultViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportTileRoleDefaultViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteRoleAssignedReport(roleId: number, reportTileId: number): Observable<ReportTileRoleDefaultViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/DeleteRoleAssignedReport?";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined and cannot be null.");
        else
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        if (reportTileId === undefined || reportTileId === null)
            throw new globalThis.Error("The parameter 'reportTileId' must be defined and cannot be null.");
        else
            url_ += "reportTileId=" + encodeURIComponent("" + reportTileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRoleAssignedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRoleAssignedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportTileRoleDefaultViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportTileRoleDefaultViewModel[]>;
        }));
    }

    protected processDeleteRoleAssignedReport(response: HttpResponseBase): Observable<ReportTileRoleDefaultViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportTileRoleDefaultViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCompletedPaidTotals(request: ReportWithDatesRequest): Observable<SalesTotalsViewModel> {
        let url_ = this.baseUrl + "/api/v1/reports/GetCompletedPaidTotals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompletedPaidTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompletedPaidTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTotalsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTotalsViewModel>;
        }));
    }

    protected processGetCompletedPaidTotals(response: HttpResponseBase): Observable<SalesTotalsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesTotalsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCustomerIssues(request: ReportWithDatesRequest): Observable<CustomerIssuesViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/GetCustomerIssues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerIssues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerIssues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerIssuesViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerIssuesViewModel[]>;
        }));
    }

    protected processGetCustomerIssues(response: HttpResponseBase): Observable<CustomerIssuesViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerIssuesViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getQuoteStats(request: ReportWithDatesRequest): Observable<QuoteStatsViewModel> {
        let url_ = this.baseUrl + "/api/v1/reports/GetQuoteStats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetQuoteStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuoteStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuoteStatsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuoteStatsViewModel>;
        }));
    }

    protected processGetQuoteStats(response: HttpResponseBase): Observable<QuoteStatsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuoteStatsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPastDue(request: ReportWithDatesRequest): Observable<PastDueGrouping> {
        let url_ = this.baseUrl + "/api/v1/reports/GetPastDue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPastDue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPastDue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PastDueGrouping>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PastDueGrouping>;
        }));
    }

    protected processGetPastDue(response: HttpResponseBase): Observable<PastDueGrouping> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PastDueGrouping.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getBacklogTotals(request: ReportWithDatesRequest): Observable<SalesTotalsViewModel> {
        let url_ = this.baseUrl + "/api/v1/reports/GetBacklogTotals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBacklogTotals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBacklogTotals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesTotalsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesTotalsViewModel>;
        }));
    }

    protected processGetBacklogTotals(response: HttpResponseBase): Observable<SalesTotalsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesTotalsViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCommissionLost(request: ReportWithDatesRequest): Observable<WorkOrderCommissionViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/GetCommissionLost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommissionLost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommissionLost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderCommissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderCommissionViewModel[]>;
        }));
    }

    protected processGetCommissionLost(response: HttpResponseBase): Observable<WorkOrderCommissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkOrderCommissionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWorkAverage(request: WorkAverageRequest): Observable<WorkHourAverageViewModel> {
        let url_ = this.baseUrl + "/api/v1/reports/GetWorkAverage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkAverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkAverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkHourAverageViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkHourAverageViewModel>;
        }));
    }

    protected processGetWorkAverage(response: HttpResponseBase): Observable<WorkHourAverageViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkHourAverageViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    checkARReportStatus(jobId: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/reports/GetARReportStatus?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckARReportStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckARReportStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processCheckARReportStatus(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getARResultsFromJob(jobId: string): Observable<PagedResultOfAccountsReceivableViewModel> {
        let url_ = this.baseUrl + "/api/v1/reports/GetARResultsFromJob?";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined and cannot be null.");
        else
            url_ += "jobId=" + encodeURIComponent("" + jobId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetARResultsFromJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetARResultsFromJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultOfAccountsReceivableViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultOfAccountsReceivableViewModel>;
        }));
    }

    protected processGetARResultsFromJob(response: HttpResponseBase): Observable<PagedResultOfAccountsReceivableViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfAccountsReceivableViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCommissionReportPaginated(advancedFilters: AdvancedCommissionFilter): Observable<PagedResultsForCommissionOfWorkOrderCommissionViewModel> {
        let url_ = this.baseUrl + "/api/v1/reports/getCommissionReportPaginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedFilters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommissionReportPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommissionReportPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsForCommissionOfWorkOrderCommissionViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsForCommissionOfWorkOrderCommissionViewModel>;
        }));
    }

    protected processGetCommissionReportPaginated(response: HttpResponseBase): Observable<PagedResultsForCommissionOfWorkOrderCommissionViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsForCommissionOfWorkOrderCommissionViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCommissionReportForExport(advancedFilters: AdvancedCommissionFilter): Observable<WorkOrderCommissionViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/reports/getCommissionReportForExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedFilters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommissionReportForExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommissionReportForExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderCommissionViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderCommissionViewModel[]>;
        }));
    }

    protected processGetCommissionReportForExport(response: HttpResponseBase): Observable<WorkOrderCommissionViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkOrderCommissionViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCurrentWorkBacklogs(): Observable<CurrentWorkBacklog[]> {
        let url_ = this.baseUrl + "/api/v1/reports/getCurrentWorkBacklog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentWorkBacklogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentWorkBacklogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentWorkBacklog[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentWorkBacklog[]>;
        }));
    }

    protected processGetCurrentWorkBacklogs(response: HttpResponseBase): Observable<CurrentWorkBacklog[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurrentWorkBacklog.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<Role> {
        let url_ = this.baseUrl + "/api/v1/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Role>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Role>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Role> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Role.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<Role[]> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Role[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Role[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Role[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Role.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScheduleCommentGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<ScheduleComment> {
        let url_ = this.baseUrl + "/api/v1/scheduleComments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleComment>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ScheduleComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(scheduleComment: ScheduleComment, id: string): Observable<ScheduleComment> {
        let url_ = this.baseUrl + "/api/v1/scheduleComments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleComment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleComment>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ScheduleComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ScheduleComment[]> {
        let url_ = this.baseUrl + "/api/v1/scheduleComments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleComment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleComment[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ScheduleComment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleComment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(scheduleComment: ScheduleComment): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduleComments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleComment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScheduledBucketGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<ScheduledBucketDTO> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ScheduledBucketDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledBucketDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ScheduledBucketDTO[]> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ScheduledBucketDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledBucketDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(scheduledBucketParam: ScheduledBucketAddDTO): Observable<ScheduledBucketDTO> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduledBucketParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ScheduledBucketDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledBucketDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWellnessScheduledBucketsInDateRange(startDate: Date, endDate: Date): Observable<ScheduledBucketDTO[]> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/getAllWellnessScheduledBucketsInDateRange?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWellnessScheduledBucketsInDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWellnessScheduledBucketsInDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO[]>;
        }));
    }

    protected processGetAllWellnessScheduledBucketsInDateRange(response: HttpResponseBase): Observable<ScheduledBucketDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledBucketDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllWorkScheduledBucketsInDateRange(startDate: Date, endDate: Date): Observable<ScheduledBucketDTO[]> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/getAllWorkScheduledBucketsInDateRange?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkScheduledBucketsInDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkScheduledBucketsInDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO[]>;
        }));
    }

    protected processGetAllWorkScheduledBucketsInDateRange(response: HttpResponseBase): Observable<ScheduledBucketDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledBucketDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllScheduledBucketsInDateRange(startDate: Date, endDate: Date): Observable<ScheduledBucketDTO[]> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/getAllScheduledBucketsInDateRange?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScheduledBucketsInDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScheduledBucketsInDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO[]>;
        }));
    }

    protected processGetAllScheduledBucketsInDateRange(response: HttpResponseBase): Observable<ScheduledBucketDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledBucketDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllScheduledBucketsInDateRangeForAUser(empId: number, startDate: Date, endDate: Date): Observable<ScheduledBucketDTO[]> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/getAllScheduledBucketsInDateRangeForAUser?";
        if (empId === undefined || empId === null)
            throw new globalThis.Error("The parameter 'empId' must be defined and cannot be null.");
        else
            url_ += "empId=" + encodeURIComponent("" + empId) + "&";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScheduledBucketsInDateRangeForAUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScheduledBucketsInDateRangeForAUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO[]>;
        }));
    }

    protected processGetAllScheduledBucketsInDateRangeForAUser(response: HttpResponseBase): Observable<ScheduledBucketDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledBucketDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addEmployeeToBucket(employeeId: number, bucketId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/AddEmployeeToBucket?";
        if (employeeId === undefined || employeeId === null)
            throw new globalThis.Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEmployeeToBucket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEmployeeToBucket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddEmployeeToBucket(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    moveEmployeeToAnotherBucket(id: number, newBucketId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/MoveEmployeeToAnotherBucket?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newBucketId === undefined || newBucketId === null)
            throw new globalThis.Error("The parameter 'newBucketId' must be defined and cannot be null.");
        else
            url_ += "newBucketId=" + encodeURIComponent("" + newBucketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEmployeeToAnotherBucket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEmployeeToAnotherBucket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processMoveEmployeeToAnotherBucket(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    removeEmployeeFromBucket(employeeId: number, bucketId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/RemoveEmployeeFromBucket?";
        if (employeeId === undefined || employeeId === null)
            throw new globalThis.Error("The parameter 'employeeId' must be defined and cannot be null.");
        else
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEmployeeFromBucket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEmployeeFromBucket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRemoveEmployeeFromBucket(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addEquipmentToBucket(equipmentId: number, bucketId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/AddEquipmentToBucket?";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined and cannot be null.");
        else
            url_ += "equipmentId=" + encodeURIComponent("" + equipmentId) + "&";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEquipmentToBucket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEquipmentToBucket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddEquipmentToBucket(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    moveEquipmentToAnotherBucket(id: number, newBucketId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/MoveEquipmentToAnotherBucket?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (newBucketId === undefined || newBucketId === null)
            throw new globalThis.Error("The parameter 'newBucketId' must be defined and cannot be null.");
        else
            url_ += "newBucketId=" + encodeURIComponent("" + newBucketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveEquipmentToAnotherBucket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveEquipmentToAnotherBucket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processMoveEquipmentToAnotherBucket(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    removeEquipmentFromBucket(equipmentId: number, bucketId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/RemoveEquipmentFromBucket?";
        if (equipmentId === undefined || equipmentId === null)
            throw new globalThis.Error("The parameter 'equipmentId' must be defined and cannot be null.");
        else
            url_ += "equipmentId=" + encodeURIComponent("" + equipmentId) + "&";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEquipmentFromBucket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEquipmentFromBucket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRemoveEquipmentFromBucket(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rescheduleBucket(bucketId: number, newIndex: number, startOfDay: Date): Observable<ScheduledBucketDTO> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/RescheduleBucket?";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        if (newIndex === undefined || newIndex === null)
            throw new globalThis.Error("The parameter 'newIndex' must be defined and cannot be null.");
        else
            url_ += "newIndex=" + encodeURIComponent("" + newIndex) + "&";
        if (startOfDay === undefined || startOfDay === null)
            throw new globalThis.Error("The parameter 'startOfDay' must be defined and cannot be null.");
        else
            url_ += "startOfDay=" + encodeURIComponent(startOfDay ? "" + startOfDay.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleBucket(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleBucket(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO>;
        }));
    }

    protected processRescheduleBucket(response: HttpResponseBase): Observable<ScheduledBucketDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledBucketDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateBucketOrdering(bucketId: number, newIndex: number, startOfDay: Date): Observable<ScheduledBucketDTO> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/UpdateBucketOrdering?";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        if (newIndex === undefined || newIndex === null)
            throw new globalThis.Error("The parameter 'newIndex' must be defined and cannot be null.");
        else
            url_ += "newIndex=" + encodeURIComponent("" + newIndex) + "&";
        if (startOfDay === undefined || startOfDay === null)
            throw new globalThis.Error("The parameter 'startOfDay' must be defined and cannot be null.");
        else
            url_ += "startOfDay=" + encodeURIComponent(startOfDay ? "" + startOfDay.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBucketOrdering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBucketOrdering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledBucketDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledBucketDTO>;
        }));
    }

    protected processUpdateBucketOrdering(response: HttpResponseBase): Observable<ScheduledBucketDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledBucketDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rescheduleWellnessWorkOrder(woId: number, oldBucketId: number, newBucketId: number, newIndex: number, startOfDay: Date): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/RescheduleWellnessWorkOrder?";
        if (woId === undefined || woId === null)
            throw new globalThis.Error("The parameter 'woId' must be defined and cannot be null.");
        else
            url_ += "woId=" + encodeURIComponent("" + woId) + "&";
        if (oldBucketId === undefined || oldBucketId === null)
            throw new globalThis.Error("The parameter 'oldBucketId' must be defined and cannot be null.");
        else
            url_ += "oldBucketId=" + encodeURIComponent("" + oldBucketId) + "&";
        if (newBucketId === undefined || newBucketId === null)
            throw new globalThis.Error("The parameter 'newBucketId' must be defined and cannot be null.");
        else
            url_ += "newBucketId=" + encodeURIComponent("" + newBucketId) + "&";
        if (newIndex === undefined || newIndex === null)
            throw new globalThis.Error("The parameter 'newIndex' must be defined and cannot be null.");
        else
            url_ += "newIndex=" + encodeURIComponent("" + newIndex) + "&";
        if (startOfDay === undefined || startOfDay === null)
            throw new globalThis.Error("The parameter 'startOfDay' must be defined and cannot be null.");
        else
            url_ += "startOfDay=" + encodeURIComponent(startOfDay ? "" + startOfDay.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleWellnessWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleWellnessWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRescheduleWellnessWorkOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateWellnessWorkOrderOrdering(bucketId: number, woId: number, newIndex: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/UpdateWellnessWorkOrderOrdering?";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        if (woId === undefined || woId === null)
            throw new globalThis.Error("The parameter 'woId' must be defined and cannot be null.");
        else
            url_ += "woId=" + encodeURIComponent("" + woId) + "&";
        if (newIndex === undefined || newIndex === null)
            throw new globalThis.Error("The parameter 'newIndex' must be defined and cannot be null.");
        else
            url_ += "newIndex=" + encodeURIComponent("" + newIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWellnessWorkOrderOrdering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWellnessWorkOrderOrdering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdateWellnessWorkOrderOrdering(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    rescheduleWorkWorkOrder(woId: number, oldBucketId: number, newBucketId: number, newIndex: number, startOfDay: Date): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/RescheduleWorkWorkOrder?";
        if (woId === undefined || woId === null)
            throw new globalThis.Error("The parameter 'woId' must be defined and cannot be null.");
        else
            url_ += "woId=" + encodeURIComponent("" + woId) + "&";
        if (oldBucketId === undefined || oldBucketId === null)
            throw new globalThis.Error("The parameter 'oldBucketId' must be defined and cannot be null.");
        else
            url_ += "oldBucketId=" + encodeURIComponent("" + oldBucketId) + "&";
        if (newBucketId === undefined || newBucketId === null)
            throw new globalThis.Error("The parameter 'newBucketId' must be defined and cannot be null.");
        else
            url_ += "newBucketId=" + encodeURIComponent("" + newBucketId) + "&";
        if (newIndex === undefined || newIndex === null)
            throw new globalThis.Error("The parameter 'newIndex' must be defined and cannot be null.");
        else
            url_ += "newIndex=" + encodeURIComponent("" + newIndex) + "&";
        if (startOfDay === undefined || startOfDay === null)
            throw new globalThis.Error("The parameter 'startOfDay' must be defined and cannot be null.");
        else
            url_ += "startOfDay=" + encodeURIComponent(startOfDay ? "" + startOfDay.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleWorkWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleWorkWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRescheduleWorkWorkOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateWorkWorkOrderOrdering(bucketId: number, woId: number, newIndex: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/UpdateWorkWorkOrderOrdering?";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        if (woId === undefined || woId === null)
            throw new globalThis.Error("The parameter 'woId' must be defined and cannot be null.");
        else
            url_ += "woId=" + encodeURIComponent("" + woId) + "&";
        if (newIndex === undefined || newIndex === null)
            throw new globalThis.Error("The parameter 'newIndex' must be defined and cannot be null.");
        else
            url_ += "newIndex=" + encodeURIComponent("" + newIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWorkWorkOrderOrdering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWorkWorkOrderOrdering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdateWorkWorkOrderOrdering(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    scheduleTask(dto: ScheduleTaskDTO): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/ScheduleTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processScheduleTask(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteScheduledBucketWellnessWorkOrder(bucketId: number, wellnessWorkOrderId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/DeleteScheduledBucketWellnessWorkOrder?";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        if (wellnessWorkOrderId === undefined || wellnessWorkOrderId === null)
            throw new globalThis.Error("The parameter 'wellnessWorkOrderId' must be defined and cannot be null.");
        else
            url_ += "wellnessWorkOrderId=" + encodeURIComponent("" + wellnessWorkOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScheduledBucketWellnessWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScheduledBucketWellnessWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteScheduledBucketWellnessWorkOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    deleteScheduledBucketWorkWorkOrder(bucketId: number, workWorkOrderId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/scheduledBuckets/DeleteScheduledBucketWorkWorkOrder?";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        if (workWorkOrderId === undefined || workWorkOrderId === null)
            throw new globalThis.Error("The parameter 'workWorkOrderId' must be defined and cannot be null.");
        else
            url_ += "workWorkOrderId=" + encodeURIComponent("" + workWorkOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScheduledBucketWorkWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScheduledBucketWorkWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteScheduledBucketWorkWorkOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SkillGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<Skill> {
        let url_ = this.baseUrl + "/api/v1/skills/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Skill>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Skill>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Skill> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Skill.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(skill: Skill, id: string): Observable<Skill> {
        let url_ = this.baseUrl + "/api/v1/skills/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skill);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Skill>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Skill>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Skill> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Skill.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/skills/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<Skill[]> {
        let url_ = this.baseUrl + "/api/v1/skills";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Skill[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Skill[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Skill[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Skill.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(skill: Skill): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/skills";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(skill);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SMSResponseGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    onIncomingSMS(smsRequest: SmsRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/smsWebhook/onIncomingSMS";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(smsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnIncomingSMS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnIncomingSMS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processOnIncomingSMS(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StateGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<State> {
        let url_ = this.baseUrl + "/api/v1/states/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<State>;
                }
            } else
                return _observableThrow(response_) as any as Observable<State>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<State> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = State.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<State[]> {
        let url_ = this.baseUrl + "/api/v1/states";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<State[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<State[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<State[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(State.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StripeGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    addOrUpdateAndChargeFirmtimeRequest(request: ChargeFirmtimeRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/stripe/AddOrUpdateAndChargeFirmtimeRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateAndChargeFirmtimeRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAndChargeFirmtimeRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAddOrUpdateAndChargeFirmtimeRequest(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cardInfoNeeded (optional) 
     * @return OK
     */
    addOrUpdateAndApproveQuote(customerId: number, billingToken: string, stripeBilling: StripeBilling, quoteId: number, manualPay: boolean, cardInfoNeeded: boolean | null | undefined): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/stripe/AddOrUpdateAndApproveQuote?";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (billingToken === undefined || billingToken === null)
            throw new globalThis.Error("The parameter 'billingToken' must be defined and cannot be null.");
        else
            url_ += "billingToken=" + encodeURIComponent("" + billingToken) + "&";
        if (quoteId === undefined || quoteId === null)
            throw new globalThis.Error("The parameter 'quoteId' must be defined and cannot be null.");
        else
            url_ += "quoteId=" + encodeURIComponent("" + quoteId) + "&";
        if (manualPay === undefined || manualPay === null)
            throw new globalThis.Error("The parameter 'manualPay' must be defined and cannot be null.");
        else
            url_ += "manualPay=" + encodeURIComponent("" + manualPay) + "&";
        if (cardInfoNeeded !== undefined && cardInfoNeeded !== null)
            url_ += "cardInfoNeeded=" + encodeURIComponent("" + cardInfoNeeded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stripeBilling);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateAndApproveQuote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateAndApproveQuote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAddOrUpdateAndApproveQuote(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addOrUpdate(customerId: number, token: string, stripeBilling: StripeBilling, manualPayment: boolean): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/stripe/AddOrUpdate?";
        if (customerId === undefined || customerId === null)
            throw new globalThis.Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (manualPayment === undefined || manualPayment === null)
            throw new globalThis.Error("The parameter 'manualPayment' must be defined and cannot be null.");
        else
            url_ += "manualPayment=" + encodeURIComponent("" + manualPayment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stripeBilling);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllInvoicesForWorkOrder(workOrderId: number, type: string): Observable<InvoiceChargeViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/stripe/getAllInvoicesForWorkOrder?";
        if (workOrderId === undefined || workOrderId === null)
            throw new globalThis.Error("The parameter 'workOrderId' must be defined and cannot be null.");
        else
            url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInvoicesForWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInvoicesForWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceChargeViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceChargeViewModel[]>;
        }));
    }

    protected processGetAllInvoicesForWorkOrder(response: HttpResponseBase): Observable<InvoiceChargeViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceChargeViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    refundCharge(model: InvoiceChargeViewModel): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/stripe/RefundCharge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefundCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefundCharge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRefundCharge(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    generateInvoiceAndCharge(workOrderId: number, type: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/stripe/generateInvoiceAndCharge?";
        if (workOrderId === undefined || workOrderId === null)
            throw new globalThis.Error("The parameter 'workOrderId' must be defined and cannot be null.");
        else
            url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateInvoiceAndCharge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateInvoiceAndCharge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGenerateInvoiceAndCharge(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    markAsPaid(workOrderId: number, workOrderType: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/stripe/markAsPaid?";
        if (workOrderId === undefined || workOrderId === null)
            throw new globalThis.Error("The parameter 'workOrderId' must be defined and cannot be null.");
        else
            url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        if (workOrderType === undefined || workOrderType === null)
            throw new globalThis.Error("The parameter 'workOrderType' must be defined and cannot be null.");
        else
            url_ += "workOrderType=" + encodeURIComponent("" + workOrderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsPaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsPaid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processMarkAsPaid(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    generatePartialInvoice(partialInvoiceRequest: PartialInvoiceRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/stripe/GeneratePartialInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partialInvoiceRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGeneratePartialInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGeneratePartialInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGeneratePartialInvoice(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    generateMyClassToAngular(): Observable<StripeBilling> {
        let url_ = this.baseUrl + "/api/v1/stripe/GenerateMyClassToAngular";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateMyClassToAngular(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateMyClassToAngular(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeBilling>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeBilling>;
        }));
    }

    protected processGenerateMyClassToAngular(response: HttpResponseBase): Observable<StripeBilling> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeBilling.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPlaidAccessToken(postData: PlaidLinkSuccessDTO): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/stripe/GetPlaidAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(postData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaidAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaidAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetPlaidAccessToken(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getStripeBillingByCustomerId(id: number): Observable<StripeBilling> {
        let url_ = this.baseUrl + "/api/v1/stripe/GetStripeBillingByCustomerId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStripeBillingByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStripeBillingByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeBilling>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeBilling>;
        }));
    }

    protected processGetStripeBillingByCustomerId(response: HttpResponseBase): Observable<StripeBilling> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeBilling.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWorkOrderReceipt(workOrderId: number, workOrderType: string): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/stripe/GetWorkOrderReceipt?";
        if (workOrderId === undefined || workOrderId === null)
            throw new globalThis.Error("The parameter 'workOrderId' must be defined and cannot be null.");
        else
            url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        if (workOrderType === undefined || workOrderType === null)
            throw new globalThis.Error("The parameter 'workOrderType' must be defined and cannot be null.");
        else
            url_ += "workOrderType=" + encodeURIComponent("" + workOrderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkOrderReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkOrderReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetWorkOrderReceipt(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    emailReceiptsForWorkOrder(workOrderId: number, workOrderType: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/stripe/EmailReceiptsForWorkOrder?";
        if (workOrderId === undefined || workOrderId === null)
            throw new globalThis.Error("The parameter 'workOrderId' must be defined and cannot be null.");
        else
            url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        if (workOrderType === undefined || workOrderType === null)
            throw new globalThis.Error("The parameter 'workOrderType' must be defined and cannot be null.");
        else
            url_ += "workOrderType=" + encodeURIComponent("" + workOrderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEmailReceiptsForWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailReceiptsForWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processEmailReceiptsForWorkOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    onStripeTestWebhook(): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/stripe/onStripeTestWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnStripeTestWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnStripeTestWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnStripeTestWebhook(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SurveyQuestionGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(): Observable<SurveyQuestion[]> {
        let url_ = this.baseUrl + "/api/v1/surveyquestions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestion[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestion[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SurveyQuestion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyQuestion.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateOrder(surveyQuestions: SurveyQuestion[]): Observable<SurveyQuestion[]> {
        let url_ = this.baseUrl + "/api/v1/surveyquestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyQuestions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestion[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestion[]>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<SurveyQuestion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyQuestion.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(surveyQuestion: SurveyQuestion): Observable<SurveyQuestion> {
        let url_ = this.baseUrl + "/api/v1/surveyquestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyQuestion);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestion>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<SurveyQuestion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(surveyQuestion: SurveyQuestion, id: string): Observable<SurveyQuestion> {
        let url_ = this.baseUrl + "/api/v1/surveyquestions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyQuestion);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestion>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestion>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SurveyQuestion> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyQuestion.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/surveyquestions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SurveyResponseGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    tEST(): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/surveyresponse/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTEST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTEST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processTEST(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<SurveyHeader[]> {
        let url_ = this.baseUrl + "/api/v1/surveyresponse";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyHeader[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyHeader[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SurveyHeader[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyHeader.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(surveyHeader: SurveyHeader): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/surveyresponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyHeader);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<SurveyHeader> {
        let url_ = this.baseUrl + "/api/v1/surveyresponse/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyHeader>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SurveyHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/surveyresponse/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getByCustIdAndQuoteNum(custId: number, quoteNum: string, surveyHash: string): Observable<SurveyHeader> {
        let url_ = this.baseUrl + "/api/v1/surveyresponse/getByCustIdAndQuoteNum/{custId}/{quoteNum}/{surveyHash}";
        if (custId === undefined || custId === null)
            throw new globalThis.Error("The parameter 'custId' must be defined.");
        url_ = url_.replace("{custId}", encodeURIComponent("" + custId));
        if (quoteNum === undefined || quoteNum === null)
            throw new globalThis.Error("The parameter 'quoteNum' must be defined.");
        url_ = url_.replace("{quoteNum}", encodeURIComponent("" + quoteNum));
        if (surveyHash === undefined || surveyHash === null)
            throw new globalThis.Error("The parameter 'surveyHash' must be defined.");
        url_ = url_.replace("{surveyHash}", encodeURIComponent("" + surveyHash));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustIdAndQuoteNum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustIdAndQuoteNum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyHeader>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyHeader>;
        }));
    }

    protected processGetByCustIdAndQuoteNum(response: HttpResponseBase): Observable<SurveyHeader> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SystemSettingGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(): Observable<SystemSettingDTO[]> {
        let url_ = this.baseUrl + "/api/v1/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSettingDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSettingDTO[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SystemSettingDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemSettingDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(setting: SystemSettingDTO): Observable<SystemSettingDTO> {
        let url_ = this.baseUrl + "/api/v1/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSettingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSettingDTO>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SystemSettingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSettingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getDefaultTaxRate(): Observable<SystemSettingDTO> {
        let url_ = this.baseUrl + "/api/v1/settings/getDefaultTaxRate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultTaxRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultTaxRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSettingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSettingDTO>;
        }));
    }

    protected processGetDefaultTaxRate(response: HttpResponseBase): Observable<SystemSettingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSettingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCommissionBonusPercentage(): Observable<SystemSettingDTO> {
        let url_ = this.baseUrl + "/api/v1/settings/getCommissionBonusPercentage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommissionBonusPercentage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommissionBonusPercentage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSettingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSettingDTO>;
        }));
    }

    protected processGetCommissionBonusPercentage(response: HttpResponseBase): Observable<SystemSettingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSettingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCommissionLaborHourRequirement(): Observable<SystemSettingDTO> {
        let url_ = this.baseUrl + "/api/v1/settings/getCommissionLaborHourRequirement";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommissionLaborHourRequirement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommissionLaborHourRequirement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSettingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSettingDTO>;
        }));
    }

    protected processGetCommissionLaborHourRequirement(response: HttpResponseBase): Observable<SystemSettingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSettingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getManualPaymentDaysDue(): Observable<SystemSettingDTO> {
        let url_ = this.baseUrl + "/api/v1/settings/getManualPaymentDaysDue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManualPaymentDaysDue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManualPaymentDaysDue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSettingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSettingDTO>;
        }));
    }

    protected processGetManualPaymentDaysDue(response: HttpResponseBase): Observable<SystemSettingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSettingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWellnessWorkHourAverageGoal(): Observable<SystemSettingDTO> {
        let url_ = this.baseUrl + "/api/v1/settings/GetWellnessWorkHourAverageGoal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWellnessWorkHourAverageGoal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWellnessWorkHourAverageGoal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSettingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSettingDTO>;
        }));
    }

    protected processGetWellnessWorkHourAverageGoal(response: HttpResponseBase): Observable<SystemSettingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSettingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWorkWorkHourAverageGoal(): Observable<SystemSettingDTO> {
        let url_ = this.baseUrl + "/api/v1/settings/GetWorkWorkHourAverageGoal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkWorkHourAverageGoal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkWorkHourAverageGoal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemSettingDTO>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemSettingDTO>;
        }));
    }

    protected processGetWorkWorkHourAverageGoal(response: HttpResponseBase): Observable<SystemSettingDTO> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemSettingDTO.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getNewVerbiage(id: number): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/settings/GetNewVerbiage?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewVerbiage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewVerbiage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNewVerbiage(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TreeTypeGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<TreeType> {
        let url_ = this.baseUrl + "/api/v1/treeTypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeType>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TreeType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/treeTypes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<TreeType[]> {
        let url_ = this.baseUrl + "/api/v1/treeTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeType[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TreeType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TreeType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(treeType: TreeType): Observable<TreeType> {
        let url_ = this.baseUrl + "/api/v1/treeTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeType>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TreeType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(treeType: TreeType): Observable<TreeType> {
        let url_ = this.baseUrl + "/api/v1/treeTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(treeType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TreeType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TreeType>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<TreeType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreeType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WellnessTaskGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<WellnessTask> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTask>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WellnessTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<WellnessTask[]> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTask[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTask[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WellnessTask[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessTask.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(wellnessTask: WellnessTask): Observable<WellnessTask> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wellnessTask);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTask>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WellnessTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(wellnessTask: WellnessTask): Observable<WellnessTask> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wellnessTask);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTask>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<WellnessTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unableToCompleteToday(dto: UnableToCompleteTaskDTO): Observable<WellnessTask> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks/UnableToCompleteToday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnableToCompleteToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnableToCompleteToday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTask>;
        }));
    }

    protected processUnableToCompleteToday(response: HttpResponseBase): Observable<WellnessTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateWithDTO(dto: WellnessTaskUpdateDTO): Observable<WellnessTask> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks/updateWithDTO";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWithDTO(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWithDTO(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTask>;
        }));
    }

    protected processUpdateWithDTO(response: HttpResponseBase): Observable<WellnessTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    setAsRenewed(taskId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks/setAsRenewed?";
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined and cannot be null.");
        else
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAsRenewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAsRenewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSetAsRenewed(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateJobFeedback(taskId: number, feedback: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks/updateJobFeedback?";
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined and cannot be null.");
        else
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (feedback === undefined || feedback === null)
            throw new globalThis.Error("The parameter 'feedback' must be defined and cannot be null.");
        else
            url_ += "feedback=" + encodeURIComponent("" + feedback) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJobFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJobFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdateJobFeedback(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateCompletionStatus(wellnessTask: WellnessTask): Observable<WellnessTask> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks/updateCompletionStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wellnessTask);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompletionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompletionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTask>;
        }));
    }

    protected processUpdateCompletionStatus(response: HttpResponseBase): Observable<WellnessTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unschedule(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/wellnesstasks/unschedule?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnschedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnschedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUnschedule(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WellnessTaskHourEntryGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    updateRange(task: WellnessTask): Observable<WellnessTaskHourEntry[]> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskHourEntries/updateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTaskHourEntry[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTaskHourEntry[]>;
        }));
    }

    protected processUpdateRange(response: HttpResponseBase): Observable<WellnessTaskHourEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessTaskHourEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(entry: WellnessTaskHourEntry): Observable<WellnessTaskHourEntry> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskHourEntries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entry);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTaskHourEntry>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTaskHourEntry>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WellnessTaskHourEntry> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTaskHourEntry.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    filter(filterDate: Date, wellnessTaskId: number): Observable<WellnessTaskHourEntry[]> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskHourEntries/filter?";
        if (filterDate === undefined || filterDate === null)
            throw new globalThis.Error("The parameter 'filterDate' must be defined and cannot be null.");
        else
            url_ += "filterDate=" + encodeURIComponent(filterDate ? "" + filterDate.toISOString() : "") + "&";
        if (wellnessTaskId === undefined || wellnessTaskId === null)
            throw new globalThis.Error("The parameter 'wellnessTaskId' must be defined and cannot be null.");
        else
            url_ += "wellnessTaskId=" + encodeURIComponent("" + wellnessTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTaskHourEntry[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTaskHourEntry[]>;
        }));
    }

    protected processFilter(response: HttpResponseBase): Observable<WellnessTaskHourEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessTaskHourEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WellnessTaskTemplateGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<WellnessTaskTemplate> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTaskTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTaskTemplate>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WellnessTaskTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTaskTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(wellnessTaskTemplate: WellnessTaskTemplate, id: string): Observable<WellnessTaskTemplate> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wellnessTaskTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTaskTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTaskTemplate>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WellnessTaskTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessTaskTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<WellnessTaskTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTaskTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTaskTemplate[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WellnessTaskTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessTaskTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(wellnessTaskTemplate: WellnessTaskTemplate): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(wellnessTaskTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllActive(): Observable<WellnessTaskTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/wellnessTaskTemplates/getallactive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessTaskTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessTaskTemplate[]>;
        }));
    }

    protected processGetAllActive(response: HttpResponseBase): Observable<WellnessTaskTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessTaskTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WellnessWorkOrderGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<WellnessWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessWorkOrder>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WellnessWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(workOrder: WellnessWorkOrder, id: string): Observable<WellnessWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workOrder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessWorkOrder>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WellnessWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<WellnessWorkOrder[]> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessWorkOrder[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WellnessWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPaginated(advancedFilters: AdvancedWorkOrderFilter): Observable<PagedResultsForInvoicingOfWorkOrderListView> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/getPaginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedFilters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsForInvoicingOfWorkOrderListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsForInvoicingOfWorkOrderListView>;
        }));
    }

    protected processGetPaginated(response: HttpResponseBase): Observable<PagedResultsForInvoicingOfWorkOrderListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsForInvoicingOfWorkOrderListView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPaginatedRenewals(advancedFilters: AdvancedWorkOrderFilter): Observable<PagedResultsForInvoicingOfWorkOrderListView> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/getPaginatedRenewals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedFilters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginatedRenewals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginatedRenewals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsForInvoicingOfWorkOrderListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsForInvoicingOfWorkOrderListView>;
        }));
    }

    protected processGetPaginatedRenewals(response: HttpResponseBase): Observable<PagedResultsForInvoicingOfWorkOrderListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsForInvoicingOfWorkOrderListView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWorkOrdersWithOpenWellnessTasks(): Observable<WellnessWorkOrder[]> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/getWorkOrdersWithOpenWellnessTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkOrdersWithOpenWellnessTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkOrdersWithOpenWellnessTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessWorkOrder[]>;
        }));
    }

    protected processGetWorkOrdersWithOpenWellnessTasks(response: HttpResponseBase): Observable<WellnessWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPartiallyCompletedWorkOrders(startDate: Date, endDate: Date): Observable<WellnessWorkOrder[]> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/GetPartiallyCompletedWorkOrders?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartiallyCompletedWorkOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartiallyCompletedWorkOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessWorkOrder[]>;
        }));
    }

    protected processGetPartiallyCompletedWorkOrders(response: HttpResponseBase): Observable<WellnessWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    saveAfterCompletion(request: SaveWorkOrderAfterCompletionRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/SaveAfterCompletion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAfterCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAfterCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSaveAfterCompletion(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    scheduleWorkOrder(id: number, tasksToSchedule: number[], bucketId: number, date: Date, index: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/ScheduleWorkOrder?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (index === undefined || index === null)
            throw new globalThis.Error("The parameter 'index' must be defined and cannot be null.");
        else
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tasksToSchedule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processScheduleWorkOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unscheduleWorkOrder(id: number, currentBucketId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/UnscheduleWorkOrder?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (currentBucketId === undefined || currentBucketId === null)
            throw new globalThis.Error("The parameter 'currentBucketId' must be defined and cannot be null.");
        else
            url_ += "currentBucketId=" + encodeURIComponent("" + currentBucketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnscheduleWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnscheduleWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUnscheduleWorkOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    undoWorkOrderCompletion(id: number, comment: string, currentUserId: number): Observable<WellnessWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/wellnessWorkOrders/UndoWorkOrderCompletion?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (comment === undefined || comment === null)
            throw new globalThis.Error("The parameter 'comment' must be defined and cannot be null.");
        else
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (currentUserId === undefined || currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' must be defined and cannot be null.");
        else
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoWorkOrderCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoWorkOrderCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessWorkOrder>;
        }));
    }

    protected processUndoWorkOrderCompletion(response: HttpResponseBase): Observable<WellnessWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WellnessWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkOrderGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    getPaginated(advancedFilters: AdvancedInvoiceFilters): Observable<PagedResultsForInvoicingOfWorkOrderInvoicingViewModel> {
        let url_ = this.baseUrl + "/api/v1/workOrder/getPaginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedFilters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsForInvoicingOfWorkOrderInvoicingViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsForInvoicingOfWorkOrderInvoicingViewModel>;
        }));
    }

    protected processGetPaginated(response: HttpResponseBase): Observable<PagedResultsForInvoicingOfWorkOrderInvoicingViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsForInvoicingOfWorkOrderInvoicingViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    applyCashCollectedToInvoice(type: string, invoiceNumber: string, cashCollectedId: number): Observable<AAInvoice> {
        let url_ = this.baseUrl + "/api/v1/workOrder/applyCashCollectedToInvoice?";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (invoiceNumber === undefined || invoiceNumber === null)
            throw new globalThis.Error("The parameter 'invoiceNumber' must be defined and cannot be null.");
        else
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        if (cashCollectedId === undefined || cashCollectedId === null)
            throw new globalThis.Error("The parameter 'cashCollectedId' must be defined and cannot be null.");
        else
            url_ += "cashCollectedId=" + encodeURIComponent("" + cashCollectedId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplyCashCollectedToInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplyCashCollectedToInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AAInvoice>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AAInvoice>;
        }));
    }

    protected processApplyCashCollectedToInvoice(response: HttpResponseBase): Observable<AAInvoice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AAInvoice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    chargeInvoice(invoiceId: string): Observable<AAInvoice> {
        let url_ = this.baseUrl + "/api/v1/workOrder/chargeInvoice?";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined and cannot be null.");
        else
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChargeInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChargeInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AAInvoice>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AAInvoice>;
        }));
    }

    protected processChargeInvoice(response: HttpResponseBase): Observable<AAInvoice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AAInvoice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWellnessCashCollected(id: number): Observable<WellnessWorkOrderCashCollected[]> {
        let url_ = this.baseUrl + "/api/v1/workOrder/getWellnessCashCollected?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWellnessCashCollected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWellnessCashCollected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WellnessWorkOrderCashCollected[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WellnessWorkOrderCashCollected[]>;
        }));
    }

    protected processGetWellnessCashCollected(response: HttpResponseBase): Observable<WellnessWorkOrderCashCollected[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WellnessWorkOrderCashCollected.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWorkCashCollected(id: number): Observable<WorkWorkOrderCashCollected[]> {
        let url_ = this.baseUrl + "/api/v1/workOrder/getWorkCashCollected?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkCashCollected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkCashCollected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkWorkOrderCashCollected[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkWorkOrderCashCollected[]>;
        }));
    }

    protected processGetWorkCashCollected(response: HttpResponseBase): Observable<WorkWorkOrderCashCollected[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkWorkOrderCashCollected.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    saveWellnessCashCollectedRange(range: WellnessWorkOrderCashCollected[], woId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workOrder/saveWellnessCashCollectedRange?";
        if (woId === undefined || woId === null)
            throw new globalThis.Error("The parameter 'woId' must be defined and cannot be null.");
        else
            url_ += "woId=" + encodeURIComponent("" + woId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(range);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveWellnessCashCollectedRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveWellnessCashCollectedRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSaveWellnessCashCollectedRange(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    saveWorkCashCollectedRange(range: WorkWorkOrderCashCollected[], woId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workOrder/saveWorkCashCollectedRange?";
        if (woId === undefined || woId === null)
            throw new globalThis.Error("The parameter 'woId' must be defined and cannot be null.");
        else
            url_ += "woId=" + encodeURIComponent("" + woId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(range);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveWorkCashCollectedRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveWorkCashCollectedRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSaveWorkCashCollectedRange(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    saveCommissionEarned(viewModel: WorkOrderCommissionViewModel): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workOrder/SaveCommissionEarned";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCommissionEarned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCommissionEarned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSaveCommissionEarned(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getByFilter(globalFilter: string): Observable<BasicWorkOrderViewModel[]> {
        let url_ = this.baseUrl + "/api/v1/workOrder/getByFilter?";
        if (globalFilter === undefined || globalFilter === null)
            throw new globalThis.Error("The parameter 'globalFilter' must be defined and cannot be null.");
        else
            url_ += "globalFilter=" + encodeURIComponent("" + globalFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicWorkOrderViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicWorkOrderViewModel[]>;
        }));
    }

    protected processGetByFilter(response: HttpResponseBase): Observable<BasicWorkOrderViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicWorkOrderViewModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkOrderPriceAdjustmentGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    deletePriceAdjustmentByWopaId(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workOrderPriceAdjustments/DeletePriceAdjustmentByWopaId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePriceAdjustmentByWopaId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePriceAdjustmentByWopaId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeletePriceAdjustmentByWopaId(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkOrderWellnessTaskGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    deleteWellnessTaskByWowtId(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workOrderWellnessTasks/DeleteWellnessTaskByWowtId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWellnessTaskByWowtId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWellnessTaskByWowtId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteWellnessTaskByWowtId(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkOrderWorkTaskGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    deleteWorkTaskByWowtId(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workOrderWorkTasks/DeleteWorkTaskByWowtId/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWorkTaskByWowtId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWorkTaskByWowtId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteWorkTaskByWowtId(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkTaskGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<WorkTask> {
        let url_ = this.baseUrl + "/api/v1/workTasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTask>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WorkTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workTasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<WorkTask[]> {
        let url_ = this.baseUrl + "/api/v1/workTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTask[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTask[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WorkTask[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkTask.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(workTask: WorkTask): Observable<WorkTask> {
        let url_ = this.baseUrl + "/api/v1/workTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workTask);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTask>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WorkTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(workTask: WorkTask): Observable<WorkTask> {
        let url_ = this.baseUrl + "/api/v1/workTasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workTask);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTask>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<WorkTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updatePrice(taskId: number, price: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workTasks/updatePrice?";
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined and cannot be null.");
        else
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        if (price === undefined || price === null)
            throw new globalThis.Error("The parameter 'price' must be defined and cannot be null.");
        else
            url_ += "price=" + encodeURIComponent("" + price) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUpdatePrice(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unableToCompleteToday(dto: UnableToCompleteTaskDTO): Observable<WorkTask> {
        let url_ = this.baseUrl + "/api/v1/workTasks/UnableToCompleteToday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnableToCompleteToday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnableToCompleteToday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTask>;
        }));
    }

    protected processUnableToCompleteToday(response: HttpResponseBase): Observable<WorkTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateWithDTO(dto: WorkTaskUpdateDTO): Observable<WorkTask> {
        let url_ = this.baseUrl + "/api/v1/workTasks/updateWithDTO";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWithDTO(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWithDTO(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTask>;
        }));
    }

    protected processUpdateWithDTO(response: HttpResponseBase): Observable<WorkTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    updateCompletionStatus(workTask: WorkTask): Observable<WorkTask> {
        let url_ = this.baseUrl + "/api/v1/workTasks/updateCompletionStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workTask);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompletionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompletionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTask>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTask>;
        }));
    }

    protected processUpdateCompletionStatus(response: HttpResponseBase): Observable<WorkTask> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTask.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unschedule(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workTasks/unschedule?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnschedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnschedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUnschedule(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkTaskHourEntryGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    updateRange(task: WorkTask): Observable<WorkTaskHourEntry[]> {
        let url_ = this.baseUrl + "/api/v1/workTaskHourEntries/updateRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(task);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTaskHourEntry[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTaskHourEntry[]>;
        }));
    }

    protected processUpdateRange(response: HttpResponseBase): Observable<WorkTaskHourEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkTaskHourEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(entry: WorkTaskHourEntry): Observable<WorkTaskHourEntry> {
        let url_ = this.baseUrl + "/api/v1/workTaskHourEntries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entry);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTaskHourEntry>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTaskHourEntry>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WorkTaskHourEntry> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTaskHourEntry.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    filter(filterDate: Date, workTaskId: number): Observable<WorkTaskHourEntry[]> {
        let url_ = this.baseUrl + "/api/v1/workTaskHourEntries/filter?";
        if (filterDate === undefined || filterDate === null)
            throw new globalThis.Error("The parameter 'filterDate' must be defined and cannot be null.");
        else
            url_ += "filterDate=" + encodeURIComponent(filterDate ? "" + filterDate.toISOString() : "") + "&";
        if (workTaskId === undefined || workTaskId === null)
            throw new globalThis.Error("The parameter 'workTaskId' must be defined and cannot be null.");
        else
            url_ += "workTaskId=" + encodeURIComponent("" + workTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTaskHourEntry[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTaskHourEntry[]>;
        }));
    }

    protected processFilter(response: HttpResponseBase): Observable<WorkTaskHourEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkTaskHourEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkTaskTemplateGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<WorkTaskTemplate> {
        let url_ = this.baseUrl + "/api/v1/workTaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTaskTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTaskTemplate>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WorkTaskTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTaskTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(workTaskTemplate: WorkTaskTemplate, id: string): Observable<WorkTaskTemplate> {
        let url_ = this.baseUrl + "/api/v1/workTaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workTaskTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTaskTemplate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTaskTemplate>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WorkTaskTemplate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTaskTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(id: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workTaskTemplates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<WorkTaskTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/workTaskTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTaskTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTaskTemplate[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WorkTaskTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkTaskTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(workTaskTemplate: WorkTaskTemplate): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workTaskTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workTaskTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllActive(): Observable<WorkTaskTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/workTaskTemplates/getallactive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkTaskTemplate[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkTaskTemplate[]>;
        }));
    }

    protected processGetAllActive(response: HttpResponseBase): Observable<WorkTaskTemplate[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkTaskTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WorkWorkOrderGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<WorkWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkWorkOrder>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WorkWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(workOrder: WorkWorkOrder, id: string): Observable<WorkWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workOrder);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkWorkOrder>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WorkWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<WorkWorkOrder[]> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkWorkOrder[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WorkWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPaginated(advancedFilters: AdvancedWorkOrderFilter): Observable<PagedResultsForInvoicingOfWorkOrderListView> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/getPaginated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(advancedFilters);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultsForInvoicingOfWorkOrderListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultsForInvoicingOfWorkOrderListView>;
        }));
    }

    protected processGetPaginated(response: HttpResponseBase): Observable<PagedResultsForInvoicingOfWorkOrderListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultsForInvoicingOfWorkOrderListView.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getWorkOrdersWithOpenWorkTasks(): Observable<WorkWorkOrder[]> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/getWorkOrdersWithOpenWorkTasks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkOrdersWithOpenWorkTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkOrdersWithOpenWorkTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkWorkOrder[]>;
        }));
    }

    protected processGetWorkOrdersWithOpenWorkTasks(response: HttpResponseBase): Observable<WorkWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getPartiallyCompletedWorkOrders(startDate: Date, endDate: Date): Observable<WorkWorkOrder[]> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/GetPartiallyCompletedWorkOrders?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartiallyCompletedWorkOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartiallyCompletedWorkOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkWorkOrder[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkWorkOrder[]>;
        }));
    }

    protected processGetPartiallyCompletedWorkOrders(response: HttpResponseBase): Observable<WorkWorkOrder[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkWorkOrder.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    saveAfterCompletion(request: SaveWorkOrderAfterCompletionRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/SaveAfterCompletion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAfterCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAfterCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processSaveAfterCompletion(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    scheduleWorkOrder(id: number, tasksToSchedule: number[], bucketId: number, date: Date, index: number): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/ScheduleWorkOrder?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (bucketId === undefined || bucketId === null)
            throw new globalThis.Error("The parameter 'bucketId' must be defined and cannot be null.");
        else
            url_ += "bucketId=" + encodeURIComponent("" + bucketId) + "&";
        if (date === undefined || date === null)
            throw new globalThis.Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (index === undefined || index === null)
            throw new globalThis.Error("The parameter 'index' must be defined and cannot be null.");
        else
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tasksToSchedule);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processScheduleWorkOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    unscheduleWorkOrder(id: number, currentBucketId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/UnscheduleWorkOrder?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (currentBucketId === undefined || currentBucketId === null)
            throw new globalThis.Error("The parameter 'currentBucketId' must be defined and cannot be null.");
        else
            url_ += "currentBucketId=" + encodeURIComponent("" + currentBucketId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnscheduleWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnscheduleWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processUnscheduleWorkOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    undoWorkOrderCompletion(id: number, comment: string, currentUserId: number): Observable<WorkWorkOrder> {
        let url_ = this.baseUrl + "/api/v1/workWorkOrders/UndoWorkOrderCompletion?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (comment === undefined || comment === null)
            throw new globalThis.Error("The parameter 'comment' must be defined and cannot be null.");
        else
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        if (currentUserId === undefined || currentUserId === null)
            throw new globalThis.Error("The parameter 'currentUserId' must be defined and cannot be null.");
        else
            url_ += "currentUserId=" + encodeURIComponent("" + currentUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUndoWorkOrderCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUndoWorkOrderCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkWorkOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkWorkOrder>;
        }));
    }

    protected processUndoWorkOrderCompletion(response: HttpResponseBase): Observable<WorkWorkOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkWorkOrder.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZipCodeGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    getByZipCode(code: string): Observable<ZipCode> {
        let url_ = this.baseUrl + "/api/v1/zipCode/GetByZipCode/{code}";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByZipCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByZipCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZipCode>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZipCode>;
        }));
    }

    protected processGetByZipCode(response: HttpResponseBase): Observable<ZipCode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZipCode.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    get(id: number): Observable<ZipCode> {
        let url_ = this.baseUrl + "/api/v1/zipCode/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZipCode>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZipCode>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ZipCode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZipCode.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    update(zipCode: ZipCode, id: string): Observable<ZipCode> {
        let url_ = this.baseUrl + "/api/v1/zipCode/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zipCode);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZipCode>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZipCode>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ZipCode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZipCode.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    delete(zipCode: ZipCode, id: string): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/zipCode/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zipCode);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ZipCode[]> {
        let url_ = this.baseUrl + "/api/v1/zipCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZipCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZipCode[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ZipCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZipCode.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(zipCode: ZipCode): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/zipCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zipCode);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZipCodeAssignmentGenSvc {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:60376";
    }

    /**
     * @return OK
     */
    get(id: number): Observable<ZipCodeAssignment> {
        let url_ = this.baseUrl + "/api/v1/zipCodeAssignment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZipCodeAssignment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZipCodeAssignment>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ZipCodeAssignment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZipCodeAssignment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAll(): Observable<ZipCodeAssignment[]> {
        let url_ = this.baseUrl + "/api/v1/zipCodeAssignment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZipCodeAssignment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZipCodeAssignment[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ZipCodeAssignment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZipCodeAssignment.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    add(zipCodeAssignment: ZipCodeAssignment): Observable<any> {
        let url_ = this.baseUrl + "/api/v1/zipCodeAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(zipCodeAssignment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class Address implements IAddress {
    id?: number | undefined;
    active?: boolean | undefined;
    street?: string | undefined;
    apartment?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    stateId?: number | undefined;
    state?: State | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    geoColor?: string | undefined;
    textColor?: string | undefined;
    readonly formattedAddress?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.street = _data["Street"];
            this.apartment = _data["Apartment"];
            this.city = _data["City"];
            this.zip = _data["Zip"];
            this.stateId = _data["StateId"];
            this.state = _data["State"] ? State.fromJS(_data["State"]) : undefined as any;
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.geoColor = _data["GeoColor"];
            this.textColor = _data["TextColor"];
            (this as any).formattedAddress = _data["FormattedAddress"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Street"] = this.street;
        data["Apartment"] = this.apartment;
        data["City"] = this.city;
        data["Zip"] = this.zip;
        data["StateId"] = this.stateId;
        data["State"] = this.state ? this.state.toJSON() : undefined as any;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["GeoColor"] = this.geoColor;
        data["TextColor"] = this.textColor;
        data["FormattedAddress"] = this.formattedAddress;
        return data;
    }
}

export interface IAddress {
    id?: number | undefined;
    active?: boolean | undefined;
    street?: string | undefined;
    apartment?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    stateId?: number | undefined;
    state?: State | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    geoColor?: string | undefined;
    textColor?: string | undefined;
    formattedAddress?: string | undefined;
}

export class State implements IState {
    id?: number | undefined;
    abbreviation?: string | undefined;
    name?: string | undefined;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.abbreviation = _data["Abbreviation"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Abbreviation"] = this.abbreviation;
        data["Name"] = this.name;
        return data;
    }
}

export interface IState {
    id?: number | undefined;
    abbreviation?: string | undefined;
    name?: string | undefined;
}

export class LoginRequest implements ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["Username"];
            this.password = _data["Password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Username"] = this.username;
        data["Password"] = this.password;
        return data;
    }
}

export interface ILoginRequest {
    username?: string | undefined;
    password?: string | undefined;
}

export class BigDayBucket implements IBigDayBucket {
    id?: number | undefined;
    active?: boolean | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    wellnessWorkOrderId?: number | undefined;
    wellnessWorkOrder?: WellnessWorkOrder | undefined;
    workWorkOrderId?: number | undefined;
    workWorkOrder?: WorkWorkOrder | undefined;

    constructor(data?: IBigDayBucket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : undefined as any;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : undefined as any;
            this.wellnessWorkOrderId = _data["WellnessWorkOrderId"];
            this.wellnessWorkOrder = _data["WellnessWorkOrder"] ? WellnessWorkOrder.fromJS(_data["WellnessWorkOrder"]) : undefined as any;
            this.workWorkOrderId = _data["WorkWorkOrderId"];
            this.workWorkOrder = _data["WorkWorkOrder"] ? WorkWorkOrder.fromJS(_data["WorkWorkOrder"]) : undefined as any;
        }
    }

    static fromJS(data: any): BigDayBucket {
        data = typeof data === 'object' ? data : {};
        let result = new BigDayBucket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["WellnessWorkOrderId"] = this.wellnessWorkOrderId;
        data["WellnessWorkOrder"] = this.wellnessWorkOrder ? this.wellnessWorkOrder.toJSON() : undefined as any;
        data["WorkWorkOrderId"] = this.workWorkOrderId;
        data["WorkWorkOrder"] = this.workWorkOrder ? this.workWorkOrder.toJSON() : undefined as any;
        return data;
    }
}

export interface IBigDayBucket {
    id?: number | undefined;
    active?: boolean | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    wellnessWorkOrderId?: number | undefined;
    wellnessWorkOrder?: WellnessWorkOrder | undefined;
    workWorkOrderId?: number | undefined;
    workWorkOrder?: WorkWorkOrder | undefined;
}

export class WellnessWorkOrder implements IWellnessWorkOrder {
    workOrderWellnessTasks?: WorkOrderWellnessTask[] | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
    completedDate?: Date | undefined;
    isMultiday?: boolean | undefined;
    autoChargeEnabled?: boolean | undefined;
    onMyWaLastSent?: Date | undefined;
    wrappingUpLastSent?: Date | undefined;
    workOrderCashCollected?: WellnessWorkOrderCashCollected[] | undefined;
    commissionEarnedOverride?: boolean | undefined;
    ignoreFirmtime?: boolean | undefined;
    quoteId?: number | undefined;
    priceSummary?: number | undefined;
    quoteNumber?: string | undefined;
    id?: number | undefined;
    customerId?: number | undefined;
    addressId?: number | undefined;
    createdDate?: Date | undefined;
    paidDate?: Date | undefined;
    completionStatus?: WellnessWorkOrderCompletionStatus | undefined;
    paymentStatus?: WellnessWorkOrderPaymentStatus | undefined;
    note?: string | undefined;
    crewNote?: string | undefined;
    representativeId?: number | undefined;
    paymentDueId?: number | undefined;
    addressSameAsCustomer?: boolean | undefined;
    hidePrice?: boolean | undefined;
    customer?: Customer | undefined;
    address?: Address | undefined;
    representative?: Employee | undefined;
    paymentDueOption?: PaymentDueOption | undefined;
    workOrderPriceAdjustments?: WorkOrderPriceAdjustment[] | undefined;
    salesTaxPercentage?: number | undefined;
    hasRentalExpense?: boolean | undefined;
    rentalCost?: number | undefined;
    rentalDescription?: string | undefined;
    mostUrgentPriorityLevel?: PriorityLevel | undefined;
    hoursSummary?: number | undefined;

    constructor(data?: IWellnessWorkOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["WorkOrderWellnessTasks"])) {
                this.workOrderWellnessTasks = [] as any;
                for (let item of _data["WorkOrderWellnessTasks"])
                    this.workOrderWellnessTasks!.push(WorkOrderWellnessTask.fromJS(item));
            }
            this.quoteWorkOrder = _data["QuoteWorkOrder"] ? QuoteWorkOrder.fromJS(_data["QuoteWorkOrder"]) : undefined as any;
            this.completedDate = _data["CompletedDate"] ? new Date(_data["CompletedDate"].toString()) : undefined as any;
            this.isMultiday = _data["IsMultiday"];
            this.autoChargeEnabled = _data["AutoChargeEnabled"];
            this.onMyWaLastSent = _data["OnMyWaLastSent"] ? new Date(_data["OnMyWaLastSent"].toString()) : undefined as any;
            this.wrappingUpLastSent = _data["WrappingUpLastSent"] ? new Date(_data["WrappingUpLastSent"].toString()) : undefined as any;
            if (Array.isArray(_data["WorkOrderCashCollected"])) {
                this.workOrderCashCollected = [] as any;
                for (let item of _data["WorkOrderCashCollected"])
                    this.workOrderCashCollected!.push(WellnessWorkOrderCashCollected.fromJS(item));
            }
            this.commissionEarnedOverride = _data["CommissionEarnedOverride"];
            this.ignoreFirmtime = _data["IgnoreFirmtime"];
            this.quoteId = _data["QuoteId"];
            this.priceSummary = _data["PriceSummary"];
            this.quoteNumber = _data["QuoteNumber"];
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.addressId = _data["AddressId"];
            this.createdDate = _data["CreatedDate"] ? new Date(_data["CreatedDate"].toString()) : undefined as any;
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : undefined as any;
            this.completionStatus = _data["CompletionStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.note = _data["Note"];
            this.crewNote = _data["CrewNote"];
            this.representativeId = _data["RepresentativeId"];
            this.paymentDueId = _data["PaymentDueId"];
            this.addressSameAsCustomer = _data["AddressSameAsCustomer"];
            this.hidePrice = _data["HidePrice"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : undefined as any;
            this.representative = _data["Representative"] ? Employee.fromJS(_data["Representative"]) : undefined as any;
            this.paymentDueOption = _data["PaymentDueOption"] ? PaymentDueOption.fromJS(_data["PaymentDueOption"]) : undefined as any;
            if (Array.isArray(_data["WorkOrderPriceAdjustments"])) {
                this.workOrderPriceAdjustments = [] as any;
                for (let item of _data["WorkOrderPriceAdjustments"])
                    this.workOrderPriceAdjustments!.push(WorkOrderPriceAdjustment.fromJS(item));
            }
            this.salesTaxPercentage = _data["SalesTaxPercentage"];
            this.hasRentalExpense = _data["HasRentalExpense"];
            this.rentalCost = _data["RentalCost"];
            this.rentalDescription = _data["RentalDescription"];
            this.mostUrgentPriorityLevel = _data["MostUrgentPriorityLevel"] ? PriorityLevel.fromJS(_data["MostUrgentPriorityLevel"]) : undefined as any;
            this.hoursSummary = _data["HoursSummary"];
        }
    }

    static fromJS(data: any): WellnessWorkOrder {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessWorkOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workOrderWellnessTasks)) {
            data["WorkOrderWellnessTasks"] = [];
            for (let item of this.workOrderWellnessTasks)
                data["WorkOrderWellnessTasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["QuoteWorkOrder"] = this.quoteWorkOrder ? this.quoteWorkOrder.toJSON() : undefined as any;
        data["CompletedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        data["IsMultiday"] = this.isMultiday;
        data["AutoChargeEnabled"] = this.autoChargeEnabled;
        data["OnMyWaLastSent"] = this.onMyWaLastSent ? this.onMyWaLastSent.toISOString() : undefined as any;
        data["WrappingUpLastSent"] = this.wrappingUpLastSent ? this.wrappingUpLastSent.toISOString() : undefined as any;
        if (Array.isArray(this.workOrderCashCollected)) {
            data["WorkOrderCashCollected"] = [];
            for (let item of this.workOrderCashCollected)
                data["WorkOrderCashCollected"].push(item ? item.toJSON() : undefined as any);
        }
        data["CommissionEarnedOverride"] = this.commissionEarnedOverride;
        data["IgnoreFirmtime"] = this.ignoreFirmtime;
        data["QuoteId"] = this.quoteId;
        data["PriceSummary"] = this.priceSummary;
        data["QuoteNumber"] = this.quoteNumber;
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["AddressId"] = this.addressId;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["CompletionStatus"] = this.completionStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["Note"] = this.note;
        data["CrewNote"] = this.crewNote;
        data["RepresentativeId"] = this.representativeId;
        data["PaymentDueId"] = this.paymentDueId;
        data["AddressSameAsCustomer"] = this.addressSameAsCustomer;
        data["HidePrice"] = this.hidePrice;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["Address"] = this.address ? this.address.toJSON() : undefined as any;
        data["Representative"] = this.representative ? this.representative.toJSON() : undefined as any;
        data["PaymentDueOption"] = this.paymentDueOption ? this.paymentDueOption.toJSON() : undefined as any;
        if (Array.isArray(this.workOrderPriceAdjustments)) {
            data["WorkOrderPriceAdjustments"] = [];
            for (let item of this.workOrderPriceAdjustments)
                data["WorkOrderPriceAdjustments"].push(item ? item.toJSON() : undefined as any);
        }
        data["SalesTaxPercentage"] = this.salesTaxPercentage;
        data["HasRentalExpense"] = this.hasRentalExpense;
        data["RentalCost"] = this.rentalCost;
        data["RentalDescription"] = this.rentalDescription;
        data["MostUrgentPriorityLevel"] = this.mostUrgentPriorityLevel ? this.mostUrgentPriorityLevel.toJSON() : undefined as any;
        data["HoursSummary"] = this.hoursSummary;
        return data;
    }
}

export interface IWellnessWorkOrder {
    workOrderWellnessTasks?: WorkOrderWellnessTask[] | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
    completedDate?: Date | undefined;
    isMultiday?: boolean | undefined;
    autoChargeEnabled?: boolean | undefined;
    onMyWaLastSent?: Date | undefined;
    wrappingUpLastSent?: Date | undefined;
    workOrderCashCollected?: WellnessWorkOrderCashCollected[] | undefined;
    commissionEarnedOverride?: boolean | undefined;
    ignoreFirmtime?: boolean | undefined;
    quoteId?: number | undefined;
    priceSummary?: number | undefined;
    quoteNumber?: string | undefined;
    id?: number | undefined;
    customerId?: number | undefined;
    addressId?: number | undefined;
    createdDate?: Date | undefined;
    paidDate?: Date | undefined;
    completionStatus?: WellnessWorkOrderCompletionStatus | undefined;
    paymentStatus?: WellnessWorkOrderPaymentStatus | undefined;
    note?: string | undefined;
    crewNote?: string | undefined;
    representativeId?: number | undefined;
    paymentDueId?: number | undefined;
    addressSameAsCustomer?: boolean | undefined;
    hidePrice?: boolean | undefined;
    customer?: Customer | undefined;
    address?: Address | undefined;
    representative?: Employee | undefined;
    paymentDueOption?: PaymentDueOption | undefined;
    workOrderPriceAdjustments?: WorkOrderPriceAdjustment[] | undefined;
    salesTaxPercentage?: number | undefined;
    hasRentalExpense?: boolean | undefined;
    rentalCost?: number | undefined;
    rentalDescription?: string | undefined;
    mostUrgentPriorityLevel?: PriorityLevel | undefined;
    hoursSummary?: number | undefined;
}

export class WorkWorkOrder implements IWorkWorkOrder {
    workOrderWorkTasks?: WorkOrderWorkTask[] | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
    completedDate?: Date | undefined;
    onMyWaLastSent?: Date | undefined;
    wrappingUpLastSent?: Date | undefined;
    workOrderCashCollected?: WorkWorkOrderCashCollected[] | undefined;
    commissionEarnedOverride?: boolean | undefined;
    ignoreFirmtime?: boolean | undefined;
    isMultiday?: boolean | undefined;
    quoteId?: number | undefined;
    autoChargeEnabled?: boolean | undefined;
    priceSummary?: number | undefined;
    quoteNumber?: string | undefined;
    id?: number | undefined;
    customerId?: number | undefined;
    addressId?: number | undefined;
    createdDate?: Date | undefined;
    paidDate?: Date | undefined;
    completionStatus?: WorkWorkOrderCompletionStatus | undefined;
    paymentStatus?: WorkWorkOrderPaymentStatus | undefined;
    note?: string | undefined;
    crewNote?: string | undefined;
    representativeId?: number | undefined;
    paymentDueId?: number | undefined;
    addressSameAsCustomer?: boolean | undefined;
    hidePrice?: boolean | undefined;
    customer?: Customer | undefined;
    address?: Address | undefined;
    representative?: Employee | undefined;
    paymentDueOption?: PaymentDueOption | undefined;
    workOrderPriceAdjustments?: WorkOrderPriceAdjustment[] | undefined;
    salesTaxPercentage?: number | undefined;
    hasRentalExpense?: boolean | undefined;
    rentalCost?: number | undefined;
    rentalDescription?: string | undefined;
    mostUrgentPriorityLevel?: PriorityLevel | undefined;
    hoursSummary?: number | undefined;

    constructor(data?: IWorkWorkOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["WorkOrderWorkTasks"])) {
                this.workOrderWorkTasks = [] as any;
                for (let item of _data["WorkOrderWorkTasks"])
                    this.workOrderWorkTasks!.push(WorkOrderWorkTask.fromJS(item));
            }
            this.quoteWorkOrder = _data["QuoteWorkOrder"] ? QuoteWorkOrder.fromJS(_data["QuoteWorkOrder"]) : undefined as any;
            this.completedDate = _data["CompletedDate"] ? new Date(_data["CompletedDate"].toString()) : undefined as any;
            this.onMyWaLastSent = _data["OnMyWaLastSent"] ? new Date(_data["OnMyWaLastSent"].toString()) : undefined as any;
            this.wrappingUpLastSent = _data["WrappingUpLastSent"] ? new Date(_data["WrappingUpLastSent"].toString()) : undefined as any;
            if (Array.isArray(_data["WorkOrderCashCollected"])) {
                this.workOrderCashCollected = [] as any;
                for (let item of _data["WorkOrderCashCollected"])
                    this.workOrderCashCollected!.push(WorkWorkOrderCashCollected.fromJS(item));
            }
            this.commissionEarnedOverride = _data["CommissionEarnedOverride"];
            this.ignoreFirmtime = _data["IgnoreFirmtime"];
            this.isMultiday = _data["IsMultiday"];
            this.quoteId = _data["QuoteId"];
            this.autoChargeEnabled = _data["AutoChargeEnabled"];
            this.priceSummary = _data["PriceSummary"];
            this.quoteNumber = _data["QuoteNumber"];
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.addressId = _data["AddressId"];
            this.createdDate = _data["CreatedDate"] ? new Date(_data["CreatedDate"].toString()) : undefined as any;
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : undefined as any;
            this.completionStatus = _data["CompletionStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.note = _data["Note"];
            this.crewNote = _data["CrewNote"];
            this.representativeId = _data["RepresentativeId"];
            this.paymentDueId = _data["PaymentDueId"];
            this.addressSameAsCustomer = _data["AddressSameAsCustomer"];
            this.hidePrice = _data["HidePrice"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : undefined as any;
            this.representative = _data["Representative"] ? Employee.fromJS(_data["Representative"]) : undefined as any;
            this.paymentDueOption = _data["PaymentDueOption"] ? PaymentDueOption.fromJS(_data["PaymentDueOption"]) : undefined as any;
            if (Array.isArray(_data["WorkOrderPriceAdjustments"])) {
                this.workOrderPriceAdjustments = [] as any;
                for (let item of _data["WorkOrderPriceAdjustments"])
                    this.workOrderPriceAdjustments!.push(WorkOrderPriceAdjustment.fromJS(item));
            }
            this.salesTaxPercentage = _data["SalesTaxPercentage"];
            this.hasRentalExpense = _data["HasRentalExpense"];
            this.rentalCost = _data["RentalCost"];
            this.rentalDescription = _data["RentalDescription"];
            this.mostUrgentPriorityLevel = _data["MostUrgentPriorityLevel"] ? PriorityLevel.fromJS(_data["MostUrgentPriorityLevel"]) : undefined as any;
            this.hoursSummary = _data["HoursSummary"];
        }
    }

    static fromJS(data: any): WorkWorkOrder {
        data = typeof data === 'object' ? data : {};
        let result = new WorkWorkOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workOrderWorkTasks)) {
            data["WorkOrderWorkTasks"] = [];
            for (let item of this.workOrderWorkTasks)
                data["WorkOrderWorkTasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["QuoteWorkOrder"] = this.quoteWorkOrder ? this.quoteWorkOrder.toJSON() : undefined as any;
        data["CompletedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        data["OnMyWaLastSent"] = this.onMyWaLastSent ? this.onMyWaLastSent.toISOString() : undefined as any;
        data["WrappingUpLastSent"] = this.wrappingUpLastSent ? this.wrappingUpLastSent.toISOString() : undefined as any;
        if (Array.isArray(this.workOrderCashCollected)) {
            data["WorkOrderCashCollected"] = [];
            for (let item of this.workOrderCashCollected)
                data["WorkOrderCashCollected"].push(item ? item.toJSON() : undefined as any);
        }
        data["CommissionEarnedOverride"] = this.commissionEarnedOverride;
        data["IgnoreFirmtime"] = this.ignoreFirmtime;
        data["IsMultiday"] = this.isMultiday;
        data["QuoteId"] = this.quoteId;
        data["AutoChargeEnabled"] = this.autoChargeEnabled;
        data["PriceSummary"] = this.priceSummary;
        data["QuoteNumber"] = this.quoteNumber;
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["AddressId"] = this.addressId;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["CompletionStatus"] = this.completionStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["Note"] = this.note;
        data["CrewNote"] = this.crewNote;
        data["RepresentativeId"] = this.representativeId;
        data["PaymentDueId"] = this.paymentDueId;
        data["AddressSameAsCustomer"] = this.addressSameAsCustomer;
        data["HidePrice"] = this.hidePrice;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["Address"] = this.address ? this.address.toJSON() : undefined as any;
        data["Representative"] = this.representative ? this.representative.toJSON() : undefined as any;
        data["PaymentDueOption"] = this.paymentDueOption ? this.paymentDueOption.toJSON() : undefined as any;
        if (Array.isArray(this.workOrderPriceAdjustments)) {
            data["WorkOrderPriceAdjustments"] = [];
            for (let item of this.workOrderPriceAdjustments)
                data["WorkOrderPriceAdjustments"].push(item ? item.toJSON() : undefined as any);
        }
        data["SalesTaxPercentage"] = this.salesTaxPercentage;
        data["HasRentalExpense"] = this.hasRentalExpense;
        data["RentalCost"] = this.rentalCost;
        data["RentalDescription"] = this.rentalDescription;
        data["MostUrgentPriorityLevel"] = this.mostUrgentPriorityLevel ? this.mostUrgentPriorityLevel.toJSON() : undefined as any;
        data["HoursSummary"] = this.hoursSummary;
        return data;
    }
}

export interface IWorkWorkOrder {
    workOrderWorkTasks?: WorkOrderWorkTask[] | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
    completedDate?: Date | undefined;
    onMyWaLastSent?: Date | undefined;
    wrappingUpLastSent?: Date | undefined;
    workOrderCashCollected?: WorkWorkOrderCashCollected[] | undefined;
    commissionEarnedOverride?: boolean | undefined;
    ignoreFirmtime?: boolean | undefined;
    isMultiday?: boolean | undefined;
    quoteId?: number | undefined;
    autoChargeEnabled?: boolean | undefined;
    priceSummary?: number | undefined;
    quoteNumber?: string | undefined;
    id?: number | undefined;
    customerId?: number | undefined;
    addressId?: number | undefined;
    createdDate?: Date | undefined;
    paidDate?: Date | undefined;
    completionStatus?: WorkWorkOrderCompletionStatus | undefined;
    paymentStatus?: WorkWorkOrderPaymentStatus | undefined;
    note?: string | undefined;
    crewNote?: string | undefined;
    representativeId?: number | undefined;
    paymentDueId?: number | undefined;
    addressSameAsCustomer?: boolean | undefined;
    hidePrice?: boolean | undefined;
    customer?: Customer | undefined;
    address?: Address | undefined;
    representative?: Employee | undefined;
    paymentDueOption?: PaymentDueOption | undefined;
    workOrderPriceAdjustments?: WorkOrderPriceAdjustment[] | undefined;
    salesTaxPercentage?: number | undefined;
    hasRentalExpense?: boolean | undefined;
    rentalCost?: number | undefined;
    rentalDescription?: string | undefined;
    mostUrgentPriorityLevel?: PriorityLevel | undefined;
    hoursSummary?: number | undefined;
}

export class WorkOrderWellnessTask implements IWorkOrderWellnessTask {
    id?: number | undefined;
    wellnessWorkOrderId?: number | undefined;
    quoteWorkOrderId?: number | undefined;
    wellnessTaskId?: number | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
    wellnessTask?: WellnessTask | undefined;

    constructor(data?: IWorkOrderWellnessTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessWorkOrderId = _data["WellnessWorkOrderId"];
            this.quoteWorkOrderId = _data["QuoteWorkOrderId"];
            this.wellnessTaskId = _data["WellnessTaskId"];
            this.quoteWorkOrder = _data["QuoteWorkOrder"] ? QuoteWorkOrder.fromJS(_data["QuoteWorkOrder"]) : undefined as any;
            this.wellnessTask = _data["WellnessTask"] ? WellnessTask.fromJS(_data["WellnessTask"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderWellnessTask {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderWellnessTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessWorkOrderId"] = this.wellnessWorkOrderId;
        data["QuoteWorkOrderId"] = this.quoteWorkOrderId;
        data["WellnessTaskId"] = this.wellnessTaskId;
        data["QuoteWorkOrder"] = this.quoteWorkOrder ? this.quoteWorkOrder.toJSON() : undefined as any;
        data["WellnessTask"] = this.wellnessTask ? this.wellnessTask.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkOrderWellnessTask {
    id?: number | undefined;
    wellnessWorkOrderId?: number | undefined;
    quoteWorkOrderId?: number | undefined;
    wellnessTaskId?: number | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
    wellnessTask?: WellnessTask | undefined;
}

export class QuoteWorkOrder implements IQuoteWorkOrder {
    workOrderWellnessTasks?: WorkOrderWellnessTask[] | undefined;
    workOrderWorkTasks?: WorkOrderWorkTask[] | undefined;
    customerSignature?: string | undefined;
    lastSent?: Date | undefined;
    neighborPermissionRequired?: boolean | undefined;
    neighborPermissions?: NeighborPermission[] | undefined;
    activationDate?: Date | undefined;
    isMultiday?: boolean | undefined;
    requestForQuoteId?: number | undefined;
    signedDate?: Date | undefined;
    rejectedDate?: Date | undefined;
    quoteRequest?: QuoteRequest | undefined;
    originalSignedDate?: Date | undefined;
    hasCalculatedPriority?: boolean | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    priorityLevelId?: number | undefined;
    manualPriorityLevel?: PriorityLevel | undefined;
    priorityShortcutId?: number | undefined;
    priorityTypeShortcut?: PriorityTypeShortcut | undefined;
    manualPriorityShortcutType?: QuoteWorkOrderManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    commissionMinimum?: number | undefined;
    commissionBonusPercentage?: number | undefined;
    active?: boolean | undefined;
    quoteId?: number | undefined;
    priceSummary?: number | undefined;
    quoteNumber?: string | undefined;
    autoChargeEnabled?: boolean | undefined;
    id?: number | undefined;
    customerId?: number | undefined;
    addressId?: number | undefined;
    createdDate?: Date | undefined;
    paidDate?: Date | undefined;
    completionStatus?: QuoteWorkOrderCompletionStatus | undefined;
    paymentStatus?: QuoteWorkOrderPaymentStatus | undefined;
    note?: string | undefined;
    crewNote?: string | undefined;
    representativeId?: number | undefined;
    paymentDueId?: number | undefined;
    addressSameAsCustomer?: boolean | undefined;
    hidePrice?: boolean | undefined;
    customer?: Customer | undefined;
    address?: Address | undefined;
    representative?: Employee | undefined;
    paymentDueOption?: PaymentDueOption | undefined;
    workOrderPriceAdjustments?: WorkOrderPriceAdjustment[] | undefined;
    salesTaxPercentage?: number | undefined;
    hasRentalExpense?: boolean | undefined;
    rentalCost?: number | undefined;
    rentalDescription?: string | undefined;
    mostUrgentPriorityLevel?: PriorityLevel | undefined;
    hoursSummary?: number | undefined;

    constructor(data?: IQuoteWorkOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["WorkOrderWellnessTasks"])) {
                this.workOrderWellnessTasks = [] as any;
                for (let item of _data["WorkOrderWellnessTasks"])
                    this.workOrderWellnessTasks!.push(WorkOrderWellnessTask.fromJS(item));
            }
            if (Array.isArray(_data["WorkOrderWorkTasks"])) {
                this.workOrderWorkTasks = [] as any;
                for (let item of _data["WorkOrderWorkTasks"])
                    this.workOrderWorkTasks!.push(WorkOrderWorkTask.fromJS(item));
            }
            this.customerSignature = _data["customerSignature"];
            this.lastSent = _data["LastSent"] ? new Date(_data["LastSent"].toString()) : undefined as any;
            this.neighborPermissionRequired = _data["NeighborPermissionRequired"];
            if (Array.isArray(_data["NeighborPermissions"])) {
                this.neighborPermissions = [] as any;
                for (let item of _data["NeighborPermissions"])
                    this.neighborPermissions!.push(NeighborPermission.fromJS(item));
            }
            this.activationDate = _data["ActivationDate"] ? new Date(_data["ActivationDate"].toString()) : undefined as any;
            this.isMultiday = _data["IsMultiday"];
            this.requestForQuoteId = _data["RequestForQuoteId"];
            this.signedDate = _data["SignedDate"] ? new Date(_data["SignedDate"].toString()) : undefined as any;
            this.rejectedDate = _data["RejectedDate"] ? new Date(_data["RejectedDate"].toString()) : undefined as any;
            this.quoteRequest = _data["QuoteRequest"] ? QuoteRequest.fromJS(_data["QuoteRequest"]) : undefined as any;
            this.originalSignedDate = _data["OriginalSignedDate"] ? new Date(_data["OriginalSignedDate"].toString()) : undefined as any;
            this.hasCalculatedPriority = _data["HasCalculatedPriority"];
            this.dueDateStart = _data["DueDateStart"] ? new Date(_data["DueDateStart"].toString()) : undefined as any;
            this.dueDateEnd = _data["DueDateEnd"] ? new Date(_data["DueDateEnd"].toString()) : undefined as any;
            this.hardStartDate = _data["HardStartDate"];
            this.hardEndDate = _data["HardEndDate"];
            this.priorityLevelId = _data["PriorityLevelId"];
            this.manualPriorityLevel = _data["ManualPriorityLevel"] ? PriorityLevel.fromJS(_data["ManualPriorityLevel"]) : undefined as any;
            this.priorityShortcutId = _data["PriorityShortcutId"];
            this.priorityTypeShortcut = _data["PriorityTypeShortcut"] ? PriorityTypeShortcut.fromJS(_data["PriorityTypeShortcut"]) : undefined as any;
            this.manualPriorityShortcutType = _data["ManualPriorityShortcutType"];
            this.manualRangeStart = _data["ManualRangeStart"];
            this.manualRangeEnd = _data["ManualRangeEnd"];
            this.commissionMinimum = _data["CommissionMinimum"];
            this.commissionBonusPercentage = _data["CommissionBonusPercentage"];
            this.active = _data["Active"];
            this.quoteId = _data["QuoteId"];
            this.priceSummary = _data["PriceSummary"];
            this.quoteNumber = _data["QuoteNumber"];
            this.autoChargeEnabled = _data["AutoChargeEnabled"];
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.addressId = _data["AddressId"];
            this.createdDate = _data["CreatedDate"] ? new Date(_data["CreatedDate"].toString()) : undefined as any;
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : undefined as any;
            this.completionStatus = _data["CompletionStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.note = _data["Note"];
            this.crewNote = _data["CrewNote"];
            this.representativeId = _data["RepresentativeId"];
            this.paymentDueId = _data["PaymentDueId"];
            this.addressSameAsCustomer = _data["AddressSameAsCustomer"];
            this.hidePrice = _data["HidePrice"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : undefined as any;
            this.representative = _data["Representative"] ? Employee.fromJS(_data["Representative"]) : undefined as any;
            this.paymentDueOption = _data["PaymentDueOption"] ? PaymentDueOption.fromJS(_data["PaymentDueOption"]) : undefined as any;
            if (Array.isArray(_data["WorkOrderPriceAdjustments"])) {
                this.workOrderPriceAdjustments = [] as any;
                for (let item of _data["WorkOrderPriceAdjustments"])
                    this.workOrderPriceAdjustments!.push(WorkOrderPriceAdjustment.fromJS(item));
            }
            this.salesTaxPercentage = _data["SalesTaxPercentage"];
            this.hasRentalExpense = _data["HasRentalExpense"];
            this.rentalCost = _data["RentalCost"];
            this.rentalDescription = _data["RentalDescription"];
            this.mostUrgentPriorityLevel = _data["MostUrgentPriorityLevel"] ? PriorityLevel.fromJS(_data["MostUrgentPriorityLevel"]) : undefined as any;
            this.hoursSummary = _data["HoursSummary"];
        }
    }

    static fromJS(data: any): QuoteWorkOrder {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteWorkOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workOrderWellnessTasks)) {
            data["WorkOrderWellnessTasks"] = [];
            for (let item of this.workOrderWellnessTasks)
                data["WorkOrderWellnessTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workOrderWorkTasks)) {
            data["WorkOrderWorkTasks"] = [];
            for (let item of this.workOrderWorkTasks)
                data["WorkOrderWorkTasks"].push(item ? item.toJSON() : undefined as any);
        }
        data["customerSignature"] = this.customerSignature;
        data["LastSent"] = this.lastSent ? this.lastSent.toISOString() : undefined as any;
        data["NeighborPermissionRequired"] = this.neighborPermissionRequired;
        if (Array.isArray(this.neighborPermissions)) {
            data["NeighborPermissions"] = [];
            for (let item of this.neighborPermissions)
                data["NeighborPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        data["ActivationDate"] = this.activationDate ? this.activationDate.toISOString() : undefined as any;
        data["IsMultiday"] = this.isMultiday;
        data["RequestForQuoteId"] = this.requestForQuoteId;
        data["SignedDate"] = this.signedDate ? this.signedDate.toISOString() : undefined as any;
        data["RejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : undefined as any;
        data["QuoteRequest"] = this.quoteRequest ? this.quoteRequest.toJSON() : undefined as any;
        data["OriginalSignedDate"] = this.originalSignedDate ? this.originalSignedDate.toISOString() : undefined as any;
        data["HasCalculatedPriority"] = this.hasCalculatedPriority;
        data["DueDateStart"] = this.dueDateStart ? this.dueDateStart.toISOString() : undefined as any;
        data["DueDateEnd"] = this.dueDateEnd ? this.dueDateEnd.toISOString() : undefined as any;
        data["HardStartDate"] = this.hardStartDate;
        data["HardEndDate"] = this.hardEndDate;
        data["PriorityLevelId"] = this.priorityLevelId;
        data["ManualPriorityLevel"] = this.manualPriorityLevel ? this.manualPriorityLevel.toJSON() : undefined as any;
        data["PriorityShortcutId"] = this.priorityShortcutId;
        data["PriorityTypeShortcut"] = this.priorityTypeShortcut ? this.priorityTypeShortcut.toJSON() : undefined as any;
        data["ManualPriorityShortcutType"] = this.manualPriorityShortcutType;
        data["ManualRangeStart"] = this.manualRangeStart;
        data["ManualRangeEnd"] = this.manualRangeEnd;
        data["CommissionMinimum"] = this.commissionMinimum;
        data["CommissionBonusPercentage"] = this.commissionBonusPercentage;
        data["Active"] = this.active;
        data["QuoteId"] = this.quoteId;
        data["PriceSummary"] = this.priceSummary;
        data["QuoteNumber"] = this.quoteNumber;
        data["AutoChargeEnabled"] = this.autoChargeEnabled;
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["AddressId"] = this.addressId;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["CompletionStatus"] = this.completionStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["Note"] = this.note;
        data["CrewNote"] = this.crewNote;
        data["RepresentativeId"] = this.representativeId;
        data["PaymentDueId"] = this.paymentDueId;
        data["AddressSameAsCustomer"] = this.addressSameAsCustomer;
        data["HidePrice"] = this.hidePrice;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["Address"] = this.address ? this.address.toJSON() : undefined as any;
        data["Representative"] = this.representative ? this.representative.toJSON() : undefined as any;
        data["PaymentDueOption"] = this.paymentDueOption ? this.paymentDueOption.toJSON() : undefined as any;
        if (Array.isArray(this.workOrderPriceAdjustments)) {
            data["WorkOrderPriceAdjustments"] = [];
            for (let item of this.workOrderPriceAdjustments)
                data["WorkOrderPriceAdjustments"].push(item ? item.toJSON() : undefined as any);
        }
        data["SalesTaxPercentage"] = this.salesTaxPercentage;
        data["HasRentalExpense"] = this.hasRentalExpense;
        data["RentalCost"] = this.rentalCost;
        data["RentalDescription"] = this.rentalDescription;
        data["MostUrgentPriorityLevel"] = this.mostUrgentPriorityLevel ? this.mostUrgentPriorityLevel.toJSON() : undefined as any;
        data["HoursSummary"] = this.hoursSummary;
        return data;
    }
}

export interface IQuoteWorkOrder {
    workOrderWellnessTasks?: WorkOrderWellnessTask[] | undefined;
    workOrderWorkTasks?: WorkOrderWorkTask[] | undefined;
    customerSignature?: string | undefined;
    lastSent?: Date | undefined;
    neighborPermissionRequired?: boolean | undefined;
    neighborPermissions?: NeighborPermission[] | undefined;
    activationDate?: Date | undefined;
    isMultiday?: boolean | undefined;
    requestForQuoteId?: number | undefined;
    signedDate?: Date | undefined;
    rejectedDate?: Date | undefined;
    quoteRequest?: QuoteRequest | undefined;
    originalSignedDate?: Date | undefined;
    hasCalculatedPriority?: boolean | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    priorityLevelId?: number | undefined;
    manualPriorityLevel?: PriorityLevel | undefined;
    priorityShortcutId?: number | undefined;
    priorityTypeShortcut?: PriorityTypeShortcut | undefined;
    manualPriorityShortcutType?: QuoteWorkOrderManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    commissionMinimum?: number | undefined;
    commissionBonusPercentage?: number | undefined;
    active?: boolean | undefined;
    quoteId?: number | undefined;
    priceSummary?: number | undefined;
    quoteNumber?: string | undefined;
    autoChargeEnabled?: boolean | undefined;
    id?: number | undefined;
    customerId?: number | undefined;
    addressId?: number | undefined;
    createdDate?: Date | undefined;
    paidDate?: Date | undefined;
    completionStatus?: QuoteWorkOrderCompletionStatus | undefined;
    paymentStatus?: QuoteWorkOrderPaymentStatus | undefined;
    note?: string | undefined;
    crewNote?: string | undefined;
    representativeId?: number | undefined;
    paymentDueId?: number | undefined;
    addressSameAsCustomer?: boolean | undefined;
    hidePrice?: boolean | undefined;
    customer?: Customer | undefined;
    address?: Address | undefined;
    representative?: Employee | undefined;
    paymentDueOption?: PaymentDueOption | undefined;
    workOrderPriceAdjustments?: WorkOrderPriceAdjustment[] | undefined;
    salesTaxPercentage?: number | undefined;
    hasRentalExpense?: boolean | undefined;
    rentalCost?: number | undefined;
    rentalDescription?: string | undefined;
    mostUrgentPriorityLevel?: PriorityLevel | undefined;
    hoursSummary?: number | undefined;
}

export class WellnessWorkOrderCashCollected implements IWellnessWorkOrderCashCollected {
    id?: number | undefined;
    wellnessWorkOrder?: WellnessWorkOrder | undefined;
    amount?: number | undefined;
    invoiced?: boolean | undefined;
    wellnessWorkOrderId?: number | undefined;
    collectedBy?: number | undefined;
    employee?: Employee | undefined;

    constructor(data?: IWellnessWorkOrderCashCollected) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessWorkOrder = _data["WellnessWorkOrder"] ? WellnessWorkOrder.fromJS(_data["WellnessWorkOrder"]) : undefined as any;
            this.amount = _data["Amount"];
            this.invoiced = _data["Invoiced"];
            this.wellnessWorkOrderId = _data["WellnessWorkOrderId"];
            this.collectedBy = _data["CollectedBy"];
            this.employee = _data["Employee"] ? Employee.fromJS(_data["Employee"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessWorkOrderCashCollected {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessWorkOrderCashCollected();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessWorkOrder"] = this.wellnessWorkOrder ? this.wellnessWorkOrder.toJSON() : undefined as any;
        data["Amount"] = this.amount;
        data["Invoiced"] = this.invoiced;
        data["WellnessWorkOrderId"] = this.wellnessWorkOrderId;
        data["CollectedBy"] = this.collectedBy;
        data["Employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellnessWorkOrderCashCollected {
    id?: number | undefined;
    wellnessWorkOrder?: WellnessWorkOrder | undefined;
    amount?: number | undefined;
    invoiced?: boolean | undefined;
    wellnessWorkOrderId?: number | undefined;
    collectedBy?: number | undefined;
    employee?: Employee | undefined;
}

export class Customer implements ICustomer {
    id?: number | undefined;
    active?: boolean | undefined;
    taxExempt?: boolean | undefined;
    manualPayment?: boolean | undefined;
    addressId?: number | undefined;
    address?: Address | undefined;
    stripeCustomerId?: string | undefined;
    customerTypeId?: number | undefined;
    companyName?: string | undefined;
    paymentInfoRequired?: boolean | undefined;
    customerType?: CustomerType | undefined;
    createdDate?: Date | undefined;
    deleted?: boolean | undefined;
    customerComments?: CustomerComment[] | undefined;
    customerRoles?: CustomerRole[] | undefined;
    customerContacts?: CustomerContact[] | undefined;
    fullName?: string | undefined;
    readonly primaryPhone?: string | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.taxExempt = _data["TaxExempt"];
            this.manualPayment = _data["ManualPayment"];
            this.addressId = _data["AddressId"];
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : undefined as any;
            this.stripeCustomerId = _data["StripeCustomerId"];
            this.customerTypeId = _data["CustomerTypeId"];
            this.companyName = _data["CompanyName"];
            this.paymentInfoRequired = _data["PaymentInfoRequired"];
            this.customerType = _data["CustomerType"] ? CustomerType.fromJS(_data["CustomerType"]) : undefined as any;
            this.createdDate = _data["CreatedDate"] ? new Date(_data["CreatedDate"].toString()) : undefined as any;
            this.deleted = _data["Deleted"];
            if (Array.isArray(_data["CustomerComments"])) {
                this.customerComments = [] as any;
                for (let item of _data["CustomerComments"])
                    this.customerComments!.push(CustomerComment.fromJS(item));
            }
            if (Array.isArray(_data["CustomerRoles"])) {
                this.customerRoles = [] as any;
                for (let item of _data["CustomerRoles"])
                    this.customerRoles!.push(CustomerRole.fromJS(item));
            }
            if (Array.isArray(_data["CustomerContacts"])) {
                this.customerContacts = [] as any;
                for (let item of _data["CustomerContacts"])
                    this.customerContacts!.push(CustomerContact.fromJS(item));
            }
            this.fullName = _data["FullName"];
            (this as any).primaryPhone = _data["PrimaryPhone"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["TaxExempt"] = this.taxExempt;
        data["ManualPayment"] = this.manualPayment;
        data["AddressId"] = this.addressId;
        data["Address"] = this.address ? this.address.toJSON() : undefined as any;
        data["StripeCustomerId"] = this.stripeCustomerId;
        data["CustomerTypeId"] = this.customerTypeId;
        data["CompanyName"] = this.companyName;
        data["PaymentInfoRequired"] = this.paymentInfoRequired;
        data["CustomerType"] = this.customerType ? this.customerType.toJSON() : undefined as any;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["Deleted"] = this.deleted;
        if (Array.isArray(this.customerComments)) {
            data["CustomerComments"] = [];
            for (let item of this.customerComments)
                data["CustomerComments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerRoles)) {
            data["CustomerRoles"] = [];
            for (let item of this.customerRoles)
                data["CustomerRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerContacts)) {
            data["CustomerContacts"] = [];
            for (let item of this.customerContacts)
                data["CustomerContacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["FullName"] = this.fullName;
        data["PrimaryPhone"] = this.primaryPhone;
        return data;
    }
}

export interface ICustomer {
    id?: number | undefined;
    active?: boolean | undefined;
    taxExempt?: boolean | undefined;
    manualPayment?: boolean | undefined;
    addressId?: number | undefined;
    address?: Address | undefined;
    stripeCustomerId?: string | undefined;
    customerTypeId?: number | undefined;
    companyName?: string | undefined;
    paymentInfoRequired?: boolean | undefined;
    customerType?: CustomerType | undefined;
    createdDate?: Date | undefined;
    deleted?: boolean | undefined;
    customerComments?: CustomerComment[] | undefined;
    customerRoles?: CustomerRole[] | undefined;
    customerContacts?: CustomerContact[] | undefined;
    fullName?: string | undefined;
    primaryPhone?: string | undefined;
}

export class Employee implements IEmployee {
    id?: number | undefined;
    active?: boolean | undefined;
    currentlyEmployed?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    employeeSignature?: string | undefined;
    salesGoal?: number | undefined;
    addressId?: number | undefined;
    address?: Address | undefined;
    emailAddressId?: number | undefined;
    emailAddress?: EmailAddress | undefined;
    employeeSkills?: EmployeeSkill[] | undefined;
    employeeRoles?: EmployeeRole[] | undefined;
    zipCodeAssignments?: ZipCodeAssignment[] | undefined;
    regionalManagerTimeSlots?: RegionalManagerTimeSlot[] | undefined;
    regionalManagerScheduleEvents?: RegionalManagerScheduleEvent[] | undefined;
    reportTileUserAssignments?: ReportTileUserAssignment[] | undefined;
    readonly isEmployee?: boolean | undefined;
    readonly fullName?: string | undefined;
    readonly passwordIsExpired?: boolean | undefined;
    requirePasswordReset?: boolean | undefined;
    lastPasswordChange?: Date | undefined;
    multiFactorAuthenticationPreference?: EmployeeMultiFactorAuthenticationPreference | undefined;
    lastMultiFactorAuthenticationDate?: Date | undefined;
    multiFactorAuthenticationCode?: string | undefined;
    readonly requireMultiFactorAuthSetup?: boolean | undefined;
    readonly requireMultiFactorAuth?: boolean | undefined;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.currentlyEmployed = _data["CurrentlyEmployed"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.phoneNumber = _data["PhoneNumber"];
            this.employeeSignature = _data["EmployeeSignature"];
            this.salesGoal = _data["SalesGoal"];
            this.addressId = _data["AddressId"];
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : undefined as any;
            this.emailAddressId = _data["EmailAddressId"];
            this.emailAddress = _data["EmailAddress"] ? EmailAddress.fromJS(_data["EmailAddress"]) : undefined as any;
            if (Array.isArray(_data["EmployeeSkills"])) {
                this.employeeSkills = [] as any;
                for (let item of _data["EmployeeSkills"])
                    this.employeeSkills!.push(EmployeeSkill.fromJS(item));
            }
            if (Array.isArray(_data["EmployeeRoles"])) {
                this.employeeRoles = [] as any;
                for (let item of _data["EmployeeRoles"])
                    this.employeeRoles!.push(EmployeeRole.fromJS(item));
            }
            if (Array.isArray(_data["ZipCodeAssignments"])) {
                this.zipCodeAssignments = [] as any;
                for (let item of _data["ZipCodeAssignments"])
                    this.zipCodeAssignments!.push(ZipCodeAssignment.fromJS(item));
            }
            if (Array.isArray(_data["RegionalManagerTimeSlots"])) {
                this.regionalManagerTimeSlots = [] as any;
                for (let item of _data["RegionalManagerTimeSlots"])
                    this.regionalManagerTimeSlots!.push(RegionalManagerTimeSlot.fromJS(item));
            }
            if (Array.isArray(_data["RegionalManagerScheduleEvents"])) {
                this.regionalManagerScheduleEvents = [] as any;
                for (let item of _data["RegionalManagerScheduleEvents"])
                    this.regionalManagerScheduleEvents!.push(RegionalManagerScheduleEvent.fromJS(item));
            }
            if (Array.isArray(_data["ReportTileUserAssignments"])) {
                this.reportTileUserAssignments = [] as any;
                for (let item of _data["ReportTileUserAssignments"])
                    this.reportTileUserAssignments!.push(ReportTileUserAssignment.fromJS(item));
            }
            (this as any).isEmployee = _data["IsEmployee"];
            (this as any).fullName = _data["FullName"];
            (this as any).passwordIsExpired = _data["PasswordIsExpired"];
            this.requirePasswordReset = _data["RequirePasswordReset"];
            this.lastPasswordChange = _data["LastPasswordChange"] ? new Date(_data["LastPasswordChange"].toString()) : undefined as any;
            this.multiFactorAuthenticationPreference = _data["MultiFactorAuthenticationPreference"];
            this.lastMultiFactorAuthenticationDate = _data["LastMultiFactorAuthenticationDate"] ? new Date(_data["LastMultiFactorAuthenticationDate"].toString()) : undefined as any;
            this.multiFactorAuthenticationCode = _data["MultiFactorAuthenticationCode"];
            (this as any).requireMultiFactorAuthSetup = _data["RequireMultiFactorAuthSetup"];
            (this as any).requireMultiFactorAuth = _data["RequireMultiFactorAuth"];
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["CurrentlyEmployed"] = this.currentlyEmployed;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["PhoneNumber"] = this.phoneNumber;
        data["EmployeeSignature"] = this.employeeSignature;
        data["SalesGoal"] = this.salesGoal;
        data["AddressId"] = this.addressId;
        data["Address"] = this.address ? this.address.toJSON() : undefined as any;
        data["EmailAddressId"] = this.emailAddressId;
        data["EmailAddress"] = this.emailAddress ? this.emailAddress.toJSON() : undefined as any;
        if (Array.isArray(this.employeeSkills)) {
            data["EmployeeSkills"] = [];
            for (let item of this.employeeSkills)
                data["EmployeeSkills"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.employeeRoles)) {
            data["EmployeeRoles"] = [];
            for (let item of this.employeeRoles)
                data["EmployeeRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.zipCodeAssignments)) {
            data["ZipCodeAssignments"] = [];
            for (let item of this.zipCodeAssignments)
                data["ZipCodeAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionalManagerTimeSlots)) {
            data["RegionalManagerTimeSlots"] = [];
            for (let item of this.regionalManagerTimeSlots)
                data["RegionalManagerTimeSlots"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.regionalManagerScheduleEvents)) {
            data["RegionalManagerScheduleEvents"] = [];
            for (let item of this.regionalManagerScheduleEvents)
                data["RegionalManagerScheduleEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.reportTileUserAssignments)) {
            data["ReportTileUserAssignments"] = [];
            for (let item of this.reportTileUserAssignments)
                data["ReportTileUserAssignments"].push(item ? item.toJSON() : undefined as any);
        }
        data["IsEmployee"] = this.isEmployee;
        data["FullName"] = this.fullName;
        data["PasswordIsExpired"] = this.passwordIsExpired;
        data["RequirePasswordReset"] = this.requirePasswordReset;
        data["LastPasswordChange"] = this.lastPasswordChange ? this.lastPasswordChange.toISOString() : undefined as any;
        data["MultiFactorAuthenticationPreference"] = this.multiFactorAuthenticationPreference;
        data["LastMultiFactorAuthenticationDate"] = this.lastMultiFactorAuthenticationDate ? this.lastMultiFactorAuthenticationDate.toISOString() : undefined as any;
        data["MultiFactorAuthenticationCode"] = this.multiFactorAuthenticationCode;
        data["RequireMultiFactorAuthSetup"] = this.requireMultiFactorAuthSetup;
        data["RequireMultiFactorAuth"] = this.requireMultiFactorAuth;
        return data;
    }
}

export interface IEmployee {
    id?: number | undefined;
    active?: boolean | undefined;
    currentlyEmployed?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    employeeSignature?: string | undefined;
    salesGoal?: number | undefined;
    addressId?: number | undefined;
    address?: Address | undefined;
    emailAddressId?: number | undefined;
    emailAddress?: EmailAddress | undefined;
    employeeSkills?: EmployeeSkill[] | undefined;
    employeeRoles?: EmployeeRole[] | undefined;
    zipCodeAssignments?: ZipCodeAssignment[] | undefined;
    regionalManagerTimeSlots?: RegionalManagerTimeSlot[] | undefined;
    regionalManagerScheduleEvents?: RegionalManagerScheduleEvent[] | undefined;
    reportTileUserAssignments?: ReportTileUserAssignment[] | undefined;
    isEmployee?: boolean | undefined;
    fullName?: string | undefined;
    passwordIsExpired?: boolean | undefined;
    requirePasswordReset?: boolean | undefined;
    lastPasswordChange?: Date | undefined;
    multiFactorAuthenticationPreference?: EmployeeMultiFactorAuthenticationPreference | undefined;
    lastMultiFactorAuthenticationDate?: Date | undefined;
    multiFactorAuthenticationCode?: string | undefined;
    requireMultiFactorAuthSetup?: boolean | undefined;
    requireMultiFactorAuth?: boolean | undefined;
}

export class PaymentDueOption implements IPaymentDueOption {
    id?: number | undefined;
    paymentDueName?: string | undefined;

    constructor(data?: IPaymentDueOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.paymentDueName = _data["PaymentDueName"];
        }
    }

    static fromJS(data: any): PaymentDueOption {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDueOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["PaymentDueName"] = this.paymentDueName;
        return data;
    }
}

export interface IPaymentDueOption {
    id?: number | undefined;
    paymentDueName?: string | undefined;
}

export class WorkOrderPriceAdjustment implements IWorkOrderPriceAdjustment {
    id?: number | undefined;
    wellnessWorkOrderId?: number | undefined;
    workWorkOrderId?: number | undefined;
    quoteWorkOrderId?: number | undefined;
    priceAdjustmentId?: number | undefined;
    priceAdjustment?: PriceAdjustment | undefined;

    constructor(data?: IWorkOrderPriceAdjustment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessWorkOrderId = _data["WellnessWorkOrderId"];
            this.workWorkOrderId = _data["WorkWorkOrderId"];
            this.quoteWorkOrderId = _data["QuoteWorkOrderId"];
            this.priceAdjustmentId = _data["PriceAdjustmentId"];
            this.priceAdjustment = _data["PriceAdjustment"] ? PriceAdjustment.fromJS(_data["PriceAdjustment"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderPriceAdjustment {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderPriceAdjustment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessWorkOrderId"] = this.wellnessWorkOrderId;
        data["WorkWorkOrderId"] = this.workWorkOrderId;
        data["QuoteWorkOrderId"] = this.quoteWorkOrderId;
        data["PriceAdjustmentId"] = this.priceAdjustmentId;
        data["PriceAdjustment"] = this.priceAdjustment ? this.priceAdjustment.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkOrderPriceAdjustment {
    id?: number | undefined;
    wellnessWorkOrderId?: number | undefined;
    workWorkOrderId?: number | undefined;
    quoteWorkOrderId?: number | undefined;
    priceAdjustmentId?: number | undefined;
    priceAdjustment?: PriceAdjustment | undefined;
}

export class PriorityLevel implements IPriorityLevel {
    id?: number | undefined;
    active?: boolean | undefined;
    status?: string | undefined;
    backgroundColor?: string | undefined;
    textColor?: string | undefined;
    order?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IPriorityLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.status = _data["Status"];
            this.backgroundColor = _data["BackgroundColor"];
            this.textColor = _data["TextColor"];
            this.order = _data["Order"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : undefined as any;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PriorityLevel {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Status"] = this.status;
        data["BackgroundColor"] = this.backgroundColor;
        data["TextColor"] = this.textColor;
        data["Order"] = this.order;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPriorityLevel {
    id?: number | undefined;
    active?: boolean | undefined;
    status?: string | undefined;
    backgroundColor?: string | undefined;
    textColor?: string | undefined;
    order?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class WorkOrderWorkTask implements IWorkOrderWorkTask {
    id?: number | undefined;
    workWorkOrderId?: number | undefined;
    quoteWorkOrderId?: number | undefined;
    workTaskId?: number | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
    workTask?: WorkTask | undefined;

    constructor(data?: IWorkOrderWorkTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.workWorkOrderId = _data["WorkWorkOrderId"];
            this.quoteWorkOrderId = _data["QuoteWorkOrderId"];
            this.workTaskId = _data["WorkTaskId"];
            this.quoteWorkOrder = _data["QuoteWorkOrder"] ? QuoteWorkOrder.fromJS(_data["QuoteWorkOrder"]) : undefined as any;
            this.workTask = _data["WorkTask"] ? WorkTask.fromJS(_data["WorkTask"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderWorkTask {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderWorkTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WorkWorkOrderId"] = this.workWorkOrderId;
        data["QuoteWorkOrderId"] = this.quoteWorkOrderId;
        data["WorkTaskId"] = this.workTaskId;
        data["QuoteWorkOrder"] = this.quoteWorkOrder ? this.quoteWorkOrder.toJSON() : undefined as any;
        data["WorkTask"] = this.workTask ? this.workTask.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkOrderWorkTask {
    id?: number | undefined;
    workWorkOrderId?: number | undefined;
    quoteWorkOrderId?: number | undefined;
    workTaskId?: number | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
    workTask?: WorkTask | undefined;
}

export class WorkWorkOrderCashCollected implements IWorkWorkOrderCashCollected {
    id?: number | undefined;
    workWorkOrder?: WorkWorkOrder | undefined;
    amount?: number | undefined;
    invoiced?: boolean | undefined;
    workWorkOrderId?: number | undefined;
    collectedBy?: number | undefined;
    employee?: Employee | undefined;

    constructor(data?: IWorkWorkOrderCashCollected) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.workWorkOrder = _data["WorkWorkOrder"] ? WorkWorkOrder.fromJS(_data["WorkWorkOrder"]) : undefined as any;
            this.amount = _data["Amount"];
            this.invoiced = _data["Invoiced"];
            this.workWorkOrderId = _data["WorkWorkOrderId"];
            this.collectedBy = _data["CollectedBy"];
            this.employee = _data["Employee"] ? Employee.fromJS(_data["Employee"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkWorkOrderCashCollected {
        data = typeof data === 'object' ? data : {};
        let result = new WorkWorkOrderCashCollected();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WorkWorkOrder"] = this.workWorkOrder ? this.workWorkOrder.toJSON() : undefined as any;
        data["Amount"] = this.amount;
        data["Invoiced"] = this.invoiced;
        data["WorkWorkOrderId"] = this.workWorkOrderId;
        data["CollectedBy"] = this.collectedBy;
        data["Employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkWorkOrderCashCollected {
    id?: number | undefined;
    workWorkOrder?: WorkWorkOrder | undefined;
    amount?: number | undefined;
    invoiced?: boolean | undefined;
    workWorkOrderId?: number | undefined;
    collectedBy?: number | undefined;
    employee?: Employee | undefined;
}

export class WellnessTask implements IWellnessTask {
    id?: number | undefined;
    name?: string | undefined;
    cost?: number | undefined;
    price?: number | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    scheduleDateFrom?: Date | undefined;
    scheduleDateTo?: Date | undefined;
    hasCalculatedPriority?: boolean | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    manualPriorityShortcutType?: WellnessTaskManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    priorityLevelId?: number | undefined;
    manualPriorityLevel?: PriorityLevel | undefined;
    priorityShortcutId?: number | undefined;
    priorityTypeShortcut?: PriorityTypeShortcut | undefined;
    growingDegreeDay?: number | undefined;
    reschedule?: boolean | undefined;
    hours?: number | undefined;
    location?: string | undefined;
    currentBucketId?: number | undefined;
    currentBigDaySubrangeId?: number | undefined;
    completionStatus?: WellnessTaskCompletionStatus | undefined;
    paymentStatus?: WellnessTaskPaymentStatus | undefined;
    completedDate?: Date | undefined;
    paidDate?: Date | undefined;
    jobFeedback?: string | undefined;
    taskHourEntries?: WellnessTaskHourEntry[] | undefined;
    wellnessTaskChemicalCombos?: WellnessTaskChemicalCombo[] | undefined;
    wellnessTaskGoBackEquipment?: WellnessTaskGoBackEquipment[] | undefined;
    wellnessTaskEquipment?: WellnessTaskEquipment[] | undefined;
    wellnessTaskSkills?: WellnessTaskSkill[] | undefined;
    wellnessTaskTreeTypes?: WellnessTaskTreeType[] | undefined;
    schedulableAfterCompletionOfId?: number | undefined;
    schedulableAfterCompletionOf?: WellnessTask | undefined;
    primordialTaskId?: number | undefined;
    timesRescheduled?: number | undefined;
    customerIssue?: string | undefined;
    goBackFeedback?: string | undefined;
    goBackHoursEstimate?: number | undefined;
    goBackCompletionDate?: Date | undefined;
    goBackBucketId?: number | undefined;
    isGoBack?: boolean | undefined;
    renewable?: boolean | undefined;
    renewalAccepted?: boolean | undefined;
    renewed?: boolean | undefined;
    fixedPrice?: boolean | undefined;
    hourlyRate?: number | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    customerSignature?: string | undefined;
    signedDate?: Date | undefined;

    constructor(data?: IWellnessTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.cost = _data["Cost"];
            this.price = _data["Price"];
            this.description = _data["Description"];
            this.active = _data["Active"];
            this.scheduleDateFrom = _data["ScheduleDateFrom"] ? new Date(_data["ScheduleDateFrom"].toString()) : undefined as any;
            this.scheduleDateTo = _data["ScheduleDateTo"] ? new Date(_data["ScheduleDateTo"].toString()) : undefined as any;
            this.hasCalculatedPriority = _data["HasCalculatedPriority"];
            this.dueDateStart = _data["DueDateStart"] ? new Date(_data["DueDateStart"].toString()) : undefined as any;
            this.dueDateEnd = _data["DueDateEnd"] ? new Date(_data["DueDateEnd"].toString()) : undefined as any;
            this.hardStartDate = _data["HardStartDate"];
            this.hardEndDate = _data["HardEndDate"];
            this.manualPriorityShortcutType = _data["ManualPriorityShortcutType"];
            this.manualRangeStart = _data["ManualRangeStart"];
            this.manualRangeEnd = _data["ManualRangeEnd"];
            this.priorityLevelId = _data["PriorityLevelId"];
            this.manualPriorityLevel = _data["ManualPriorityLevel"] ? PriorityLevel.fromJS(_data["ManualPriorityLevel"]) : undefined as any;
            this.priorityShortcutId = _data["PriorityShortcutId"];
            this.priorityTypeShortcut = _data["PriorityTypeShortcut"] ? PriorityTypeShortcut.fromJS(_data["PriorityTypeShortcut"]) : undefined as any;
            this.growingDegreeDay = _data["GrowingDegreeDay"];
            this.reschedule = _data["Reschedule"];
            this.hours = _data["Hours"];
            this.location = _data["Location"];
            this.currentBucketId = _data["CurrentBucketId"];
            this.currentBigDaySubrangeId = _data["CurrentBigDaySubrangeId"];
            this.completionStatus = _data["CompletionStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.completedDate = _data["CompletedDate"] ? new Date(_data["CompletedDate"].toString()) : undefined as any;
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : undefined as any;
            this.jobFeedback = _data["JobFeedback"];
            if (Array.isArray(_data["TaskHourEntries"])) {
                this.taskHourEntries = [] as any;
                for (let item of _data["TaskHourEntries"])
                    this.taskHourEntries!.push(WellnessTaskHourEntry.fromJS(item));
            }
            if (Array.isArray(_data["WellnessTaskChemicalCombos"])) {
                this.wellnessTaskChemicalCombos = [] as any;
                for (let item of _data["WellnessTaskChemicalCombos"])
                    this.wellnessTaskChemicalCombos!.push(WellnessTaskChemicalCombo.fromJS(item));
            }
            if (Array.isArray(_data["WellnessTaskGoBackEquipment"])) {
                this.wellnessTaskGoBackEquipment = [] as any;
                for (let item of _data["WellnessTaskGoBackEquipment"])
                    this.wellnessTaskGoBackEquipment!.push(WellnessTaskGoBackEquipment.fromJS(item));
            }
            if (Array.isArray(_data["WellnessTaskEquipment"])) {
                this.wellnessTaskEquipment = [] as any;
                for (let item of _data["WellnessTaskEquipment"])
                    this.wellnessTaskEquipment!.push(WellnessTaskEquipment.fromJS(item));
            }
            if (Array.isArray(_data["WellnessTaskSkills"])) {
                this.wellnessTaskSkills = [] as any;
                for (let item of _data["WellnessTaskSkills"])
                    this.wellnessTaskSkills!.push(WellnessTaskSkill.fromJS(item));
            }
            if (Array.isArray(_data["WellnessTaskTreeTypes"])) {
                this.wellnessTaskTreeTypes = [] as any;
                for (let item of _data["WellnessTaskTreeTypes"])
                    this.wellnessTaskTreeTypes!.push(WellnessTaskTreeType.fromJS(item));
            }
            this.schedulableAfterCompletionOfId = _data["SchedulableAfterCompletionOfId"];
            this.schedulableAfterCompletionOf = _data["SchedulableAfterCompletionOf"] ? WellnessTask.fromJS(_data["SchedulableAfterCompletionOf"]) : undefined as any;
            this.primordialTaskId = _data["PrimordialTaskId"];
            this.timesRescheduled = _data["TimesRescheduled"];
            this.customerIssue = _data["CustomerIssue"];
            this.goBackFeedback = _data["GoBackFeedback"];
            this.goBackHoursEstimate = _data["GoBackHoursEstimate"];
            this.goBackCompletionDate = _data["GoBackCompletionDate"] ? new Date(_data["GoBackCompletionDate"].toString()) : undefined as any;
            this.goBackBucketId = _data["GoBackBucketId"];
            this.isGoBack = _data["IsGoBack"];
            this.renewable = _data["Renewable"];
            this.renewalAccepted = _data["RenewalAccepted"];
            this.renewed = _data["Renewed"];
            this.fixedPrice = _data["FixedPrice"];
            this.hourlyRate = _data["HourlyRate"];
            this.minPrice = _data["MinPrice"];
            this.maxPrice = _data["MaxPrice"];
            this.customerSignature = _data["CustomerSignature"];
            this.signedDate = _data["SignedDate"] ? new Date(_data["SignedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessTask {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Cost"] = this.cost;
        data["Price"] = this.price;
        data["Description"] = this.description;
        data["Active"] = this.active;
        data["ScheduleDateFrom"] = this.scheduleDateFrom ? this.scheduleDateFrom.toISOString() : undefined as any;
        data["ScheduleDateTo"] = this.scheduleDateTo ? this.scheduleDateTo.toISOString() : undefined as any;
        data["HasCalculatedPriority"] = this.hasCalculatedPriority;
        data["DueDateStart"] = this.dueDateStart ? this.dueDateStart.toISOString() : undefined as any;
        data["DueDateEnd"] = this.dueDateEnd ? this.dueDateEnd.toISOString() : undefined as any;
        data["HardStartDate"] = this.hardStartDate;
        data["HardEndDate"] = this.hardEndDate;
        data["ManualPriorityShortcutType"] = this.manualPriorityShortcutType;
        data["ManualRangeStart"] = this.manualRangeStart;
        data["ManualRangeEnd"] = this.manualRangeEnd;
        data["PriorityLevelId"] = this.priorityLevelId;
        data["ManualPriorityLevel"] = this.manualPriorityLevel ? this.manualPriorityLevel.toJSON() : undefined as any;
        data["PriorityShortcutId"] = this.priorityShortcutId;
        data["PriorityTypeShortcut"] = this.priorityTypeShortcut ? this.priorityTypeShortcut.toJSON() : undefined as any;
        data["GrowingDegreeDay"] = this.growingDegreeDay;
        data["Reschedule"] = this.reschedule;
        data["Hours"] = this.hours;
        data["Location"] = this.location;
        data["CurrentBucketId"] = this.currentBucketId;
        data["CurrentBigDaySubrangeId"] = this.currentBigDaySubrangeId;
        data["CompletionStatus"] = this.completionStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["CompletedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["JobFeedback"] = this.jobFeedback;
        if (Array.isArray(this.taskHourEntries)) {
            data["TaskHourEntries"] = [];
            for (let item of this.taskHourEntries)
                data["TaskHourEntries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellnessTaskChemicalCombos)) {
            data["WellnessTaskChemicalCombos"] = [];
            for (let item of this.wellnessTaskChemicalCombos)
                data["WellnessTaskChemicalCombos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellnessTaskGoBackEquipment)) {
            data["WellnessTaskGoBackEquipment"] = [];
            for (let item of this.wellnessTaskGoBackEquipment)
                data["WellnessTaskGoBackEquipment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellnessTaskEquipment)) {
            data["WellnessTaskEquipment"] = [];
            for (let item of this.wellnessTaskEquipment)
                data["WellnessTaskEquipment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellnessTaskSkills)) {
            data["WellnessTaskSkills"] = [];
            for (let item of this.wellnessTaskSkills)
                data["WellnessTaskSkills"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.wellnessTaskTreeTypes)) {
            data["WellnessTaskTreeTypes"] = [];
            for (let item of this.wellnessTaskTreeTypes)
                data["WellnessTaskTreeTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["SchedulableAfterCompletionOfId"] = this.schedulableAfterCompletionOfId;
        data["SchedulableAfterCompletionOf"] = this.schedulableAfterCompletionOf ? this.schedulableAfterCompletionOf.toJSON() : undefined as any;
        data["PrimordialTaskId"] = this.primordialTaskId;
        data["TimesRescheduled"] = this.timesRescheduled;
        data["CustomerIssue"] = this.customerIssue;
        data["GoBackFeedback"] = this.goBackFeedback;
        data["GoBackHoursEstimate"] = this.goBackHoursEstimate;
        data["GoBackCompletionDate"] = this.goBackCompletionDate ? this.goBackCompletionDate.toISOString() : undefined as any;
        data["GoBackBucketId"] = this.goBackBucketId;
        data["IsGoBack"] = this.isGoBack;
        data["Renewable"] = this.renewable;
        data["RenewalAccepted"] = this.renewalAccepted;
        data["Renewed"] = this.renewed;
        data["FixedPrice"] = this.fixedPrice;
        data["HourlyRate"] = this.hourlyRate;
        data["MinPrice"] = this.minPrice;
        data["MaxPrice"] = this.maxPrice;
        data["CustomerSignature"] = this.customerSignature;
        data["SignedDate"] = this.signedDate ? this.signedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWellnessTask {
    id?: number | undefined;
    name?: string | undefined;
    cost?: number | undefined;
    price?: number | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    scheduleDateFrom?: Date | undefined;
    scheduleDateTo?: Date | undefined;
    hasCalculatedPriority?: boolean | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    manualPriorityShortcutType?: WellnessTaskManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    priorityLevelId?: number | undefined;
    manualPriorityLevel?: PriorityLevel | undefined;
    priorityShortcutId?: number | undefined;
    priorityTypeShortcut?: PriorityTypeShortcut | undefined;
    growingDegreeDay?: number | undefined;
    reschedule?: boolean | undefined;
    hours?: number | undefined;
    location?: string | undefined;
    currentBucketId?: number | undefined;
    currentBigDaySubrangeId?: number | undefined;
    completionStatus?: WellnessTaskCompletionStatus | undefined;
    paymentStatus?: WellnessTaskPaymentStatus | undefined;
    completedDate?: Date | undefined;
    paidDate?: Date | undefined;
    jobFeedback?: string | undefined;
    taskHourEntries?: WellnessTaskHourEntry[] | undefined;
    wellnessTaskChemicalCombos?: WellnessTaskChemicalCombo[] | undefined;
    wellnessTaskGoBackEquipment?: WellnessTaskGoBackEquipment[] | undefined;
    wellnessTaskEquipment?: WellnessTaskEquipment[] | undefined;
    wellnessTaskSkills?: WellnessTaskSkill[] | undefined;
    wellnessTaskTreeTypes?: WellnessTaskTreeType[] | undefined;
    schedulableAfterCompletionOfId?: number | undefined;
    schedulableAfterCompletionOf?: WellnessTask | undefined;
    primordialTaskId?: number | undefined;
    timesRescheduled?: number | undefined;
    customerIssue?: string | undefined;
    goBackFeedback?: string | undefined;
    goBackHoursEstimate?: number | undefined;
    goBackCompletionDate?: Date | undefined;
    goBackBucketId?: number | undefined;
    isGoBack?: boolean | undefined;
    renewable?: boolean | undefined;
    renewalAccepted?: boolean | undefined;
    renewed?: boolean | undefined;
    fixedPrice?: boolean | undefined;
    hourlyRate?: number | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    customerSignature?: string | undefined;
    signedDate?: Date | undefined;
}

export class NeighborPermission implements INeighborPermission {
    id?: number | undefined;
    activitiesOnNeighborProperty?: string | undefined;
    address?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    signUpForEmails?: boolean | undefined;
    neighborSignature?: string | undefined;
    signedDate?: Date | undefined;
    lastSentDate?: Date | undefined;
    deleted?: boolean | undefined;
    quoteWorkOrderId?: number | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;

    constructor(data?: INeighborPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.activitiesOnNeighborProperty = _data["ActivitiesOnNeighborProperty"];
            this.address = _data["Address"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.email = _data["Email"];
            this.signUpForEmails = _data["SignUpForEmails"];
            this.neighborSignature = _data["NeighborSignature"];
            this.signedDate = _data["SignedDate"] ? new Date(_data["SignedDate"].toString()) : undefined as any;
            this.lastSentDate = _data["LastSentDate"] ? new Date(_data["LastSentDate"].toString()) : undefined as any;
            this.deleted = _data["Deleted"];
            this.quoteWorkOrderId = _data["QuoteWorkOrderId"];
            this.quoteWorkOrder = _data["QuoteWorkOrder"] ? QuoteWorkOrder.fromJS(_data["QuoteWorkOrder"]) : undefined as any;
        }
    }

    static fromJS(data: any): NeighborPermission {
        data = typeof data === 'object' ? data : {};
        let result = new NeighborPermission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ActivitiesOnNeighborProperty"] = this.activitiesOnNeighborProperty;
        data["Address"] = this.address;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Email"] = this.email;
        data["SignUpForEmails"] = this.signUpForEmails;
        data["NeighborSignature"] = this.neighborSignature;
        data["SignedDate"] = this.signedDate ? this.signedDate.toISOString() : undefined as any;
        data["LastSentDate"] = this.lastSentDate ? this.lastSentDate.toISOString() : undefined as any;
        data["Deleted"] = this.deleted;
        data["QuoteWorkOrderId"] = this.quoteWorkOrderId;
        data["QuoteWorkOrder"] = this.quoteWorkOrder ? this.quoteWorkOrder.toJSON() : undefined as any;
        return data;
    }
}

export interface INeighborPermission {
    id?: number | undefined;
    activitiesOnNeighborProperty?: string | undefined;
    address?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    signUpForEmails?: boolean | undefined;
    neighborSignature?: string | undefined;
    signedDate?: Date | undefined;
    lastSentDate?: Date | undefined;
    deleted?: boolean | undefined;
    quoteWorkOrderId?: number | undefined;
    quoteWorkOrder?: QuoteWorkOrder | undefined;
}

export class QuoteRequest implements IQuoteRequest {
    id?: number | undefined;
    active?: boolean | undefined;
    customerId?: number | undefined;
    completionStatus?: QuoteRequestCompletionStatus | undefined;
    paymentStatus?: QuoteRequestPaymentStatus | undefined;
    quoteRequestType?: QuoteRequestType | undefined;
    addressId?: number | undefined;
    broughtById?: number | undefined;
    broughtByOtherNote?: string | undefined;
    description?: string | undefined;
    needsPruning?: boolean | undefined;
    needsRemoval?: boolean | undefined;
    needsCablingAndBracing?: boolean | undefined;
    needsLightningProtection?: boolean | undefined;
    needsStumpRemoval?: boolean | undefined;
    needsLotClearingAndForestryMower?: boolean | undefined;
    needsMunicipalTreeServices?: boolean | undefined;
    needsCommercialTreeServices?: boolean | undefined;
    needsFertilization?: boolean | undefined;
    needsInsectOrDiseaseControl?: boolean | undefined;
    needsHealthManagement?: boolean | undefined;
    needsRootZoneManagement?: boolean | undefined;
    needsLandscapeInspection?: boolean | undefined;
    needsTreeRiskAssessment?: boolean | undefined;
    needsPreConstructionTreeConsulting?: boolean | undefined;
    needsTreeMapping?: boolean | undefined;
    needsTreeRecommendations?: boolean | undefined;
    representativeId?: number | undefined;
    createdDate?: Date | undefined;
    address?: Address | undefined;
    broughtBy?: BroughtBy | undefined;
    customer?: Customer | undefined;
    representative?: Employee | undefined;
    eventStart?: Date | undefined;
    eventEnd?: Date | undefined;
    addressSameAsCustomer?: boolean | undefined;
    isUrgent?: boolean | undefined;
    callAhead?: boolean | undefined;
    onMyWaLastSent?: Date | undefined;
    recaptchToken?: string | undefined;

    constructor(data?: IQuoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.customerId = _data["CustomerId"];
            this.completionStatus = _data["CompletionStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.quoteRequestType = _data["QuoteRequestType"];
            this.addressId = _data["AddressId"];
            this.broughtById = _data["BroughtById"];
            this.broughtByOtherNote = _data["BroughtByOtherNote"];
            this.description = _data["Description"];
            this.needsPruning = _data["NeedsPruning"];
            this.needsRemoval = _data["NeedsRemoval"];
            this.needsCablingAndBracing = _data["NeedsCablingAndBracing"];
            this.needsLightningProtection = _data["NeedsLightningProtection"];
            this.needsStumpRemoval = _data["NeedsStumpRemoval"];
            this.needsLotClearingAndForestryMower = _data["NeedsLotClearingAndForestryMower"];
            this.needsMunicipalTreeServices = _data["NeedsMunicipalTreeServices"];
            this.needsCommercialTreeServices = _data["NeedsCommercialTreeServices"];
            this.needsFertilization = _data["NeedsFertilization"];
            this.needsInsectOrDiseaseControl = _data["NeedsInsectOrDiseaseControl"];
            this.needsHealthManagement = _data["NeedsHealthManagement"];
            this.needsRootZoneManagement = _data["NeedsRootZoneManagement"];
            this.needsLandscapeInspection = _data["NeedsLandscapeInspection"];
            this.needsTreeRiskAssessment = _data["NeedsTreeRiskAssessment"];
            this.needsPreConstructionTreeConsulting = _data["NeedsPreConstructionTreeConsulting"];
            this.needsTreeMapping = _data["NeedsTreeMapping"];
            this.needsTreeRecommendations = _data["NeedsTreeRecommendations"];
            this.representativeId = _data["RepresentativeId"];
            this.createdDate = _data["CreatedDate"] ? new Date(_data["CreatedDate"].toString()) : undefined as any;
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : undefined as any;
            this.broughtBy = _data["BroughtBy"] ? BroughtBy.fromJS(_data["BroughtBy"]) : undefined as any;
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.representative = _data["Representative"] ? Employee.fromJS(_data["Representative"]) : undefined as any;
            this.eventStart = _data["EventStart"] ? new Date(_data["EventStart"].toString()) : undefined as any;
            this.eventEnd = _data["EventEnd"] ? new Date(_data["EventEnd"].toString()) : undefined as any;
            this.addressSameAsCustomer = _data["AddressSameAsCustomer"];
            this.isUrgent = _data["IsUrgent"];
            this.callAhead = _data["CallAhead"];
            this.onMyWaLastSent = _data["OnMyWaLastSent"] ? new Date(_data["OnMyWaLastSent"].toString()) : undefined as any;
            this.recaptchToken = _data["RecaptchToken"];
        }
    }

    static fromJS(data: any): QuoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["CustomerId"] = this.customerId;
        data["CompletionStatus"] = this.completionStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["QuoteRequestType"] = this.quoteRequestType;
        data["AddressId"] = this.addressId;
        data["BroughtById"] = this.broughtById;
        data["BroughtByOtherNote"] = this.broughtByOtherNote;
        data["Description"] = this.description;
        data["NeedsPruning"] = this.needsPruning;
        data["NeedsRemoval"] = this.needsRemoval;
        data["NeedsCablingAndBracing"] = this.needsCablingAndBracing;
        data["NeedsLightningProtection"] = this.needsLightningProtection;
        data["NeedsStumpRemoval"] = this.needsStumpRemoval;
        data["NeedsLotClearingAndForestryMower"] = this.needsLotClearingAndForestryMower;
        data["NeedsMunicipalTreeServices"] = this.needsMunicipalTreeServices;
        data["NeedsCommercialTreeServices"] = this.needsCommercialTreeServices;
        data["NeedsFertilization"] = this.needsFertilization;
        data["NeedsInsectOrDiseaseControl"] = this.needsInsectOrDiseaseControl;
        data["NeedsHealthManagement"] = this.needsHealthManagement;
        data["NeedsRootZoneManagement"] = this.needsRootZoneManagement;
        data["NeedsLandscapeInspection"] = this.needsLandscapeInspection;
        data["NeedsTreeRiskAssessment"] = this.needsTreeRiskAssessment;
        data["NeedsPreConstructionTreeConsulting"] = this.needsPreConstructionTreeConsulting;
        data["NeedsTreeMapping"] = this.needsTreeMapping;
        data["NeedsTreeRecommendations"] = this.needsTreeRecommendations;
        data["RepresentativeId"] = this.representativeId;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["Address"] = this.address ? this.address.toJSON() : undefined as any;
        data["BroughtBy"] = this.broughtBy ? this.broughtBy.toJSON() : undefined as any;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["Representative"] = this.representative ? this.representative.toJSON() : undefined as any;
        data["EventStart"] = this.eventStart ? this.eventStart.toISOString() : undefined as any;
        data["EventEnd"] = this.eventEnd ? this.eventEnd.toISOString() : undefined as any;
        data["AddressSameAsCustomer"] = this.addressSameAsCustomer;
        data["IsUrgent"] = this.isUrgent;
        data["CallAhead"] = this.callAhead;
        data["OnMyWaLastSent"] = this.onMyWaLastSent ? this.onMyWaLastSent.toISOString() : undefined as any;
        data["RecaptchToken"] = this.recaptchToken;
        return data;
    }
}

export interface IQuoteRequest {
    id?: number | undefined;
    active?: boolean | undefined;
    customerId?: number | undefined;
    completionStatus?: QuoteRequestCompletionStatus | undefined;
    paymentStatus?: QuoteRequestPaymentStatus | undefined;
    quoteRequestType?: QuoteRequestType | undefined;
    addressId?: number | undefined;
    broughtById?: number | undefined;
    broughtByOtherNote?: string | undefined;
    description?: string | undefined;
    needsPruning?: boolean | undefined;
    needsRemoval?: boolean | undefined;
    needsCablingAndBracing?: boolean | undefined;
    needsLightningProtection?: boolean | undefined;
    needsStumpRemoval?: boolean | undefined;
    needsLotClearingAndForestryMower?: boolean | undefined;
    needsMunicipalTreeServices?: boolean | undefined;
    needsCommercialTreeServices?: boolean | undefined;
    needsFertilization?: boolean | undefined;
    needsInsectOrDiseaseControl?: boolean | undefined;
    needsHealthManagement?: boolean | undefined;
    needsRootZoneManagement?: boolean | undefined;
    needsLandscapeInspection?: boolean | undefined;
    needsTreeRiskAssessment?: boolean | undefined;
    needsPreConstructionTreeConsulting?: boolean | undefined;
    needsTreeMapping?: boolean | undefined;
    needsTreeRecommendations?: boolean | undefined;
    representativeId?: number | undefined;
    createdDate?: Date | undefined;
    address?: Address | undefined;
    broughtBy?: BroughtBy | undefined;
    customer?: Customer | undefined;
    representative?: Employee | undefined;
    eventStart?: Date | undefined;
    eventEnd?: Date | undefined;
    addressSameAsCustomer?: boolean | undefined;
    isUrgent?: boolean | undefined;
    callAhead?: boolean | undefined;
    onMyWaLastSent?: Date | undefined;
    recaptchToken?: string | undefined;
}

export class PriorityTypeShortcut implements IPriorityTypeShortcut {
    id?: number | undefined;
    active?: boolean | undefined;
    name?: string | undefined;
    hasCalculatedPriority?: boolean | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    priorityLevelId?: number | undefined;
    weeksOutStart?: number | undefined;
    weeksOutEnd?: number | undefined;

    constructor(data?: IPriorityTypeShortcut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.name = _data["Name"];
            this.hasCalculatedPriority = _data["HasCalculatedPriority"];
            this.dueDateStart = _data["DueDateStart"] ? new Date(_data["DueDateStart"].toString()) : undefined as any;
            this.dueDateEnd = _data["DueDateEnd"] ? new Date(_data["DueDateEnd"].toString()) : undefined as any;
            this.hardStartDate = _data["HardStartDate"];
            this.hardEndDate = _data["HardEndDate"];
            this.priorityLevelId = _data["PriorityLevelId"];
            this.weeksOutStart = _data["WeeksOutStart"];
            this.weeksOutEnd = _data["WeeksOutEnd"];
        }
    }

    static fromJS(data: any): PriorityTypeShortcut {
        data = typeof data === 'object' ? data : {};
        let result = new PriorityTypeShortcut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Name"] = this.name;
        data["HasCalculatedPriority"] = this.hasCalculatedPriority;
        data["DueDateStart"] = this.dueDateStart ? this.dueDateStart.toISOString() : undefined as any;
        data["DueDateEnd"] = this.dueDateEnd ? this.dueDateEnd.toISOString() : undefined as any;
        data["HardStartDate"] = this.hardStartDate;
        data["HardEndDate"] = this.hardEndDate;
        data["PriorityLevelId"] = this.priorityLevelId;
        data["WeeksOutStart"] = this.weeksOutStart;
        data["WeeksOutEnd"] = this.weeksOutEnd;
        return data;
    }
}

export interface IPriorityTypeShortcut {
    id?: number | undefined;
    active?: boolean | undefined;
    name?: string | undefined;
    hasCalculatedPriority?: boolean | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    priorityLevelId?: number | undefined;
    weeksOutStart?: number | undefined;
    weeksOutEnd?: number | undefined;
}

export class CustomerType implements ICustomerType {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: ICustomerType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): CustomerType {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface ICustomerType {
    id?: number | undefined;
    name?: string | undefined;
}

export class CustomerComment implements ICustomerComment {
    id?: number | undefined;
    active?: boolean | undefined;
    comment?: string | undefined;
    dateCreated?: Date | undefined;
    customerId?: number | undefined;
    employeeId?: number | undefined;
    employee?: Employee | undefined;
    customerCommentStageId?: number | undefined;
    customerCommentStage?: CustomerCommentStage | undefined;
    quoteNumber?: string | undefined;
    companyWide?: boolean | undefined;
    lastEditedDate?: Date | undefined;

    constructor(data?: ICustomerComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.comment = _data["Comment"];
            this.dateCreated = _data["DateCreated"] ? new Date(_data["DateCreated"].toString()) : undefined as any;
            this.customerId = _data["CustomerId"];
            this.employeeId = _data["EmployeeId"];
            this.employee = _data["Employee"] ? Employee.fromJS(_data["Employee"]) : undefined as any;
            this.customerCommentStageId = _data["CustomerCommentStageId"];
            this.customerCommentStage = _data["CustomerCommentStage"] ? CustomerCommentStage.fromJS(_data["CustomerCommentStage"]) : undefined as any;
            this.quoteNumber = _data["QuoteNumber"];
            this.companyWide = _data["CompanyWide"];
            this.lastEditedDate = _data["LastEditedDate"] ? new Date(_data["LastEditedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerComment {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Comment"] = this.comment;
        data["DateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["CustomerId"] = this.customerId;
        data["EmployeeId"] = this.employeeId;
        data["Employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        data["CustomerCommentStageId"] = this.customerCommentStageId;
        data["CustomerCommentStage"] = this.customerCommentStage ? this.customerCommentStage.toJSON() : undefined as any;
        data["QuoteNumber"] = this.quoteNumber;
        data["CompanyWide"] = this.companyWide;
        data["LastEditedDate"] = this.lastEditedDate ? this.lastEditedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICustomerComment {
    id?: number | undefined;
    active?: boolean | undefined;
    comment?: string | undefined;
    dateCreated?: Date | undefined;
    customerId?: number | undefined;
    employeeId?: number | undefined;
    employee?: Employee | undefined;
    customerCommentStageId?: number | undefined;
    customerCommentStage?: CustomerCommentStage | undefined;
    quoteNumber?: string | undefined;
    companyWide?: boolean | undefined;
    lastEditedDate?: Date | undefined;
}

export class CustomerRole implements ICustomerRole {
    id?: number | undefined;
    customerId?: number | undefined;
    roleId?: number | undefined;
    role?: Role | undefined;

    constructor(data?: ICustomerRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.roleId = _data["RoleId"];
            this.role = _data["Role"] ? Role.fromJS(_data["Role"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerRole {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["RoleId"] = this.roleId;
        data["Role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustomerRole {
    id?: number | undefined;
    customerId?: number | undefined;
    roleId?: number | undefined;
    role?: Role | undefined;
}

export class CustomerContact implements ICustomerContact {
    id?: number | undefined;
    active?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    primary?: boolean | undefined;
    emailAddressId?: number | undefined;
    emailAddress?: EmailAddress | undefined;
    customerId?: number | undefined;
    canLogin?: boolean | undefined;
    requirePasswordReset?: boolean | undefined;
    textingOptOut?: boolean | undefined;
    receiveNonInvoicingEmails?: boolean | undefined;
    receiveInvoicingEmails?: boolean | undefined;
    readonly fullName?: string | undefined;
    readonly requireMultiFactorAuthSetup?: boolean | undefined;
    readonly requireMultiFactorAuth?: boolean | undefined;

    constructor(data?: ICustomerContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.firstName = _data["FirstName"];
            this.lastName = _data["LastName"];
            this.position = _data["Position"];
            this.phoneNumber = _data["PhoneNumber"];
            this.notes = _data["Notes"];
            this.primary = _data["Primary"];
            this.emailAddressId = _data["EmailAddressId"];
            this.emailAddress = _data["EmailAddress"] ? EmailAddress.fromJS(_data["EmailAddress"]) : undefined as any;
            this.customerId = _data["CustomerId"];
            this.canLogin = _data["CanLogin"];
            this.requirePasswordReset = _data["RequirePasswordReset"];
            this.textingOptOut = _data["TextingOptOut"];
            this.receiveNonInvoicingEmails = _data["ReceiveNonInvoicingEmails"];
            this.receiveInvoicingEmails = _data["ReceiveInvoicingEmails"];
            (this as any).fullName = _data["FullName"];
            (this as any).requireMultiFactorAuthSetup = _data["RequireMultiFactorAuthSetup"];
            (this as any).requireMultiFactorAuth = _data["RequireMultiFactorAuth"];
        }
    }

    static fromJS(data: any): CustomerContact {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["FirstName"] = this.firstName;
        data["LastName"] = this.lastName;
        data["Position"] = this.position;
        data["PhoneNumber"] = this.phoneNumber;
        data["Notes"] = this.notes;
        data["Primary"] = this.primary;
        data["EmailAddressId"] = this.emailAddressId;
        data["EmailAddress"] = this.emailAddress ? this.emailAddress.toJSON() : undefined as any;
        data["CustomerId"] = this.customerId;
        data["CanLogin"] = this.canLogin;
        data["RequirePasswordReset"] = this.requirePasswordReset;
        data["TextingOptOut"] = this.textingOptOut;
        data["ReceiveNonInvoicingEmails"] = this.receiveNonInvoicingEmails;
        data["ReceiveInvoicingEmails"] = this.receiveInvoicingEmails;
        data["FullName"] = this.fullName;
        data["RequireMultiFactorAuthSetup"] = this.requireMultiFactorAuthSetup;
        data["RequireMultiFactorAuth"] = this.requireMultiFactorAuth;
        return data;
    }
}

export interface ICustomerContact {
    id?: number | undefined;
    active?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    position?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    primary?: boolean | undefined;
    emailAddressId?: number | undefined;
    emailAddress?: EmailAddress | undefined;
    customerId?: number | undefined;
    canLogin?: boolean | undefined;
    requirePasswordReset?: boolean | undefined;
    textingOptOut?: boolean | undefined;
    receiveNonInvoicingEmails?: boolean | undefined;
    receiveInvoicingEmails?: boolean | undefined;
    fullName?: string | undefined;
    requireMultiFactorAuthSetup?: boolean | undefined;
    requireMultiFactorAuth?: boolean | undefined;
}

export class EmailAddress implements IEmailAddress {
    id?: number | undefined;
    email?: string | undefined;

    constructor(data?: IEmailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): EmailAddress {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Email"] = this.email;
        return data;
    }
}

export interface IEmailAddress {
    id?: number | undefined;
    email?: string | undefined;
}

export class EmployeeSkill implements IEmployeeSkill {
    id?: number | undefined;
    employeeId?: number | undefined;
    skillId?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    skill?: Skill | undefined;
    tempSaveGUID?: string | undefined;

    constructor(data?: IEmployeeSkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.employeeId = _data["EmployeeId"];
            this.skillId = _data["SkillId"];
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : undefined as any;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : undefined as any;
            this.skill = _data["Skill"] ? Skill.fromJS(_data["Skill"]) : undefined as any;
            this.tempSaveGUID = _data["TempSaveGUID"];
        }
    }

    static fromJS(data: any): EmployeeSkill {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeSkill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EmployeeId"] = this.employeeId;
        data["SkillId"] = this.skillId;
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["Skill"] = this.skill ? this.skill.toJSON() : undefined as any;
        data["TempSaveGUID"] = this.tempSaveGUID;
        return data;
    }
}

export interface IEmployeeSkill {
    id?: number | undefined;
    employeeId?: number | undefined;
    skillId?: number | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    skill?: Skill | undefined;
    tempSaveGUID?: string | undefined;
}

export class EmployeeRole implements IEmployeeRole {
    id?: number | undefined;
    employeeId?: number | undefined;
    roleId?: number | undefined;
    role?: Role | undefined;

    constructor(data?: IEmployeeRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.employeeId = _data["EmployeeId"];
            this.roleId = _data["RoleId"];
            this.role = _data["Role"] ? Role.fromJS(_data["Role"]) : undefined as any;
        }
    }

    static fromJS(data: any): EmployeeRole {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EmployeeId"] = this.employeeId;
        data["RoleId"] = this.roleId;
        data["Role"] = this.role ? this.role.toJSON() : undefined as any;
        return data;
    }
}

export interface IEmployeeRole {
    id?: number | undefined;
    employeeId?: number | undefined;
    roleId?: number | undefined;
    role?: Role | undefined;
}

export class ZipCodeAssignment implements IZipCodeAssignment {
    id?: number | undefined;
    employeeId?: number | undefined;
    zipCodeId?: number | undefined;
    zipCode?: ZipCode | undefined;

    constructor(data?: IZipCodeAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.employeeId = _data["EmployeeId"];
            this.zipCodeId = _data["ZipCodeId"];
            this.zipCode = _data["ZipCode"] ? ZipCode.fromJS(_data["ZipCode"]) : undefined as any;
        }
    }

    static fromJS(data: any): ZipCodeAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new ZipCodeAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EmployeeId"] = this.employeeId;
        data["ZipCodeId"] = this.zipCodeId;
        data["ZipCode"] = this.zipCode ? this.zipCode.toJSON() : undefined as any;
        return data;
    }
}

export interface IZipCodeAssignment {
    id?: number | undefined;
    employeeId?: number | undefined;
    zipCodeId?: number | undefined;
    zipCode?: ZipCode | undefined;
}

export class RegionalManagerTimeSlot implements IRegionalManagerTimeSlot {
    id?: number | undefined;
    employeeId?: number | undefined;
    dayOfTheWeek?: number | undefined;
    timeBegin?: Date | undefined;
    timeEnd?: Date | undefined;
    regionalManagerTimeSlotZipCodes?: RegionalManagerTimeSlotZipCode[] | undefined;

    constructor(data?: IRegionalManagerTimeSlot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.employeeId = _data["EmployeeId"];
            this.dayOfTheWeek = _data["DayOfTheWeek"];
            this.timeBegin = _data["TimeBegin"] ? new Date(_data["TimeBegin"].toString()) : undefined as any;
            this.timeEnd = _data["TimeEnd"] ? new Date(_data["TimeEnd"].toString()) : undefined as any;
            if (Array.isArray(_data["RegionalManagerTimeSlotZipCodes"])) {
                this.regionalManagerTimeSlotZipCodes = [] as any;
                for (let item of _data["RegionalManagerTimeSlotZipCodes"])
                    this.regionalManagerTimeSlotZipCodes!.push(RegionalManagerTimeSlotZipCode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegionalManagerTimeSlot {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalManagerTimeSlot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EmployeeId"] = this.employeeId;
        data["DayOfTheWeek"] = this.dayOfTheWeek;
        data["TimeBegin"] = this.timeBegin ? this.timeBegin.toISOString() : undefined as any;
        data["TimeEnd"] = this.timeEnd ? this.timeEnd.toISOString() : undefined as any;
        if (Array.isArray(this.regionalManagerTimeSlotZipCodes)) {
            data["RegionalManagerTimeSlotZipCodes"] = [];
            for (let item of this.regionalManagerTimeSlotZipCodes)
                data["RegionalManagerTimeSlotZipCodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRegionalManagerTimeSlot {
    id?: number | undefined;
    employeeId?: number | undefined;
    dayOfTheWeek?: number | undefined;
    timeBegin?: Date | undefined;
    timeEnd?: Date | undefined;
    regionalManagerTimeSlotZipCodes?: RegionalManagerTimeSlotZipCode[] | undefined;
}

export class RegionalManagerScheduleEvent implements IRegionalManagerScheduleEvent {
    id?: number | undefined;
    eventStart?: Date | undefined;
    eventEnd?: Date | undefined;
    allDay?: boolean | undefined;
    title?: string | undefined;
    additionalText?: string | undefined;
    employeeId?: number | undefined;

    constructor(data?: IRegionalManagerScheduleEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.eventStart = _data["EventStart"] ? new Date(_data["EventStart"].toString()) : undefined as any;
            this.eventEnd = _data["EventEnd"] ? new Date(_data["EventEnd"].toString()) : undefined as any;
            this.allDay = _data["AllDay"];
            this.title = _data["Title"];
            this.additionalText = _data["AdditionalText"];
            this.employeeId = _data["EmployeeId"];
        }
    }

    static fromJS(data: any): RegionalManagerScheduleEvent {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalManagerScheduleEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EventStart"] = this.eventStart ? this.eventStart.toISOString() : undefined as any;
        data["EventEnd"] = this.eventEnd ? this.eventEnd.toISOString() : undefined as any;
        data["AllDay"] = this.allDay;
        data["Title"] = this.title;
        data["AdditionalText"] = this.additionalText;
        data["EmployeeId"] = this.employeeId;
        return data;
    }
}

export interface IRegionalManagerScheduleEvent {
    id?: number | undefined;
    eventStart?: Date | undefined;
    eventEnd?: Date | undefined;
    allDay?: boolean | undefined;
    title?: string | undefined;
    additionalText?: string | undefined;
    employeeId?: number | undefined;
}

export class ReportTileUserAssignment implements IReportTileUserAssignment {
    id?: number | undefined;
    employeeId?: number | undefined;
    reportTileId?: number | undefined;
    reportTile?: ReportTile | undefined;

    constructor(data?: IReportTileUserAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.employeeId = _data["EmployeeId"];
            this.reportTileId = _data["ReportTileId"];
            this.reportTile = _data["ReportTile"] ? ReportTile.fromJS(_data["ReportTile"]) : undefined as any;
        }
    }

    static fromJS(data: any): ReportTileUserAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTileUserAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EmployeeId"] = this.employeeId;
        data["ReportTileId"] = this.reportTileId;
        data["ReportTile"] = this.reportTile ? this.reportTile.toJSON() : undefined as any;
        return data;
    }
}

export interface IReportTileUserAssignment {
    id?: number | undefined;
    employeeId?: number | undefined;
    reportTileId?: number | undefined;
    reportTile?: ReportTile | undefined;
}

export class PriceAdjustment implements IPriceAdjustment {
    id?: number | undefined;
    active?: boolean | undefined;
    reason?: string | undefined;
    percentage?: number | undefined;

    constructor(data?: IPriceAdjustment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.reason = _data["Reason"];
            this.percentage = _data["Percentage"];
        }
    }

    static fromJS(data: any): PriceAdjustment {
        data = typeof data === 'object' ? data : {};
        let result = new PriceAdjustment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Reason"] = this.reason;
        data["Percentage"] = this.percentage;
        return data;
    }
}

export interface IPriceAdjustment {
    id?: number | undefined;
    active?: boolean | undefined;
    reason?: string | undefined;
    percentage?: number | undefined;
}

export class WorkTask implements IWorkTask {
    id?: number | undefined;
    name?: string | undefined;
    cost?: number | undefined;
    price?: number | undefined;
    salesTaxCode?: string | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    scheduleDateFrom?: Date | undefined;
    scheduleDateTo?: Date | undefined;
    hasCalculatedPriority?: boolean | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    manualPriorityShortcutType?: WorkTaskManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    priorityLevelId?: number | undefined;
    manualPriorityLevel?: PriorityLevel | undefined;
    priorityShortcutId?: number | undefined;
    priorityTypeShortcut?: PriorityTypeShortcut | undefined;
    taskHourEntries?: WorkTaskHourEntry[] | undefined;
    jobFeedback?: string | undefined;
    reschedule?: boolean | undefined;
    hours?: number | undefined;
    location?: string | undefined;
    currentBucketId?: number | undefined;
    currentBigDaySubrangeId?: number | undefined;
    completionStatus?: WorkTaskCompletionStatus | undefined;
    paymentStatus?: WorkTaskPaymentStatus | undefined;
    completedDate?: Date | undefined;
    paidDate?: Date | undefined;
    workTaskGoBackEquipment?: WorkTaskGoBackEquipment[] | undefined;
    workTaskEquipment?: WorkTaskEquipment[] | undefined;
    workTaskSkills?: WorkTaskSkill[] | undefined;
    workTaskTreeTypes?: WorkTaskTreeType[] | undefined;
    schedulableAfterCompletionOfId?: number | undefined;
    schedulableAfterCompletionOf?: WorkTask | undefined;
    primordialTaskId?: number | undefined;
    timesRescheduled?: number | undefined;
    customerIssue?: string | undefined;
    goBackFeedback?: string | undefined;
    goBackHoursEstimate?: number | undefined;
    goBackCompletionDate?: Date | undefined;
    goBackBucketId?: number | undefined;
    isGoBack?: boolean | undefined;
    fixedPrice?: boolean | undefined;
    hourlyRate?: number | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    customerSignature?: string | undefined;
    signedDate?: Date | undefined;

    constructor(data?: IWorkTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.cost = _data["Cost"];
            this.price = _data["Price"];
            this.salesTaxCode = _data["SalesTaxCode"];
            this.description = _data["Description"];
            this.active = _data["Active"];
            this.scheduleDateFrom = _data["ScheduleDateFrom"] ? new Date(_data["ScheduleDateFrom"].toString()) : undefined as any;
            this.scheduleDateTo = _data["ScheduleDateTo"] ? new Date(_data["ScheduleDateTo"].toString()) : undefined as any;
            this.hasCalculatedPriority = _data["HasCalculatedPriority"];
            this.dueDateStart = _data["DueDateStart"] ? new Date(_data["DueDateStart"].toString()) : undefined as any;
            this.dueDateEnd = _data["DueDateEnd"] ? new Date(_data["DueDateEnd"].toString()) : undefined as any;
            this.hardStartDate = _data["HardStartDate"];
            this.hardEndDate = _data["HardEndDate"];
            this.manualPriorityShortcutType = _data["ManualPriorityShortcutType"];
            this.manualRangeStart = _data["ManualRangeStart"];
            this.manualRangeEnd = _data["ManualRangeEnd"];
            this.priorityLevelId = _data["PriorityLevelId"];
            this.manualPriorityLevel = _data["ManualPriorityLevel"] ? PriorityLevel.fromJS(_data["ManualPriorityLevel"]) : undefined as any;
            this.priorityShortcutId = _data["PriorityShortcutId"];
            this.priorityTypeShortcut = _data["PriorityTypeShortcut"] ? PriorityTypeShortcut.fromJS(_data["PriorityTypeShortcut"]) : undefined as any;
            if (Array.isArray(_data["TaskHourEntries"])) {
                this.taskHourEntries = [] as any;
                for (let item of _data["TaskHourEntries"])
                    this.taskHourEntries!.push(WorkTaskHourEntry.fromJS(item));
            }
            this.jobFeedback = _data["JobFeedback"];
            this.reschedule = _data["Reschedule"];
            this.hours = _data["Hours"];
            this.location = _data["Location"];
            this.currentBucketId = _data["CurrentBucketId"];
            this.currentBigDaySubrangeId = _data["CurrentBigDaySubrangeId"];
            this.completionStatus = _data["CompletionStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.completedDate = _data["CompletedDate"] ? new Date(_data["CompletedDate"].toString()) : undefined as any;
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : undefined as any;
            if (Array.isArray(_data["WorkTaskGoBackEquipment"])) {
                this.workTaskGoBackEquipment = [] as any;
                for (let item of _data["WorkTaskGoBackEquipment"])
                    this.workTaskGoBackEquipment!.push(WorkTaskGoBackEquipment.fromJS(item));
            }
            if (Array.isArray(_data["WorkTaskEquipment"])) {
                this.workTaskEquipment = [] as any;
                for (let item of _data["WorkTaskEquipment"])
                    this.workTaskEquipment!.push(WorkTaskEquipment.fromJS(item));
            }
            if (Array.isArray(_data["WorkTaskSkills"])) {
                this.workTaskSkills = [] as any;
                for (let item of _data["WorkTaskSkills"])
                    this.workTaskSkills!.push(WorkTaskSkill.fromJS(item));
            }
            if (Array.isArray(_data["WorkTaskTreeTypes"])) {
                this.workTaskTreeTypes = [] as any;
                for (let item of _data["WorkTaskTreeTypes"])
                    this.workTaskTreeTypes!.push(WorkTaskTreeType.fromJS(item));
            }
            this.schedulableAfterCompletionOfId = _data["SchedulableAfterCompletionOfId"];
            this.schedulableAfterCompletionOf = _data["SchedulableAfterCompletionOf"] ? WorkTask.fromJS(_data["SchedulableAfterCompletionOf"]) : undefined as any;
            this.primordialTaskId = _data["PrimordialTaskId"];
            this.timesRescheduled = _data["TimesRescheduled"];
            this.customerIssue = _data["CustomerIssue"];
            this.goBackFeedback = _data["GoBackFeedback"];
            this.goBackHoursEstimate = _data["GoBackHoursEstimate"];
            this.goBackCompletionDate = _data["GoBackCompletionDate"] ? new Date(_data["GoBackCompletionDate"].toString()) : undefined as any;
            this.goBackBucketId = _data["GoBackBucketId"];
            this.isGoBack = _data["IsGoBack"];
            this.fixedPrice = _data["FixedPrice"];
            this.hourlyRate = _data["HourlyRate"];
            this.minPrice = _data["MinPrice"];
            this.maxPrice = _data["MaxPrice"];
            this.customerSignature = _data["CustomerSignature"];
            this.signedDate = _data["SignedDate"] ? new Date(_data["SignedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkTask {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Cost"] = this.cost;
        data["Price"] = this.price;
        data["SalesTaxCode"] = this.salesTaxCode;
        data["Description"] = this.description;
        data["Active"] = this.active;
        data["ScheduleDateFrom"] = this.scheduleDateFrom ? this.scheduleDateFrom.toISOString() : undefined as any;
        data["ScheduleDateTo"] = this.scheduleDateTo ? this.scheduleDateTo.toISOString() : undefined as any;
        data["HasCalculatedPriority"] = this.hasCalculatedPriority;
        data["DueDateStart"] = this.dueDateStart ? this.dueDateStart.toISOString() : undefined as any;
        data["DueDateEnd"] = this.dueDateEnd ? this.dueDateEnd.toISOString() : undefined as any;
        data["HardStartDate"] = this.hardStartDate;
        data["HardEndDate"] = this.hardEndDate;
        data["ManualPriorityShortcutType"] = this.manualPriorityShortcutType;
        data["ManualRangeStart"] = this.manualRangeStart;
        data["ManualRangeEnd"] = this.manualRangeEnd;
        data["PriorityLevelId"] = this.priorityLevelId;
        data["ManualPriorityLevel"] = this.manualPriorityLevel ? this.manualPriorityLevel.toJSON() : undefined as any;
        data["PriorityShortcutId"] = this.priorityShortcutId;
        data["PriorityTypeShortcut"] = this.priorityTypeShortcut ? this.priorityTypeShortcut.toJSON() : undefined as any;
        if (Array.isArray(this.taskHourEntries)) {
            data["TaskHourEntries"] = [];
            for (let item of this.taskHourEntries)
                data["TaskHourEntries"].push(item ? item.toJSON() : undefined as any);
        }
        data["JobFeedback"] = this.jobFeedback;
        data["Reschedule"] = this.reschedule;
        data["Hours"] = this.hours;
        data["Location"] = this.location;
        data["CurrentBucketId"] = this.currentBucketId;
        data["CurrentBigDaySubrangeId"] = this.currentBigDaySubrangeId;
        data["CompletionStatus"] = this.completionStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["CompletedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        if (Array.isArray(this.workTaskGoBackEquipment)) {
            data["WorkTaskGoBackEquipment"] = [];
            for (let item of this.workTaskGoBackEquipment)
                data["WorkTaskGoBackEquipment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workTaskEquipment)) {
            data["WorkTaskEquipment"] = [];
            for (let item of this.workTaskEquipment)
                data["WorkTaskEquipment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workTaskSkills)) {
            data["WorkTaskSkills"] = [];
            for (let item of this.workTaskSkills)
                data["WorkTaskSkills"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workTaskTreeTypes)) {
            data["WorkTaskTreeTypes"] = [];
            for (let item of this.workTaskTreeTypes)
                data["WorkTaskTreeTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["SchedulableAfterCompletionOfId"] = this.schedulableAfterCompletionOfId;
        data["SchedulableAfterCompletionOf"] = this.schedulableAfterCompletionOf ? this.schedulableAfterCompletionOf.toJSON() : undefined as any;
        data["PrimordialTaskId"] = this.primordialTaskId;
        data["TimesRescheduled"] = this.timesRescheduled;
        data["CustomerIssue"] = this.customerIssue;
        data["GoBackFeedback"] = this.goBackFeedback;
        data["GoBackHoursEstimate"] = this.goBackHoursEstimate;
        data["GoBackCompletionDate"] = this.goBackCompletionDate ? this.goBackCompletionDate.toISOString() : undefined as any;
        data["GoBackBucketId"] = this.goBackBucketId;
        data["IsGoBack"] = this.isGoBack;
        data["FixedPrice"] = this.fixedPrice;
        data["HourlyRate"] = this.hourlyRate;
        data["MinPrice"] = this.minPrice;
        data["MaxPrice"] = this.maxPrice;
        data["CustomerSignature"] = this.customerSignature;
        data["SignedDate"] = this.signedDate ? this.signedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkTask {
    id?: number | undefined;
    name?: string | undefined;
    cost?: number | undefined;
    price?: number | undefined;
    salesTaxCode?: string | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    scheduleDateFrom?: Date | undefined;
    scheduleDateTo?: Date | undefined;
    hasCalculatedPriority?: boolean | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    manualPriorityShortcutType?: WorkTaskManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    priorityLevelId?: number | undefined;
    manualPriorityLevel?: PriorityLevel | undefined;
    priorityShortcutId?: number | undefined;
    priorityTypeShortcut?: PriorityTypeShortcut | undefined;
    taskHourEntries?: WorkTaskHourEntry[] | undefined;
    jobFeedback?: string | undefined;
    reschedule?: boolean | undefined;
    hours?: number | undefined;
    location?: string | undefined;
    currentBucketId?: number | undefined;
    currentBigDaySubrangeId?: number | undefined;
    completionStatus?: WorkTaskCompletionStatus | undefined;
    paymentStatus?: WorkTaskPaymentStatus | undefined;
    completedDate?: Date | undefined;
    paidDate?: Date | undefined;
    workTaskGoBackEquipment?: WorkTaskGoBackEquipment[] | undefined;
    workTaskEquipment?: WorkTaskEquipment[] | undefined;
    workTaskSkills?: WorkTaskSkill[] | undefined;
    workTaskTreeTypes?: WorkTaskTreeType[] | undefined;
    schedulableAfterCompletionOfId?: number | undefined;
    schedulableAfterCompletionOf?: WorkTask | undefined;
    primordialTaskId?: number | undefined;
    timesRescheduled?: number | undefined;
    customerIssue?: string | undefined;
    goBackFeedback?: string | undefined;
    goBackHoursEstimate?: number | undefined;
    goBackCompletionDate?: Date | undefined;
    goBackBucketId?: number | undefined;
    isGoBack?: boolean | undefined;
    fixedPrice?: boolean | undefined;
    hourlyRate?: number | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    customerSignature?: string | undefined;
    signedDate?: Date | undefined;
}

export class WellnessTaskHourEntry implements IWellnessTaskHourEntry {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    employeeId?: number | undefined;
    hours?: number | undefined;
    isGoBack?: boolean | undefined;
    workDate?: Date | undefined;
    employee?: Employee | undefined;

    constructor(data?: IWellnessTaskHourEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessTaskId = _data["WellnessTaskId"];
            this.employeeId = _data["EmployeeId"];
            this.hours = _data["Hours"];
            this.isGoBack = _data["IsGoBack"];
            this.workDate = _data["WorkDate"] ? new Date(_data["WorkDate"].toString()) : undefined as any;
            this.employee = _data["Employee"] ? Employee.fromJS(_data["Employee"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessTaskHourEntry {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTaskHourEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessTaskId"] = this.wellnessTaskId;
        data["EmployeeId"] = this.employeeId;
        data["Hours"] = this.hours;
        data["IsGoBack"] = this.isGoBack;
        data["WorkDate"] = this.workDate ? this.workDate.toISOString() : undefined as any;
        data["Employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellnessTaskHourEntry {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    employeeId?: number | undefined;
    hours?: number | undefined;
    isGoBack?: boolean | undefined;
    workDate?: Date | undefined;
    employee?: Employee | undefined;
}

export class WellnessTaskChemicalCombo implements IWellnessTaskChemicalCombo {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    chemicalComboId?: number | undefined;
    chemicalCombo?: ChemicalCombo | undefined;

    constructor(data?: IWellnessTaskChemicalCombo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessTaskId = _data["WellnessTaskId"];
            this.chemicalComboId = _data["ChemicalComboId"];
            this.chemicalCombo = _data["ChemicalCombo"] ? ChemicalCombo.fromJS(_data["ChemicalCombo"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessTaskChemicalCombo {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTaskChemicalCombo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessTaskId"] = this.wellnessTaskId;
        data["ChemicalComboId"] = this.chemicalComboId;
        data["ChemicalCombo"] = this.chemicalCombo ? this.chemicalCombo.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellnessTaskChemicalCombo {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    chemicalComboId?: number | undefined;
    chemicalCombo?: ChemicalCombo | undefined;
}

export class WellnessTaskGoBackEquipment implements IWellnessTaskGoBackEquipment {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    goBackEquipmentId?: number | undefined;
    equipmentType?: EquipmentType | undefined;

    constructor(data?: IWellnessTaskGoBackEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessTaskId = _data["WellnessTaskId"];
            this.goBackEquipmentId = _data["GoBackEquipmentId"];
            this.equipmentType = _data["EquipmentType"] ? EquipmentType.fromJS(_data["EquipmentType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessTaskGoBackEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTaskGoBackEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessTaskId"] = this.wellnessTaskId;
        data["GoBackEquipmentId"] = this.goBackEquipmentId;
        data["EquipmentType"] = this.equipmentType ? this.equipmentType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellnessTaskGoBackEquipment {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    goBackEquipmentId?: number | undefined;
    equipmentType?: EquipmentType | undefined;
}

export class WellnessTaskEquipment implements IWellnessTaskEquipment {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    equipmentTypeId?: number | undefined;
    equipmentType?: EquipmentType | undefined;

    constructor(data?: IWellnessTaskEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessTaskId = _data["WellnessTaskId"];
            this.equipmentTypeId = _data["EquipmentTypeId"];
            this.equipmentType = _data["EquipmentType"] ? EquipmentType.fromJS(_data["EquipmentType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessTaskEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTaskEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessTaskId"] = this.wellnessTaskId;
        data["EquipmentTypeId"] = this.equipmentTypeId;
        data["EquipmentType"] = this.equipmentType ? this.equipmentType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellnessTaskEquipment {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    equipmentTypeId?: number | undefined;
    equipmentType?: EquipmentType | undefined;
}

export class WellnessTaskSkill implements IWellnessTaskSkill {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    skillId?: number | undefined;
    skill?: Skill | undefined;

    constructor(data?: IWellnessTaskSkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessTaskId = _data["WellnessTaskId"];
            this.skillId = _data["SkillId"];
            this.skill = _data["Skill"] ? Skill.fromJS(_data["Skill"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessTaskSkill {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTaskSkill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessTaskId"] = this.wellnessTaskId;
        data["SkillId"] = this.skillId;
        data["Skill"] = this.skill ? this.skill.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellnessTaskSkill {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    skillId?: number | undefined;
    skill?: Skill | undefined;
}

export class WellnessTaskTreeType implements IWellnessTaskTreeType {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    treeTypeId?: number | undefined;
    treeType?: TreeType | undefined;

    constructor(data?: IWellnessTaskTreeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.wellnessTaskId = _data["WellnessTaskId"];
            this.treeTypeId = _data["TreeTypeId"];
            this.treeType = _data["TreeType"] ? TreeType.fromJS(_data["TreeType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessTaskTreeType {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTaskTreeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WellnessTaskId"] = this.wellnessTaskId;
        data["TreeTypeId"] = this.treeTypeId;
        data["TreeType"] = this.treeType ? this.treeType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWellnessTaskTreeType {
    id?: number | undefined;
    wellnessTaskId?: number | undefined;
    treeTypeId?: number | undefined;
    treeType?: TreeType | undefined;
}

export class BroughtBy implements IBroughtBy {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: IBroughtBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): BroughtBy {
        data = typeof data === 'object' ? data : {};
        let result = new BroughtBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IBroughtBy {
    id?: number | undefined;
    name?: string | undefined;
}

export class CustomerCommentStage implements ICustomerCommentStage {
    id?: number | undefined;
    commentStage?: string | undefined;

    constructor(data?: ICustomerCommentStage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.commentStage = _data["CommentStage"];
        }
    }

    static fromJS(data: any): CustomerCommentStage {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCommentStage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CommentStage"] = this.commentStage;
        return data;
    }
}

export interface ICustomerCommentStage {
    id?: number | undefined;
    commentStage?: string | undefined;
}

export class Role implements IRole {
    id?: number | undefined;
    name?: string | undefined;
    active?: boolean | undefined;
    isSchedulable?: boolean | undefined;
    roleClaims?: RoleClaim[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
            this.isSchedulable = _data["IsSchedulable"];
            if (Array.isArray(_data["RoleClaims"])) {
                this.roleClaims = [] as any;
                for (let item of _data["RoleClaims"])
                    this.roleClaims!.push(RoleClaim.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        data["IsSchedulable"] = this.isSchedulable;
        if (Array.isArray(this.roleClaims)) {
            data["RoleClaims"] = [];
            for (let item of this.roleClaims)
                data["RoleClaims"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRole {
    id?: number | undefined;
    name?: string | undefined;
    active?: boolean | undefined;
    isSchedulable?: boolean | undefined;
    roleClaims?: RoleClaim[] | undefined;
}

export class Skill implements ISkill {
    id?: number | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    active?: boolean | undefined;
    length?: number | undefined;

    constructor(data?: ISkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.shortName = _data["ShortName"];
            this.active = _data["Active"];
            this.length = _data["Length"];
        }
    }

    static fromJS(data: any): Skill {
        data = typeof data === 'object' ? data : {};
        let result = new Skill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["ShortName"] = this.shortName;
        data["Active"] = this.active;
        data["Length"] = this.length;
        return data;
    }
}

export interface ISkill {
    id?: number | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    active?: boolean | undefined;
    length?: number | undefined;
}

export class ZipCode implements IZipCode {
    id?: number | undefined;
    code?: string | undefined;
    city?: string | undefined;
    taxRate?: number | undefined;

    constructor(data?: IZipCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.code = _data["Code"];
            this.city = _data["City"];
            this.taxRate = _data["TaxRate"];
        }
    }

    static fromJS(data: any): ZipCode {
        data = typeof data === 'object' ? data : {};
        let result = new ZipCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Code"] = this.code;
        data["City"] = this.city;
        data["TaxRate"] = this.taxRate;
        return data;
    }
}

export interface IZipCode {
    id?: number | undefined;
    code?: string | undefined;
    city?: string | undefined;
    taxRate?: number | undefined;
}

export class RegionalManagerTimeSlotZipCode implements IRegionalManagerTimeSlotZipCode {
    id?: number | undefined;
    regionalManagerTimeSlotId?: number | undefined;
    zipCodeId?: number | undefined;
    zipCode?: ZipCode | undefined;

    constructor(data?: IRegionalManagerTimeSlotZipCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.regionalManagerTimeSlotId = _data["RegionalManagerTimeSlotId"];
            this.zipCodeId = _data["ZipCodeId"];
            this.zipCode = _data["ZipCode"] ? ZipCode.fromJS(_data["ZipCode"]) : undefined as any;
        }
    }

    static fromJS(data: any): RegionalManagerTimeSlotZipCode {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalManagerTimeSlotZipCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RegionalManagerTimeSlotId"] = this.regionalManagerTimeSlotId;
        data["ZipCodeId"] = this.zipCodeId;
        data["ZipCode"] = this.zipCode ? this.zipCode.toJSON() : undefined as any;
        return data;
    }
}

export interface IRegionalManagerTimeSlotZipCode {
    id?: number | undefined;
    regionalManagerTimeSlotId?: number | undefined;
    zipCodeId?: number | undefined;
    zipCode?: ZipCode | undefined;
}

export class ReportTile implements IReportTile {
    id?: number | undefined;
    name?: string | undefined;
    companyWide?: boolean | undefined;

    constructor(data?: IReportTile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.companyWide = _data["CompanyWide"];
        }
    }

    static fromJS(data: any): ReportTile {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["CompanyWide"] = this.companyWide;
        return data;
    }
}

export interface IReportTile {
    id?: number | undefined;
    name?: string | undefined;
    companyWide?: boolean | undefined;
}

export class WorkTaskHourEntry implements IWorkTaskHourEntry {
    id?: number | undefined;
    workTaskId?: number | undefined;
    employeeId?: number | undefined;
    hours?: number | undefined;
    isGoBack?: boolean | undefined;
    workDate?: Date | undefined;
    employee?: Employee | undefined;

    constructor(data?: IWorkTaskHourEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.workTaskId = _data["WorkTaskId"];
            this.employeeId = _data["EmployeeId"];
            this.hours = _data["Hours"];
            this.isGoBack = _data["IsGoBack"];
            this.workDate = _data["WorkDate"] ? new Date(_data["WorkDate"].toString()) : undefined as any;
            this.employee = _data["Employee"] ? Employee.fromJS(_data["Employee"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkTaskHourEntry {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTaskHourEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WorkTaskId"] = this.workTaskId;
        data["EmployeeId"] = this.employeeId;
        data["Hours"] = this.hours;
        data["IsGoBack"] = this.isGoBack;
        data["WorkDate"] = this.workDate ? this.workDate.toISOString() : undefined as any;
        data["Employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkTaskHourEntry {
    id?: number | undefined;
    workTaskId?: number | undefined;
    employeeId?: number | undefined;
    hours?: number | undefined;
    isGoBack?: boolean | undefined;
    workDate?: Date | undefined;
    employee?: Employee | undefined;
}

export class WorkTaskGoBackEquipment implements IWorkTaskGoBackEquipment {
    id?: number | undefined;
    workTaskId?: number | undefined;
    goBackEquipmentId?: number | undefined;
    equipmentType?: EquipmentType | undefined;

    constructor(data?: IWorkTaskGoBackEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.workTaskId = _data["WorkTaskId"];
            this.goBackEquipmentId = _data["GoBackEquipmentId"];
            this.equipmentType = _data["EquipmentType"] ? EquipmentType.fromJS(_data["EquipmentType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkTaskGoBackEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTaskGoBackEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WorkTaskId"] = this.workTaskId;
        data["GoBackEquipmentId"] = this.goBackEquipmentId;
        data["EquipmentType"] = this.equipmentType ? this.equipmentType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkTaskGoBackEquipment {
    id?: number | undefined;
    workTaskId?: number | undefined;
    goBackEquipmentId?: number | undefined;
    equipmentType?: EquipmentType | undefined;
}

export class WorkTaskEquipment implements IWorkTaskEquipment {
    id?: number | undefined;
    workTaskId?: number | undefined;
    equipmentTypeId?: number | undefined;
    equipmentType?: EquipmentType | undefined;

    constructor(data?: IWorkTaskEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.workTaskId = _data["WorkTaskId"];
            this.equipmentTypeId = _data["EquipmentTypeId"];
            this.equipmentType = _data["EquipmentType"] ? EquipmentType.fromJS(_data["EquipmentType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkTaskEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTaskEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WorkTaskId"] = this.workTaskId;
        data["EquipmentTypeId"] = this.equipmentTypeId;
        data["EquipmentType"] = this.equipmentType ? this.equipmentType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkTaskEquipment {
    id?: number | undefined;
    workTaskId?: number | undefined;
    equipmentTypeId?: number | undefined;
    equipmentType?: EquipmentType | undefined;
}

export class WorkTaskSkill implements IWorkTaskSkill {
    id?: number | undefined;
    workTaskId?: number | undefined;
    skillId?: number | undefined;
    skill?: Skill | undefined;

    constructor(data?: IWorkTaskSkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.workTaskId = _data["WorkTaskId"];
            this.skillId = _data["SkillId"];
            this.skill = _data["Skill"] ? Skill.fromJS(_data["Skill"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkTaskSkill {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTaskSkill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WorkTaskId"] = this.workTaskId;
        data["SkillId"] = this.skillId;
        data["Skill"] = this.skill ? this.skill.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkTaskSkill {
    id?: number | undefined;
    workTaskId?: number | undefined;
    skillId?: number | undefined;
    skill?: Skill | undefined;
}

export class WorkTaskTreeType implements IWorkTaskTreeType {
    id?: number | undefined;
    workTaskId?: number | undefined;
    treeTypeId?: number | undefined;
    treeType?: TreeType | undefined;

    constructor(data?: IWorkTaskTreeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.workTaskId = _data["WorkTaskId"];
            this.treeTypeId = _data["TreeTypeId"];
            this.treeType = _data["TreeType"] ? TreeType.fromJS(_data["TreeType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkTaskTreeType {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTaskTreeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["WorkTaskId"] = this.workTaskId;
        data["TreeTypeId"] = this.treeTypeId;
        data["TreeType"] = this.treeType ? this.treeType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkTaskTreeType {
    id?: number | undefined;
    workTaskId?: number | undefined;
    treeTypeId?: number | undefined;
    treeType?: TreeType | undefined;
}

export class ChemicalCombo implements IChemicalCombo {
    id?: number | undefined;
    chemicalId?: number | undefined;
    chemicalApplicationMethodId?: number | undefined;
    chemicalApplicationLocationId?: number | undefined;
    chemical?: Chemical | undefined;
    chemicalApplicationMethod?: ChemicalApplicationMethod | undefined;
    chemicalApplicationLocation?: ChemicalApplicationLocation | undefined;

    constructor(data?: IChemicalCombo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.chemicalId = _data["ChemicalId"];
            this.chemicalApplicationMethodId = _data["ChemicalApplicationMethodId"];
            this.chemicalApplicationLocationId = _data["ChemicalApplicationLocationId"];
            this.chemical = _data["Chemical"] ? Chemical.fromJS(_data["Chemical"]) : undefined as any;
            this.chemicalApplicationMethod = _data["ChemicalApplicationMethod"] ? ChemicalApplicationMethod.fromJS(_data["ChemicalApplicationMethod"]) : undefined as any;
            this.chemicalApplicationLocation = _data["ChemicalApplicationLocation"] ? ChemicalApplicationLocation.fromJS(_data["ChemicalApplicationLocation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChemicalCombo {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalCombo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ChemicalId"] = this.chemicalId;
        data["ChemicalApplicationMethodId"] = this.chemicalApplicationMethodId;
        data["ChemicalApplicationLocationId"] = this.chemicalApplicationLocationId;
        data["Chemical"] = this.chemical ? this.chemical.toJSON() : undefined as any;
        data["ChemicalApplicationMethod"] = this.chemicalApplicationMethod ? this.chemicalApplicationMethod.toJSON() : undefined as any;
        data["ChemicalApplicationLocation"] = this.chemicalApplicationLocation ? this.chemicalApplicationLocation.toJSON() : undefined as any;
        return data;
    }
}

export interface IChemicalCombo {
    id?: number | undefined;
    chemicalId?: number | undefined;
    chemicalApplicationMethodId?: number | undefined;
    chemicalApplicationLocationId?: number | undefined;
    chemical?: Chemical | undefined;
    chemicalApplicationMethod?: ChemicalApplicationMethod | undefined;
    chemicalApplicationLocation?: ChemicalApplicationLocation | undefined;
}

export class EquipmentType implements IEquipmentType {
    id?: number | undefined;
    type?: string | undefined;
    active?: boolean | undefined;
    abbreviation?: string | undefined;

    constructor(data?: IEquipmentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.active = _data["Active"];
            this.abbreviation = _data["Abbreviation"];
        }
    }

    static fromJS(data: any): EquipmentType {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["Active"] = this.active;
        data["Abbreviation"] = this.abbreviation;
        return data;
    }
}

export interface IEquipmentType {
    id?: number | undefined;
    type?: string | undefined;
    active?: boolean | undefined;
    abbreviation?: string | undefined;
}

export class TreeType implements ITreeType {
    id?: number | undefined;
    active?: boolean | undefined;
    commonName?: string | undefined;
    genus?: string | undefined;
    species?: string | undefined;
    readonly label?: string | undefined;

    constructor(data?: ITreeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.commonName = _data["CommonName"];
            this.genus = _data["Genus"];
            this.species = _data["Species"];
            (this as any).label = _data["Label"];
        }
    }

    static fromJS(data: any): TreeType {
        data = typeof data === 'object' ? data : {};
        let result = new TreeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["CommonName"] = this.commonName;
        data["Genus"] = this.genus;
        data["Species"] = this.species;
        data["Label"] = this.label;
        return data;
    }
}

export interface ITreeType {
    id?: number | undefined;
    active?: boolean | undefined;
    commonName?: string | undefined;
    genus?: string | undefined;
    species?: string | undefined;
    label?: string | undefined;
}

export class RoleClaim implements IRoleClaim {
    id?: number | undefined;
    roleId?: number | undefined;
    claimId?: number | undefined;
    claim?: Claim | undefined;

    constructor(data?: IRoleClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.roleId = _data["RoleId"];
            this.claimId = _data["ClaimId"];
            this.claim = _data["Claim"] ? Claim.fromJS(_data["Claim"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoleClaim {
        data = typeof data === 'object' ? data : {};
        let result = new RoleClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RoleId"] = this.roleId;
        data["ClaimId"] = this.claimId;
        data["Claim"] = this.claim ? this.claim.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoleClaim {
    id?: number | undefined;
    roleId?: number | undefined;
    claimId?: number | undefined;
    claim?: Claim | undefined;
}

export class Chemical implements IChemical {
    id?: number | undefined;
    active?: boolean | undefined;
    chemicalName?: string | undefined;
    tradeName?: string | undefined;
    registrationNumber?: string | undefined;
    mixRate?: string | undefined;
    readonly displayName?: string | undefined;

    constructor(data?: IChemical) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.chemicalName = _data["ChemicalName"];
            this.tradeName = _data["TradeName"];
            this.registrationNumber = _data["RegistrationNumber"];
            this.mixRate = _data["MixRate"];
            (this as any).displayName = _data["DisplayName"];
        }
    }

    static fromJS(data: any): Chemical {
        data = typeof data === 'object' ? data : {};
        let result = new Chemical();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["ChemicalName"] = this.chemicalName;
        data["TradeName"] = this.tradeName;
        data["RegistrationNumber"] = this.registrationNumber;
        data["MixRate"] = this.mixRate;
        data["DisplayName"] = this.displayName;
        return data;
    }
}

export interface IChemical {
    id?: number | undefined;
    active?: boolean | undefined;
    chemicalName?: string | undefined;
    tradeName?: string | undefined;
    registrationNumber?: string | undefined;
    mixRate?: string | undefined;
    displayName?: string | undefined;
}

export class ChemicalApplicationMethod implements IChemicalApplicationMethod {
    id?: number | undefined;
    active?: boolean | undefined;
    method?: string | undefined;

    constructor(data?: IChemicalApplicationMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.method = _data["Method"];
        }
    }

    static fromJS(data: any): ChemicalApplicationMethod {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalApplicationMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Method"] = this.method;
        return data;
    }
}

export interface IChemicalApplicationMethod {
    id?: number | undefined;
    active?: boolean | undefined;
    method?: string | undefined;
}

export class ChemicalApplicationLocation implements IChemicalApplicationLocation {
    id?: number | undefined;
    active?: boolean | undefined;
    location?: string | undefined;

    constructor(data?: IChemicalApplicationLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.location = _data["Location"];
        }
    }

    static fromJS(data: any): ChemicalApplicationLocation {
        data = typeof data === 'object' ? data : {};
        let result = new ChemicalApplicationLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Location"] = this.location;
        return data;
    }
}

export interface IChemicalApplicationLocation {
    id?: number | undefined;
    active?: boolean | undefined;
    location?: string | undefined;
}

export class Claim implements IClaim {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }
}

export interface IClaim {
    id?: number | undefined;
    name?: string | undefined;
}

export class BigDayBucketUpdateRequest implements IBigDayBucketUpdateRequest {
    id?: number | undefined;
    active?: boolean | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;

    constructor(data?: IBigDayBucketUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : undefined as any;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BigDayBucketUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BigDayBucketUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IBigDayBucketUpdateRequest {
    id?: number | undefined;
    active?: boolean | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
}

export class BigDayBucketSubrange implements IBigDayBucketSubrange {
    id?: number | undefined;
    active?: boolean | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    bigDayBucketId?: number | undefined;
    bigDayBucket?: BigDayBucket | undefined;
    bigDayEmployees?: BigDayEmployee[] | undefined;
    bigDayEquipment?: BigDayEquipment[] | undefined;

    constructor(data?: IBigDayBucketSubrange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.fromDate = _data["FromDate"] ? new Date(_data["FromDate"].toString()) : undefined as any;
            this.toDate = _data["ToDate"] ? new Date(_data["ToDate"].toString()) : undefined as any;
            this.bigDayBucketId = _data["BigDayBucketId"];
            this.bigDayBucket = _data["BigDayBucket"] ? BigDayBucket.fromJS(_data["BigDayBucket"]) : undefined as any;
            if (Array.isArray(_data["BigDayEmployees"])) {
                this.bigDayEmployees = [] as any;
                for (let item of _data["BigDayEmployees"])
                    this.bigDayEmployees!.push(BigDayEmployee.fromJS(item));
            }
            if (Array.isArray(_data["BigDayEquipment"])) {
                this.bigDayEquipment = [] as any;
                for (let item of _data["BigDayEquipment"])
                    this.bigDayEquipment!.push(BigDayEquipment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BigDayBucketSubrange {
        data = typeof data === 'object' ? data : {};
        let result = new BigDayBucketSubrange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["FromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["ToDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["BigDayBucketId"] = this.bigDayBucketId;
        data["BigDayBucket"] = this.bigDayBucket ? this.bigDayBucket.toJSON() : undefined as any;
        if (Array.isArray(this.bigDayEmployees)) {
            data["BigDayEmployees"] = [];
            for (let item of this.bigDayEmployees)
                data["BigDayEmployees"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bigDayEquipment)) {
            data["BigDayEquipment"] = [];
            for (let item of this.bigDayEquipment)
                data["BigDayEquipment"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBigDayBucketSubrange {
    id?: number | undefined;
    active?: boolean | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    bigDayBucketId?: number | undefined;
    bigDayBucket?: BigDayBucket | undefined;
    bigDayEmployees?: BigDayEmployee[] | undefined;
    bigDayEquipment?: BigDayEquipment[] | undefined;
}

export class BigDayEmployee implements IBigDayEmployee {
    id?: number | undefined;
    bigDayBucketSubrangeId?: number | undefined;
    bigDayBucketSubrange?: BigDayBucketSubrange | undefined;
    employeeId?: number | undefined;
    employee?: Employee | undefined;

    constructor(data?: IBigDayEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.bigDayBucketSubrangeId = _data["BigDayBucketSubrangeId"];
            this.bigDayBucketSubrange = _data["BigDayBucketSubrange"] ? BigDayBucketSubrange.fromJS(_data["BigDayBucketSubrange"]) : undefined as any;
            this.employeeId = _data["EmployeeId"];
            this.employee = _data["Employee"] ? Employee.fromJS(_data["Employee"]) : undefined as any;
        }
    }

    static fromJS(data: any): BigDayEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new BigDayEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["BigDayBucketSubrangeId"] = this.bigDayBucketSubrangeId;
        data["BigDayBucketSubrange"] = this.bigDayBucketSubrange ? this.bigDayBucketSubrange.toJSON() : undefined as any;
        data["EmployeeId"] = this.employeeId;
        data["Employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        return data;
    }
}

export interface IBigDayEmployee {
    id?: number | undefined;
    bigDayBucketSubrangeId?: number | undefined;
    bigDayBucketSubrange?: BigDayBucketSubrange | undefined;
    employeeId?: number | undefined;
    employee?: Employee | undefined;
}

export class BigDayEquipment implements IBigDayEquipment {
    id?: number | undefined;
    bigDayBucketSubrangeId?: number | undefined;
    bigDayBucketSubrange?: BigDayBucketSubrange | undefined;
    equipmentId?: number | undefined;
    equipment?: Equipment | undefined;

    constructor(data?: IBigDayEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.bigDayBucketSubrangeId = _data["BigDayBucketSubrangeId"];
            this.bigDayBucketSubrange = _data["BigDayBucketSubrange"] ? BigDayBucketSubrange.fromJS(_data["BigDayBucketSubrange"]) : undefined as any;
            this.equipmentId = _data["EquipmentId"];
            this.equipment = _data["Equipment"] ? Equipment.fromJS(_data["Equipment"]) : undefined as any;
        }
    }

    static fromJS(data: any): BigDayEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new BigDayEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["BigDayBucketSubrangeId"] = this.bigDayBucketSubrangeId;
        data["BigDayBucketSubrange"] = this.bigDayBucketSubrange ? this.bigDayBucketSubrange.toJSON() : undefined as any;
        data["EquipmentId"] = this.equipmentId;
        data["Equipment"] = this.equipment ? this.equipment.toJSON() : undefined as any;
        return data;
    }
}

export interface IBigDayEquipment {
    id?: number | undefined;
    bigDayBucketSubrangeId?: number | undefined;
    bigDayBucketSubrange?: BigDayBucketSubrange | undefined;
    equipmentId?: number | undefined;
    equipment?: Equipment | undefined;
}

export class Equipment implements IEquipment {
    id?: number | undefined;
    active?: boolean | undefined;
    number?: string | undefined;
    name?: string | undefined;
    typeId?: number | undefined;
    equipmentType?: EquipmentType | undefined;
    baseFee?: number | undefined;
    readonly isEquipment?: boolean | undefined;
    readonly fullTitle?: string | undefined;
    equipmentAlternatives?: EquipmentAlternative[] | undefined;
    equipmentSkills?: EquipmentSkill[] | undefined;
    equipmentServiceRecords?: EquipmentServiceRecord[] | undefined;
    vIN?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    motor?: string | undefined;
    boom?: string | undefined;
    serialNo?: string | undefined;
    fuel?: string | undefined;
    tires?: string | undefined;
    engineOil?: string | undefined;
    oilDrainPlug?: string | undefined;
    engineOilFilter?: string | undefined;
    fuelFirstFilter?: string | undefined;
    fuelWaterSep?: string | undefined;
    airFilter?: string | undefined;
    hydraulicOil?: string | undefined;
    hydraulicOilFilter?: string | undefined;
    grease?: string | undefined;
    coolant?: string | undefined;
    axelFilter?: string | undefined;
    brakes?: string | undefined;
    powerSteeringOil?: string | undefined;
    transmissionType?: string | undefined;
    transmissionOil?: string | undefined;
    transmissionFilter?: string | undefined;
    differentialType?: string | undefined;
    differentialOil?: string | undefined;

    constructor(data?: IEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.number = _data["Number"];
            this.name = _data["Name"];
            this.typeId = _data["TypeId"];
            this.equipmentType = _data["EquipmentType"] ? EquipmentType.fromJS(_data["EquipmentType"]) : undefined as any;
            this.baseFee = _data["BaseFee"];
            (this as any).isEquipment = _data["IsEquipment"];
            (this as any).fullTitle = _data["FullTitle"];
            if (Array.isArray(_data["EquipmentAlternatives"])) {
                this.equipmentAlternatives = [] as any;
                for (let item of _data["EquipmentAlternatives"])
                    this.equipmentAlternatives!.push(EquipmentAlternative.fromJS(item));
            }
            if (Array.isArray(_data["EquipmentSkills"])) {
                this.equipmentSkills = [] as any;
                for (let item of _data["EquipmentSkills"])
                    this.equipmentSkills!.push(EquipmentSkill.fromJS(item));
            }
            if (Array.isArray(_data["EquipmentServiceRecords"])) {
                this.equipmentServiceRecords = [] as any;
                for (let item of _data["EquipmentServiceRecords"])
                    this.equipmentServiceRecords!.push(EquipmentServiceRecord.fromJS(item));
            }
            this.vIN = _data["VIN"];
            this.year = _data["Year"];
            this.make = _data["Make"];
            this.model = _data["Model"];
            this.motor = _data["Motor"];
            this.boom = _data["Boom"];
            this.serialNo = _data["SerialNo"];
            this.fuel = _data["Fuel"];
            this.tires = _data["Tires"];
            this.engineOil = _data["EngineOil"];
            this.oilDrainPlug = _data["OilDrainPlug"];
            this.engineOilFilter = _data["EngineOilFilter"];
            this.fuelFirstFilter = _data["FuelFirstFilter"];
            this.fuelWaterSep = _data["FuelWaterSep"];
            this.airFilter = _data["AirFilter"];
            this.hydraulicOil = _data["HydraulicOil"];
            this.hydraulicOilFilter = _data["HydraulicOilFilter"];
            this.grease = _data["Grease"];
            this.coolant = _data["Coolant"];
            this.axelFilter = _data["AxelFilter"];
            this.brakes = _data["Brakes"];
            this.powerSteeringOil = _data["PowerSteeringOil"];
            this.transmissionType = _data["TransmissionType"];
            this.transmissionOil = _data["TransmissionOil"];
            this.transmissionFilter = _data["TransmissionFilter"];
            this.differentialType = _data["DifferentialType"];
            this.differentialOil = _data["DifferentialOil"];
        }
    }

    static fromJS(data: any): Equipment {
        data = typeof data === 'object' ? data : {};
        let result = new Equipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Number"] = this.number;
        data["Name"] = this.name;
        data["TypeId"] = this.typeId;
        data["EquipmentType"] = this.equipmentType ? this.equipmentType.toJSON() : undefined as any;
        data["BaseFee"] = this.baseFee;
        data["IsEquipment"] = this.isEquipment;
        data["FullTitle"] = this.fullTitle;
        if (Array.isArray(this.equipmentAlternatives)) {
            data["EquipmentAlternatives"] = [];
            for (let item of this.equipmentAlternatives)
                data["EquipmentAlternatives"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.equipmentSkills)) {
            data["EquipmentSkills"] = [];
            for (let item of this.equipmentSkills)
                data["EquipmentSkills"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.equipmentServiceRecords)) {
            data["EquipmentServiceRecords"] = [];
            for (let item of this.equipmentServiceRecords)
                data["EquipmentServiceRecords"].push(item ? item.toJSON() : undefined as any);
        }
        data["VIN"] = this.vIN;
        data["Year"] = this.year;
        data["Make"] = this.make;
        data["Model"] = this.model;
        data["Motor"] = this.motor;
        data["Boom"] = this.boom;
        data["SerialNo"] = this.serialNo;
        data["Fuel"] = this.fuel;
        data["Tires"] = this.tires;
        data["EngineOil"] = this.engineOil;
        data["OilDrainPlug"] = this.oilDrainPlug;
        data["EngineOilFilter"] = this.engineOilFilter;
        data["FuelFirstFilter"] = this.fuelFirstFilter;
        data["FuelWaterSep"] = this.fuelWaterSep;
        data["AirFilter"] = this.airFilter;
        data["HydraulicOil"] = this.hydraulicOil;
        data["HydraulicOilFilter"] = this.hydraulicOilFilter;
        data["Grease"] = this.grease;
        data["Coolant"] = this.coolant;
        data["AxelFilter"] = this.axelFilter;
        data["Brakes"] = this.brakes;
        data["PowerSteeringOil"] = this.powerSteeringOil;
        data["TransmissionType"] = this.transmissionType;
        data["TransmissionOil"] = this.transmissionOil;
        data["TransmissionFilter"] = this.transmissionFilter;
        data["DifferentialType"] = this.differentialType;
        data["DifferentialOil"] = this.differentialOil;
        return data;
    }
}

export interface IEquipment {
    id?: number | undefined;
    active?: boolean | undefined;
    number?: string | undefined;
    name?: string | undefined;
    typeId?: number | undefined;
    equipmentType?: EquipmentType | undefined;
    baseFee?: number | undefined;
    isEquipment?: boolean | undefined;
    fullTitle?: string | undefined;
    equipmentAlternatives?: EquipmentAlternative[] | undefined;
    equipmentSkills?: EquipmentSkill[] | undefined;
    equipmentServiceRecords?: EquipmentServiceRecord[] | undefined;
    vIN?: string | undefined;
    year?: number | undefined;
    make?: string | undefined;
    model?: string | undefined;
    motor?: string | undefined;
    boom?: string | undefined;
    serialNo?: string | undefined;
    fuel?: string | undefined;
    tires?: string | undefined;
    engineOil?: string | undefined;
    oilDrainPlug?: string | undefined;
    engineOilFilter?: string | undefined;
    fuelFirstFilter?: string | undefined;
    fuelWaterSep?: string | undefined;
    airFilter?: string | undefined;
    hydraulicOil?: string | undefined;
    hydraulicOilFilter?: string | undefined;
    grease?: string | undefined;
    coolant?: string | undefined;
    axelFilter?: string | undefined;
    brakes?: string | undefined;
    powerSteeringOil?: string | undefined;
    transmissionType?: string | undefined;
    transmissionOil?: string | undefined;
    transmissionFilter?: string | undefined;
    differentialType?: string | undefined;
    differentialOil?: string | undefined;
}

export class EquipmentAlternative implements IEquipmentAlternative {
    id?: number | undefined;
    equipmentId?: number | undefined;
    alternativeId?: number | undefined;
    alternative?: Equipment | undefined;

    constructor(data?: IEquipmentAlternative) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.equipmentId = _data["EquipmentId"];
            this.alternativeId = _data["AlternativeId"];
            this.alternative = _data["Alternative"] ? Equipment.fromJS(_data["Alternative"]) : undefined as any;
        }
    }

    static fromJS(data: any): EquipmentAlternative {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentAlternative();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EquipmentId"] = this.equipmentId;
        data["AlternativeId"] = this.alternativeId;
        data["Alternative"] = this.alternative ? this.alternative.toJSON() : undefined as any;
        return data;
    }
}

export interface IEquipmentAlternative {
    id?: number | undefined;
    equipmentId?: number | undefined;
    alternativeId?: number | undefined;
    alternative?: Equipment | undefined;
}

export class EquipmentSkill implements IEquipmentSkill {
    id?: number | undefined;
    equipmentId?: number | undefined;
    skillId?: number | undefined;
    equipment?: Equipment | undefined;
    skill?: Skill | undefined;

    constructor(data?: IEquipmentSkill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.equipmentId = _data["EquipmentId"];
            this.skillId = _data["SkillId"];
            this.equipment = _data["Equipment"] ? Equipment.fromJS(_data["Equipment"]) : undefined as any;
            this.skill = _data["Skill"] ? Skill.fromJS(_data["Skill"]) : undefined as any;
        }
    }

    static fromJS(data: any): EquipmentSkill {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentSkill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EquipmentId"] = this.equipmentId;
        data["SkillId"] = this.skillId;
        data["Equipment"] = this.equipment ? this.equipment.toJSON() : undefined as any;
        data["Skill"] = this.skill ? this.skill.toJSON() : undefined as any;
        return data;
    }
}

export interface IEquipmentSkill {
    id?: number | undefined;
    equipmentId?: number | undefined;
    skillId?: number | undefined;
    equipment?: Equipment | undefined;
    skill?: Skill | undefined;
}

export class EquipmentServiceRecord implements IEquipmentServiceRecord {
    id?: number | undefined;
    equipmentId?: number | undefined;
    inactiveDateFrom?: Date | undefined;
    inactiveDateTo?: Date | undefined;
    description?: string | undefined;
    dateServicePerformed?: Date | undefined;
    mileage?: number | undefined;

    constructor(data?: IEquipmentServiceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.equipmentId = _data["EquipmentId"];
            this.inactiveDateFrom = _data["InactiveDateFrom"] ? new Date(_data["InactiveDateFrom"].toString()) : undefined as any;
            this.inactiveDateTo = _data["InactiveDateTo"] ? new Date(_data["InactiveDateTo"].toString()) : undefined as any;
            this.description = _data["Description"];
            this.dateServicePerformed = _data["DateServicePerformed"] ? new Date(_data["DateServicePerformed"].toString()) : undefined as any;
            this.mileage = _data["Mileage"];
        }
    }

    static fromJS(data: any): EquipmentServiceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentServiceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["EquipmentId"] = this.equipmentId;
        data["InactiveDateFrom"] = this.inactiveDateFrom ? this.inactiveDateFrom.toISOString() : undefined as any;
        data["InactiveDateTo"] = this.inactiveDateTo ? this.inactiveDateTo.toISOString() : undefined as any;
        data["Description"] = this.description;
        data["DateServicePerformed"] = this.dateServicePerformed ? this.dateServicePerformed.toISOString() : undefined as any;
        data["Mileage"] = this.mileage;
        return data;
    }
}

export interface IEquipmentServiceRecord {
    id?: number | undefined;
    equipmentId?: number | undefined;
    inactiveDateFrom?: Date | undefined;
    inactiveDateTo?: Date | undefined;
    description?: string | undefined;
    dateServicePerformed?: Date | undefined;
    mileage?: number | undefined;
}

export class BlobWithSAS implements IBlobWithSAS {
    sASUri?: string | undefined;
    streamWriteSizeInBytes?: number | undefined;
    readonly serviceClient?: CloudBlobClient | undefined;
    streamMinimumReadSizeInBytes?: number | undefined;
    readonly properties?: BlobProperties | undefined;
    readonly metadata?: { [key: string]: string; } | undefined;
    readonly uri?: string | undefined;
    readonly storageUri?: StorageUri | undefined;
    readonly snapshotTime?: Date | undefined;
    readonly isSnapshot?: boolean | undefined;
    readonly isDeleted?: boolean | undefined;
    readonly snapshotQualifiedUri?: string | undefined;
    readonly snapshotQualifiedStorageUri?: StorageUri | undefined;
    readonly copyState?: CopyState | undefined;
    readonly name?: string | undefined;
    readonly container?: CloudBlobContainer | undefined;
    readonly parent?: CloudBlobDirectory | undefined;
    readonly blobType?: BlobWithSASBlobType | undefined;

    constructor(data?: IBlobWithSAS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sASUri = _data["SASUri"];
            this.streamWriteSizeInBytes = _data["StreamWriteSizeInBytes"];
            (this as any).serviceClient = _data["ServiceClient"] ? CloudBlobClient.fromJS(_data["ServiceClient"]) : undefined as any;
            this.streamMinimumReadSizeInBytes = _data["StreamMinimumReadSizeInBytes"];
            (this as any).properties = _data["Properties"] ? BlobProperties.fromJS(_data["Properties"]) : undefined as any;
            if (_data["Metadata"]) {
                (this as any).metadata = {} as any;
                for (let key in _data["Metadata"]) {
                    if (_data["Metadata"].hasOwnProperty(key))
                        ((this as any).metadata as any)![key] = _data["Metadata"][key];
                }
            }
            (this as any).uri = _data["Uri"];
            (this as any).storageUri = _data["StorageUri"] ? StorageUri.fromJS(_data["StorageUri"]) : undefined as any;
            (this as any).snapshotTime = _data["SnapshotTime"] ? new Date(_data["SnapshotTime"].toString()) : undefined as any;
            (this as any).isSnapshot = _data["IsSnapshot"];
            (this as any).isDeleted = _data["IsDeleted"];
            (this as any).snapshotQualifiedUri = _data["SnapshotQualifiedUri"];
            (this as any).snapshotQualifiedStorageUri = _data["SnapshotQualifiedStorageUri"] ? StorageUri.fromJS(_data["SnapshotQualifiedStorageUri"]) : undefined as any;
            (this as any).copyState = _data["CopyState"] ? CopyState.fromJS(_data["CopyState"]) : undefined as any;
            (this as any).name = _data["Name"];
            (this as any).container = _data["Container"] ? CloudBlobContainer.fromJS(_data["Container"]) : undefined as any;
            (this as any).parent = _data["Parent"] ? CloudBlobDirectory.fromJS(_data["Parent"]) : undefined as any;
            (this as any).blobType = _data["BlobType"];
        }
    }

    static fromJS(data: any): BlobWithSAS {
        data = typeof data === 'object' ? data : {};
        let result = new BlobWithSAS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SASUri"] = this.sASUri;
        data["StreamWriteSizeInBytes"] = this.streamWriteSizeInBytes;
        data["ServiceClient"] = this.serviceClient ? this.serviceClient.toJSON() : undefined as any;
        data["StreamMinimumReadSizeInBytes"] = this.streamMinimumReadSizeInBytes;
        data["Properties"] = this.properties ? this.properties.toJSON() : undefined as any;
        if (this.metadata) {
            data["Metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["Metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["Uri"] = this.uri;
        data["StorageUri"] = this.storageUri ? this.storageUri.toJSON() : undefined as any;
        data["SnapshotTime"] = this.snapshotTime ? this.snapshotTime.toISOString() : undefined as any;
        data["IsSnapshot"] = this.isSnapshot;
        data["IsDeleted"] = this.isDeleted;
        data["SnapshotQualifiedUri"] = this.snapshotQualifiedUri;
        data["SnapshotQualifiedStorageUri"] = this.snapshotQualifiedStorageUri ? this.snapshotQualifiedStorageUri.toJSON() : undefined as any;
        data["CopyState"] = this.copyState ? this.copyState.toJSON() : undefined as any;
        data["Name"] = this.name;
        data["Container"] = this.container ? this.container.toJSON() : undefined as any;
        data["Parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["BlobType"] = this.blobType;
        return data;
    }
}

export interface IBlobWithSAS {
    sASUri?: string | undefined;
    streamWriteSizeInBytes?: number | undefined;
    serviceClient?: CloudBlobClient | undefined;
    streamMinimumReadSizeInBytes?: number | undefined;
    properties?: BlobProperties | undefined;
    metadata?: { [key: string]: string; } | undefined;
    uri?: string | undefined;
    storageUri?: StorageUri | undefined;
    snapshotTime?: Date | undefined;
    isSnapshot?: boolean | undefined;
    isDeleted?: boolean | undefined;
    snapshotQualifiedUri?: string | undefined;
    snapshotQualifiedStorageUri?: StorageUri | undefined;
    copyState?: CopyState | undefined;
    name?: string | undefined;
    container?: CloudBlobContainer | undefined;
    parent?: CloudBlobDirectory | undefined;
    blobType?: BlobWithSASBlobType | undefined;
}

export class CloudBlobClient implements ICloudBlobClient {
    authenticationScheme?: CloudBlobClientAuthenticationScheme | undefined;
    bufferManager?: IBufferManager | undefined;
    readonly credentials?: StorageCredentials | undefined;
    readonly baseUri?: string | undefined;
    readonly storageUri?: StorageUri | undefined;
    defaultRequestOptions?: BlobRequestOptions | undefined;
    retryPolicy?: IRetryPolicy | undefined;
    defaultDelimiter?: string | undefined;

    constructor(data?: ICloudBlobClient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationScheme = _data["AuthenticationScheme"];
            this.bufferManager = _data["BufferManager"] ? IBufferManager.fromJS(_data["BufferManager"]) : undefined as any;
            (this as any).credentials = _data["Credentials"] ? StorageCredentials.fromJS(_data["Credentials"]) : undefined as any;
            (this as any).baseUri = _data["BaseUri"];
            (this as any).storageUri = _data["StorageUri"] ? StorageUri.fromJS(_data["StorageUri"]) : undefined as any;
            this.defaultRequestOptions = _data["DefaultRequestOptions"] ? BlobRequestOptions.fromJS(_data["DefaultRequestOptions"]) : undefined as any;
            this.retryPolicy = _data["RetryPolicy"] ? IRetryPolicy.fromJS(_data["RetryPolicy"]) : undefined as any;
            this.defaultDelimiter = _data["DefaultDelimiter"];
        }
    }

    static fromJS(data: any): CloudBlobClient {
        data = typeof data === 'object' ? data : {};
        let result = new CloudBlobClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AuthenticationScheme"] = this.authenticationScheme;
        data["BufferManager"] = this.bufferManager ? this.bufferManager.toJSON() : undefined as any;
        data["Credentials"] = this.credentials ? this.credentials.toJSON() : undefined as any;
        data["BaseUri"] = this.baseUri;
        data["StorageUri"] = this.storageUri ? this.storageUri.toJSON() : undefined as any;
        data["DefaultRequestOptions"] = this.defaultRequestOptions ? this.defaultRequestOptions.toJSON() : undefined as any;
        data["RetryPolicy"] = this.retryPolicy ? this.retryPolicy.toJSON() : undefined as any;
        data["DefaultDelimiter"] = this.defaultDelimiter;
        return data;
    }
}

export interface ICloudBlobClient {
    authenticationScheme?: CloudBlobClientAuthenticationScheme | undefined;
    bufferManager?: IBufferManager | undefined;
    credentials?: StorageCredentials | undefined;
    baseUri?: string | undefined;
    storageUri?: StorageUri | undefined;
    defaultRequestOptions?: BlobRequestOptions | undefined;
    retryPolicy?: IRetryPolicy | undefined;
    defaultDelimiter?: string | undefined;
}

export class BlobProperties implements IBlobProperties {
    cacheControl?: string | undefined;
    contentDisposition?: string | undefined;
    contentEncoding?: string | undefined;
    contentLanguage?: string | undefined;
    readonly length?: number | undefined;
    contentMD5?: string | undefined;
    contentType?: string | undefined;
    readonly eTag?: string | undefined;
    readonly created?: Date | undefined;
    readonly lastModified?: Date | undefined;
    readonly blobType?: BlobPropertiesBlobType | undefined;
    readonly leaseStatus?: BlobPropertiesLeaseStatus | undefined;
    readonly leaseState?: BlobPropertiesLeaseState | undefined;
    readonly leaseDuration?: BlobPropertiesLeaseDuration | undefined;
    readonly pageBlobSequenceNumber?: number | undefined;
    readonly appendBlobCommittedBlockCount?: number | undefined;
    readonly isServerEncrypted?: boolean | undefined;
    readonly isIncrementalCopy?: boolean | undefined;
    readonly standardBlobTier?: BlobPropertiesStandardBlobTier | undefined;
    readonly rehydrationStatus?: BlobPropertiesRehydrationStatus | undefined;
    readonly premiumPageBlobTier?: BlobPropertiesPremiumPageBlobTier | undefined;
    readonly blobTierInferred?: boolean | undefined;
    readonly blobTierLastModifiedTime?: Date | undefined;
    readonly deletedTime?: Date | undefined;
    readonly remainingDaysBeforePermanentDelete?: number | undefined;

    constructor(data?: IBlobProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheControl = _data["CacheControl"];
            this.contentDisposition = _data["ContentDisposition"];
            this.contentEncoding = _data["ContentEncoding"];
            this.contentLanguage = _data["ContentLanguage"];
            (this as any).length = _data["Length"];
            this.contentMD5 = _data["ContentMD5"];
            this.contentType = _data["ContentType"];
            (this as any).eTag = _data["ETag"];
            (this as any).created = _data["Created"] ? new Date(_data["Created"].toString()) : undefined as any;
            (this as any).lastModified = _data["LastModified"] ? new Date(_data["LastModified"].toString()) : undefined as any;
            (this as any).blobType = _data["BlobType"];
            (this as any).leaseStatus = _data["LeaseStatus"];
            (this as any).leaseState = _data["LeaseState"];
            (this as any).leaseDuration = _data["LeaseDuration"];
            (this as any).pageBlobSequenceNumber = _data["PageBlobSequenceNumber"];
            (this as any).appendBlobCommittedBlockCount = _data["AppendBlobCommittedBlockCount"];
            (this as any).isServerEncrypted = _data["IsServerEncrypted"];
            (this as any).isIncrementalCopy = _data["IsIncrementalCopy"];
            (this as any).standardBlobTier = _data["StandardBlobTier"];
            (this as any).rehydrationStatus = _data["RehydrationStatus"];
            (this as any).premiumPageBlobTier = _data["PremiumPageBlobTier"];
            (this as any).blobTierInferred = _data["BlobTierInferred"];
            (this as any).blobTierLastModifiedTime = _data["BlobTierLastModifiedTime"] ? new Date(_data["BlobTierLastModifiedTime"].toString()) : undefined as any;
            (this as any).deletedTime = _data["DeletedTime"] ? new Date(_data["DeletedTime"].toString()) : undefined as any;
            (this as any).remainingDaysBeforePermanentDelete = _data["RemainingDaysBeforePermanentDelete"];
        }
    }

    static fromJS(data: any): BlobProperties {
        data = typeof data === 'object' ? data : {};
        let result = new BlobProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CacheControl"] = this.cacheControl;
        data["ContentDisposition"] = this.contentDisposition;
        data["ContentEncoding"] = this.contentEncoding;
        data["ContentLanguage"] = this.contentLanguage;
        data["Length"] = this.length;
        data["ContentMD5"] = this.contentMD5;
        data["ContentType"] = this.contentType;
        data["ETag"] = this.eTag;
        data["Created"] = this.created ? this.created.toISOString() : undefined as any;
        data["LastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["BlobType"] = this.blobType;
        data["LeaseStatus"] = this.leaseStatus;
        data["LeaseState"] = this.leaseState;
        data["LeaseDuration"] = this.leaseDuration;
        data["PageBlobSequenceNumber"] = this.pageBlobSequenceNumber;
        data["AppendBlobCommittedBlockCount"] = this.appendBlobCommittedBlockCount;
        data["IsServerEncrypted"] = this.isServerEncrypted;
        data["IsIncrementalCopy"] = this.isIncrementalCopy;
        data["StandardBlobTier"] = this.standardBlobTier;
        data["RehydrationStatus"] = this.rehydrationStatus;
        data["PremiumPageBlobTier"] = this.premiumPageBlobTier;
        data["BlobTierInferred"] = this.blobTierInferred;
        data["BlobTierLastModifiedTime"] = this.blobTierLastModifiedTime ? this.blobTierLastModifiedTime.toISOString() : undefined as any;
        data["DeletedTime"] = this.deletedTime ? this.deletedTime.toISOString() : undefined as any;
        data["RemainingDaysBeforePermanentDelete"] = this.remainingDaysBeforePermanentDelete;
        return data;
    }
}

export interface IBlobProperties {
    cacheControl?: string | undefined;
    contentDisposition?: string | undefined;
    contentEncoding?: string | undefined;
    contentLanguage?: string | undefined;
    length?: number | undefined;
    contentMD5?: string | undefined;
    contentType?: string | undefined;
    eTag?: string | undefined;
    created?: Date | undefined;
    lastModified?: Date | undefined;
    blobType?: BlobPropertiesBlobType | undefined;
    leaseStatus?: BlobPropertiesLeaseStatus | undefined;
    leaseState?: BlobPropertiesLeaseState | undefined;
    leaseDuration?: BlobPropertiesLeaseDuration | undefined;
    pageBlobSequenceNumber?: number | undefined;
    appendBlobCommittedBlockCount?: number | undefined;
    isServerEncrypted?: boolean | undefined;
    isIncrementalCopy?: boolean | undefined;
    standardBlobTier?: BlobPropertiesStandardBlobTier | undefined;
    rehydrationStatus?: BlobPropertiesRehydrationStatus | undefined;
    premiumPageBlobTier?: BlobPropertiesPremiumPageBlobTier | undefined;
    blobTierInferred?: boolean | undefined;
    blobTierLastModifiedTime?: Date | undefined;
    deletedTime?: Date | undefined;
    remainingDaysBeforePermanentDelete?: number | undefined;
}

export class StorageUri implements IStorageUri {
    readonly primaryUri?: string | undefined;
    readonly secondaryUri?: string | undefined;

    constructor(data?: IStorageUri) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).primaryUri = _data["PrimaryUri"];
            (this as any).secondaryUri = _data["SecondaryUri"];
        }
    }

    static fromJS(data: any): StorageUri {
        data = typeof data === 'object' ? data : {};
        let result = new StorageUri();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PrimaryUri"] = this.primaryUri;
        data["SecondaryUri"] = this.secondaryUri;
        return data;
    }
}

export interface IStorageUri {
    primaryUri?: string | undefined;
    secondaryUri?: string | undefined;
}

export class CopyState implements ICopyState {
    readonly copyId?: string | undefined;
    readonly completionTime?: Date | undefined;
    readonly status?: CopyStateStatus | undefined;
    readonly source?: string | undefined;
    readonly bytesCopied?: number | undefined;
    readonly totalBytes?: number | undefined;
    readonly statusDescription?: string | undefined;
    readonly destinationSnapshotTime?: Date | undefined;

    constructor(data?: ICopyState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).copyId = _data["CopyId"];
            (this as any).completionTime = _data["CompletionTime"] ? new Date(_data["CompletionTime"].toString()) : undefined as any;
            (this as any).status = _data["Status"];
            (this as any).source = _data["Source"];
            (this as any).bytesCopied = _data["BytesCopied"];
            (this as any).totalBytes = _data["TotalBytes"];
            (this as any).statusDescription = _data["StatusDescription"];
            (this as any).destinationSnapshotTime = _data["DestinationSnapshotTime"] ? new Date(_data["DestinationSnapshotTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CopyState {
        data = typeof data === 'object' ? data : {};
        let result = new CopyState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CopyId"] = this.copyId;
        data["CompletionTime"] = this.completionTime ? this.completionTime.toISOString() : undefined as any;
        data["Status"] = this.status;
        data["Source"] = this.source;
        data["BytesCopied"] = this.bytesCopied;
        data["TotalBytes"] = this.totalBytes;
        data["StatusDescription"] = this.statusDescription;
        data["DestinationSnapshotTime"] = this.destinationSnapshotTime ? this.destinationSnapshotTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ICopyState {
    copyId?: string | undefined;
    completionTime?: Date | undefined;
    status?: CopyStateStatus | undefined;
    source?: string | undefined;
    bytesCopied?: number | undefined;
    totalBytes?: number | undefined;
    statusDescription?: string | undefined;
    destinationSnapshotTime?: Date | undefined;
}

export class CloudBlobContainer implements ICloudBlobContainer {
    readonly serviceClient?: CloudBlobClient | undefined;
    readonly uri?: string | undefined;
    readonly storageUri?: StorageUri | undefined;
    readonly name?: string | undefined;
    readonly metadata?: { [key: string]: string; } | undefined;
    readonly properties?: BlobContainerProperties | undefined;

    constructor(data?: ICloudBlobContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).serviceClient = _data["ServiceClient"] ? CloudBlobClient.fromJS(_data["ServiceClient"]) : undefined as any;
            (this as any).uri = _data["Uri"];
            (this as any).storageUri = _data["StorageUri"] ? StorageUri.fromJS(_data["StorageUri"]) : undefined as any;
            (this as any).name = _data["Name"];
            if (_data["Metadata"]) {
                (this as any).metadata = {} as any;
                for (let key in _data["Metadata"]) {
                    if (_data["Metadata"].hasOwnProperty(key))
                        ((this as any).metadata as any)![key] = _data["Metadata"][key];
                }
            }
            (this as any).properties = _data["Properties"] ? BlobContainerProperties.fromJS(_data["Properties"]) : undefined as any;
        }
    }

    static fromJS(data: any): CloudBlobContainer {
        data = typeof data === 'object' ? data : {};
        let result = new CloudBlobContainer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ServiceClient"] = this.serviceClient ? this.serviceClient.toJSON() : undefined as any;
        data["Uri"] = this.uri;
        data["StorageUri"] = this.storageUri ? this.storageUri.toJSON() : undefined as any;
        data["Name"] = this.name;
        if (this.metadata) {
            data["Metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    (data["Metadata"] as any)[key] = (this.metadata as any)[key];
            }
        }
        data["Properties"] = this.properties ? this.properties.toJSON() : undefined as any;
        return data;
    }
}

export interface ICloudBlobContainer {
    serviceClient?: CloudBlobClient | undefined;
    uri?: string | undefined;
    storageUri?: StorageUri | undefined;
    name?: string | undefined;
    metadata?: { [key: string]: string; } | undefined;
    properties?: BlobContainerProperties | undefined;
}

export class CloudBlobDirectory implements ICloudBlobDirectory {
    readonly serviceClient?: CloudBlobClient | undefined;
    readonly uri?: string | undefined;
    readonly storageUri?: StorageUri | undefined;
    readonly container?: CloudBlobContainer | undefined;
    readonly parent?: CloudBlobDirectory | undefined;
    readonly prefix?: string | undefined;

    constructor(data?: ICloudBlobDirectory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).serviceClient = _data["ServiceClient"] ? CloudBlobClient.fromJS(_data["ServiceClient"]) : undefined as any;
            (this as any).uri = _data["Uri"];
            (this as any).storageUri = _data["StorageUri"] ? StorageUri.fromJS(_data["StorageUri"]) : undefined as any;
            (this as any).container = _data["Container"] ? CloudBlobContainer.fromJS(_data["Container"]) : undefined as any;
            (this as any).parent = _data["Parent"] ? CloudBlobDirectory.fromJS(_data["Parent"]) : undefined as any;
            (this as any).prefix = _data["Prefix"];
        }
    }

    static fromJS(data: any): CloudBlobDirectory {
        data = typeof data === 'object' ? data : {};
        let result = new CloudBlobDirectory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ServiceClient"] = this.serviceClient ? this.serviceClient.toJSON() : undefined as any;
        data["Uri"] = this.uri;
        data["StorageUri"] = this.storageUri ? this.storageUri.toJSON() : undefined as any;
        data["Container"] = this.container ? this.container.toJSON() : undefined as any;
        data["Parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["Prefix"] = this.prefix;
        return data;
    }
}

export interface ICloudBlobDirectory {
    serviceClient?: CloudBlobClient | undefined;
    uri?: string | undefined;
    storageUri?: StorageUri | undefined;
    container?: CloudBlobContainer | undefined;
    parent?: CloudBlobDirectory | undefined;
    prefix?: string | undefined;
}

export class IBufferManager implements IIBufferManager {

    constructor(data?: IIBufferManager) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IBufferManager {
        data = typeof data === 'object' ? data : {};
        let result = new IBufferManager();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIBufferManager {
}

export class StorageCredentials implements IStorageCredentials {
    readonly sASToken?: string | undefined;
    readonly accountName?: string | undefined;
    readonly keyName?: string | undefined;
    readonly isAnonymous?: boolean | undefined;
    readonly isSAS?: boolean | undefined;
    readonly isSharedKey?: boolean | undefined;
    readonly isToken?: boolean | undefined;
    readonly sASSignature?: string | undefined;

    constructor(data?: IStorageCredentials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).sASToken = _data["SASToken"];
            (this as any).accountName = _data["AccountName"];
            (this as any).keyName = _data["KeyName"];
            (this as any).isAnonymous = _data["IsAnonymous"];
            (this as any).isSAS = _data["IsSAS"];
            (this as any).isSharedKey = _data["IsSharedKey"];
            (this as any).isToken = _data["IsToken"];
            (this as any).sASSignature = _data["SASSignature"];
        }
    }

    static fromJS(data: any): StorageCredentials {
        data = typeof data === 'object' ? data : {};
        let result = new StorageCredentials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SASToken"] = this.sASToken;
        data["AccountName"] = this.accountName;
        data["KeyName"] = this.keyName;
        data["IsAnonymous"] = this.isAnonymous;
        data["IsSAS"] = this.isSAS;
        data["IsSharedKey"] = this.isSharedKey;
        data["IsToken"] = this.isToken;
        data["SASSignature"] = this.sASSignature;
        return data;
    }
}

export interface IStorageCredentials {
    sASToken?: string | undefined;
    accountName?: string | undefined;
    keyName?: string | undefined;
    isAnonymous?: boolean | undefined;
    isSAS?: boolean | undefined;
    isSharedKey?: boolean | undefined;
    isToken?: boolean | undefined;
    sASSignature?: string | undefined;
}

export class BlobRequestOptions implements IBlobRequestOptions {
    retryPolicy?: IRetryPolicy | undefined;
    encryptionPolicy?: BlobEncryptionPolicy | undefined;
    requireEncryption?: boolean | undefined;
    absorbConditionalErrorsOnRetry?: boolean | undefined;
    locationMode?: BlobRequestOptionsLocationMode | undefined;
    serverTimeout?: string | undefined;
    maximumExecutionTime?: string | undefined;
    parallelOperationThreadCount?: number | undefined;
    singleBlobUploadThresholdInBytes?: number | undefined;
    useTransactionalMD5?: boolean | undefined;
    storeBlobContentMD5?: boolean | undefined;
    disableContentMD5Validation?: boolean | undefined;

    constructor(data?: IBlobRequestOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.retryPolicy = _data["RetryPolicy"] ? IRetryPolicy.fromJS(_data["RetryPolicy"]) : undefined as any;
            this.encryptionPolicy = _data["EncryptionPolicy"] ? BlobEncryptionPolicy.fromJS(_data["EncryptionPolicy"]) : undefined as any;
            this.requireEncryption = _data["RequireEncryption"];
            this.absorbConditionalErrorsOnRetry = _data["AbsorbConditionalErrorsOnRetry"];
            this.locationMode = _data["LocationMode"];
            this.serverTimeout = _data["ServerTimeout"];
            this.maximumExecutionTime = _data["MaximumExecutionTime"];
            this.parallelOperationThreadCount = _data["ParallelOperationThreadCount"];
            this.singleBlobUploadThresholdInBytes = _data["SingleBlobUploadThresholdInBytes"];
            this.useTransactionalMD5 = _data["UseTransactionalMD5"];
            this.storeBlobContentMD5 = _data["StoreBlobContentMD5"];
            this.disableContentMD5Validation = _data["DisableContentMD5Validation"];
        }
    }

    static fromJS(data: any): BlobRequestOptions {
        data = typeof data === 'object' ? data : {};
        let result = new BlobRequestOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RetryPolicy"] = this.retryPolicy ? this.retryPolicy.toJSON() : undefined as any;
        data["EncryptionPolicy"] = this.encryptionPolicy ? this.encryptionPolicy.toJSON() : undefined as any;
        data["RequireEncryption"] = this.requireEncryption;
        data["AbsorbConditionalErrorsOnRetry"] = this.absorbConditionalErrorsOnRetry;
        data["LocationMode"] = this.locationMode;
        data["ServerTimeout"] = this.serverTimeout;
        data["MaximumExecutionTime"] = this.maximumExecutionTime;
        data["ParallelOperationThreadCount"] = this.parallelOperationThreadCount;
        data["SingleBlobUploadThresholdInBytes"] = this.singleBlobUploadThresholdInBytes;
        data["UseTransactionalMD5"] = this.useTransactionalMD5;
        data["StoreBlobContentMD5"] = this.storeBlobContentMD5;
        data["DisableContentMD5Validation"] = this.disableContentMD5Validation;
        return data;
    }
}

export interface IBlobRequestOptions {
    retryPolicy?: IRetryPolicy | undefined;
    encryptionPolicy?: BlobEncryptionPolicy | undefined;
    requireEncryption?: boolean | undefined;
    absorbConditionalErrorsOnRetry?: boolean | undefined;
    locationMode?: BlobRequestOptionsLocationMode | undefined;
    serverTimeout?: string | undefined;
    maximumExecutionTime?: string | undefined;
    parallelOperationThreadCount?: number | undefined;
    singleBlobUploadThresholdInBytes?: number | undefined;
    useTransactionalMD5?: boolean | undefined;
    storeBlobContentMD5?: boolean | undefined;
    disableContentMD5Validation?: boolean | undefined;
}

export class IRetryPolicy implements IIRetryPolicy {

    constructor(data?: IIRetryPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IRetryPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new IRetryPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIRetryPolicy {
}

export class BlobContainerProperties implements IBlobContainerProperties {
    readonly eTag?: string | undefined;
    readonly hasImmutabilityPolicy?: boolean | undefined;
    readonly hasLegalHold?: boolean | undefined;
    readonly lastModified?: Date | undefined;
    readonly leaseStatus?: BlobContainerPropertiesLeaseStatus | undefined;
    readonly leaseState?: BlobContainerPropertiesLeaseState | undefined;
    readonly leaseDuration?: BlobContainerPropertiesLeaseDuration | undefined;
    readonly publicAccess?: BlobContainerPropertiesPublicAccess | undefined;

    constructor(data?: IBlobContainerProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).eTag = _data["ETag"];
            (this as any).hasImmutabilityPolicy = _data["HasImmutabilityPolicy"];
            (this as any).hasLegalHold = _data["HasLegalHold"];
            (this as any).lastModified = _data["LastModified"] ? new Date(_data["LastModified"].toString()) : undefined as any;
            (this as any).leaseStatus = _data["LeaseStatus"];
            (this as any).leaseState = _data["LeaseState"];
            (this as any).leaseDuration = _data["LeaseDuration"];
            (this as any).publicAccess = _data["PublicAccess"];
        }
    }

    static fromJS(data: any): BlobContainerProperties {
        data = typeof data === 'object' ? data : {};
        let result = new BlobContainerProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ETag"] = this.eTag;
        data["HasImmutabilityPolicy"] = this.hasImmutabilityPolicy;
        data["HasLegalHold"] = this.hasLegalHold;
        data["LastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["LeaseStatus"] = this.leaseStatus;
        data["LeaseState"] = this.leaseState;
        data["LeaseDuration"] = this.leaseDuration;
        data["PublicAccess"] = this.publicAccess;
        return data;
    }
}

export interface IBlobContainerProperties {
    eTag?: string | undefined;
    hasImmutabilityPolicy?: boolean | undefined;
    hasLegalHold?: boolean | undefined;
    lastModified?: Date | undefined;
    leaseStatus?: BlobContainerPropertiesLeaseStatus | undefined;
    leaseState?: BlobContainerPropertiesLeaseState | undefined;
    leaseDuration?: BlobContainerPropertiesLeaseDuration | undefined;
    publicAccess?: BlobContainerPropertiesPublicAccess | undefined;
}

export class BlobEncryptionPolicy implements IBlobEncryptionPolicy {
    readonly key?: IKey | undefined;
    readonly keyResolver?: IKeyResolver | undefined;

    constructor(data?: IBlobEncryptionPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).key = _data["Key"] ? IKey.fromJS(_data["Key"]) : undefined as any;
            (this as any).keyResolver = _data["KeyResolver"] ? IKeyResolver.fromJS(_data["KeyResolver"]) : undefined as any;
        }
    }

    static fromJS(data: any): BlobEncryptionPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new BlobEncryptionPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Key"] = this.key ? this.key.toJSON() : undefined as any;
        data["KeyResolver"] = this.keyResolver ? this.keyResolver.toJSON() : undefined as any;
        return data;
    }
}

export interface IBlobEncryptionPolicy {
    key?: IKey | undefined;
    keyResolver?: IKeyResolver | undefined;
}

export class IKey implements IIKey {
    readonly defaultEncryptionAlgorithm?: string | undefined;
    readonly defaultKeyWrapAlgorithm?: string | undefined;
    readonly defaultSignatureAlgorithm?: string | undefined;
    readonly kid?: string | undefined;

    constructor(data?: IIKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).defaultEncryptionAlgorithm = _data["DefaultEncryptionAlgorithm"];
            (this as any).defaultKeyWrapAlgorithm = _data["DefaultKeyWrapAlgorithm"];
            (this as any).defaultSignatureAlgorithm = _data["DefaultSignatureAlgorithm"];
            (this as any).kid = _data["Kid"];
        }
    }

    static fromJS(data: any): IKey {
        data = typeof data === 'object' ? data : {};
        let result = new IKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["DefaultEncryptionAlgorithm"] = this.defaultEncryptionAlgorithm;
        data["DefaultKeyWrapAlgorithm"] = this.defaultKeyWrapAlgorithm;
        data["DefaultSignatureAlgorithm"] = this.defaultSignatureAlgorithm;
        data["Kid"] = this.kid;
        return data;
    }
}

export interface IIKey {
    defaultEncryptionAlgorithm?: string | undefined;
    defaultKeyWrapAlgorithm?: string | undefined;
    defaultSignatureAlgorithm?: string | undefined;
    kid?: string | undefined;
}

export class IKeyResolver implements IIKeyResolver {

    constructor(data?: IIKeyResolver) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IKeyResolver {
        data = typeof data === 'object' ? data : {};
        let result = new IKeyResolver();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIKeyResolver {
}

export class SasResponse implements ISasResponse {
    token?: string | undefined;
    signature?: string | undefined;

    constructor(data?: ISasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["Token"];
            this.signature = _data["Signature"];
        }
    }

    static fromJS(data: any): SasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Token"] = this.token;
        data["Signature"] = this.signature;
        return data;
    }
}

export interface ISasResponse {
    token?: string | undefined;
    signature?: string | undefined;
}

export class Crew implements ICrew {
    id?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    active?: boolean | undefined;
    crewEquipment?: CrewEquipment[] | undefined;
    crewEmployees?: CrewEmployee[] | undefined;
    readonly isCrew?: boolean | undefined;

    constructor(data?: ICrew) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : undefined as any;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : undefined as any;
            this.active = _data["Active"];
            if (Array.isArray(_data["CrewEquipment"])) {
                this.crewEquipment = [] as any;
                for (let item of _data["CrewEquipment"])
                    this.crewEquipment!.push(CrewEquipment.fromJS(item));
            }
            if (Array.isArray(_data["CrewEmployees"])) {
                this.crewEmployees = [] as any;
                for (let item of _data["CrewEmployees"])
                    this.crewEmployees!.push(CrewEmployee.fromJS(item));
            }
            (this as any).isCrew = _data["IsCrew"];
        }
    }

    static fromJS(data: any): Crew {
        data = typeof data === 'object' ? data : {};
        let result = new Crew();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["Active"] = this.active;
        if (Array.isArray(this.crewEquipment)) {
            data["CrewEquipment"] = [];
            for (let item of this.crewEquipment)
                data["CrewEquipment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.crewEmployees)) {
            data["CrewEmployees"] = [];
            for (let item of this.crewEmployees)
                data["CrewEmployees"].push(item ? item.toJSON() : undefined as any);
        }
        data["IsCrew"] = this.isCrew;
        return data;
    }
}

export interface ICrew {
    id?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    active?: boolean | undefined;
    crewEquipment?: CrewEquipment[] | undefined;
    crewEmployees?: CrewEmployee[] | undefined;
    isCrew?: boolean | undefined;
}

export class CrewEquipment implements ICrewEquipment {
    id?: number | undefined;
    crewId?: number | undefined;
    equipmentId?: number | undefined;
    equipment?: Equipment | undefined;

    constructor(data?: ICrewEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.crewId = _data["CrewId"];
            this.equipmentId = _data["EquipmentId"];
            this.equipment = _data["Equipment"] ? Equipment.fromJS(_data["Equipment"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrewEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new CrewEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CrewId"] = this.crewId;
        data["EquipmentId"] = this.equipmentId;
        data["Equipment"] = this.equipment ? this.equipment.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrewEquipment {
    id?: number | undefined;
    crewId?: number | undefined;
    equipmentId?: number | undefined;
    equipment?: Equipment | undefined;
}

export class CrewEmployee implements ICrewEmployee {
    id?: number | undefined;
    crewId?: number | undefined;
    employeeId?: number | undefined;
    employee?: Employee | undefined;

    constructor(data?: ICrewEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.crewId = _data["CrewId"];
            this.employeeId = _data["EmployeeId"];
            this.employee = _data["Employee"] ? Employee.fromJS(_data["Employee"]) : undefined as any;
        }
    }

    static fromJS(data: any): CrewEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new CrewEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CrewId"] = this.crewId;
        data["EmployeeId"] = this.employeeId;
        data["Employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        return data;
    }
}

export interface ICrewEmployee {
    id?: number | undefined;
    crewId?: number | undefined;
    employeeId?: number | undefined;
    employee?: Employee | undefined;
}

export class CustomerAndToken implements ICustomerAndToken {
    token?: string | undefined;
    id?: number | undefined;
    active?: boolean | undefined;
    taxExempt?: boolean | undefined;
    manualPayment?: boolean | undefined;
    addressId?: number | undefined;
    address?: Address | undefined;
    stripeCustomerId?: string | undefined;
    customerTypeId?: number | undefined;
    companyName?: string | undefined;
    paymentInfoRequired?: boolean | undefined;
    customerType?: CustomerType | undefined;
    createdDate?: Date | undefined;
    deleted?: boolean | undefined;
    customerComments?: CustomerComment[] | undefined;
    customerRoles?: CustomerRole[] | undefined;
    customerContacts?: CustomerContact[] | undefined;
    fullName?: string | undefined;
    readonly primaryPhone?: string | undefined;

    constructor(data?: ICustomerAndToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.taxExempt = _data["TaxExempt"];
            this.manualPayment = _data["ManualPayment"];
            this.addressId = _data["AddressId"];
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : undefined as any;
            this.stripeCustomerId = _data["StripeCustomerId"];
            this.customerTypeId = _data["CustomerTypeId"];
            this.companyName = _data["CompanyName"];
            this.paymentInfoRequired = _data["PaymentInfoRequired"];
            this.customerType = _data["CustomerType"] ? CustomerType.fromJS(_data["CustomerType"]) : undefined as any;
            this.createdDate = _data["CreatedDate"] ? new Date(_data["CreatedDate"].toString()) : undefined as any;
            this.deleted = _data["Deleted"];
            if (Array.isArray(_data["CustomerComments"])) {
                this.customerComments = [] as any;
                for (let item of _data["CustomerComments"])
                    this.customerComments!.push(CustomerComment.fromJS(item));
            }
            if (Array.isArray(_data["CustomerRoles"])) {
                this.customerRoles = [] as any;
                for (let item of _data["CustomerRoles"])
                    this.customerRoles!.push(CustomerRole.fromJS(item));
            }
            if (Array.isArray(_data["CustomerContacts"])) {
                this.customerContacts = [] as any;
                for (let item of _data["CustomerContacts"])
                    this.customerContacts!.push(CustomerContact.fromJS(item));
            }
            this.fullName = _data["FullName"];
            (this as any).primaryPhone = _data["PrimaryPhone"];
        }
    }

    static fromJS(data: any): CustomerAndToken {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAndToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["TaxExempt"] = this.taxExempt;
        data["ManualPayment"] = this.manualPayment;
        data["AddressId"] = this.addressId;
        data["Address"] = this.address ? this.address.toJSON() : undefined as any;
        data["StripeCustomerId"] = this.stripeCustomerId;
        data["CustomerTypeId"] = this.customerTypeId;
        data["CompanyName"] = this.companyName;
        data["PaymentInfoRequired"] = this.paymentInfoRequired;
        data["CustomerType"] = this.customerType ? this.customerType.toJSON() : undefined as any;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["Deleted"] = this.deleted;
        if (Array.isArray(this.customerComments)) {
            data["CustomerComments"] = [];
            for (let item of this.customerComments)
                data["CustomerComments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerRoles)) {
            data["CustomerRoles"] = [];
            for (let item of this.customerRoles)
                data["CustomerRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.customerContacts)) {
            data["CustomerContacts"] = [];
            for (let item of this.customerContacts)
                data["CustomerContacts"].push(item ? item.toJSON() : undefined as any);
        }
        data["FullName"] = this.fullName;
        data["PrimaryPhone"] = this.primaryPhone;
        return data;
    }
}

export interface ICustomerAndToken {
    token?: string | undefined;
    id?: number | undefined;
    active?: boolean | undefined;
    taxExempt?: boolean | undefined;
    manualPayment?: boolean | undefined;
    addressId?: number | undefined;
    address?: Address | undefined;
    stripeCustomerId?: string | undefined;
    customerTypeId?: number | undefined;
    companyName?: string | undefined;
    paymentInfoRequired?: boolean | undefined;
    customerType?: CustomerType | undefined;
    createdDate?: Date | undefined;
    deleted?: boolean | undefined;
    customerComments?: CustomerComment[] | undefined;
    customerRoles?: CustomerRole[] | undefined;
    customerContacts?: CustomerContact[] | undefined;
    fullName?: string | undefined;
    primaryPhone?: string | undefined;
}

export class PagedResultOfCustomerListView implements IPagedResultOfCustomerListView {
    results?: CustomerListView[] | undefined;
    totalResults?: number | undefined;

    constructor(data?: IPagedResultOfCustomerListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(CustomerListView.fromJS(item));
            }
            this.totalResults = _data["TotalResults"];
        }
    }

    static fromJS(data: any): PagedResultOfCustomerListView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfCustomerListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalResults"] = this.totalResults;
        return data;
    }
}

export interface IPagedResultOfCustomerListView {
    results?: CustomerListView[] | undefined;
    totalResults?: number | undefined;
}

export class CustomerListView implements ICustomerListView {
    id?: number | undefined;
    fullName?: string | undefined;
    customerType?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    taxExempt?: boolean | undefined;
    active?: boolean | undefined;

    constructor(data?: ICustomerListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.customerType = _data["CustomerType"];
            this.address = _data["Address"];
            this.phoneNumber = _data["PhoneNumber"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zip = _data["Zip"];
            this.taxExempt = _data["TaxExempt"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): CustomerListView {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CustomerType"] = this.customerType;
        data["Address"] = this.address;
        data["PhoneNumber"] = this.phoneNumber;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Zip"] = this.zip;
        data["TaxExempt"] = this.taxExempt;
        data["Active"] = this.active;
        return data;
    }
}

export interface ICustomerListView {
    id?: number | undefined;
    fullName?: string | undefined;
    customerType?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    taxExempt?: boolean | undefined;
    active?: boolean | undefined;
}

export class CustomerDetails implements ICustomerDetails {
    id?: number | undefined;
    fullName?: string | undefined;
    customerType?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    taxExempt?: boolean | undefined;
    active?: boolean | undefined;
    contacts?: Contact[] | undefined;

    constructor(data?: ICustomerDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.customerType = _data["CustomerType"];
            this.address = _data["Address"];
            this.phoneNumber = _data["PhoneNumber"];
            this.city = _data["City"];
            this.state = _data["State"];
            this.zip = _data["Zip"];
            this.taxExempt = _data["TaxExempt"];
            this.active = _data["Active"];
            if (Array.isArray(_data["Contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["Contacts"])
                    this.contacts!.push(Contact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerDetails {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["CustomerType"] = this.customerType;
        data["Address"] = this.address;
        data["PhoneNumber"] = this.phoneNumber;
        data["City"] = this.city;
        data["State"] = this.state;
        data["Zip"] = this.zip;
        data["TaxExempt"] = this.taxExempt;
        data["Active"] = this.active;
        if (Array.isArray(this.contacts)) {
            data["Contacts"] = [];
            for (let item of this.contacts)
                data["Contacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerDetails {
    id?: number | undefined;
    fullName?: string | undefined;
    customerType?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    taxExempt?: boolean | undefined;
    active?: boolean | undefined;
    contacts?: Contact[] | undefined;
}

export class Contact implements IContact {
    id?: number | undefined;
    fullName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    isPrimary?: boolean | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.phone = _data["Phone"];
            this.email = _data["Email"];
            this.isPrimary = _data["IsPrimary"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["Phone"] = this.phone;
        data["Email"] = this.email;
        data["IsPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IContact {
    id?: number | undefined;
    fullName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    isPrimary?: boolean | undefined;
}

export class WorkOrderInfoPaginatedRequest implements IWorkOrderInfoPaginatedRequest {
    customerId?: number | undefined;
    skip?: number | undefined;
    take?: number | undefined;

    constructor(data?: IWorkOrderInfoPaginatedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["CustomerId"];
            this.skip = _data["Skip"];
            this.take = _data["Take"];
        }
    }

    static fromJS(data: any): WorkOrderInfoPaginatedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderInfoPaginatedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerId"] = this.customerId;
        data["Skip"] = this.skip;
        data["Take"] = this.take;
        return data;
    }
}

export interface IWorkOrderInfoPaginatedRequest {
    customerId?: number | undefined;
    skip?: number | undefined;
    take?: number | undefined;
}

export class AllQuoteRequests implements IAllQuoteRequests {
    quoteRequests?: QuoteRequest[] | undefined;
    requestsTotal?: number | undefined;

    constructor(data?: IAllQuoteRequests) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["QuoteRequests"])) {
                this.quoteRequests = [] as any;
                for (let item of _data["QuoteRequests"])
                    this.quoteRequests!.push(QuoteRequest.fromJS(item));
            }
            this.requestsTotal = _data["RequestsTotal"];
        }
    }

    static fromJS(data: any): AllQuoteRequests {
        data = typeof data === 'object' ? data : {};
        let result = new AllQuoteRequests();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quoteRequests)) {
            data["QuoteRequests"] = [];
            for (let item of this.quoteRequests)
                data["QuoteRequests"].push(item ? item.toJSON() : undefined as any);
        }
        data["RequestsTotal"] = this.requestsTotal;
        return data;
    }
}

export interface IAllQuoteRequests {
    quoteRequests?: QuoteRequest[] | undefined;
    requestsTotal?: number | undefined;
}

export class AllWorkOrders implements IAllWorkOrders {
    quoteWorkOrders?: QuoteWorkOrder[] | undefined;
    quoteTotal?: number | undefined;
    wellnessWorkOrders?: WellnessWorkOrder[] | undefined;
    workWorkOrders?: WorkWorkOrder[] | undefined;
    workOrderTotal?: number | undefined;

    constructor(data?: IAllWorkOrders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["QuoteWorkOrders"])) {
                this.quoteWorkOrders = [] as any;
                for (let item of _data["QuoteWorkOrders"])
                    this.quoteWorkOrders!.push(QuoteWorkOrder.fromJS(item));
            }
            this.quoteTotal = _data["QuoteTotal"];
            if (Array.isArray(_data["WellnessWorkOrders"])) {
                this.wellnessWorkOrders = [] as any;
                for (let item of _data["WellnessWorkOrders"])
                    this.wellnessWorkOrders!.push(WellnessWorkOrder.fromJS(item));
            }
            if (Array.isArray(_data["WorkWorkOrders"])) {
                this.workWorkOrders = [] as any;
                for (let item of _data["WorkWorkOrders"])
                    this.workWorkOrders!.push(WorkWorkOrder.fromJS(item));
            }
            this.workOrderTotal = _data["WorkOrderTotal"];
        }
    }

    static fromJS(data: any): AllWorkOrders {
        data = typeof data === 'object' ? data : {};
        let result = new AllWorkOrders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.quoteWorkOrders)) {
            data["QuoteWorkOrders"] = [];
            for (let item of this.quoteWorkOrders)
                data["QuoteWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        data["QuoteTotal"] = this.quoteTotal;
        if (Array.isArray(this.wellnessWorkOrders)) {
            data["WellnessWorkOrders"] = [];
            for (let item of this.wellnessWorkOrders)
                data["WellnessWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workWorkOrders)) {
            data["WorkWorkOrders"] = [];
            for (let item of this.workWorkOrders)
                data["WorkWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        data["WorkOrderTotal"] = this.workOrderTotal;
        return data;
    }
}

export interface IAllWorkOrders {
    quoteWorkOrders?: QuoteWorkOrder[] | undefined;
    quoteTotal?: number | undefined;
    wellnessWorkOrders?: WellnessWorkOrder[] | undefined;
    workWorkOrders?: WorkWorkOrder[] | undefined;
    workOrderTotal?: number | undefined;
}

export class AllWorkOrdersWithBilling implements IAllWorkOrdersWithBilling {
    workOrderBilling?: WorkOrderBilling[] | undefined;
    quoteWorkOrders?: QuoteWorkOrder[] | undefined;
    quoteTotal?: number | undefined;
    wellnessWorkOrders?: WellnessWorkOrder[] | undefined;
    workWorkOrders?: WorkWorkOrder[] | undefined;
    workOrderTotal?: number | undefined;

    constructor(data?: IAllWorkOrdersWithBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["WorkOrderBilling"])) {
                this.workOrderBilling = [] as any;
                for (let item of _data["WorkOrderBilling"])
                    this.workOrderBilling!.push(WorkOrderBilling.fromJS(item));
            }
            if (Array.isArray(_data["QuoteWorkOrders"])) {
                this.quoteWorkOrders = [] as any;
                for (let item of _data["QuoteWorkOrders"])
                    this.quoteWorkOrders!.push(QuoteWorkOrder.fromJS(item));
            }
            this.quoteTotal = _data["QuoteTotal"];
            if (Array.isArray(_data["WellnessWorkOrders"])) {
                this.wellnessWorkOrders = [] as any;
                for (let item of _data["WellnessWorkOrders"])
                    this.wellnessWorkOrders!.push(WellnessWorkOrder.fromJS(item));
            }
            if (Array.isArray(_data["WorkWorkOrders"])) {
                this.workWorkOrders = [] as any;
                for (let item of _data["WorkWorkOrders"])
                    this.workWorkOrders!.push(WorkWorkOrder.fromJS(item));
            }
            this.workOrderTotal = _data["WorkOrderTotal"];
        }
    }

    static fromJS(data: any): AllWorkOrdersWithBilling {
        data = typeof data === 'object' ? data : {};
        let result = new AllWorkOrdersWithBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workOrderBilling)) {
            data["WorkOrderBilling"] = [];
            for (let item of this.workOrderBilling)
                data["WorkOrderBilling"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.quoteWorkOrders)) {
            data["QuoteWorkOrders"] = [];
            for (let item of this.quoteWorkOrders)
                data["QuoteWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        data["QuoteTotal"] = this.quoteTotal;
        if (Array.isArray(this.wellnessWorkOrders)) {
            data["WellnessWorkOrders"] = [];
            for (let item of this.wellnessWorkOrders)
                data["WellnessWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workWorkOrders)) {
            data["WorkWorkOrders"] = [];
            for (let item of this.workWorkOrders)
                data["WorkWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        data["WorkOrderTotal"] = this.workOrderTotal;
        return data;
    }
}

export interface IAllWorkOrdersWithBilling {
    workOrderBilling?: WorkOrderBilling[] | undefined;
    quoteWorkOrders?: QuoteWorkOrder[] | undefined;
    quoteTotal?: number | undefined;
    wellnessWorkOrders?: WellnessWorkOrder[] | undefined;
    workWorkOrders?: WorkWorkOrder[] | undefined;
    workOrderTotal?: number | undefined;
}

export class WorkOrderBilling implements IWorkOrderBilling {
    workOrderId?: number | undefined;
    workOrderType?: string | undefined;
    invoicedAmount?: number | undefined;
    paymentType?: string | undefined;
    paymentTypeLast4?: string | undefined;
    amountDueFromInvoices?: number | undefined;
    receiptURLAndTaskName?: ReceiptURLAndTaskName[] | undefined;

    constructor(data?: IWorkOrderBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["WorkOrderId"];
            this.workOrderType = _data["WorkOrderType"];
            this.invoicedAmount = _data["InvoicedAmount"];
            this.paymentType = _data["PaymentType"];
            this.paymentTypeLast4 = _data["PaymentTypeLast4"];
            this.amountDueFromInvoices = _data["AmountDueFromInvoices"];
            if (Array.isArray(_data["ReceiptURLAndTaskName"])) {
                this.receiptURLAndTaskName = [] as any;
                for (let item of _data["ReceiptURLAndTaskName"])
                    this.receiptURLAndTaskName!.push(ReceiptURLAndTaskName.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkOrderBilling {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WorkOrderId"] = this.workOrderId;
        data["WorkOrderType"] = this.workOrderType;
        data["InvoicedAmount"] = this.invoicedAmount;
        data["PaymentType"] = this.paymentType;
        data["PaymentTypeLast4"] = this.paymentTypeLast4;
        data["AmountDueFromInvoices"] = this.amountDueFromInvoices;
        if (Array.isArray(this.receiptURLAndTaskName)) {
            data["ReceiptURLAndTaskName"] = [];
            for (let item of this.receiptURLAndTaskName)
                data["ReceiptURLAndTaskName"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkOrderBilling {
    workOrderId?: number | undefined;
    workOrderType?: string | undefined;
    invoicedAmount?: number | undefined;
    paymentType?: string | undefined;
    paymentTypeLast4?: string | undefined;
    amountDueFromInvoices?: number | undefined;
    receiptURLAndTaskName?: ReceiptURLAndTaskName[] | undefined;
}

export class ReceiptURLAndTaskName implements IReceiptURLAndTaskName {
    receiptURLs?: string[] | undefined;
    taskNames?: string | undefined;
    invoiceNumber?: string | undefined;

    constructor(data?: IReceiptURLAndTaskName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ReceiptURLs"])) {
                this.receiptURLs = [] as any;
                for (let item of _data["ReceiptURLs"])
                    this.receiptURLs!.push(item);
            }
            this.taskNames = _data["TaskNames"];
            this.invoiceNumber = _data["InvoiceNumber"];
        }
    }

    static fromJS(data: any): ReceiptURLAndTaskName {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptURLAndTaskName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.receiptURLs)) {
            data["ReceiptURLs"] = [];
            for (let item of this.receiptURLs)
                data["ReceiptURLs"].push(item);
        }
        data["TaskNames"] = this.taskNames;
        data["InvoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IReceiptURLAndTaskName {
    receiptURLs?: string[] | undefined;
    taskNames?: string | undefined;
    invoiceNumber?: string | undefined;
}

export class RequestChangesEmailRequest implements IRequestChangesEmailRequest {
    customerName?: string | undefined;
    customerEmails?: string[] | undefined;
    recipientEmail?: string | undefined;
    requestedChangesText?: string | undefined;
    quoteNumber?: string | undefined;
    customerComment?: CustomerComment | undefined;
    encodedCustId?: string | undefined;
    encodedQuoteId?: string | undefined;

    constructor(data?: IRequestChangesEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["CustomerName"];
            if (Array.isArray(_data["CustomerEmails"])) {
                this.customerEmails = [] as any;
                for (let item of _data["CustomerEmails"])
                    this.customerEmails!.push(item);
            }
            this.recipientEmail = _data["RecipientEmail"];
            this.requestedChangesText = _data["RequestedChangesText"];
            this.quoteNumber = _data["QuoteNumber"];
            this.customerComment = _data["CustomerComment"] ? CustomerComment.fromJS(_data["CustomerComment"]) : undefined as any;
            this.encodedCustId = _data["EncodedCustId"];
            this.encodedQuoteId = _data["EncodedQuoteId"];
        }
    }

    static fromJS(data: any): RequestChangesEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestChangesEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerName"] = this.customerName;
        if (Array.isArray(this.customerEmails)) {
            data["CustomerEmails"] = [];
            for (let item of this.customerEmails)
                data["CustomerEmails"].push(item);
        }
        data["RecipientEmail"] = this.recipientEmail;
        data["RequestedChangesText"] = this.requestedChangesText;
        data["QuoteNumber"] = this.quoteNumber;
        data["CustomerComment"] = this.customerComment ? this.customerComment.toJSON() : undefined as any;
        data["EncodedCustId"] = this.encodedCustId;
        data["EncodedQuoteId"] = this.encodedQuoteId;
        return data;
    }
}

export interface IRequestChangesEmailRequest {
    customerName?: string | undefined;
    customerEmails?: string[] | undefined;
    recipientEmail?: string | undefined;
    requestedChangesText?: string | undefined;
    quoteNumber?: string | undefined;
    customerComment?: CustomerComment | undefined;
    encodedCustId?: string | undefined;
    encodedQuoteId?: string | undefined;
}

export class EmployeeMFAPreferenceViewModel implements IEmployeeMFAPreferenceViewModel {
    id?: number | undefined;
    maskedEmail?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    preferenceType?: EmployeeMFAPreferenceViewModelPreferenceType | undefined;

    constructor(data?: IEmployeeMFAPreferenceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.maskedEmail = _data["MaskedEmail"];
            this.emailAddress = _data["EmailAddress"];
            this.phoneNumber = _data["PhoneNumber"];
            this.preferenceType = _data["PreferenceType"];
        }
    }

    static fromJS(data: any): EmployeeMFAPreferenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeMFAPreferenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["MaskedEmail"] = this.maskedEmail;
        data["EmailAddress"] = this.emailAddress;
        data["PhoneNumber"] = this.phoneNumber;
        data["PreferenceType"] = this.preferenceType;
        return data;
    }
}

export interface IEmployeeMFAPreferenceViewModel {
    id?: number | undefined;
    maskedEmail?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
    preferenceType?: EmployeeMFAPreferenceViewModelPreferenceType | undefined;
}

export class ExportModel implements IExportModel {
    id?: number | undefined;
    name?: string | undefined;
    options?: ExportOptionModel[] | undefined;

    constructor(data?: IExportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Options"])) {
                this.options = [] as any;
                for (let item of _data["Options"])
                    this.options!.push(ExportOptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.options)) {
            data["Options"] = [];
            for (let item of this.options)
                data["Options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExportModel {
    id?: number | undefined;
    name?: string | undefined;
    options?: ExportOptionModel[] | undefined;
}

export class ExportOptionModel implements IExportOptionModel {
    id?: number | undefined;
    name?: string | undefined;
    filterOn?: string | undefined;

    constructor(data?: IExportOptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.filterOn = _data["FilterOn"];
        }
    }

    static fromJS(data: any): ExportOptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["FilterOn"] = this.filterOn;
        return data;
    }
}

export interface IExportOptionModel {
    id?: number | undefined;
    name?: string | undefined;
    filterOn?: string | undefined;
}

export class ReportWithDatesRequest implements IReportWithDatesRequest {
    id?: number | undefined;
    afterDate?: Date | undefined;
    beforeDate?: Date | undefined;

    constructor(data?: IReportWithDatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.afterDate = _data["AfterDate"] ? new Date(_data["AfterDate"].toString()) : undefined as any;
            this.beforeDate = _data["BeforeDate"] ? new Date(_data["BeforeDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ReportWithDatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportWithDatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["AfterDate"] = this.afterDate ? this.afterDate.toISOString() : undefined as any;
        data["BeforeDate"] = this.beforeDate ? this.beforeDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IReportWithDatesRequest {
    id?: number | undefined;
    afterDate?: Date | undefined;
    beforeDate?: Date | undefined;
}

export class ExportResponseModel implements IExportResponseModel {
    headers?: string[] | undefined;
    jSONData?: string | undefined;

    constructor(data?: IExportResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Headers"])) {
                this.headers = [] as any;
                for (let item of _data["Headers"])
                    this.headers!.push(item);
            }
            this.jSONData = _data["JSONData"];
        }
    }

    static fromJS(data: any): ExportResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExportResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.headers)) {
            data["Headers"] = [];
            for (let item of this.headers)
                data["Headers"].push(item);
        }
        data["JSONData"] = this.jSONData;
        return data;
    }
}

export interface IExportResponseModel {
    headers?: string[] | undefined;
    jSONData?: string | undefined;
}

export class LogViewModel implements ILogViewModel {
    entryDate?: Date | undefined;
    message?: string | undefined;
    level?: LogViewModelLevel | undefined;

    constructor(data?: ILogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDate = _data["EntryDate"] ? new Date(_data["EntryDate"].toString()) : undefined as any;
            this.message = _data["Message"];
            this.level = _data["Level"];
        }
    }

    static fromJS(data: any): LogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["EntryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["Message"] = this.message;
        data["Level"] = this.level;
        return data;
    }
}

export interface ILogViewModel {
    entryDate?: Date | undefined;
    message?: string | undefined;
    level?: LogViewModelLevel | undefined;
}

export class MessageToCustomerTemplate implements IMessageToCustomerTemplate {
    id?: number | undefined;
    active?: boolean | undefined;
    name?: string | undefined;
    message?: string | undefined;

    constructor(data?: IMessageToCustomerTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.name = _data["Name"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): MessageToCustomerTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new MessageToCustomerTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Name"] = this.name;
        data["Message"] = this.message;
        return data;
    }
}

export interface IMessageToCustomerTemplate {
    id?: number | undefined;
    active?: boolean | undefined;
    name?: string | undefined;
    message?: string | undefined;
}

export class NeighborPermissionDTO implements INeighborPermissionDTO {
    neighborPermissionId?: number | undefined;
    quoteId?: number | undefined;

    constructor(data?: INeighborPermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neighborPermissionId = _data["NeighborPermissionId"];
            this.quoteId = _data["QuoteId"];
        }
    }

    static fromJS(data: any): NeighborPermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NeighborPermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NeighborPermissionId"] = this.neighborPermissionId;
        data["QuoteId"] = this.quoteId;
        return data;
    }
}

export interface INeighborPermissionDTO {
    neighborPermissionId?: number | undefined;
    quoteId?: number | undefined;
}

export class NotificationTemplateDTO implements INotificationTemplateDTO {
    id?: number | undefined;
    active?: boolean | undefined;
    name?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    extra?: string | undefined;

    constructor(data?: INotificationTemplateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.name = _data["Name"];
            this.subject = _data["Subject"];
            this.title = _data["Title"];
            this.body = _data["Body"];
            this.extra = _data["Extra"];
        }
    }

    static fromJS(data: any): NotificationTemplateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTemplateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Name"] = this.name;
        data["Subject"] = this.subject;
        data["Title"] = this.title;
        data["Body"] = this.body;
        data["Extra"] = this.extra;
        return data;
    }
}

export interface INotificationTemplateDTO {
    id?: number | undefined;
    active?: boolean | undefined;
    name?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    body?: string | undefined;
    extra?: string | undefined;
}

export class PesticideApplicationRecord implements IPesticideApplicationRecord {
    id?: number | undefined;
    active?: boolean | undefined;
    dateApplied?: Date | undefined;
    applicatorId?: number | undefined;
    applicator?: Employee | undefined;
    certifiedApplicatorId?: number | undefined;
    certifiedApplicator?: Employee | undefined;
    chemicalId?: number | undefined;
    chemical?: Chemical | undefined;
    amountConcentrateUsed?: string | undefined;
    totalVolume?: string | undefined;
    chemicalApplicationMethodId?: number | undefined;
    chemicalApplicationMethod?: ChemicalApplicationMethod | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    windDirectionAndSpeed?: string | undefined;
    temperature?: number | undefined;
    chemicalApplicationLocationId?: number | undefined;
    chemicalApplicationLocation?: ChemicalApplicationLocation | undefined;
    wellnessWorkOrderId?: number | undefined;
    wellnessWorkOrder?: WellnessWorkOrder | undefined;
    workWorkOrderId?: number | undefined;
    workWorkOrder?: WorkWorkOrder | undefined;
    quoteNumber?: string | undefined;
    readonly customerName?: string | undefined;
    readonly address?: string | undefined;

    constructor(data?: IPesticideApplicationRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.dateApplied = _data["DateApplied"] ? new Date(_data["DateApplied"].toString()) : undefined as any;
            this.applicatorId = _data["ApplicatorId"];
            this.applicator = _data["Applicator"] ? Employee.fromJS(_data["Applicator"]) : undefined as any;
            this.certifiedApplicatorId = _data["CertifiedApplicatorId"];
            this.certifiedApplicator = _data["CertifiedApplicator"] ? Employee.fromJS(_data["CertifiedApplicator"]) : undefined as any;
            this.chemicalId = _data["ChemicalId"];
            this.chemical = _data["Chemical"] ? Chemical.fromJS(_data["Chemical"]) : undefined as any;
            this.amountConcentrateUsed = _data["AmountConcentrateUsed"];
            this.totalVolume = _data["TotalVolume"];
            this.chemicalApplicationMethodId = _data["ChemicalApplicationMethodId"];
            this.chemicalApplicationMethod = _data["ChemicalApplicationMethod"] ? ChemicalApplicationMethod.fromJS(_data["ChemicalApplicationMethod"]) : undefined as any;
            this.startTime = _data["StartTime"] ? new Date(_data["StartTime"].toString()) : undefined as any;
            this.endTime = _data["EndTime"] ? new Date(_data["EndTime"].toString()) : undefined as any;
            this.windDirectionAndSpeed = _data["WindDirectionAndSpeed"];
            this.temperature = _data["Temperature"];
            this.chemicalApplicationLocationId = _data["ChemicalApplicationLocationId"];
            this.chemicalApplicationLocation = _data["ChemicalApplicationLocation"] ? ChemicalApplicationLocation.fromJS(_data["ChemicalApplicationLocation"]) : undefined as any;
            this.wellnessWorkOrderId = _data["WellnessWorkOrderId"];
            this.wellnessWorkOrder = _data["WellnessWorkOrder"] ? WellnessWorkOrder.fromJS(_data["WellnessWorkOrder"]) : undefined as any;
            this.workWorkOrderId = _data["WorkWorkOrderId"];
            this.workWorkOrder = _data["WorkWorkOrder"] ? WorkWorkOrder.fromJS(_data["WorkWorkOrder"]) : undefined as any;
            this.quoteNumber = _data["QuoteNumber"];
            (this as any).customerName = _data["CustomerName"];
            (this as any).address = _data["Address"];
        }
    }

    static fromJS(data: any): PesticideApplicationRecord {
        data = typeof data === 'object' ? data : {};
        let result = new PesticideApplicationRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["DateApplied"] = this.dateApplied ? this.dateApplied.toISOString() : undefined as any;
        data["ApplicatorId"] = this.applicatorId;
        data["Applicator"] = this.applicator ? this.applicator.toJSON() : undefined as any;
        data["CertifiedApplicatorId"] = this.certifiedApplicatorId;
        data["CertifiedApplicator"] = this.certifiedApplicator ? this.certifiedApplicator.toJSON() : undefined as any;
        data["ChemicalId"] = this.chemicalId;
        data["Chemical"] = this.chemical ? this.chemical.toJSON() : undefined as any;
        data["AmountConcentrateUsed"] = this.amountConcentrateUsed;
        data["TotalVolume"] = this.totalVolume;
        data["ChemicalApplicationMethodId"] = this.chemicalApplicationMethodId;
        data["ChemicalApplicationMethod"] = this.chemicalApplicationMethod ? this.chemicalApplicationMethod.toJSON() : undefined as any;
        data["StartTime"] = this.startTime ? this.startTime.toISOString() : undefined as any;
        data["EndTime"] = this.endTime ? this.endTime.toISOString() : undefined as any;
        data["WindDirectionAndSpeed"] = this.windDirectionAndSpeed;
        data["Temperature"] = this.temperature;
        data["ChemicalApplicationLocationId"] = this.chemicalApplicationLocationId;
        data["ChemicalApplicationLocation"] = this.chemicalApplicationLocation ? this.chemicalApplicationLocation.toJSON() : undefined as any;
        data["WellnessWorkOrderId"] = this.wellnessWorkOrderId;
        data["WellnessWorkOrder"] = this.wellnessWorkOrder ? this.wellnessWorkOrder.toJSON() : undefined as any;
        data["WorkWorkOrderId"] = this.workWorkOrderId;
        data["WorkWorkOrder"] = this.workWorkOrder ? this.workWorkOrder.toJSON() : undefined as any;
        data["QuoteNumber"] = this.quoteNumber;
        data["CustomerName"] = this.customerName;
        data["Address"] = this.address;
        return data;
    }
}

export interface IPesticideApplicationRecord {
    id?: number | undefined;
    active?: boolean | undefined;
    dateApplied?: Date | undefined;
    applicatorId?: number | undefined;
    applicator?: Employee | undefined;
    certifiedApplicatorId?: number | undefined;
    certifiedApplicator?: Employee | undefined;
    chemicalId?: number | undefined;
    chemical?: Chemical | undefined;
    amountConcentrateUsed?: string | undefined;
    totalVolume?: string | undefined;
    chemicalApplicationMethodId?: number | undefined;
    chemicalApplicationMethod?: ChemicalApplicationMethod | undefined;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    windDirectionAndSpeed?: string | undefined;
    temperature?: number | undefined;
    chemicalApplicationLocationId?: number | undefined;
    chemicalApplicationLocation?: ChemicalApplicationLocation | undefined;
    wellnessWorkOrderId?: number | undefined;
    wellnessWorkOrder?: WellnessWorkOrder | undefined;
    workWorkOrderId?: number | undefined;
    workWorkOrder?: WorkWorkOrder | undefined;
    quoteNumber?: string | undefined;
    customerName?: string | undefined;
    address?: string | undefined;
}

export class AdvancedWorkOrderFilter implements IAdvancedWorkOrderFilter {
    shouldFilterByRM?: boolean | undefined;
    shouldFilterByEquipmentType?: boolean | undefined;
    shouldFilterByDueDate?: boolean | undefined;
    shouldFilterByPriority?: boolean | undefined;
    shouldFilterByGeoRegion?: boolean | undefined;
    shouldFilterByGDD?: boolean | undefined;
    shouldFilterByAutoRenewalSelected?: boolean | undefined;
    shouldFilterByNeedsRenewed?: boolean | undefined;
    shouldFilterByQuoteDeclined?: boolean | undefined;
    shouldFilterByZip?: boolean | undefined;
    shouldFilterByCreatedDate?: boolean | undefined;
    shouldFilterByCompletedDate?: boolean | undefined;
    rMs?: string[] | undefined;
    equipmentTypes?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    priorities?: string[] | undefined;
    geoRegionMiles?: number | undefined;
    geoRegionOrigQuoteId?: string | undefined;
    gDDStart?: number | undefined;
    gDDEnd?: number | undefined;
    zipCodes?: string[] | undefined;
    createdDateStart?: Date | undefined;
    createdDateEnd?: Date | undefined;
    completedDateStart?: Date | undefined;
    completedDateEnd?: Date | undefined;
    skip?: number | undefined;
    take?: number | undefined;
    globalFilter?: string | undefined;
    orderBy?: string | undefined;

    constructor(data?: IAdvancedWorkOrderFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldFilterByRM = _data["ShouldFilterByRM"];
            this.shouldFilterByEquipmentType = _data["ShouldFilterByEquipmentType"];
            this.shouldFilterByDueDate = _data["ShouldFilterByDueDate"];
            this.shouldFilterByPriority = _data["ShouldFilterByPriority"];
            this.shouldFilterByGeoRegion = _data["ShouldFilterByGeoRegion"];
            this.shouldFilterByGDD = _data["ShouldFilterByGDD"];
            this.shouldFilterByAutoRenewalSelected = _data["ShouldFilterByAutoRenewalSelected"];
            this.shouldFilterByNeedsRenewed = _data["ShouldFilterByNeedsRenewed"];
            this.shouldFilterByQuoteDeclined = _data["shouldFilterByQuoteDeclined"];
            this.shouldFilterByZip = _data["ShouldFilterByZip"];
            this.shouldFilterByCreatedDate = _data["ShouldFilterByCreatedDate"];
            this.shouldFilterByCompletedDate = _data["ShouldFilterByCompletedDate"];
            if (Array.isArray(_data["RMs"])) {
                this.rMs = [] as any;
                for (let item of _data["RMs"])
                    this.rMs!.push(item);
            }
            if (Array.isArray(_data["EquipmentTypes"])) {
                this.equipmentTypes = [] as any;
                for (let item of _data["EquipmentTypes"])
                    this.equipmentTypes!.push(item);
            }
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : undefined as any;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : undefined as any;
            if (Array.isArray(_data["Priorities"])) {
                this.priorities = [] as any;
                for (let item of _data["Priorities"])
                    this.priorities!.push(item);
            }
            this.geoRegionMiles = _data["GeoRegionMiles"];
            this.geoRegionOrigQuoteId = _data["GeoRegionOrigQuoteId"];
            this.gDDStart = _data["GDDStart"];
            this.gDDEnd = _data["GDDEnd"];
            if (Array.isArray(_data["ZipCodes"])) {
                this.zipCodes = [] as any;
                for (let item of _data["ZipCodes"])
                    this.zipCodes!.push(item);
            }
            this.createdDateStart = _data["CreatedDateStart"] ? new Date(_data["CreatedDateStart"].toString()) : undefined as any;
            this.createdDateEnd = _data["CreatedDateEnd"] ? new Date(_data["CreatedDateEnd"].toString()) : undefined as any;
            this.completedDateStart = _data["CompletedDateStart"] ? new Date(_data["CompletedDateStart"].toString()) : undefined as any;
            this.completedDateEnd = _data["CompletedDateEnd"] ? new Date(_data["CompletedDateEnd"].toString()) : undefined as any;
            this.skip = _data["Skip"];
            this.take = _data["Take"];
            this.globalFilter = _data["GlobalFilter"];
            this.orderBy = _data["OrderBy"];
        }
    }

    static fromJS(data: any): AdvancedWorkOrderFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedWorkOrderFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShouldFilterByRM"] = this.shouldFilterByRM;
        data["ShouldFilterByEquipmentType"] = this.shouldFilterByEquipmentType;
        data["ShouldFilterByDueDate"] = this.shouldFilterByDueDate;
        data["ShouldFilterByPriority"] = this.shouldFilterByPriority;
        data["ShouldFilterByGeoRegion"] = this.shouldFilterByGeoRegion;
        data["ShouldFilterByGDD"] = this.shouldFilterByGDD;
        data["ShouldFilterByAutoRenewalSelected"] = this.shouldFilterByAutoRenewalSelected;
        data["ShouldFilterByNeedsRenewed"] = this.shouldFilterByNeedsRenewed;
        data["shouldFilterByQuoteDeclined"] = this.shouldFilterByQuoteDeclined;
        data["ShouldFilterByZip"] = this.shouldFilterByZip;
        data["ShouldFilterByCreatedDate"] = this.shouldFilterByCreatedDate;
        data["ShouldFilterByCompletedDate"] = this.shouldFilterByCompletedDate;
        if (Array.isArray(this.rMs)) {
            data["RMs"] = [];
            for (let item of this.rMs)
                data["RMs"].push(item);
        }
        if (Array.isArray(this.equipmentTypes)) {
            data["EquipmentTypes"] = [];
            for (let item of this.equipmentTypes)
                data["EquipmentTypes"].push(item);
        }
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        if (Array.isArray(this.priorities)) {
            data["Priorities"] = [];
            for (let item of this.priorities)
                data["Priorities"].push(item);
        }
        data["GeoRegionMiles"] = this.geoRegionMiles;
        data["GeoRegionOrigQuoteId"] = this.geoRegionOrigQuoteId;
        data["GDDStart"] = this.gDDStart;
        data["GDDEnd"] = this.gDDEnd;
        if (Array.isArray(this.zipCodes)) {
            data["ZipCodes"] = [];
            for (let item of this.zipCodes)
                data["ZipCodes"].push(item);
        }
        data["CreatedDateStart"] = this.createdDateStart ? this.createdDateStart.toISOString() : undefined as any;
        data["CreatedDateEnd"] = this.createdDateEnd ? this.createdDateEnd.toISOString() : undefined as any;
        data["CompletedDateStart"] = this.completedDateStart ? this.completedDateStart.toISOString() : undefined as any;
        data["CompletedDateEnd"] = this.completedDateEnd ? this.completedDateEnd.toISOString() : undefined as any;
        data["Skip"] = this.skip;
        data["Take"] = this.take;
        data["GlobalFilter"] = this.globalFilter;
        data["OrderBy"] = this.orderBy;
        return data;
    }
}

export interface IAdvancedWorkOrderFilter {
    shouldFilterByRM?: boolean | undefined;
    shouldFilterByEquipmentType?: boolean | undefined;
    shouldFilterByDueDate?: boolean | undefined;
    shouldFilterByPriority?: boolean | undefined;
    shouldFilterByGeoRegion?: boolean | undefined;
    shouldFilterByGDD?: boolean | undefined;
    shouldFilterByAutoRenewalSelected?: boolean | undefined;
    shouldFilterByNeedsRenewed?: boolean | undefined;
    shouldFilterByQuoteDeclined?: boolean | undefined;
    shouldFilterByZip?: boolean | undefined;
    shouldFilterByCreatedDate?: boolean | undefined;
    shouldFilterByCompletedDate?: boolean | undefined;
    rMs?: string[] | undefined;
    equipmentTypes?: string[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    priorities?: string[] | undefined;
    geoRegionMiles?: number | undefined;
    geoRegionOrigQuoteId?: string | undefined;
    gDDStart?: number | undefined;
    gDDEnd?: number | undefined;
    zipCodes?: string[] | undefined;
    createdDateStart?: Date | undefined;
    createdDateEnd?: Date | undefined;
    completedDateStart?: Date | undefined;
    completedDateEnd?: Date | undefined;
    skip?: number | undefined;
    take?: number | undefined;
    globalFilter?: string | undefined;
    orderBy?: string | undefined;
}

export class PagedResultsForInvoicingOfWorkOrderListView implements IPagedResultsForInvoicingOfWorkOrderListView {
    completionStatuses?: string[] | undefined;
    rMs?: string[] | undefined;
    equipmentTypes?: string[] | undefined;
    results?: WorkOrderListView[] | undefined;
    totalResults?: number | undefined;

    constructor(data?: IPagedResultsForInvoicingOfWorkOrderListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["CompletionStatuses"])) {
                this.completionStatuses = [] as any;
                for (let item of _data["CompletionStatuses"])
                    this.completionStatuses!.push(item);
            }
            if (Array.isArray(_data["RMs"])) {
                this.rMs = [] as any;
                for (let item of _data["RMs"])
                    this.rMs!.push(item);
            }
            if (Array.isArray(_data["EquipmentTypes"])) {
                this.equipmentTypes = [] as any;
                for (let item of _data["EquipmentTypes"])
                    this.equipmentTypes!.push(item);
            }
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(WorkOrderListView.fromJS(item));
            }
            this.totalResults = _data["TotalResults"];
        }
    }

    static fromJS(data: any): PagedResultsForInvoicingOfWorkOrderListView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsForInvoicingOfWorkOrderListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.completionStatuses)) {
            data["CompletionStatuses"] = [];
            for (let item of this.completionStatuses)
                data["CompletionStatuses"].push(item);
        }
        if (Array.isArray(this.rMs)) {
            data["RMs"] = [];
            for (let item of this.rMs)
                data["RMs"].push(item);
        }
        if (Array.isArray(this.equipmentTypes)) {
            data["EquipmentTypes"] = [];
            for (let item of this.equipmentTypes)
                data["EquipmentTypes"].push(item);
        }
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalResults"] = this.totalResults;
        return data;
    }
}

export interface IPagedResultsForInvoicingOfWorkOrderListView {
    completionStatuses?: string[] | undefined;
    rMs?: string[] | undefined;
    equipmentTypes?: string[] | undefined;
    results?: WorkOrderListView[] | undefined;
    totalResults?: number | undefined;
}

export class WorkOrderListView implements IWorkOrderListView {
    number?: string | undefined;
    fullName?: string | undefined;
    representative?: string | undefined;
    customerId?: number | undefined;
    id?: number | undefined;
    wellnessTasksCount?: number | undefined;
    workTasksCount?: number | undefined;
    price?: number | undefined;
    hours?: number | undefined;
    createdOn?: Date | undefined;
    status?: string | undefined;
    mostUrgentPriorityLevel?: string | undefined;
    equipmentTypes?: string[] | undefined;
    anyAreRenewable?: boolean | undefined;
    anyRenewalAccepted?: boolean | undefined;
    anyNeedsRenewed?: boolean | undefined;
    zip?: string | undefined;
    taskNames?: string | undefined;
    completedDate?: Date | undefined;

    constructor(data?: IWorkOrderListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["Number"];
            this.fullName = _data["FullName"];
            this.representative = _data["Representative"];
            this.customerId = _data["CustomerId"];
            this.id = _data["Id"];
            this.wellnessTasksCount = _data["WellnessTasksCount"];
            this.workTasksCount = _data["WorkTasksCount"];
            this.price = _data["Price"];
            this.hours = _data["Hours"];
            this.createdOn = _data["CreatedOn"] ? new Date(_data["CreatedOn"].toString()) : undefined as any;
            this.status = _data["Status"];
            this.mostUrgentPriorityLevel = _data["MostUrgentPriorityLevel"];
            if (Array.isArray(_data["EquipmentTypes"])) {
                this.equipmentTypes = [] as any;
                for (let item of _data["EquipmentTypes"])
                    this.equipmentTypes!.push(item);
            }
            this.anyAreRenewable = _data["AnyAreRenewable"];
            this.anyRenewalAccepted = _data["AnyRenewalAccepted"];
            this.anyNeedsRenewed = _data["AnyNeedsRenewed"];
            this.zip = _data["Zip"];
            this.taskNames = _data["TaskNames"];
            this.completedDate = _data["CompletedDate"] ? new Date(_data["CompletedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderListView {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["FullName"] = this.fullName;
        data["Representative"] = this.representative;
        data["CustomerId"] = this.customerId;
        data["Id"] = this.id;
        data["WellnessTasksCount"] = this.wellnessTasksCount;
        data["WorkTasksCount"] = this.workTasksCount;
        data["Price"] = this.price;
        data["Hours"] = this.hours;
        data["CreatedOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["Status"] = this.status;
        data["MostUrgentPriorityLevel"] = this.mostUrgentPriorityLevel;
        if (Array.isArray(this.equipmentTypes)) {
            data["EquipmentTypes"] = [];
            for (let item of this.equipmentTypes)
                data["EquipmentTypes"].push(item);
        }
        data["AnyAreRenewable"] = this.anyAreRenewable;
        data["AnyRenewalAccepted"] = this.anyRenewalAccepted;
        data["AnyNeedsRenewed"] = this.anyNeedsRenewed;
        data["Zip"] = this.zip;
        data["TaskNames"] = this.taskNames;
        data["CompletedDate"] = this.completedDate ? this.completedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkOrderListView {
    number?: string | undefined;
    fullName?: string | undefined;
    representative?: string | undefined;
    customerId?: number | undefined;
    id?: number | undefined;
    wellnessTasksCount?: number | undefined;
    workTasksCount?: number | undefined;
    price?: number | undefined;
    hours?: number | undefined;
    createdOn?: Date | undefined;
    status?: string | undefined;
    mostUrgentPriorityLevel?: string | undefined;
    equipmentTypes?: string[] | undefined;
    anyAreRenewable?: boolean | undefined;
    anyRenewalAccepted?: boolean | undefined;
    anyNeedsRenewed?: boolean | undefined;
    zip?: string | undefined;
    taskNames?: string | undefined;
    completedDate?: Date | undefined;
}

export class Dto implements IDto {
    quoteId?: number | undefined;
    selectedWellnessTaskIds?: number[] | undefined;
    selectedWorkTaskIds?: number[] | undefined;

    constructor(data?: IDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data["quoteId"];
            if (Array.isArray(_data["selectedWellnessTaskIds"])) {
                this.selectedWellnessTaskIds = [] as any;
                for (let item of _data["selectedWellnessTaskIds"])
                    this.selectedWellnessTaskIds!.push(item);
            }
            if (Array.isArray(_data["selectedWorkTaskIds"])) {
                this.selectedWorkTaskIds = [] as any;
                for (let item of _data["selectedWorkTaskIds"])
                    this.selectedWorkTaskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): Dto {
        data = typeof data === 'object' ? data : {};
        let result = new Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quoteId"] = this.quoteId;
        if (Array.isArray(this.selectedWellnessTaskIds)) {
            data["selectedWellnessTaskIds"] = [];
            for (let item of this.selectedWellnessTaskIds)
                data["selectedWellnessTaskIds"].push(item);
        }
        if (Array.isArray(this.selectedWorkTaskIds)) {
            data["selectedWorkTaskIds"] = [];
            for (let item of this.selectedWorkTaskIds)
                data["selectedWorkTaskIds"].push(item);
        }
        return data;
    }
}

export interface IDto {
    quoteId?: number | undefined;
    selectedWellnessTaskIds?: number[] | undefined;
    selectedWorkTaskIds?: number[] | undefined;
}

export class WorkOrdersCreatedDTO implements IWorkOrdersCreatedDTO {
    wellnessWorkOrderId?: number | undefined;
    workWorkOrderId?: number | undefined;

    constructor(data?: IWorkOrdersCreatedDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellnessWorkOrderId = _data["WellnessWorkOrderId"];
            this.workWorkOrderId = _data["WorkWorkOrderId"];
        }
    }

    static fromJS(data: any): WorkOrdersCreatedDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrdersCreatedDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WellnessWorkOrderId"] = this.wellnessWorkOrderId;
        data["WorkWorkOrderId"] = this.workWorkOrderId;
        return data;
    }
}

export interface IWorkOrdersCreatedDTO {
    wellnessWorkOrderId?: number | undefined;
    workWorkOrderId?: number | undefined;
}

export class PagedResultOfQuoteRequestListView implements IPagedResultOfQuoteRequestListView {
    results?: QuoteRequestListView[] | undefined;
    totalResults?: number | undefined;

    constructor(data?: IPagedResultOfQuoteRequestListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(QuoteRequestListView.fromJS(item));
            }
            this.totalResults = _data["TotalResults"];
        }
    }

    static fromJS(data: any): PagedResultOfQuoteRequestListView {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfQuoteRequestListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalResults"] = this.totalResults;
        return data;
    }
}

export interface IPagedResultOfQuoteRequestListView {
    results?: QuoteRequestListView[] | undefined;
    totalResults?: number | undefined;
}

export class QuoteRequestListView implements IQuoteRequestListView {
    id?: number | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    state?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    active?: boolean | undefined;
    completionStatus?: string | undefined;
    paymentStatus?: string | undefined;
    type?: string | undefined;
    isScheduled?: boolean | undefined;
    createdDate?: Date | undefined;
    isUrgent?: boolean | undefined;

    constructor(data?: IQuoteRequestListView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.fullName = _data["FullName"];
            this.phoneNumber = _data["PhoneNumber"];
            this.state = _data["State"];
            this.address = _data["Address"];
            this.zip = _data["Zip"];
            this.active = _data["Active"];
            this.completionStatus = _data["CompletionStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.type = _data["Type"];
            this.isScheduled = _data["IsScheduled"];
            this.createdDate = _data["CreatedDate"] ? new Date(_data["CreatedDate"].toString()) : undefined as any;
            this.isUrgent = _data["IsUrgent"];
        }
    }

    static fromJS(data: any): QuoteRequestListView {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteRequestListView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["FullName"] = this.fullName;
        data["PhoneNumber"] = this.phoneNumber;
        data["State"] = this.state;
        data["Address"] = this.address;
        data["Zip"] = this.zip;
        data["Active"] = this.active;
        data["CompletionStatus"] = this.completionStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["Type"] = this.type;
        data["IsScheduled"] = this.isScheduled;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["IsUrgent"] = this.isUrgent;
        return data;
    }
}

export interface IQuoteRequestListView {
    id?: number | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    state?: string | undefined;
    address?: string | undefined;
    zip?: string | undefined;
    active?: boolean | undefined;
    completionStatus?: string | undefined;
    paymentStatus?: string | undefined;
    type?: string | undefined;
    isScheduled?: boolean | undefined;
    createdDate?: Date | undefined;
    isUrgent?: boolean | undefined;
}

export class RegionalManagerDateRangeRequest implements IRegionalManagerDateRangeRequest {
    employeeIds?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IRegionalManagerDateRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["EmployeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["EmployeeIds"])
                    this.employeeIds!.push(item);
            }
            this.startDate = _data["StartDate"] ? new Date(_data["StartDate"].toString()) : undefined as any;
            this.endDate = _data["EndDate"] ? new Date(_data["EndDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RegionalManagerDateRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalManagerDateRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeIds)) {
            data["EmployeeIds"] = [];
            for (let item of this.employeeIds)
                data["EmployeeIds"].push(item);
        }
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IRegionalManagerDateRangeRequest {
    employeeIds?: number[] | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class QuoteRequestScheduleUpdate implements IQuoteRequestScheduleUpdate {
    quoteRequestId?: number | undefined;
    eventStart?: Date | undefined;
    eventEnd?: Date | undefined;
    regionalManagerId?: number | undefined;

    constructor(data?: IQuoteRequestScheduleUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteRequestId = _data["QuoteRequestId"];
            this.eventStart = _data["EventStart"] ? new Date(_data["EventStart"].toString()) : undefined as any;
            this.eventEnd = _data["EventEnd"] ? new Date(_data["EventEnd"].toString()) : undefined as any;
            this.regionalManagerId = _data["RegionalManagerId"];
        }
    }

    static fromJS(data: any): QuoteRequestScheduleUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteRequestScheduleUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuoteRequestId"] = this.quoteRequestId;
        data["EventStart"] = this.eventStart ? this.eventStart.toISOString() : undefined as any;
        data["EventEnd"] = this.eventEnd ? this.eventEnd.toISOString() : undefined as any;
        data["RegionalManagerId"] = this.regionalManagerId;
        return data;
    }
}

export interface IQuoteRequestScheduleUpdate {
    quoteRequestId?: number | undefined;
    eventStart?: Date | undefined;
    eventEnd?: Date | undefined;
    regionalManagerId?: number | undefined;
}

export class IWorkOrder implements IIWorkOrder {
    id?: number | undefined;
    customerId?: number | undefined;
    addressId?: number | undefined;
    createdDate?: Date | undefined;
    paidDate?: Date | undefined;
    completionStatus?: IWorkOrderCompletionStatus | undefined;
    paymentStatus?: IWorkOrderPaymentStatus | undefined;
    note?: string | undefined;
    crewNote?: string | undefined;
    representativeId?: number | undefined;
    paymentDueId?: number | undefined;
    addressSameAsCustomer?: boolean | undefined;
    hidePrice?: boolean | undefined;
    autoChargeEnabled?: boolean | undefined;
    customer?: Customer | undefined;
    address?: Address | undefined;
    representative?: Employee | undefined;
    paymentDueOption?: PaymentDueOption | undefined;
    workOrderPriceAdjustments?: WorkOrderPriceAdjustment[] | undefined;
    salesTaxPercentage?: number | undefined;
    quoteId?: number | undefined;
    hasRentalExpense?: boolean | undefined;
    rentalCost?: number | undefined;
    rentalDescription?: string | undefined;
    mostUrgentPriorityLevel?: PriorityLevel | undefined;
    hoursSummary?: number | undefined;
    priceSummary?: number | undefined;
    quoteNumber?: string | undefined;

    constructor(data?: IIWorkOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerId = _data["CustomerId"];
            this.addressId = _data["AddressId"];
            this.createdDate = _data["CreatedDate"] ? new Date(_data["CreatedDate"].toString()) : undefined as any;
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : undefined as any;
            this.completionStatus = _data["CompletionStatus"];
            this.paymentStatus = _data["PaymentStatus"];
            this.note = _data["Note"];
            this.crewNote = _data["CrewNote"];
            this.representativeId = _data["RepresentativeId"];
            this.paymentDueId = _data["PaymentDueId"];
            this.addressSameAsCustomer = _data["AddressSameAsCustomer"];
            this.hidePrice = _data["HidePrice"];
            this.autoChargeEnabled = _data["AutoChargeEnabled"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            this.address = _data["Address"] ? Address.fromJS(_data["Address"]) : undefined as any;
            this.representative = _data["Representative"] ? Employee.fromJS(_data["Representative"]) : undefined as any;
            this.paymentDueOption = _data["PaymentDueOption"] ? PaymentDueOption.fromJS(_data["PaymentDueOption"]) : undefined as any;
            if (Array.isArray(_data["WorkOrderPriceAdjustments"])) {
                this.workOrderPriceAdjustments = [] as any;
                for (let item of _data["WorkOrderPriceAdjustments"])
                    this.workOrderPriceAdjustments!.push(WorkOrderPriceAdjustment.fromJS(item));
            }
            this.salesTaxPercentage = _data["SalesTaxPercentage"];
            this.quoteId = _data["QuoteId"];
            this.hasRentalExpense = _data["HasRentalExpense"];
            this.rentalCost = _data["RentalCost"];
            this.rentalDescription = _data["RentalDescription"];
            this.mostUrgentPriorityLevel = _data["MostUrgentPriorityLevel"] ? PriorityLevel.fromJS(_data["MostUrgentPriorityLevel"]) : undefined as any;
            this.hoursSummary = _data["HoursSummary"];
            this.priceSummary = _data["PriceSummary"];
            this.quoteNumber = _data["QuoteNumber"];
        }
    }

    static fromJS(data: any): IWorkOrder {
        data = typeof data === 'object' ? data : {};
        let result = new IWorkOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerId"] = this.customerId;
        data["AddressId"] = this.addressId;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["CompletionStatus"] = this.completionStatus;
        data["PaymentStatus"] = this.paymentStatus;
        data["Note"] = this.note;
        data["CrewNote"] = this.crewNote;
        data["RepresentativeId"] = this.representativeId;
        data["PaymentDueId"] = this.paymentDueId;
        data["AddressSameAsCustomer"] = this.addressSameAsCustomer;
        data["HidePrice"] = this.hidePrice;
        data["AutoChargeEnabled"] = this.autoChargeEnabled;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        data["Address"] = this.address ? this.address.toJSON() : undefined as any;
        data["Representative"] = this.representative ? this.representative.toJSON() : undefined as any;
        data["PaymentDueOption"] = this.paymentDueOption ? this.paymentDueOption.toJSON() : undefined as any;
        if (Array.isArray(this.workOrderPriceAdjustments)) {
            data["WorkOrderPriceAdjustments"] = [];
            for (let item of this.workOrderPriceAdjustments)
                data["WorkOrderPriceAdjustments"].push(item ? item.toJSON() : undefined as any);
        }
        data["SalesTaxPercentage"] = this.salesTaxPercentage;
        data["QuoteId"] = this.quoteId;
        data["HasRentalExpense"] = this.hasRentalExpense;
        data["RentalCost"] = this.rentalCost;
        data["RentalDescription"] = this.rentalDescription;
        data["MostUrgentPriorityLevel"] = this.mostUrgentPriorityLevel ? this.mostUrgentPriorityLevel.toJSON() : undefined as any;
        data["HoursSummary"] = this.hoursSummary;
        data["PriceSummary"] = this.priceSummary;
        data["QuoteNumber"] = this.quoteNumber;
        return data;
    }
}

export interface IIWorkOrder {
    id?: number | undefined;
    customerId?: number | undefined;
    addressId?: number | undefined;
    createdDate?: Date | undefined;
    paidDate?: Date | undefined;
    completionStatus?: IWorkOrderCompletionStatus | undefined;
    paymentStatus?: IWorkOrderPaymentStatus | undefined;
    note?: string | undefined;
    crewNote?: string | undefined;
    representativeId?: number | undefined;
    paymentDueId?: number | undefined;
    addressSameAsCustomer?: boolean | undefined;
    hidePrice?: boolean | undefined;
    autoChargeEnabled?: boolean | undefined;
    customer?: Customer | undefined;
    address?: Address | undefined;
    representative?: Employee | undefined;
    paymentDueOption?: PaymentDueOption | undefined;
    workOrderPriceAdjustments?: WorkOrderPriceAdjustment[] | undefined;
    salesTaxPercentage?: number | undefined;
    quoteId?: number | undefined;
    hasRentalExpense?: boolean | undefined;
    rentalCost?: number | undefined;
    rentalDescription?: string | undefined;
    mostUrgentPriorityLevel?: PriorityLevel | undefined;
    hoursSummary?: number | undefined;
    priceSummary?: number | undefined;
    quoteNumber?: string | undefined;
}

export class AdvancedAccountsReceivableFilter implements IAdvancedAccountsReceivableFilter {
    asOfDate?: Date | undefined;
    orderBy?: string | undefined;

    constructor(data?: IAdvancedAccountsReceivableFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asOfDate = _data["AsOfDate"] ? new Date(_data["AsOfDate"].toString()) : undefined as any;
            this.orderBy = _data["OrderBy"];
        }
    }

    static fromJS(data: any): AdvancedAccountsReceivableFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedAccountsReceivableFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["AsOfDate"] = this.asOfDate ? this.asOfDate.toISOString() : undefined as any;
        data["OrderBy"] = this.orderBy;
        return data;
    }
}

export interface IAdvancedAccountsReceivableFilter {
    asOfDate?: Date | undefined;
    orderBy?: string | undefined;
}

export class ReportTileViewModel implements IReportTileViewModel {
    id?: number | undefined;
    name?: string | undefined;
    companyWide?: boolean | undefined;

    constructor(data?: IReportTileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.companyWide = _data["CompanyWide"];
        }
    }

    static fromJS(data: any): ReportTileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["CompanyWide"] = this.companyWide;
        return data;
    }
}

export interface IReportTileViewModel {
    id?: number | undefined;
    name?: string | undefined;
    companyWide?: boolean | undefined;
}

export class ReportTileRoleDefaultViewModel implements IReportTileRoleDefaultViewModel {
    id?: number | undefined;
    roleId?: number | undefined;
    reportTileId?: number | undefined;

    constructor(data?: IReportTileRoleDefaultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.roleId = _data["RoleId"];
            this.reportTileId = _data["ReportTileId"];
        }
    }

    static fromJS(data: any): ReportTileRoleDefaultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTileRoleDefaultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RoleId"] = this.roleId;
        data["ReportTileId"] = this.reportTileId;
        return data;
    }
}

export interface IReportTileRoleDefaultViewModel {
    id?: number | undefined;
    roleId?: number | undefined;
    reportTileId?: number | undefined;
}

export class SalesTotalsViewModel implements ISalesTotalsViewModel {
    wellnessCurrentRange?: number | undefined;
    workCurrentRange?: number | undefined;
    wellnessPreviousRange?: number | undefined;
    workPreviousRange?: number | undefined;
    readonly workPercentageChange?: number | undefined;
    readonly wellnessPercentageChange?: number | undefined;

    constructor(data?: ISalesTotalsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wellnessCurrentRange = _data["WellnessCurrentRange"];
            this.workCurrentRange = _data["WorkCurrentRange"];
            this.wellnessPreviousRange = _data["WellnessPreviousRange"];
            this.workPreviousRange = _data["WorkPreviousRange"];
            (this as any).workPercentageChange = _data["WorkPercentageChange"];
            (this as any).wellnessPercentageChange = _data["WellnessPercentageChange"];
        }
    }

    static fromJS(data: any): SalesTotalsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesTotalsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WellnessCurrentRange"] = this.wellnessCurrentRange;
        data["WorkCurrentRange"] = this.workCurrentRange;
        data["WellnessPreviousRange"] = this.wellnessPreviousRange;
        data["WorkPreviousRange"] = this.workPreviousRange;
        data["WorkPercentageChange"] = this.workPercentageChange;
        data["WellnessPercentageChange"] = this.wellnessPercentageChange;
        return data;
    }
}

export interface ISalesTotalsViewModel {
    wellnessCurrentRange?: number | undefined;
    workCurrentRange?: number | undefined;
    wellnessPreviousRange?: number | undefined;
    workPreviousRange?: number | undefined;
    workPercentageChange?: number | undefined;
    wellnessPercentageChange?: number | undefined;
}

export class CustomerIssuesViewModel implements ICustomerIssuesViewModel {
    quoteNumber?: string | undefined;
    link?: string | undefined;
    reportedOn?: Date | undefined;

    constructor(data?: ICustomerIssuesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteNumber = _data["QuoteNumber"];
            this.link = _data["Link"];
            this.reportedOn = _data["ReportedOn"] ? new Date(_data["ReportedOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CustomerIssuesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerIssuesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["QuoteNumber"] = this.quoteNumber;
        data["Link"] = this.link;
        data["ReportedOn"] = this.reportedOn ? this.reportedOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ICustomerIssuesViewModel {
    quoteNumber?: string | undefined;
    link?: string | undefined;
    reportedOn?: Date | undefined;
}

export class QuoteStatsViewModel implements IQuoteStatsViewModel {
    sent?: number | undefined;
    opened?: number | undefined;
    signed?: number | undefined;

    constructor(data?: IQuoteStatsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sent = _data["Sent"];
            this.opened = _data["Opened"];
            this.signed = _data["Signed"];
        }
    }

    static fromJS(data: any): QuoteStatsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteStatsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Sent"] = this.sent;
        data["Opened"] = this.opened;
        data["Signed"] = this.signed;
        return data;
    }
}

export interface IQuoteStatsViewModel {
    sent?: number | undefined;
    opened?: number | undefined;
    signed?: number | undefined;
}

export class PastDueGrouping implements IPastDueGrouping {
    underThirty?: PastDueViewModel[] | undefined;
    readonly underThirtyTotal?: number | undefined;
    thirtyToSixty?: PastDueViewModel[] | undefined;
    readonly thirtyToSixtyTotal?: number | undefined;
    overSixty?: PastDueViewModel[] | undefined;
    readonly overSixtyTotal?: number | undefined;

    constructor(data?: IPastDueGrouping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["UnderThirty"])) {
                this.underThirty = [] as any;
                for (let item of _data["UnderThirty"])
                    this.underThirty!.push(PastDueViewModel.fromJS(item));
            }
            (this as any).underThirtyTotal = _data["UnderThirtyTotal"];
            if (Array.isArray(_data["ThirtyToSixty"])) {
                this.thirtyToSixty = [] as any;
                for (let item of _data["ThirtyToSixty"])
                    this.thirtyToSixty!.push(PastDueViewModel.fromJS(item));
            }
            (this as any).thirtyToSixtyTotal = _data["ThirtyToSixtyTotal"];
            if (Array.isArray(_data["OverSixty"])) {
                this.overSixty = [] as any;
                for (let item of _data["OverSixty"])
                    this.overSixty!.push(PastDueViewModel.fromJS(item));
            }
            (this as any).overSixtyTotal = _data["OverSixtyTotal"];
        }
    }

    static fromJS(data: any): PastDueGrouping {
        data = typeof data === 'object' ? data : {};
        let result = new PastDueGrouping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.underThirty)) {
            data["UnderThirty"] = [];
            for (let item of this.underThirty)
                data["UnderThirty"].push(item ? item.toJSON() : undefined as any);
        }
        data["UnderThirtyTotal"] = this.underThirtyTotal;
        if (Array.isArray(this.thirtyToSixty)) {
            data["ThirtyToSixty"] = [];
            for (let item of this.thirtyToSixty)
                data["ThirtyToSixty"].push(item ? item.toJSON() : undefined as any);
        }
        data["ThirtyToSixtyTotal"] = this.thirtyToSixtyTotal;
        if (Array.isArray(this.overSixty)) {
            data["OverSixty"] = [];
            for (let item of this.overSixty)
                data["OverSixty"].push(item ? item.toJSON() : undefined as any);
        }
        data["OverSixtyTotal"] = this.overSixtyTotal;
        return data;
    }
}

export interface IPastDueGrouping {
    underThirty?: PastDueViewModel[] | undefined;
    underThirtyTotal?: number | undefined;
    thirtyToSixty?: PastDueViewModel[] | undefined;
    thirtyToSixtyTotal?: number | undefined;
    overSixty?: PastDueViewModel[] | undefined;
    overSixtyTotal?: number | undefined;
}

export class PastDueViewModel implements IPastDueViewModel {
    range?: string | undefined;
    total?: number | undefined;
    number?: string | undefined;
    fullName?: string | undefined;
    serviceType?: string | undefined;
    dateCompleted?: Date | undefined;
    paymentStatus?: string | undefined;
    representative?: string | undefined;
    customerId?: number | undefined;
    workOrderId?: number | undefined;
    stripeCustomerId?: string | undefined;
    quoteId?: number | undefined;
    paidDate?: Date | undefined;
    amountDue?: number | undefined;
    tax?: number | undefined;
    taskId?: number | undefined;
    getsFirmTime?: boolean | undefined;

    constructor(data?: IPastDueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.range = _data["Range"];
            this.total = _data["Total"];
            this.number = _data["Number"];
            this.fullName = _data["FullName"];
            this.serviceType = _data["ServiceType"];
            this.dateCompleted = _data["DateCompleted"] ? new Date(_data["DateCompleted"].toString()) : undefined as any;
            this.paymentStatus = _data["PaymentStatus"];
            this.representative = _data["Representative"];
            this.customerId = _data["CustomerId"];
            this.workOrderId = _data["WorkOrderId"];
            this.stripeCustomerId = _data["StripeCustomerId"];
            this.quoteId = _data["QuoteId"];
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : undefined as any;
            this.amountDue = _data["AmountDue"];
            this.tax = _data["Tax"];
            this.taskId = _data["TaskId"];
            this.getsFirmTime = _data["GetsFirmTime"];
        }
    }

    static fromJS(data: any): PastDueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PastDueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Range"] = this.range;
        data["Total"] = this.total;
        data["Number"] = this.number;
        data["FullName"] = this.fullName;
        data["ServiceType"] = this.serviceType;
        data["DateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : undefined as any;
        data["PaymentStatus"] = this.paymentStatus;
        data["Representative"] = this.representative;
        data["CustomerId"] = this.customerId;
        data["WorkOrderId"] = this.workOrderId;
        data["StripeCustomerId"] = this.stripeCustomerId;
        data["QuoteId"] = this.quoteId;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["AmountDue"] = this.amountDue;
        data["Tax"] = this.tax;
        data["TaskId"] = this.taskId;
        data["GetsFirmTime"] = this.getsFirmTime;
        return data;
    }
}

export interface IPastDueViewModel {
    range?: string | undefined;
    total?: number | undefined;
    number?: string | undefined;
    fullName?: string | undefined;
    serviceType?: string | undefined;
    dateCompleted?: Date | undefined;
    paymentStatus?: string | undefined;
    representative?: string | undefined;
    customerId?: number | undefined;
    workOrderId?: number | undefined;
    stripeCustomerId?: string | undefined;
    quoteId?: number | undefined;
    paidDate?: Date | undefined;
    amountDue?: number | undefined;
    tax?: number | undefined;
    taskId?: number | undefined;
    getsFirmTime?: boolean | undefined;
}

export class WorkOrderCommissionViewModel implements IWorkOrderCommissionViewModel {
    number?: string | undefined;
    dateCompleted?: string | undefined;
    serviceType?: string | undefined;
    representative?: string | undefined;
    total?: number | undefined;
    stumpGrindingTotal?: number | undefined;
    rentalCost?: number | undefined;
    netTotal?: number | undefined;
    hoursTotal?: number | undefined;
    workHourAverage?: number | undefined;
    commissionEarned?: boolean | undefined;
    latestNote?: string | undefined;
    workOrderId?: number | undefined;
    customerId?: number | undefined;
    dateSigned?: string | undefined;
    commissionMinimum?: number | undefined;
    commissionBonusPercentage?: number | undefined;
    paidStatus?: string | undefined;
    editing?: boolean | undefined;

    constructor(data?: IWorkOrderCommissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["Number"];
            this.dateCompleted = _data["DateCompleted"];
            this.serviceType = _data["ServiceType"];
            this.representative = _data["Representative"];
            this.total = _data["Total"];
            this.stumpGrindingTotal = _data["StumpGrindingTotal"];
            this.rentalCost = _data["RentalCost"];
            this.netTotal = _data["NetTotal"];
            this.hoursTotal = _data["HoursTotal"];
            this.workHourAverage = _data["WorkHourAverage"];
            this.commissionEarned = _data["CommissionEarned"];
            this.latestNote = _data["LatestNote"];
            this.workOrderId = _data["WorkOrderId"];
            this.customerId = _data["CustomerId"];
            this.dateSigned = _data["DateSigned"];
            this.commissionMinimum = _data["CommissionMinimum"];
            this.commissionBonusPercentage = _data["CommissionBonusPercentage"];
            this.paidStatus = _data["PaidStatus"];
            this.editing = _data["Editing"];
        }
    }

    static fromJS(data: any): WorkOrderCommissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderCommissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["DateCompleted"] = this.dateCompleted;
        data["ServiceType"] = this.serviceType;
        data["Representative"] = this.representative;
        data["Total"] = this.total;
        data["StumpGrindingTotal"] = this.stumpGrindingTotal;
        data["RentalCost"] = this.rentalCost;
        data["NetTotal"] = this.netTotal;
        data["HoursTotal"] = this.hoursTotal;
        data["WorkHourAverage"] = this.workHourAverage;
        data["CommissionEarned"] = this.commissionEarned;
        data["LatestNote"] = this.latestNote;
        data["WorkOrderId"] = this.workOrderId;
        data["CustomerId"] = this.customerId;
        data["DateSigned"] = this.dateSigned;
        data["CommissionMinimum"] = this.commissionMinimum;
        data["CommissionBonusPercentage"] = this.commissionBonusPercentage;
        data["PaidStatus"] = this.paidStatus;
        data["Editing"] = this.editing;
        return data;
    }
}

export interface IWorkOrderCommissionViewModel {
    number?: string | undefined;
    dateCompleted?: string | undefined;
    serviceType?: string | undefined;
    representative?: string | undefined;
    total?: number | undefined;
    stumpGrindingTotal?: number | undefined;
    rentalCost?: number | undefined;
    netTotal?: number | undefined;
    hoursTotal?: number | undefined;
    workHourAverage?: number | undefined;
    commissionEarned?: boolean | undefined;
    latestNote?: string | undefined;
    workOrderId?: number | undefined;
    customerId?: number | undefined;
    dateSigned?: string | undefined;
    commissionMinimum?: number | undefined;
    commissionBonusPercentage?: number | undefined;
    paidStatus?: string | undefined;
    editing?: boolean | undefined;
}

export class WorkAverageRequest implements IWorkAverageRequest {
    representativeId?: number | undefined;
    afterDate?: Date | undefined;
    beforeDate?: Date | undefined;
    type?: string | undefined;

    constructor(data?: IWorkAverageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.representativeId = _data["RepresentativeId"];
            this.afterDate = _data["AfterDate"] ? new Date(_data["AfterDate"].toString()) : undefined as any;
            this.beforeDate = _data["BeforeDate"] ? new Date(_data["BeforeDate"].toString()) : undefined as any;
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): WorkAverageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new WorkAverageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RepresentativeId"] = this.representativeId;
        data["AfterDate"] = this.afterDate ? this.afterDate.toISOString() : undefined as any;
        data["BeforeDate"] = this.beforeDate ? this.beforeDate.toISOString() : undefined as any;
        data["Type"] = this.type;
        return data;
    }
}

export interface IWorkAverageRequest {
    representativeId?: number | undefined;
    afterDate?: Date | undefined;
    beforeDate?: Date | undefined;
    type?: string | undefined;
}

export class WorkHourAverageViewModel implements IWorkHourAverageViewModel {
    workHourAverage?: number | undefined;

    constructor(data?: IWorkHourAverageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workHourAverage = _data["WorkHourAverage"];
        }
    }

    static fromJS(data: any): WorkHourAverageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkHourAverageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["WorkHourAverage"] = this.workHourAverage;
        return data;
    }
}

export interface IWorkHourAverageViewModel {
    workHourAverage?: number | undefined;
}

export class PagedResultOfAccountsReceivableViewModel implements IPagedResultOfAccountsReceivableViewModel {
    results?: AccountsReceivableViewModel[] | undefined;
    totalResults?: number | undefined;

    constructor(data?: IPagedResultOfAccountsReceivableViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(AccountsReceivableViewModel.fromJS(item));
            }
            this.totalResults = _data["TotalResults"];
        }
    }

    static fromJS(data: any): PagedResultOfAccountsReceivableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfAccountsReceivableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalResults"] = this.totalResults;
        return data;
    }
}

export interface IPagedResultOfAccountsReceivableViewModel {
    results?: AccountsReceivableViewModel[] | undefined;
    totalResults?: number | undefined;
}

export class AccountsReceivableViewModel implements IAccountsReceivableViewModel {
    number?: string | undefined;
    fullName?: string | undefined;
    serviceType?: string | undefined;
    dateCompleted?: Date | undefined;
    paymentStatus?: string | undefined;
    representative?: string | undefined;
    customerId?: number | undefined;
    workOrderId?: number | undefined;
    stripeCustomerId?: string | undefined;
    quoteId?: number | undefined;
    paidDate?: Date | undefined;
    amountDue?: number | undefined;
    tax?: number | undefined;
    taskId?: number | undefined;
    getsFirmTime?: boolean | undefined;

    constructor(data?: IAccountsReceivableViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["Number"];
            this.fullName = _data["FullName"];
            this.serviceType = _data["ServiceType"];
            this.dateCompleted = _data["DateCompleted"] ? new Date(_data["DateCompleted"].toString()) : undefined as any;
            this.paymentStatus = _data["PaymentStatus"];
            this.representative = _data["Representative"];
            this.customerId = _data["CustomerId"];
            this.workOrderId = _data["WorkOrderId"];
            this.stripeCustomerId = _data["StripeCustomerId"];
            this.quoteId = _data["QuoteId"];
            this.paidDate = _data["PaidDate"] ? new Date(_data["PaidDate"].toString()) : undefined as any;
            this.amountDue = _data["AmountDue"];
            this.tax = _data["Tax"];
            this.taskId = _data["TaskId"];
            this.getsFirmTime = _data["GetsFirmTime"];
        }
    }

    static fromJS(data: any): AccountsReceivableViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsReceivableViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["FullName"] = this.fullName;
        data["ServiceType"] = this.serviceType;
        data["DateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : undefined as any;
        data["PaymentStatus"] = this.paymentStatus;
        data["Representative"] = this.representative;
        data["CustomerId"] = this.customerId;
        data["WorkOrderId"] = this.workOrderId;
        data["StripeCustomerId"] = this.stripeCustomerId;
        data["QuoteId"] = this.quoteId;
        data["PaidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["AmountDue"] = this.amountDue;
        data["Tax"] = this.tax;
        data["TaskId"] = this.taskId;
        data["GetsFirmTime"] = this.getsFirmTime;
        return data;
    }
}

export interface IAccountsReceivableViewModel {
    number?: string | undefined;
    fullName?: string | undefined;
    serviceType?: string | undefined;
    dateCompleted?: Date | undefined;
    paymentStatus?: string | undefined;
    representative?: string | undefined;
    customerId?: number | undefined;
    workOrderId?: number | undefined;
    stripeCustomerId?: string | undefined;
    quoteId?: number | undefined;
    paidDate?: Date | undefined;
    amountDue?: number | undefined;
    tax?: number | undefined;
    taskId?: number | undefined;
    getsFirmTime?: boolean | undefined;
}

export class AdvancedCommissionFilter implements IAdvancedCommissionFilter {
    shouldFilterByWONumber?: boolean | undefined;
    shouldFilterBySignedDate?: boolean | undefined;
    shouldFilterByCompletionDate?: boolean | undefined;
    shouldFilterByType?: boolean | undefined;
    shouldFilterByRM?: boolean | undefined;
    shouldFilterByTotal?: boolean | undefined;
    shouldFilterByStumpTotal?: boolean | undefined;
    shouldFilterByRentalTotal?: boolean | undefined;
    shouldFilterByNetTotal?: boolean | undefined;
    shouldFilterByWorkHours?: boolean | undefined;
    shouldFilterByCommissionEarned?: boolean | undefined;
    shouldFilterByNotes?: boolean | undefined;
    shouldFilterByPaidStatus?: boolean | undefined;
    wONumberSearch?: string | undefined;
    dateSearch?: string[] | undefined;
    signedDateSearch?: string[] | undefined;
    services?: string[] | undefined;
    rMs?: string[] | undefined;
    totalSearch?: string | undefined;
    stumpSearch?: string | undefined;
    rentalSearch?: string | undefined;
    workHoursSearch?: string | undefined;
    commissionEarnedSearch?: string | undefined;
    noteSearch?: string | undefined;
    paidStatuses?: string[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
    globalFilter?: string | undefined;
    orderBy?: string | undefined;

    constructor(data?: IAdvancedCommissionFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldFilterByWONumber = _data["ShouldFilterByWONumber"];
            this.shouldFilterBySignedDate = _data["ShouldFilterBySignedDate"];
            this.shouldFilterByCompletionDate = _data["ShouldFilterByCompletionDate"];
            this.shouldFilterByType = _data["ShouldFilterByType"];
            this.shouldFilterByRM = _data["ShouldFilterByRM"];
            this.shouldFilterByTotal = _data["ShouldFilterByTotal"];
            this.shouldFilterByStumpTotal = _data["ShouldFilterByStumpTotal"];
            this.shouldFilterByRentalTotal = _data["ShouldFilterByRentalTotal"];
            this.shouldFilterByNetTotal = _data["ShouldFilterByNetTotal"];
            this.shouldFilterByWorkHours = _data["ShouldFilterByWorkHours"];
            this.shouldFilterByCommissionEarned = _data["ShouldFilterByCommissionEarned"];
            this.shouldFilterByNotes = _data["ShouldFilterByNotes"];
            this.shouldFilterByPaidStatus = _data["ShouldFilterByPaidStatus"];
            this.wONumberSearch = _data["WONumberSearch"];
            if (Array.isArray(_data["DateSearch"])) {
                this.dateSearch = [] as any;
                for (let item of _data["DateSearch"])
                    this.dateSearch!.push(item);
            }
            if (Array.isArray(_data["SignedDateSearch"])) {
                this.signedDateSearch = [] as any;
                for (let item of _data["SignedDateSearch"])
                    this.signedDateSearch!.push(item);
            }
            if (Array.isArray(_data["Services"])) {
                this.services = [] as any;
                for (let item of _data["Services"])
                    this.services!.push(item);
            }
            if (Array.isArray(_data["RMs"])) {
                this.rMs = [] as any;
                for (let item of _data["RMs"])
                    this.rMs!.push(item);
            }
            this.totalSearch = _data["TotalSearch"];
            this.stumpSearch = _data["StumpSearch"];
            this.rentalSearch = _data["RentalSearch"];
            this.workHoursSearch = _data["WorkHoursSearch"];
            this.commissionEarnedSearch = _data["CommissionEarnedSearch"];
            this.noteSearch = _data["NoteSearch"];
            if (Array.isArray(_data["PaidStatuses"])) {
                this.paidStatuses = [] as any;
                for (let item of _data["PaidStatuses"])
                    this.paidStatuses!.push(item);
            }
            this.skip = _data["Skip"];
            this.take = _data["Take"];
            this.globalFilter = _data["GlobalFilter"];
            this.orderBy = _data["OrderBy"];
        }
    }

    static fromJS(data: any): AdvancedCommissionFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedCommissionFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShouldFilterByWONumber"] = this.shouldFilterByWONumber;
        data["ShouldFilterBySignedDate"] = this.shouldFilterBySignedDate;
        data["ShouldFilterByCompletionDate"] = this.shouldFilterByCompletionDate;
        data["ShouldFilterByType"] = this.shouldFilterByType;
        data["ShouldFilterByRM"] = this.shouldFilterByRM;
        data["ShouldFilterByTotal"] = this.shouldFilterByTotal;
        data["ShouldFilterByStumpTotal"] = this.shouldFilterByStumpTotal;
        data["ShouldFilterByRentalTotal"] = this.shouldFilterByRentalTotal;
        data["ShouldFilterByNetTotal"] = this.shouldFilterByNetTotal;
        data["ShouldFilterByWorkHours"] = this.shouldFilterByWorkHours;
        data["ShouldFilterByCommissionEarned"] = this.shouldFilterByCommissionEarned;
        data["ShouldFilterByNotes"] = this.shouldFilterByNotes;
        data["ShouldFilterByPaidStatus"] = this.shouldFilterByPaidStatus;
        data["WONumberSearch"] = this.wONumberSearch;
        if (Array.isArray(this.dateSearch)) {
            data["DateSearch"] = [];
            for (let item of this.dateSearch)
                data["DateSearch"].push(item);
        }
        if (Array.isArray(this.signedDateSearch)) {
            data["SignedDateSearch"] = [];
            for (let item of this.signedDateSearch)
                data["SignedDateSearch"].push(item);
        }
        if (Array.isArray(this.services)) {
            data["Services"] = [];
            for (let item of this.services)
                data["Services"].push(item);
        }
        if (Array.isArray(this.rMs)) {
            data["RMs"] = [];
            for (let item of this.rMs)
                data["RMs"].push(item);
        }
        data["TotalSearch"] = this.totalSearch;
        data["StumpSearch"] = this.stumpSearch;
        data["RentalSearch"] = this.rentalSearch;
        data["WorkHoursSearch"] = this.workHoursSearch;
        data["CommissionEarnedSearch"] = this.commissionEarnedSearch;
        data["NoteSearch"] = this.noteSearch;
        if (Array.isArray(this.paidStatuses)) {
            data["PaidStatuses"] = [];
            for (let item of this.paidStatuses)
                data["PaidStatuses"].push(item);
        }
        data["Skip"] = this.skip;
        data["Take"] = this.take;
        data["GlobalFilter"] = this.globalFilter;
        data["OrderBy"] = this.orderBy;
        return data;
    }
}

export interface IAdvancedCommissionFilter {
    shouldFilterByWONumber?: boolean | undefined;
    shouldFilterBySignedDate?: boolean | undefined;
    shouldFilterByCompletionDate?: boolean | undefined;
    shouldFilterByType?: boolean | undefined;
    shouldFilterByRM?: boolean | undefined;
    shouldFilterByTotal?: boolean | undefined;
    shouldFilterByStumpTotal?: boolean | undefined;
    shouldFilterByRentalTotal?: boolean | undefined;
    shouldFilterByNetTotal?: boolean | undefined;
    shouldFilterByWorkHours?: boolean | undefined;
    shouldFilterByCommissionEarned?: boolean | undefined;
    shouldFilterByNotes?: boolean | undefined;
    shouldFilterByPaidStatus?: boolean | undefined;
    wONumberSearch?: string | undefined;
    dateSearch?: string[] | undefined;
    signedDateSearch?: string[] | undefined;
    services?: string[] | undefined;
    rMs?: string[] | undefined;
    totalSearch?: string | undefined;
    stumpSearch?: string | undefined;
    rentalSearch?: string | undefined;
    workHoursSearch?: string | undefined;
    commissionEarnedSearch?: string | undefined;
    noteSearch?: string | undefined;
    paidStatuses?: string[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
    globalFilter?: string | undefined;
    orderBy?: string | undefined;
}

export class PagedResultsForCommissionOfWorkOrderCommissionViewModel implements IPagedResultsForCommissionOfWorkOrderCommissionViewModel {
    rMs?: string[] | undefined;
    results?: WorkOrderCommissionViewModel[] | undefined;
    totalResults?: number | undefined;

    constructor(data?: IPagedResultsForCommissionOfWorkOrderCommissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["RMs"])) {
                this.rMs = [] as any;
                for (let item of _data["RMs"])
                    this.rMs!.push(item);
            }
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(WorkOrderCommissionViewModel.fromJS(item));
            }
            this.totalResults = _data["TotalResults"];
        }
    }

    static fromJS(data: any): PagedResultsForCommissionOfWorkOrderCommissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsForCommissionOfWorkOrderCommissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rMs)) {
            data["RMs"] = [];
            for (let item of this.rMs)
                data["RMs"].push(item);
        }
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalResults"] = this.totalResults;
        return data;
    }
}

export interface IPagedResultsForCommissionOfWorkOrderCommissionViewModel {
    rMs?: string[] | undefined;
    results?: WorkOrderCommissionViewModel[] | undefined;
    totalResults?: number | undefined;
}

export class CurrentWorkBacklog implements ICurrentWorkBacklog {
    type?: string | undefined;
    total?: number | undefined;

    constructor(data?: ICurrentWorkBacklog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.total = _data["Total"];
        }
    }

    static fromJS(data: any): CurrentWorkBacklog {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentWorkBacklog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Total"] = this.total;
        return data;
    }
}

export interface ICurrentWorkBacklog {
    type?: string | undefined;
    total?: number | undefined;
}

export class ScheduleComment implements IScheduleComment {
    id?: number | undefined;
    dateEntered?: Date | undefined;
    dateScheduled?: Date | undefined;
    employeeId?: number | undefined;
    comment?: string | undefined;

    constructor(data?: IScheduleComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.dateEntered = _data["DateEntered"] ? new Date(_data["DateEntered"].toString()) : undefined as any;
            this.dateScheduled = _data["DateScheduled"] ? new Date(_data["DateScheduled"].toString()) : undefined as any;
            this.employeeId = _data["EmployeeId"];
            this.comment = _data["Comment"];
        }
    }

    static fromJS(data: any): ScheduleComment {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["DateEntered"] = this.dateEntered ? this.dateEntered.toISOString() : undefined as any;
        data["DateScheduled"] = this.dateScheduled ? this.dateScheduled.toISOString() : undefined as any;
        data["EmployeeId"] = this.employeeId;
        data["Comment"] = this.comment;
        return data;
    }
}

export interface IScheduleComment {
    id?: number | undefined;
    dateEntered?: Date | undefined;
    dateScheduled?: Date | undefined;
    employeeId?: number | undefined;
    comment?: string | undefined;
}

export class ScheduledBucketDTO implements IScheduledBucketDTO {
    id?: number | undefined;
    active?: boolean | undefined;
    date?: string | undefined;
    bucketIndex?: number | undefined;
    isWork?: boolean | undefined;
    scheduledBucketEmployees?: ScheduledBucketEmployee[] | undefined;
    scheduledBucketEquipment?: ScheduledBucketEquipment[] | undefined;
    scheduledBucketWellnessWorkOrders?: ScheduledBucketWellnessWorkOrder[] | undefined;
    scheduledBucketWorkWorkOrders?: ScheduledBucketWorkWorkOrder[] | undefined;
    isBucket?: boolean | undefined;

    constructor(data?: IScheduledBucketDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.date = _data["Date"];
            this.bucketIndex = _data["BucketIndex"];
            this.isWork = _data["IsWork"];
            if (Array.isArray(_data["ScheduledBucketEmployees"])) {
                this.scheduledBucketEmployees = [] as any;
                for (let item of _data["ScheduledBucketEmployees"])
                    this.scheduledBucketEmployees!.push(ScheduledBucketEmployee.fromJS(item));
            }
            if (Array.isArray(_data["ScheduledBucketEquipment"])) {
                this.scheduledBucketEquipment = [] as any;
                for (let item of _data["ScheduledBucketEquipment"])
                    this.scheduledBucketEquipment!.push(ScheduledBucketEquipment.fromJS(item));
            }
            if (Array.isArray(_data["ScheduledBucketWellnessWorkOrders"])) {
                this.scheduledBucketWellnessWorkOrders = [] as any;
                for (let item of _data["ScheduledBucketWellnessWorkOrders"])
                    this.scheduledBucketWellnessWorkOrders!.push(ScheduledBucketWellnessWorkOrder.fromJS(item));
            }
            if (Array.isArray(_data["ScheduledBucketWorkWorkOrders"])) {
                this.scheduledBucketWorkWorkOrders = [] as any;
                for (let item of _data["ScheduledBucketWorkWorkOrders"])
                    this.scheduledBucketWorkWorkOrders!.push(ScheduledBucketWorkWorkOrder.fromJS(item));
            }
            this.isBucket = _data["IsBucket"];
        }
    }

    static fromJS(data: any): ScheduledBucketDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledBucketDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Date"] = this.date;
        data["BucketIndex"] = this.bucketIndex;
        data["IsWork"] = this.isWork;
        if (Array.isArray(this.scheduledBucketEmployees)) {
            data["ScheduledBucketEmployees"] = [];
            for (let item of this.scheduledBucketEmployees)
                data["ScheduledBucketEmployees"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scheduledBucketEquipment)) {
            data["ScheduledBucketEquipment"] = [];
            for (let item of this.scheduledBucketEquipment)
                data["ScheduledBucketEquipment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scheduledBucketWellnessWorkOrders)) {
            data["ScheduledBucketWellnessWorkOrders"] = [];
            for (let item of this.scheduledBucketWellnessWorkOrders)
                data["ScheduledBucketWellnessWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scheduledBucketWorkWorkOrders)) {
            data["ScheduledBucketWorkWorkOrders"] = [];
            for (let item of this.scheduledBucketWorkWorkOrders)
                data["ScheduledBucketWorkWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        data["IsBucket"] = this.isBucket;
        return data;
    }
}

export interface IScheduledBucketDTO {
    id?: number | undefined;
    active?: boolean | undefined;
    date?: string | undefined;
    bucketIndex?: number | undefined;
    isWork?: boolean | undefined;
    scheduledBucketEmployees?: ScheduledBucketEmployee[] | undefined;
    scheduledBucketEquipment?: ScheduledBucketEquipment[] | undefined;
    scheduledBucketWellnessWorkOrders?: ScheduledBucketWellnessWorkOrder[] | undefined;
    scheduledBucketWorkWorkOrders?: ScheduledBucketWorkWorkOrder[] | undefined;
    isBucket?: boolean | undefined;
}

export class ScheduledBucketEmployee implements IScheduledBucketEmployee {
    id?: number | undefined;
    scheduledBucketId?: number | undefined;
    employeeId?: number | undefined;
    employee?: Employee | undefined;

    constructor(data?: IScheduledBucketEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.scheduledBucketId = _data["ScheduledBucketId"];
            this.employeeId = _data["EmployeeId"];
            this.employee = _data["Employee"] ? Employee.fromJS(_data["Employee"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduledBucketEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledBucketEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ScheduledBucketId"] = this.scheduledBucketId;
        data["EmployeeId"] = this.employeeId;
        data["Employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        return data;
    }
}

export interface IScheduledBucketEmployee {
    id?: number | undefined;
    scheduledBucketId?: number | undefined;
    employeeId?: number | undefined;
    employee?: Employee | undefined;
}

export class ScheduledBucketEquipment implements IScheduledBucketEquipment {
    id?: number | undefined;
    scheduledBucketId?: number | undefined;
    equipmentId?: number | undefined;
    equipment?: Equipment | undefined;

    constructor(data?: IScheduledBucketEquipment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.scheduledBucketId = _data["ScheduledBucketId"];
            this.equipmentId = _data["EquipmentId"];
            this.equipment = _data["Equipment"] ? Equipment.fromJS(_data["Equipment"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduledBucketEquipment {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledBucketEquipment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ScheduledBucketId"] = this.scheduledBucketId;
        data["EquipmentId"] = this.equipmentId;
        data["Equipment"] = this.equipment ? this.equipment.toJSON() : undefined as any;
        return data;
    }
}

export interface IScheduledBucketEquipment {
    id?: number | undefined;
    scheduledBucketId?: number | undefined;
    equipmentId?: number | undefined;
    equipment?: Equipment | undefined;
}

export class ScheduledBucketWellnessWorkOrder implements IScheduledBucketWellnessWorkOrder {
    id?: number | undefined;
    scheduledBucketId?: number | undefined;
    wellnessWorkOrderId?: number | undefined;
    order?: number | undefined;
    wellnessWorkOrder?: WellnessWorkOrder | undefined;

    constructor(data?: IScheduledBucketWellnessWorkOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.scheduledBucketId = _data["ScheduledBucketId"];
            this.wellnessWorkOrderId = _data["WellnessWorkOrderId"];
            this.order = _data["Order"];
            this.wellnessWorkOrder = _data["WellnessWorkOrder"] ? WellnessWorkOrder.fromJS(_data["WellnessWorkOrder"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduledBucketWellnessWorkOrder {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledBucketWellnessWorkOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ScheduledBucketId"] = this.scheduledBucketId;
        data["WellnessWorkOrderId"] = this.wellnessWorkOrderId;
        data["Order"] = this.order;
        data["WellnessWorkOrder"] = this.wellnessWorkOrder ? this.wellnessWorkOrder.toJSON() : undefined as any;
        return data;
    }
}

export interface IScheduledBucketWellnessWorkOrder {
    id?: number | undefined;
    scheduledBucketId?: number | undefined;
    wellnessWorkOrderId?: number | undefined;
    order?: number | undefined;
    wellnessWorkOrder?: WellnessWorkOrder | undefined;
}

export class ScheduledBucketWorkWorkOrder implements IScheduledBucketWorkWorkOrder {
    id?: number | undefined;
    scheduledBucketId?: number | undefined;
    workWorkOrderId?: number | undefined;
    order?: number | undefined;
    workWorkOrder?: WorkWorkOrder | undefined;

    constructor(data?: IScheduledBucketWorkWorkOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.scheduledBucketId = _data["ScheduledBucketId"];
            this.workWorkOrderId = _data["WorkWorkOrderId"];
            this.order = _data["Order"];
            this.workWorkOrder = _data["WorkWorkOrder"] ? WorkWorkOrder.fromJS(_data["WorkWorkOrder"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduledBucketWorkWorkOrder {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledBucketWorkWorkOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ScheduledBucketId"] = this.scheduledBucketId;
        data["WorkWorkOrderId"] = this.workWorkOrderId;
        data["Order"] = this.order;
        data["WorkWorkOrder"] = this.workWorkOrder ? this.workWorkOrder.toJSON() : undefined as any;
        return data;
    }
}

export interface IScheduledBucketWorkWorkOrder {
    id?: number | undefined;
    scheduledBucketId?: number | undefined;
    workWorkOrderId?: number | undefined;
    order?: number | undefined;
    workWorkOrder?: WorkWorkOrder | undefined;
}

export class ScheduledBucketAddDTO implements IScheduledBucketAddDTO {
    id?: number | undefined;
    active?: boolean | undefined;
    date?: string | undefined;
    bucketIndex?: number | undefined;
    isWork?: boolean | undefined;
    scheduledBucketEmployees?: ScheduledBucketEmployee[] | undefined;
    scheduledBucketEquipment?: ScheduledBucketEquipment[] | undefined;
    scheduledBucketWellnessWorkOrders?: ScheduledBucketWellnessWorkOrder[] | undefined;
    scheduledBucketWorkWorkOrders?: ScheduledBucketWorkWorkOrder[] | undefined;
    readonly isBucket?: boolean | undefined;

    constructor(data?: IScheduledBucketAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.date = _data["Date"];
            this.bucketIndex = _data["BucketIndex"];
            this.isWork = _data["IsWork"];
            if (Array.isArray(_data["ScheduledBucketEmployees"])) {
                this.scheduledBucketEmployees = [] as any;
                for (let item of _data["ScheduledBucketEmployees"])
                    this.scheduledBucketEmployees!.push(ScheduledBucketEmployee.fromJS(item));
            }
            if (Array.isArray(_data["ScheduledBucketEquipment"])) {
                this.scheduledBucketEquipment = [] as any;
                for (let item of _data["ScheduledBucketEquipment"])
                    this.scheduledBucketEquipment!.push(ScheduledBucketEquipment.fromJS(item));
            }
            if (Array.isArray(_data["ScheduledBucketWellnessWorkOrders"])) {
                this.scheduledBucketWellnessWorkOrders = [] as any;
                for (let item of _data["ScheduledBucketWellnessWorkOrders"])
                    this.scheduledBucketWellnessWorkOrders!.push(ScheduledBucketWellnessWorkOrder.fromJS(item));
            }
            if (Array.isArray(_data["ScheduledBucketWorkWorkOrders"])) {
                this.scheduledBucketWorkWorkOrders = [] as any;
                for (let item of _data["ScheduledBucketWorkWorkOrders"])
                    this.scheduledBucketWorkWorkOrders!.push(ScheduledBucketWorkWorkOrder.fromJS(item));
            }
            (this as any).isBucket = _data["IsBucket"];
        }
    }

    static fromJS(data: any): ScheduledBucketAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledBucketAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Date"] = this.date;
        data["BucketIndex"] = this.bucketIndex;
        data["IsWork"] = this.isWork;
        if (Array.isArray(this.scheduledBucketEmployees)) {
            data["ScheduledBucketEmployees"] = [];
            for (let item of this.scheduledBucketEmployees)
                data["ScheduledBucketEmployees"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scheduledBucketEquipment)) {
            data["ScheduledBucketEquipment"] = [];
            for (let item of this.scheduledBucketEquipment)
                data["ScheduledBucketEquipment"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scheduledBucketWellnessWorkOrders)) {
            data["ScheduledBucketWellnessWorkOrders"] = [];
            for (let item of this.scheduledBucketWellnessWorkOrders)
                data["ScheduledBucketWellnessWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scheduledBucketWorkWorkOrders)) {
            data["ScheduledBucketWorkWorkOrders"] = [];
            for (let item of this.scheduledBucketWorkWorkOrders)
                data["ScheduledBucketWorkWorkOrders"].push(item ? item.toJSON() : undefined as any);
        }
        data["IsBucket"] = this.isBucket;
        return data;
    }
}

export interface IScheduledBucketAddDTO {
    id?: number | undefined;
    active?: boolean | undefined;
    date?: string | undefined;
    bucketIndex?: number | undefined;
    isWork?: boolean | undefined;
    scheduledBucketEmployees?: ScheduledBucketEmployee[] | undefined;
    scheduledBucketEquipment?: ScheduledBucketEquipment[] | undefined;
    scheduledBucketWellnessWorkOrders?: ScheduledBucketWellnessWorkOrder[] | undefined;
    scheduledBucketWorkWorkOrders?: ScheduledBucketWorkWorkOrder[] | undefined;
    isBucket?: boolean | undefined;
}

export class ScheduleTaskDTO implements IScheduleTaskDTO {
    taskId?: number | undefined;
    type?: ScheduleTaskDTOType | undefined;
    bucketId?: number | undefined;
    workOrderId?: number | undefined;
    order?: number | undefined;

    constructor(data?: IScheduleTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["TaskId"];
            this.type = _data["Type"];
            this.bucketId = _data["BucketId"];
            this.workOrderId = _data["WorkOrderId"];
            this.order = _data["Order"];
        }
    }

    static fromJS(data: any): ScheduleTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TaskId"] = this.taskId;
        data["Type"] = this.type;
        data["BucketId"] = this.bucketId;
        data["WorkOrderId"] = this.workOrderId;
        data["Order"] = this.order;
        return data;
    }
}

export interface IScheduleTaskDTO {
    taskId?: number | undefined;
    type?: ScheduleTaskDTOType | undefined;
    bucketId?: number | undefined;
    workOrderId?: number | undefined;
    order?: number | undefined;
}

export class SmsRequest implements ISmsRequest {
    smsSid?: string | undefined;
    body?: string | undefined;
    messageStatus?: string | undefined;
    optOutType?: string | undefined;
    messagingServiceSid?: string | undefined;
    accountSid?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    fromCity?: string | undefined;
    fromState?: string | undefined;
    fromZip?: string | undefined;
    fromCountry?: string | undefined;
    toCity?: string | undefined;
    toState?: string | undefined;
    toZip?: string | undefined;
    toCountry?: string | undefined;

    constructor(data?: ISmsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsSid = _data["SmsSid"];
            this.body = _data["Body"];
            this.messageStatus = _data["MessageStatus"];
            this.optOutType = _data["OptOutType"];
            this.messagingServiceSid = _data["MessagingServiceSid"];
            this.accountSid = _data["AccountSid"];
            this.from = _data["From"];
            this.to = _data["To"];
            this.fromCity = _data["FromCity"];
            this.fromState = _data["FromState"];
            this.fromZip = _data["FromZip"];
            this.fromCountry = _data["FromCountry"];
            this.toCity = _data["ToCity"];
            this.toState = _data["ToState"];
            this.toZip = _data["ToZip"];
            this.toCountry = _data["ToCountry"];
        }
    }

    static fromJS(data: any): SmsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SmsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SmsSid"] = this.smsSid;
        data["Body"] = this.body;
        data["MessageStatus"] = this.messageStatus;
        data["OptOutType"] = this.optOutType;
        data["MessagingServiceSid"] = this.messagingServiceSid;
        data["AccountSid"] = this.accountSid;
        data["From"] = this.from;
        data["To"] = this.to;
        data["FromCity"] = this.fromCity;
        data["FromState"] = this.fromState;
        data["FromZip"] = this.fromZip;
        data["FromCountry"] = this.fromCountry;
        data["ToCity"] = this.toCity;
        data["ToState"] = this.toState;
        data["ToZip"] = this.toZip;
        data["ToCountry"] = this.toCountry;
        return data;
    }
}

export interface ISmsRequest {
    smsSid?: string | undefined;
    body?: string | undefined;
    messageStatus?: string | undefined;
    optOutType?: string | undefined;
    messagingServiceSid?: string | undefined;
    accountSid?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    fromCity?: string | undefined;
    fromState?: string | undefined;
    fromZip?: string | undefined;
    fromCountry?: string | undefined;
    toCity?: string | undefined;
    toState?: string | undefined;
    toZip?: string | undefined;
    toCountry?: string | undefined;
}

export class ChargeFirmtimeRequest implements IChargeFirmtimeRequest {
    customerId?: number | undefined;
    billingToken?: string | undefined;
    stripeBilling?: StripeBilling | undefined;
    quoteId?: number | undefined;
    eventStart?: Date | undefined;

    constructor(data?: IChargeFirmtimeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["CustomerId"];
            this.billingToken = _data["BillingToken"];
            this.stripeBilling = _data["StripeBilling"] ? StripeBilling.fromJS(_data["StripeBilling"]) : undefined as any;
            this.quoteId = _data["QuoteId"];
            this.eventStart = _data["EventStart"] ? new Date(_data["EventStart"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ChargeFirmtimeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChargeFirmtimeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CustomerId"] = this.customerId;
        data["BillingToken"] = this.billingToken;
        data["StripeBilling"] = this.stripeBilling ? this.stripeBilling.toJSON() : undefined as any;
        data["QuoteId"] = this.quoteId;
        data["EventStart"] = this.eventStart ? this.eventStart.toISOString() : undefined as any;
        return data;
    }
}

export interface IChargeFirmtimeRequest {
    customerId?: number | undefined;
    billingToken?: string | undefined;
    stripeBilling?: StripeBilling | undefined;
    quoteId?: number | undefined;
    eventStart?: Date | undefined;
}

export class StripeBilling implements IStripeBilling {
    name?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: number | undefined;
    email?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    billingEmails?: string[] | undefined;
    state_Id?: number | undefined;
    zip?: string | undefined;
    state?: State | undefined;
    paymentType?: StripeBillingPaymentType | undefined;
    cCBrand?: string | undefined;
    cCLast4?: number | undefined;
    expiration?: string | undefined;
    cVC?: number | undefined;
    bankName?: string | undefined;
    aCHLast4?: number | undefined;

    constructor(data?: IStripeBilling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.phone = _data["Phone"];
            this.phoneExtension = _data["PhoneExtension"];
            this.email = _data["Email"];
            this.address = _data["Address"];
            this.city = _data["City"];
            if (Array.isArray(_data["BillingEmails"])) {
                this.billingEmails = [] as any;
                for (let item of _data["BillingEmails"])
                    this.billingEmails!.push(item);
            }
            this.state_Id = _data["State_Id"];
            this.zip = _data["Zip"];
            this.state = _data["State"] ? State.fromJS(_data["State"]) : undefined as any;
            this.paymentType = _data["paymentType"];
            this.cCBrand = _data["CCBrand"];
            this.cCLast4 = _data["CCLast4"];
            this.expiration = _data["Expiration"];
            this.cVC = _data["CVC"];
            this.bankName = _data["BankName"];
            this.aCHLast4 = _data["ACHLast4"];
        }
    }

    static fromJS(data: any): StripeBilling {
        data = typeof data === 'object' ? data : {};
        let result = new StripeBilling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Phone"] = this.phone;
        data["PhoneExtension"] = this.phoneExtension;
        data["Email"] = this.email;
        data["Address"] = this.address;
        data["City"] = this.city;
        if (Array.isArray(this.billingEmails)) {
            data["BillingEmails"] = [];
            for (let item of this.billingEmails)
                data["BillingEmails"].push(item);
        }
        data["State_Id"] = this.state_Id;
        data["Zip"] = this.zip;
        data["State"] = this.state ? this.state.toJSON() : undefined as any;
        data["paymentType"] = this.paymentType;
        data["CCBrand"] = this.cCBrand;
        data["CCLast4"] = this.cCLast4;
        data["Expiration"] = this.expiration;
        data["CVC"] = this.cVC;
        data["BankName"] = this.bankName;
        data["ACHLast4"] = this.aCHLast4;
        return data;
    }
}

export interface IStripeBilling {
    name?: string | undefined;
    phone?: string | undefined;
    phoneExtension?: number | undefined;
    email?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    billingEmails?: string[] | undefined;
    state_Id?: number | undefined;
    zip?: string | undefined;
    state?: State | undefined;
    paymentType?: StripeBillingPaymentType | undefined;
    cCBrand?: string | undefined;
    cCLast4?: number | undefined;
    expiration?: string | undefined;
    cVC?: number | undefined;
    bankName?: string | undefined;
    aCHLast4?: number | undefined;
}

export class InvoiceChargeViewModel implements IInvoiceChargeViewModel {
    chargeId?: string | undefined;
    invoiceId?: string | undefined;
    created?: Date | undefined;
    chargeAmount?: number | undefined;
    refunded?: boolean | undefined;
    amountRefunded?: number | undefined;
    recharge?: boolean | undefined;
    quoteNumber?: string | undefined;
    customerId?: number | undefined;

    constructor(data?: IInvoiceChargeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeId = _data["ChargeId"];
            this.invoiceId = _data["InvoiceId"];
            this.created = _data["Created"] ? new Date(_data["Created"].toString()) : undefined as any;
            this.chargeAmount = _data["ChargeAmount"];
            this.refunded = _data["Refunded"];
            this.amountRefunded = _data["AmountRefunded"];
            this.recharge = _data["Recharge"];
            this.quoteNumber = _data["QuoteNumber"];
            this.customerId = _data["CustomerId"];
        }
    }

    static fromJS(data: any): InvoiceChargeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceChargeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ChargeId"] = this.chargeId;
        data["InvoiceId"] = this.invoiceId;
        data["Created"] = this.created ? this.created.toISOString() : undefined as any;
        data["ChargeAmount"] = this.chargeAmount;
        data["Refunded"] = this.refunded;
        data["AmountRefunded"] = this.amountRefunded;
        data["Recharge"] = this.recharge;
        data["QuoteNumber"] = this.quoteNumber;
        data["CustomerId"] = this.customerId;
        return data;
    }
}

export interface IInvoiceChargeViewModel {
    chargeId?: string | undefined;
    invoiceId?: string | undefined;
    created?: Date | undefined;
    chargeAmount?: number | undefined;
    refunded?: boolean | undefined;
    amountRefunded?: number | undefined;
    recharge?: boolean | undefined;
    quoteNumber?: string | undefined;
    customerId?: number | undefined;
}

export class PartialInvoiceRequest implements IPartialInvoiceRequest {
    taskIds?: number[] | undefined;
    workOrderId?: number | undefined;
    workOrderType?: string | undefined;

    constructor(data?: IPartialInvoiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["TaskIds"])) {
                this.taskIds = [] as any;
                for (let item of _data["TaskIds"])
                    this.taskIds!.push(item);
            }
            this.workOrderId = _data["WorkOrderId"];
            this.workOrderType = _data["WorkOrderType"];
        }
    }

    static fromJS(data: any): PartialInvoiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PartialInvoiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taskIds)) {
            data["TaskIds"] = [];
            for (let item of this.taskIds)
                data["TaskIds"].push(item);
        }
        data["WorkOrderId"] = this.workOrderId;
        data["WorkOrderType"] = this.workOrderType;
        return data;
    }
}

export interface IPartialInvoiceRequest {
    taskIds?: number[] | undefined;
    workOrderId?: number | undefined;
    workOrderType?: string | undefined;
}

export class PlaidLinkSuccessDTO implements IPlaidLinkSuccessDTO {
    publicToken?: string | undefined;
    account_id?: string | undefined;

    constructor(data?: IPlaidLinkSuccessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicToken = _data["publicToken"];
            this.account_id = _data["account_id"];
        }
    }

    static fromJS(data: any): PlaidLinkSuccessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PlaidLinkSuccessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicToken"] = this.publicToken;
        data["account_id"] = this.account_id;
        return data;
    }
}

export interface IPlaidLinkSuccessDTO {
    publicToken?: string | undefined;
    account_id?: string | undefined;
}

export class SurveyQuestion implements ISurveyQuestion {
    id?: number | undefined;
    active?: boolean | undefined;
    visible?: boolean | undefined;
    question?: string | undefined;
    isYesNo?: boolean | undefined;
    priority?: number | undefined;

    constructor(data?: ISurveyQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.visible = _data["Visible"];
            this.question = _data["Question"];
            this.isYesNo = _data["IsYesNo"];
            this.priority = _data["Priority"];
        }
    }

    static fromJS(data: any): SurveyQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["Visible"] = this.visible;
        data["Question"] = this.question;
        data["IsYesNo"] = this.isYesNo;
        data["Priority"] = this.priority;
        return data;
    }
}

export interface ISurveyQuestion {
    id?: number | undefined;
    active?: boolean | undefined;
    visible?: boolean | undefined;
    question?: string | undefined;
    isYesNo?: boolean | undefined;
    priority?: number | undefined;
}

export class SurveyHeader implements ISurveyHeader {
    id?: number | undefined;
    active?: boolean | undefined;
    customerId?: number | undefined;
    dateSent?: Date | undefined;
    dateCompleted?: Date | undefined;
    surveyHash?: string | undefined;
    customer?: Customer | undefined;
    surveyAnswers?: SurveyAnswer[] | undefined;
    quoteNumber?: string | undefined;

    constructor(data?: ISurveyHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.active = _data["Active"];
            this.customerId = _data["CustomerId"];
            this.dateSent = _data["DateSent"] ? new Date(_data["DateSent"].toString()) : undefined as any;
            this.dateCompleted = _data["DateCompleted"] ? new Date(_data["DateCompleted"].toString()) : undefined as any;
            this.surveyHash = _data["SurveyHash"];
            this.customer = _data["Customer"] ? Customer.fromJS(_data["Customer"]) : undefined as any;
            if (Array.isArray(_data["SurveyAnswers"])) {
                this.surveyAnswers = [] as any;
                for (let item of _data["SurveyAnswers"])
                    this.surveyAnswers!.push(SurveyAnswer.fromJS(item));
            }
            this.quoteNumber = _data["QuoteNumber"];
        }
    }

    static fromJS(data: any): SurveyHeader {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Active"] = this.active;
        data["CustomerId"] = this.customerId;
        data["DateSent"] = this.dateSent ? this.dateSent.toISOString() : undefined as any;
        data["DateCompleted"] = this.dateCompleted ? this.dateCompleted.toISOString() : undefined as any;
        data["SurveyHash"] = this.surveyHash;
        data["Customer"] = this.customer ? this.customer.toJSON() : undefined as any;
        if (Array.isArray(this.surveyAnswers)) {
            data["SurveyAnswers"] = [];
            for (let item of this.surveyAnswers)
                data["SurveyAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["QuoteNumber"] = this.quoteNumber;
        return data;
    }
}

export interface ISurveyHeader {
    id?: number | undefined;
    active?: boolean | undefined;
    customerId?: number | undefined;
    dateSent?: Date | undefined;
    dateCompleted?: Date | undefined;
    surveyHash?: string | undefined;
    customer?: Customer | undefined;
    surveyAnswers?: SurveyAnswer[] | undefined;
    quoteNumber?: string | undefined;
}

export class SurveyAnswer implements ISurveyAnswer {
    id?: number | undefined;
    surveyHeaderId?: number | undefined;
    surveyQuestionId?: number | undefined;
    yesNoResponse?: boolean | undefined;
    comment?: string | undefined;
    surveyHeader?: SurveyHeader | undefined;
    surveyQuestion?: SurveyQuestion | undefined;

    constructor(data?: ISurveyAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.surveyHeaderId = _data["SurveyHeaderId"];
            this.surveyQuestionId = _data["SurveyQuestionId"];
            this.yesNoResponse = _data["YesNoResponse"];
            this.comment = _data["Comment"];
            this.surveyHeader = _data["SurveyHeader"] ? SurveyHeader.fromJS(_data["SurveyHeader"]) : undefined as any;
            this.surveyQuestion = _data["SurveyQuestion"] ? SurveyQuestion.fromJS(_data["SurveyQuestion"]) : undefined as any;
        }
    }

    static fromJS(data: any): SurveyAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["SurveyHeaderId"] = this.surveyHeaderId;
        data["SurveyQuestionId"] = this.surveyQuestionId;
        data["YesNoResponse"] = this.yesNoResponse;
        data["Comment"] = this.comment;
        data["SurveyHeader"] = this.surveyHeader ? this.surveyHeader.toJSON() : undefined as any;
        data["SurveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : undefined as any;
        return data;
    }
}

export interface ISurveyAnswer {
    id?: number | undefined;
    surveyHeaderId?: number | undefined;
    surveyQuestionId?: number | undefined;
    yesNoResponse?: boolean | undefined;
    comment?: string | undefined;
    surveyHeader?: SurveyHeader | undefined;
    surveyQuestion?: SurveyQuestion | undefined;
}

export class SystemSettingDTO implements ISystemSettingDTO {
    id?: number | undefined;
    type?: SystemSettingDTOType | undefined;
    name?: string | undefined;
    value?: string | undefined;
    claimName?: string | undefined;
    step?: number | undefined;

    constructor(data?: ISystemSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.name = _data["Name"];
            this.value = _data["Value"];
            this.claimName = _data["ClaimName"];
            this.step = _data["Step"];
        }
    }

    static fromJS(data: any): SystemSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SystemSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["Name"] = this.name;
        data["Value"] = this.value;
        data["ClaimName"] = this.claimName;
        data["Step"] = this.step;
        return data;
    }
}

export interface ISystemSettingDTO {
    id?: number | undefined;
    type?: SystemSettingDTOType | undefined;
    name?: string | undefined;
    value?: string | undefined;
    claimName?: string | undefined;
    step?: number | undefined;
}

export class UnableToCompleteTaskDTO implements IUnableToCompleteTaskDTO {
    id?: number | undefined;
    feedback?: string | undefined;

    constructor(data?: IUnableToCompleteTaskDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.feedback = _data["Feedback"];
        }
    }

    static fromJS(data: any): UnableToCompleteTaskDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UnableToCompleteTaskDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Feedback"] = this.feedback;
        return data;
    }
}

export interface IUnableToCompleteTaskDTO {
    id?: number | undefined;
    feedback?: string | undefined;
}

export class WellnessTaskUpdateDTO implements IWellnessTaskUpdateDTO {
    growingDegreeDay?: number | undefined;
    renewable?: boolean | undefined;
    renewalAccepted?: boolean | undefined;
    renewed?: boolean | undefined;
    id?: number | undefined;
    name?: string | undefined;
    price?: number | undefined;
    hours?: number | undefined;
    description?: string | undefined;
    treeTypeIds?: number[] | undefined;
    location?: string | undefined;
    skillIds?: number[] | undefined;
    equipmentTypeIds?: number[] | undefined;
    schedulableAfterCompletionOfId?: number | undefined;
    completionStatus?: WellnessTaskUpdateDTOCompletionStatus | undefined;
    customerIssue?: string | undefined;
    goBackHoursEstimate?: number | undefined;
    goBackEquipmentTypeIds?: number[] | undefined;
    priorityLevelId?: number | undefined;
    hasCalculatedPriority?: boolean | undefined;
    priorityShortcutId?: number | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    manualPriorityShortcutType?: WellnessTaskUpdateDTOManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    quoteSignedDate?: Date | undefined;

    constructor(data?: IWellnessTaskUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.growingDegreeDay = _data["GrowingDegreeDay"];
            this.renewable = _data["Renewable"];
            this.renewalAccepted = _data["RenewalAccepted"];
            this.renewed = _data["Renewed"];
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.price = _data["Price"];
            this.hours = _data["Hours"];
            this.description = _data["Description"];
            if (Array.isArray(_data["TreeTypeIds"])) {
                this.treeTypeIds = [] as any;
                for (let item of _data["TreeTypeIds"])
                    this.treeTypeIds!.push(item);
            }
            this.location = _data["Location"];
            if (Array.isArray(_data["SkillIds"])) {
                this.skillIds = [] as any;
                for (let item of _data["SkillIds"])
                    this.skillIds!.push(item);
            }
            if (Array.isArray(_data["EquipmentTypeIds"])) {
                this.equipmentTypeIds = [] as any;
                for (let item of _data["EquipmentTypeIds"])
                    this.equipmentTypeIds!.push(item);
            }
            this.schedulableAfterCompletionOfId = _data["SchedulableAfterCompletionOfId"];
            this.completionStatus = _data["CompletionStatus"];
            this.customerIssue = _data["CustomerIssue"];
            this.goBackHoursEstimate = _data["GoBackHoursEstimate"];
            if (Array.isArray(_data["GoBackEquipmentTypeIds"])) {
                this.goBackEquipmentTypeIds = [] as any;
                for (let item of _data["GoBackEquipmentTypeIds"])
                    this.goBackEquipmentTypeIds!.push(item);
            }
            this.priorityLevelId = _data["PriorityLevelId"];
            this.hasCalculatedPriority = _data["HasCalculatedPriority"];
            this.priorityShortcutId = _data["PriorityShortcutId"];
            this.dueDateStart = _data["DueDateStart"] ? new Date(_data["DueDateStart"].toString()) : undefined as any;
            this.dueDateEnd = _data["DueDateEnd"] ? new Date(_data["DueDateEnd"].toString()) : undefined as any;
            this.hardStartDate = _data["HardStartDate"];
            this.hardEndDate = _data["HardEndDate"];
            this.manualPriorityShortcutType = _data["ManualPriorityShortcutType"];
            this.manualRangeStart = _data["ManualRangeStart"];
            this.manualRangeEnd = _data["ManualRangeEnd"];
            this.quoteSignedDate = _data["QuoteSignedDate"] ? new Date(_data["QuoteSignedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WellnessTaskUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTaskUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["GrowingDegreeDay"] = this.growingDegreeDay;
        data["Renewable"] = this.renewable;
        data["RenewalAccepted"] = this.renewalAccepted;
        data["Renewed"] = this.renewed;
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Price"] = this.price;
        data["Hours"] = this.hours;
        data["Description"] = this.description;
        if (Array.isArray(this.treeTypeIds)) {
            data["TreeTypeIds"] = [];
            for (let item of this.treeTypeIds)
                data["TreeTypeIds"].push(item);
        }
        data["Location"] = this.location;
        if (Array.isArray(this.skillIds)) {
            data["SkillIds"] = [];
            for (let item of this.skillIds)
                data["SkillIds"].push(item);
        }
        if (Array.isArray(this.equipmentTypeIds)) {
            data["EquipmentTypeIds"] = [];
            for (let item of this.equipmentTypeIds)
                data["EquipmentTypeIds"].push(item);
        }
        data["SchedulableAfterCompletionOfId"] = this.schedulableAfterCompletionOfId;
        data["CompletionStatus"] = this.completionStatus;
        data["CustomerIssue"] = this.customerIssue;
        data["GoBackHoursEstimate"] = this.goBackHoursEstimate;
        if (Array.isArray(this.goBackEquipmentTypeIds)) {
            data["GoBackEquipmentTypeIds"] = [];
            for (let item of this.goBackEquipmentTypeIds)
                data["GoBackEquipmentTypeIds"].push(item);
        }
        data["PriorityLevelId"] = this.priorityLevelId;
        data["HasCalculatedPriority"] = this.hasCalculatedPriority;
        data["PriorityShortcutId"] = this.priorityShortcutId;
        data["DueDateStart"] = this.dueDateStart ? this.dueDateStart.toISOString() : undefined as any;
        data["DueDateEnd"] = this.dueDateEnd ? this.dueDateEnd.toISOString() : undefined as any;
        data["HardStartDate"] = this.hardStartDate;
        data["HardEndDate"] = this.hardEndDate;
        data["ManualPriorityShortcutType"] = this.manualPriorityShortcutType;
        data["ManualRangeStart"] = this.manualRangeStart;
        data["ManualRangeEnd"] = this.manualRangeEnd;
        data["QuoteSignedDate"] = this.quoteSignedDate ? this.quoteSignedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWellnessTaskUpdateDTO {
    growingDegreeDay?: number | undefined;
    renewable?: boolean | undefined;
    renewalAccepted?: boolean | undefined;
    renewed?: boolean | undefined;
    id?: number | undefined;
    name?: string | undefined;
    price?: number | undefined;
    hours?: number | undefined;
    description?: string | undefined;
    treeTypeIds?: number[] | undefined;
    location?: string | undefined;
    skillIds?: number[] | undefined;
    equipmentTypeIds?: number[] | undefined;
    schedulableAfterCompletionOfId?: number | undefined;
    completionStatus?: WellnessTaskUpdateDTOCompletionStatus | undefined;
    customerIssue?: string | undefined;
    goBackHoursEstimate?: number | undefined;
    goBackEquipmentTypeIds?: number[] | undefined;
    priorityLevelId?: number | undefined;
    hasCalculatedPriority?: boolean | undefined;
    priorityShortcutId?: number | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    manualPriorityShortcutType?: WellnessTaskUpdateDTOManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    quoteSignedDate?: Date | undefined;
}

export class WellnessTaskTemplate implements IWellnessTaskTemplate {
    id?: number | undefined;
    name?: string | undefined;
    cost?: number | undefined;
    price?: number | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    growingDegreeDay?: number | undefined;
    hours?: number | undefined;
    deleted?: boolean | undefined;

    constructor(data?: IWellnessTaskTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.cost = _data["Cost"];
            this.price = _data["Price"];
            this.description = _data["Description"];
            this.active = _data["Active"];
            this.growingDegreeDay = _data["GrowingDegreeDay"];
            this.hours = _data["Hours"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): WellnessTaskTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new WellnessTaskTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Cost"] = this.cost;
        data["Price"] = this.price;
        data["Description"] = this.description;
        data["Active"] = this.active;
        data["GrowingDegreeDay"] = this.growingDegreeDay;
        data["Hours"] = this.hours;
        data["Deleted"] = this.deleted;
        return data;
    }
}

export interface IWellnessTaskTemplate {
    id?: number | undefined;
    name?: string | undefined;
    cost?: number | undefined;
    price?: number | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    growingDegreeDay?: number | undefined;
    hours?: number | undefined;
    deleted?: boolean | undefined;
}

export class SaveWorkOrderAfterCompletionRequest implements ISaveWorkOrderAfterCompletionRequest {
    id?: number | undefined;
    hasRentalCosts?: boolean | undefined;
    rentalCosts?: number | undefined;
    rentalDescription?: string | undefined;
    crewNote?: string | undefined;

    constructor(data?: ISaveWorkOrderAfterCompletionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.hasRentalCosts = _data["HasRentalCosts"];
            this.rentalCosts = _data["RentalCosts"];
            this.rentalDescription = _data["RentalDescription"];
            this.crewNote = _data["CrewNote"];
        }
    }

    static fromJS(data: any): SaveWorkOrderAfterCompletionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkOrderAfterCompletionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["HasRentalCosts"] = this.hasRentalCosts;
        data["RentalCosts"] = this.rentalCosts;
        data["RentalDescription"] = this.rentalDescription;
        data["CrewNote"] = this.crewNote;
        return data;
    }
}

export interface ISaveWorkOrderAfterCompletionRequest {
    id?: number | undefined;
    hasRentalCosts?: boolean | undefined;
    rentalCosts?: number | undefined;
    rentalDescription?: string | undefined;
    crewNote?: string | undefined;
}

export class AdvancedInvoiceFilters implements IAdvancedInvoiceFilters {
    shouldFilterByType?: boolean | undefined;
    shouldFilterByWOStatus?: boolean | undefined;
    shouldFilterByPaymentStatus?: boolean | undefined;
    shouldFilterByRM?: boolean | undefined;
    services?: string[] | undefined;
    completionStatuses?: string[] | undefined;
    paymentStatuses?: string[] | undefined;
    rMs?: string[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
    globalFilter?: string | undefined;
    orderBy?: string | undefined;

    constructor(data?: IAdvancedInvoiceFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldFilterByType = _data["ShouldFilterByType"];
            this.shouldFilterByWOStatus = _data["shouldFilterByWOStatus"];
            this.shouldFilterByPaymentStatus = _data["shouldFilterByPaymentStatus"];
            this.shouldFilterByRM = _data["shouldFilterByRM"];
            if (Array.isArray(_data["Services"])) {
                this.services = [] as any;
                for (let item of _data["Services"])
                    this.services!.push(item);
            }
            if (Array.isArray(_data["CompletionStatuses"])) {
                this.completionStatuses = [] as any;
                for (let item of _data["CompletionStatuses"])
                    this.completionStatuses!.push(item);
            }
            if (Array.isArray(_data["PaymentStatuses"])) {
                this.paymentStatuses = [] as any;
                for (let item of _data["PaymentStatuses"])
                    this.paymentStatuses!.push(item);
            }
            if (Array.isArray(_data["RMs"])) {
                this.rMs = [] as any;
                for (let item of _data["RMs"])
                    this.rMs!.push(item);
            }
            this.skip = _data["Skip"];
            this.take = _data["Take"];
            this.globalFilter = _data["GlobalFilter"];
            this.orderBy = _data["OrderBy"];
        }
    }

    static fromJS(data: any): AdvancedInvoiceFilters {
        data = typeof data === 'object' ? data : {};
        let result = new AdvancedInvoiceFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ShouldFilterByType"] = this.shouldFilterByType;
        data["shouldFilterByWOStatus"] = this.shouldFilterByWOStatus;
        data["shouldFilterByPaymentStatus"] = this.shouldFilterByPaymentStatus;
        data["shouldFilterByRM"] = this.shouldFilterByRM;
        if (Array.isArray(this.services)) {
            data["Services"] = [];
            for (let item of this.services)
                data["Services"].push(item);
        }
        if (Array.isArray(this.completionStatuses)) {
            data["CompletionStatuses"] = [];
            for (let item of this.completionStatuses)
                data["CompletionStatuses"].push(item);
        }
        if (Array.isArray(this.paymentStatuses)) {
            data["PaymentStatuses"] = [];
            for (let item of this.paymentStatuses)
                data["PaymentStatuses"].push(item);
        }
        if (Array.isArray(this.rMs)) {
            data["RMs"] = [];
            for (let item of this.rMs)
                data["RMs"].push(item);
        }
        data["Skip"] = this.skip;
        data["Take"] = this.take;
        data["GlobalFilter"] = this.globalFilter;
        data["OrderBy"] = this.orderBy;
        return data;
    }
}

export interface IAdvancedInvoiceFilters {
    shouldFilterByType?: boolean | undefined;
    shouldFilterByWOStatus?: boolean | undefined;
    shouldFilterByPaymentStatus?: boolean | undefined;
    shouldFilterByRM?: boolean | undefined;
    services?: string[] | undefined;
    completionStatuses?: string[] | undefined;
    paymentStatuses?: string[] | undefined;
    rMs?: string[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
    globalFilter?: string | undefined;
    orderBy?: string | undefined;
}

export class PagedResultsForInvoicingOfWorkOrderInvoicingViewModel implements IPagedResultsForInvoicingOfWorkOrderInvoicingViewModel {
    completionStatuses?: string[] | undefined;
    rMs?: string[] | undefined;
    equipmentTypes?: string[] | undefined;
    results?: WorkOrderInvoicingViewModel[] | undefined;
    totalResults?: number | undefined;

    constructor(data?: IPagedResultsForInvoicingOfWorkOrderInvoicingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["CompletionStatuses"])) {
                this.completionStatuses = [] as any;
                for (let item of _data["CompletionStatuses"])
                    this.completionStatuses!.push(item);
            }
            if (Array.isArray(_data["RMs"])) {
                this.rMs = [] as any;
                for (let item of _data["RMs"])
                    this.rMs!.push(item);
            }
            if (Array.isArray(_data["EquipmentTypes"])) {
                this.equipmentTypes = [] as any;
                for (let item of _data["EquipmentTypes"])
                    this.equipmentTypes!.push(item);
            }
            if (Array.isArray(_data["Results"])) {
                this.results = [] as any;
                for (let item of _data["Results"])
                    this.results!.push(WorkOrderInvoicingViewModel.fromJS(item));
            }
            this.totalResults = _data["TotalResults"];
        }
    }

    static fromJS(data: any): PagedResultsForInvoicingOfWorkOrderInvoicingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultsForInvoicingOfWorkOrderInvoicingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.completionStatuses)) {
            data["CompletionStatuses"] = [];
            for (let item of this.completionStatuses)
                data["CompletionStatuses"].push(item);
        }
        if (Array.isArray(this.rMs)) {
            data["RMs"] = [];
            for (let item of this.rMs)
                data["RMs"].push(item);
        }
        if (Array.isArray(this.equipmentTypes)) {
            data["EquipmentTypes"] = [];
            for (let item of this.equipmentTypes)
                data["EquipmentTypes"].push(item);
        }
        if (Array.isArray(this.results)) {
            data["Results"] = [];
            for (let item of this.results)
                data["Results"].push(item ? item.toJSON() : undefined as any);
        }
        data["TotalResults"] = this.totalResults;
        return data;
    }
}

export interface IPagedResultsForInvoicingOfWorkOrderInvoicingViewModel {
    completionStatuses?: string[] | undefined;
    rMs?: string[] | undefined;
    equipmentTypes?: string[] | undefined;
    results?: WorkOrderInvoicingViewModel[] | undefined;
    totalResults?: number | undefined;
}

export class WorkOrderInvoicingViewModel implements IWorkOrderInvoicingViewModel {
    number?: string | undefined;
    customerName?: string | undefined;
    phoneNumber?: string | undefined;
    serviceType?: string | undefined;
    wOStatus?: string | undefined;
    dateCompleted?: string | undefined;
    paymentStatus?: string | undefined;
    preferredPayment?: string | undefined;
    cardOnFile?: string | undefined;
    amountDue?: number | undefined;
    latestNote?: string | undefined;
    representative?: string | undefined;
    customerId?: number | undefined;
    workOrderId?: number | undefined;
    stripeCustomerId?: string | undefined;
    quoteId?: number | undefined;
    workOrderBilling?: WorkOrderBilling | undefined;
    cashCollected?: number | undefined;
    workOrderTotal?: number | undefined;
    hasHourlyRateTask?: boolean | undefined;
    completedCount?: string | undefined;
    paidCount?: string | undefined;
    showAsPartiallyComplete?: boolean | undefined;
    invoices?: AAInvoice[] | undefined;

    constructor(data?: IWorkOrderInvoicingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["Number"];
            this.customerName = _data["CustomerName"];
            this.phoneNumber = _data["PhoneNumber"];
            this.serviceType = _data["ServiceType"];
            this.wOStatus = _data["WOStatus"];
            this.dateCompleted = _data["DateCompleted"];
            this.paymentStatus = _data["PaymentStatus"];
            this.preferredPayment = _data["PreferredPayment"];
            this.cardOnFile = _data["CardOnFile"];
            this.amountDue = _data["AmountDue"];
            this.latestNote = _data["LatestNote"];
            this.representative = _data["Representative"];
            this.customerId = _data["CustomerId"];
            this.workOrderId = _data["WorkOrderId"];
            this.stripeCustomerId = _data["StripeCustomerId"];
            this.quoteId = _data["QuoteId"];
            this.workOrderBilling = _data["WorkOrderBilling"] ? WorkOrderBilling.fromJS(_data["WorkOrderBilling"]) : undefined as any;
            this.cashCollected = _data["CashCollected"];
            this.workOrderTotal = _data["WorkOrderTotal"];
            this.hasHourlyRateTask = _data["HasHourlyRateTask"];
            this.completedCount = _data["CompletedCount"];
            this.paidCount = _data["PaidCount"];
            this.showAsPartiallyComplete = _data["ShowAsPartiallyComplete"];
            if (Array.isArray(_data["Invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["Invoices"])
                    this.invoices!.push(AAInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkOrderInvoicingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderInvoicingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Number"] = this.number;
        data["CustomerName"] = this.customerName;
        data["PhoneNumber"] = this.phoneNumber;
        data["ServiceType"] = this.serviceType;
        data["WOStatus"] = this.wOStatus;
        data["DateCompleted"] = this.dateCompleted;
        data["PaymentStatus"] = this.paymentStatus;
        data["PreferredPayment"] = this.preferredPayment;
        data["CardOnFile"] = this.cardOnFile;
        data["AmountDue"] = this.amountDue;
        data["LatestNote"] = this.latestNote;
        data["Representative"] = this.representative;
        data["CustomerId"] = this.customerId;
        data["WorkOrderId"] = this.workOrderId;
        data["StripeCustomerId"] = this.stripeCustomerId;
        data["QuoteId"] = this.quoteId;
        data["WorkOrderBilling"] = this.workOrderBilling ? this.workOrderBilling.toJSON() : undefined as any;
        data["CashCollected"] = this.cashCollected;
        data["WorkOrderTotal"] = this.workOrderTotal;
        data["HasHourlyRateTask"] = this.hasHourlyRateTask;
        data["CompletedCount"] = this.completedCount;
        data["PaidCount"] = this.paidCount;
        data["ShowAsPartiallyComplete"] = this.showAsPartiallyComplete;
        if (Array.isArray(this.invoices)) {
            data["Invoices"] = [];
            for (let item of this.invoices)
                data["Invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkOrderInvoicingViewModel {
    number?: string | undefined;
    customerName?: string | undefined;
    phoneNumber?: string | undefined;
    serviceType?: string | undefined;
    wOStatus?: string | undefined;
    dateCompleted?: string | undefined;
    paymentStatus?: string | undefined;
    preferredPayment?: string | undefined;
    cardOnFile?: string | undefined;
    amountDue?: number | undefined;
    latestNote?: string | undefined;
    representative?: string | undefined;
    customerId?: number | undefined;
    workOrderId?: number | undefined;
    stripeCustomerId?: string | undefined;
    quoteId?: number | undefined;
    workOrderBilling?: WorkOrderBilling | undefined;
    cashCollected?: number | undefined;
    workOrderTotal?: number | undefined;
    hasHourlyRateTask?: boolean | undefined;
    completedCount?: string | undefined;
    paidCount?: string | undefined;
    showAsPartiallyComplete?: boolean | undefined;
    invoices?: AAInvoice[] | undefined;
}

export class AAInvoice implements IAAInvoice {
    invoiceId?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceUrl?: string | undefined;
    status?: string | undefined;
    created?: Date | undefined;
    amountDue?: number | undefined;
    amountPaid?: number | undefined;
    datePaid?: Date | undefined;
    refunded?: boolean | undefined;
    amountRefunded?: number | undefined;
    cashIdToApply?: number | undefined;

    constructor(data?: IAAInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["InvoiceId"];
            this.invoiceNumber = _data["InvoiceNumber"];
            this.invoiceUrl = _data["InvoiceUrl"];
            this.status = _data["Status"];
            this.created = _data["Created"] ? new Date(_data["Created"].toString()) : undefined as any;
            this.amountDue = _data["AmountDue"];
            this.amountPaid = _data["AmountPaid"];
            this.datePaid = _data["DatePaid"] ? new Date(_data["DatePaid"].toString()) : undefined as any;
            this.refunded = _data["Refunded"];
            this.amountRefunded = _data["AmountRefunded"];
            this.cashIdToApply = _data["CashIdToApply"];
        }
    }

    static fromJS(data: any): AAInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new AAInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InvoiceId"] = this.invoiceId;
        data["InvoiceNumber"] = this.invoiceNumber;
        data["InvoiceUrl"] = this.invoiceUrl;
        data["Status"] = this.status;
        data["Created"] = this.created ? this.created.toISOString() : undefined as any;
        data["AmountDue"] = this.amountDue;
        data["AmountPaid"] = this.amountPaid;
        data["DatePaid"] = this.datePaid ? this.datePaid.toISOString() : undefined as any;
        data["Refunded"] = this.refunded;
        data["AmountRefunded"] = this.amountRefunded;
        data["CashIdToApply"] = this.cashIdToApply;
        return data;
    }
}

export interface IAAInvoice {
    invoiceId?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceUrl?: string | undefined;
    status?: string | undefined;
    created?: Date | undefined;
    amountDue?: number | undefined;
    amountPaid?: number | undefined;
    datePaid?: Date | undefined;
    refunded?: boolean | undefined;
    amountRefunded?: number | undefined;
    cashIdToApply?: number | undefined;
}

export class BasicWorkOrderViewModel implements IBasicWorkOrderViewModel {
    id?: number | undefined;
    customerName?: string | undefined;
    address?: string | undefined;
    quoteNumber?: string | undefined;
    type?: string | undefined;

    constructor(data?: IBasicWorkOrderViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.customerName = _data["CustomerName"];
            this.address = _data["Address"];
            this.quoteNumber = _data["QuoteNumber"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): BasicWorkOrderViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BasicWorkOrderViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CustomerName"] = this.customerName;
        data["Address"] = this.address;
        data["QuoteNumber"] = this.quoteNumber;
        data["Type"] = this.type;
        return data;
    }
}

export interface IBasicWorkOrderViewModel {
    id?: number | undefined;
    customerName?: string | undefined;
    address?: string | undefined;
    quoteNumber?: string | undefined;
    type?: string | undefined;
}

export class WorkTaskUpdateDTO implements IWorkTaskUpdateDTO {
    fixedPrice?: boolean | undefined;
    hourlyRate?: number | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    id?: number | undefined;
    name?: string | undefined;
    price?: number | undefined;
    hours?: number | undefined;
    description?: string | undefined;
    treeTypeIds?: number[] | undefined;
    location?: string | undefined;
    skillIds?: number[] | undefined;
    equipmentTypeIds?: number[] | undefined;
    schedulableAfterCompletionOfId?: number | undefined;
    completionStatus?: WorkTaskUpdateDTOCompletionStatus | undefined;
    customerIssue?: string | undefined;
    goBackHoursEstimate?: number | undefined;
    goBackEquipmentTypeIds?: number[] | undefined;
    priorityLevelId?: number | undefined;
    hasCalculatedPriority?: boolean | undefined;
    priorityShortcutId?: number | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    manualPriorityShortcutType?: WorkTaskUpdateDTOManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    quoteSignedDate?: Date | undefined;

    constructor(data?: IWorkTaskUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedPrice = _data["FixedPrice"];
            this.hourlyRate = _data["HourlyRate"];
            this.minPrice = _data["MinPrice"];
            this.maxPrice = _data["MaxPrice"];
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.price = _data["Price"];
            this.hours = _data["Hours"];
            this.description = _data["Description"];
            if (Array.isArray(_data["TreeTypeIds"])) {
                this.treeTypeIds = [] as any;
                for (let item of _data["TreeTypeIds"])
                    this.treeTypeIds!.push(item);
            }
            this.location = _data["Location"];
            if (Array.isArray(_data["SkillIds"])) {
                this.skillIds = [] as any;
                for (let item of _data["SkillIds"])
                    this.skillIds!.push(item);
            }
            if (Array.isArray(_data["EquipmentTypeIds"])) {
                this.equipmentTypeIds = [] as any;
                for (let item of _data["EquipmentTypeIds"])
                    this.equipmentTypeIds!.push(item);
            }
            this.schedulableAfterCompletionOfId = _data["SchedulableAfterCompletionOfId"];
            this.completionStatus = _data["CompletionStatus"];
            this.customerIssue = _data["CustomerIssue"];
            this.goBackHoursEstimate = _data["GoBackHoursEstimate"];
            if (Array.isArray(_data["GoBackEquipmentTypeIds"])) {
                this.goBackEquipmentTypeIds = [] as any;
                for (let item of _data["GoBackEquipmentTypeIds"])
                    this.goBackEquipmentTypeIds!.push(item);
            }
            this.priorityLevelId = _data["PriorityLevelId"];
            this.hasCalculatedPriority = _data["HasCalculatedPriority"];
            this.priorityShortcutId = _data["PriorityShortcutId"];
            this.dueDateStart = _data["DueDateStart"] ? new Date(_data["DueDateStart"].toString()) : undefined as any;
            this.dueDateEnd = _data["DueDateEnd"] ? new Date(_data["DueDateEnd"].toString()) : undefined as any;
            this.hardStartDate = _data["HardStartDate"];
            this.hardEndDate = _data["HardEndDate"];
            this.manualPriorityShortcutType = _data["ManualPriorityShortcutType"];
            this.manualRangeStart = _data["ManualRangeStart"];
            this.manualRangeEnd = _data["ManualRangeEnd"];
            this.quoteSignedDate = _data["QuoteSignedDate"] ? new Date(_data["QuoteSignedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkTaskUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTaskUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["FixedPrice"] = this.fixedPrice;
        data["HourlyRate"] = this.hourlyRate;
        data["MinPrice"] = this.minPrice;
        data["MaxPrice"] = this.maxPrice;
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Price"] = this.price;
        data["Hours"] = this.hours;
        data["Description"] = this.description;
        if (Array.isArray(this.treeTypeIds)) {
            data["TreeTypeIds"] = [];
            for (let item of this.treeTypeIds)
                data["TreeTypeIds"].push(item);
        }
        data["Location"] = this.location;
        if (Array.isArray(this.skillIds)) {
            data["SkillIds"] = [];
            for (let item of this.skillIds)
                data["SkillIds"].push(item);
        }
        if (Array.isArray(this.equipmentTypeIds)) {
            data["EquipmentTypeIds"] = [];
            for (let item of this.equipmentTypeIds)
                data["EquipmentTypeIds"].push(item);
        }
        data["SchedulableAfterCompletionOfId"] = this.schedulableAfterCompletionOfId;
        data["CompletionStatus"] = this.completionStatus;
        data["CustomerIssue"] = this.customerIssue;
        data["GoBackHoursEstimate"] = this.goBackHoursEstimate;
        if (Array.isArray(this.goBackEquipmentTypeIds)) {
            data["GoBackEquipmentTypeIds"] = [];
            for (let item of this.goBackEquipmentTypeIds)
                data["GoBackEquipmentTypeIds"].push(item);
        }
        data["PriorityLevelId"] = this.priorityLevelId;
        data["HasCalculatedPriority"] = this.hasCalculatedPriority;
        data["PriorityShortcutId"] = this.priorityShortcutId;
        data["DueDateStart"] = this.dueDateStart ? this.dueDateStart.toISOString() : undefined as any;
        data["DueDateEnd"] = this.dueDateEnd ? this.dueDateEnd.toISOString() : undefined as any;
        data["HardStartDate"] = this.hardStartDate;
        data["HardEndDate"] = this.hardEndDate;
        data["ManualPriorityShortcutType"] = this.manualPriorityShortcutType;
        data["ManualRangeStart"] = this.manualRangeStart;
        data["ManualRangeEnd"] = this.manualRangeEnd;
        data["QuoteSignedDate"] = this.quoteSignedDate ? this.quoteSignedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkTaskUpdateDTO {
    fixedPrice?: boolean | undefined;
    hourlyRate?: number | undefined;
    minPrice?: number | undefined;
    maxPrice?: number | undefined;
    id?: number | undefined;
    name?: string | undefined;
    price?: number | undefined;
    hours?: number | undefined;
    description?: string | undefined;
    treeTypeIds?: number[] | undefined;
    location?: string | undefined;
    skillIds?: number[] | undefined;
    equipmentTypeIds?: number[] | undefined;
    schedulableAfterCompletionOfId?: number | undefined;
    completionStatus?: WorkTaskUpdateDTOCompletionStatus | undefined;
    customerIssue?: string | undefined;
    goBackHoursEstimate?: number | undefined;
    goBackEquipmentTypeIds?: number[] | undefined;
    priorityLevelId?: number | undefined;
    hasCalculatedPriority?: boolean | undefined;
    priorityShortcutId?: number | undefined;
    dueDateStart?: Date | undefined;
    dueDateEnd?: Date | undefined;
    hardStartDate?: boolean | undefined;
    hardEndDate?: boolean | undefined;
    manualPriorityShortcutType?: WorkTaskUpdateDTOManualPriorityShortcutType | undefined;
    manualRangeStart?: number | undefined;
    manualRangeEnd?: number | undefined;
    quoteSignedDate?: Date | undefined;
}

export class WorkTaskTemplate implements IWorkTaskTemplate {
    id?: number | undefined;
    name?: string | undefined;
    cost?: number | undefined;
    price?: number | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    hours?: number | undefined;
    deleted?: boolean | undefined;

    constructor(data?: IWorkTaskTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.cost = _data["Cost"];
            this.price = _data["Price"];
            this.description = _data["Description"];
            this.active = _data["Active"];
            this.hours = _data["Hours"];
            this.deleted = _data["Deleted"];
        }
    }

    static fromJS(data: any): WorkTaskTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTaskTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Cost"] = this.cost;
        data["Price"] = this.price;
        data["Description"] = this.description;
        data["Active"] = this.active;
        data["Hours"] = this.hours;
        data["Deleted"] = this.deleted;
        return data;
    }
}

export interface IWorkTaskTemplate {
    id?: number | undefined;
    name?: string | undefined;
    cost?: number | undefined;
    price?: number | undefined;
    description?: string | undefined;
    active?: boolean | undefined;
    hours?: number | undefined;
    deleted?: boolean | undefined;
}

export enum SortOption {
    None = "None",
    CustomerName = "CustomerName",
    CustomerNameDesc = "CustomerNameDesc",
    CustomerPhone = "CustomerPhone",
    CustomerPhoneDesc = "CustomerPhoneDesc",
    CustomerType = "CustomerType",
    CustomerTypeDesc = "CustomerTypeDesc",
    StreetAddress = "StreetAddress",
    StreetAddressDesc = "StreetAddressDesc",
    StateName = "StateName",
    StateNameDesc = "StateNameDesc",
    Zip = "Zip",
    ZipDesc = "ZipDesc",
    Tax = "Tax",
    TaxDesc = "TaxDesc",
    Status = "Status",
    StatusDesc = "StatusDesc",
}

export enum SortOption2 {
    None = "None",
    CustomerName = "CustomerName",
    CustomerNameDesc = "CustomerNameDesc",
    CustomerPhone = "CustomerPhone",
    CustomerPhoneDesc = "CustomerPhoneDesc",
    CompletionStatus = "CompletionStatus",
    CompletionStatusDesc = "CompletionStatusDesc",
    StreetAddress = "StreetAddress",
    StreetAddressDesc = "StreetAddressDesc",
    StateName = "StateName",
    StateNameDesc = "StateNameDesc",
    Zip = "Zip",
    ZipDesc = "ZipDesc",
    PaymentStatus = "PaymentStatus",
    PaymentStatusDesc = "PaymentStatusDesc",
    Date = "Date",
    DateDesc = "DateDesc",
    Urgent = "Urgent",
    UrgentDesc = "UrgentDesc",
}

export enum WellnessWorkOrderCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum WellnessWorkOrderPaymentStatus {
    Not_Paid = "Not Paid",
    Invoiced = "Invoiced",
    Paid = "Paid",
}

export enum WorkWorkOrderCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum WorkWorkOrderPaymentStatus {
    Not_Paid = "Not Paid",
    Invoiced = "Invoiced",
    Paid = "Paid",
}

export enum QuoteWorkOrderManualPriorityShortcutType {
    Week = "Week",
    Day = "Day",
}

export enum QuoteWorkOrderCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum QuoteWorkOrderPaymentStatus {
    Not_Paid = "Not Paid",
    Invoiced = "Invoiced",
    Paid = "Paid",
}

export enum EmployeeMultiFactorAuthenticationPreference {
    Email = "Email",
    Text_Message = "Text Message",
}

export enum WellnessTaskManualPriorityShortcutType {
    Week = "Week",
    Day = "Day",
}

export enum WellnessTaskCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum WellnessTaskPaymentStatus {
    Not_Paid = "Not Paid",
    Invoiced = "Invoiced",
    Paid = "Paid",
}

export enum QuoteRequestCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum QuoteRequestPaymentStatus {
    Not_Paid = "Not Paid",
    Invoiced = "Invoiced",
    Paid = "Paid",
}

export enum QuoteRequestType {
    Anytime = "Anytime",
    Firmtime = "Firmtime",
    Virtual = "Virtual",
}

export enum WorkTaskManualPriorityShortcutType {
    Week = "Week",
    Day = "Day",
}

export enum WorkTaskCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum WorkTaskPaymentStatus {
    Not_Paid = "Not Paid",
    Invoiced = "Invoiced",
    Paid = "Paid",
}

export enum BlobWithSASBlobType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum CloudBlobClientAuthenticationScheme {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum BlobPropertiesBlobType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum BlobPropertiesLeaseStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum BlobPropertiesLeaseState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum BlobPropertiesLeaseDuration {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum BlobPropertiesStandardBlobTier {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum BlobPropertiesRehydrationStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum BlobPropertiesPremiumPageBlobTier {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export enum CopyStateStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum BlobRequestOptionsLocationMode {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum BlobContainerPropertiesLeaseStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum BlobContainerPropertiesLeaseState {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export enum BlobContainerPropertiesLeaseDuration {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum BlobContainerPropertiesPublicAccess {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum EmployeeMFAPreferenceViewModelPreferenceType {
    Email = "Email",
    Text_Message = "Text Message",
}

export enum LogViewModelLevel {
    All = "All",
    Debug = "Debug",
    Info = "Info",
    Warn = "Warn",
    Error = "Error",
    Fatal = "Fatal",
    Off = "Off",
}

export enum IWorkOrderCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum IWorkOrderPaymentStatus {
    Not_Paid = "Not Paid",
    Invoiced = "Invoiced",
    Paid = "Paid",
}

export enum ScheduleTaskDTOType {
    _0 = 0,
    _1 = 1,
}

export enum StripeBillingPaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum SystemSettingDTOType {
    Number = "number",
    Text = "text",
}

export enum WellnessTaskUpdateDTOCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum WellnessTaskUpdateDTOManualPriorityShortcutType {
    Week = "Week",
    Day = "Day",
}

export enum WorkTaskUpdateDTOCompletionStatus {
    Pending = "Pending",
    Transformed_to_Quote = "Transformed to Quote",
    New = "New",
    Sent = "Sent",
    Opened = "Opened",
    Quote_Expired = "Quote Expired",
    Quote_Rejected = "Quote Rejected",
    Credit_Card_Needed = "Credit Card Needed",
    Work_Orders_Created = "Work Orders Created",
    Created = "Created",
    Ready_to_Schedule = "Ready to Schedule",
    Customer_Not_Notified = "Customer Not Notified",
    Customer_Notified = "Customer Notified",
    Partially_Complete = "Partially Complete",
    Completed = "Completed",
    Customer_Unsatisfied__RM_Follow_Up = "Customer Unsatisfied - RM Follow Up",
    Go_Back = "Go Back",
    Customer_Satisfied = "Customer Satisfied",
    Unable_to_be_Completed = "Unable to be Completed",
    Paid = "Paid",
}

export enum WorkTaskUpdateDTOManualPriorityShortcutType {
    Week = "Week",
    Day = "Day",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}